/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/frankfurt_districts/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(178);
	module.exports = __webpack_require__(93);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(7);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  (function () {
	    var printWarning = function printWarning(format) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var argIndex = 0;
	      var message = 'Warning: ' + format.replace(/%s/g, function () {
	        return args[argIndex++];
	      });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // --- Welcome to debugging React ---
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch (x) {}
	    };
	
	    warning = function warning(condition, format) {
	      if (format === undefined) {
	        throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	      }
	
	      if (format.indexOf('Failed Composite propType: ') === 0) {
	        return; // Ignore CompositeComponent proptype check.
	      }
	
	      if (!condition) {
	        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	          args[_key2 - 2] = arguments[_key2];
	        }
	
	        printWarning.apply(undefined, [format].concat(args));
	      }
	    };
	  })();
	}
	
	module.exports = warning;

/***/ },
/* 3 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ },
/* 4 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var DOMProperty = __webpack_require__(14);
	var ReactDOMComponentFlags = __webpack_require__(59);
	
	var invariant = __webpack_require__(1);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Check if a given node should be cached.
	 */
	function shouldPrecacheNode(node, nodeID) {
	  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
	}
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID === 0) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (shouldPrecacheNode(childNode, childID)) {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ },
/* 6 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 7 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	// Trust the developer to only use ReactInstrumentation with a __DEV__ check
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3),
	    _assign = __webpack_require__(4);
	
	var CallbackQueue = __webpack_require__(57);
	var PooledClass = __webpack_require__(12);
	var ReactFeatureFlags = __webpack_require__(62);
	var ReactReconciler = __webpack_require__(15);
	var Transaction = __webpack_require__(27);
	
	var invariant = __webpack_require__(1);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.type.isReactTopLevelWrapper) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context whereupdates are not being batched.') : _prodInvariant('125') : void 0;
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var PooledClass = __webpack_require__(12);
	
	var emptyFunction = __webpack_require__(7);
	var warning = __webpack_require__(2);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	    } else if (typeof event.returnValue !== 'unknown') {
	      // eslint-disable-line valid-typeof
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	    } else if (typeof event.cancelBubble !== 'unknown') {
	      // eslint-disable-line valid-typeof
	      // The ChangeEventPlugin registers a "propertychange" event for
	      // IE. This event does not support bubbling or cancelling, and
	      // any references to cancelBubble throw "Member not found".  A
	      // typeof check of "unknown" circumvents this issue (and is also
	      // IE specific).
	      event.cancelBubble = true;
	    }
	
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re adding a new property in the synthetic event object. ' + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, 'This synthetic event is reused for performance reasons. If you\'re seeing this, ' + 'you\'re %s `%s` on a released/nullified synthetic event. %s. ' + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ },
/* 11 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	
	};
	
	module.exports = ReactCurrentOwner;

/***/ },
/* 12 */
[192, 3],
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(34);
	var setInnerHTML = __webpack_require__(29);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(42);
	var setTextContent = __webpack_require__(74);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var invariant = __webpack_require__(1);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   *
	   * autofocus is predefined, because adding it to the property whitelist
	   * causes unintended side effects.
	   *
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(150);
	var ReactInstrumentation = __webpack_require__(8);
	
	var warning = __webpack_require__(2);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID // 0 in production and for roots
	  ) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactReconciler;

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var ReactChildren = __webpack_require__(182);
	var ReactComponent = __webpack_require__(49);
	var ReactPureComponent = __webpack_require__(187);
	var ReactClass = __webpack_require__(183);
	var ReactDOMFactories = __webpack_require__(184);
	var ReactElement = __webpack_require__(17);
	var ReactPropTypes = __webpack_require__(185);
	var ReactVersion = __webpack_require__(188);
	
	var onlyChild = __webpack_require__(189);
	var warning = __webpack_require__(2);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	
	if (false) {
	  var warned = false;
	  __spread = function () {
	    process.env.NODE_ENV !== 'production' ? warning(warned, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.') : void 0;
	    warned = true;
	    return _assign.apply(null, arguments);
	  };
	}
	
	var React = {
	
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: ReactClass.createClass,
	  createFactory: createFactory,
	  createMixin: function (mixin) {
	    // Currently a noop. Will be used to validate and trace mixins.
	    return mixin;
	  },
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	module.exports = React;

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var ReactCurrentOwner = __webpack_require__(11);
	
	var warning = __webpack_require__(2);
	var canDefineProperty = __webpack_require__(79);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(77);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (false) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ },
/* 18 */
3,
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var EventPluginRegistry = __webpack_require__(35);
	var EventPluginUtils = __webpack_require__(36);
	var ReactErrorUtils = __webpack_require__(40);
	
	var accumulateInto = __webpack_require__(68);
	var forEachAccumulated = __webpack_require__(69);
	var invariant = __webpack_require__(1);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function (inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	};
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	function shouldPreventMouseEvent(name, type, props) {
	  switch (name) {
	    case 'onClick':
	    case 'onClickCapture':
	    case 'onDoubleClick':
	    case 'onDoubleClickCapture':
	    case 'onMouseDown':
	    case 'onMouseDownCapture':
	    case 'onMouseMove':
	    case 'onMouseMoveCapture':
	    case 'onMouseUp':
	    case 'onMouseUpCapture':
	      return !!(props.disabled && isInteractive(type));
	    default:
	      return false;
	  }
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
	    // live here; needs to be moved to a better place soon
	    var bankForRegistrationName = listenerBank[registrationName];
	    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
	      return null;
	    }
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	
	};
	
	module.exports = EventPluginHub;

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(20);
	var EventPluginUtils = __webpack_require__(36);
	
	var accumulateInto = __webpack_require__(68);
	var forEachAccumulated = __webpack_require__(69);
	var warning = __webpack_require__(2);
	
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, phase, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ },
/* 22 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	
	};
	
	module.exports = ReactInstanceMap;

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(10);
	
	var getEventTarget = __webpack_require__(45);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(16);


/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var EventPluginRegistry = __webpack_require__(35);
	var ReactEventEmitterMixin = __webpack_require__(142);
	var ViewportMetrics = __webpack_require__(67);
	
	var getVendorPrefixedEventName = __webpack_require__(175);
	var isEventSupported = __webpack_require__(46);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === 'topWheel') {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === 'topScroll') {
	
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
	
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening.topBlur = true;
	          isListening.topFocus = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Protect against document.createEvent() returning null
	   * Some popup blocker extensions appear to do this:
	   * https://github.com/facebook/react/issues/6887
	   */
	  supportsEventPageXY: function () {
	    if (!document.createEvent) {
	      return false;
	    }
	    var ev = document.createEvent('MouseEvent');
	    return ev != null && 'pageX' in ev;
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(23);
	var ViewportMetrics = __webpack_require__(67);
	
	var getEventModifierState = __webpack_require__(44);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var invariant = __webpack_require__(1);
	
	var OBSERVED_ERROR = {};
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var TransactionImpl = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	module.exports = TransactionImpl;

/***/ },
/* 28 */
/***/ function(module, exports) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(6);
	var DOMNamespaces = __webpack_require__(34);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(42);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var svgNode = reusableSVGContainer.firstChild;
	    while (svgNode.firstChild) {
	      node.appendChild(svgNode.firstChild);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xFEFF) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ },
/* 30 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var extractDataHelper = exports.extractDataHelper = function extractDataHelper(rawData, id, name) {
	  var data = {};
	  rawData.map(function (district) {
	    data[district.Stadtteil] = parseFloat(district[id].replace(',', '.'));
	  });
	  return {
	    id: id,
	    name: name,
	    data: data
	  };
	};
	
	var extractData = exports.extractData = function extractData(rawData, id) {
	  var districtKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'Stadtteil';
	
	  var data = {};
	  rawData.map(function (district) {
	    data[district[districtKey].trim()] = parseFloat(district[id].replace(',', '.'));
	  });
	  return data;
	};

/***/ },
/* 31 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * @license
	 * Lodash <https://lodash.com/>
	 * Copyright JS Foundation and other contributors <https://js.foundation/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '4.17.4';
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Error message constants. */
	  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
	      FUNC_ERROR_TEXT = 'Expected a function';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as the maximum memoize cache size. */
	  var MAX_MEMOIZE_SIZE = 500;
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** Used to compose bitmasks for cloning. */
	  var CLONE_DEEP_FLAG = 1,
	      CLONE_FLAT_FLAG = 2,
	      CLONE_SYMBOLS_FLAG = 4;
	
	  /** Used to compose bitmasks for value comparisons. */
	  var COMPARE_PARTIAL_FLAG = 1,
	      COMPARE_UNORDERED_FLAG = 2;
	
	  /** Used to compose bitmasks for function metadata. */
	  var WRAP_BIND_FLAG = 1,
	      WRAP_BIND_KEY_FLAG = 2,
	      WRAP_CURRY_BOUND_FLAG = 4,
	      WRAP_CURRY_FLAG = 8,
	      WRAP_CURRY_RIGHT_FLAG = 16,
	      WRAP_PARTIAL_FLAG = 32,
	      WRAP_PARTIAL_RIGHT_FLAG = 64,
	      WRAP_ARY_FLAG = 128,
	      WRAP_REARG_FLAG = 256,
	      WRAP_FLIP_FLAG = 512;
	
	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 800,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;
	
	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	  /** Used to associate wrap methods with their bit flags. */
	  var wrapFlags = [
	    ['ary', WRAP_ARY_FLAG],
	    ['bind', WRAP_BIND_FLAG],
	    ['bindKey', WRAP_BIND_KEY_FLAG],
	    ['curry', WRAP_CURRY_FLAG],
	    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	    ['flip', WRAP_FLIP_FLAG],
	    ['partial', WRAP_PARTIAL_FLAG],
	    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	    ['rearg', WRAP_REARG_FLAG]
	  ];
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      asyncTag = '[object AsyncFunction]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      domExcTag = '[object DOMException]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      nullTag = '[object Null]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      proxyTag = '[object Proxy]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      undefinedTag = '[object Undefined]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
	      reUnescapedHtml = /[&<>"']/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      reLeadingDot = /^\./,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  /** Used to match leading and trailing whitespace. */
	  var reTrim = /^\s+|\s+$/g,
	      reTrimStart = /^\s+/,
	      reTrimEnd = /\s+$/;
	
	  /** Used to match wrap detail comments. */
	  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	      reSplitDetails = /,? & /;
	
	  /** Used to match words composed of alphanumeric characters. */
	  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f',
	      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	      rsComboSymbolsRange = '\\u20d0-\\u20ff',
	      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';
	
	  /** Used to compose unicode regexes. */
	  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsOrdLower = '\\d*(?:(?:1st|2nd|3rd|(?![123])\\dth)\\b)',
	      rsOrdUpper = '\\d*(?:(?:1ST|2ND|3RD|(?![123])\\dTH)\\b)',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	  /** Used to match complex or compound words. */
	  var reUnicodeWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	    rsUpper + '+' + rsOptContrUpper,
	    rsOrdUpper,
	    rsOrdLower,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');
	
	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	    '\u0134': 'J',  '\u0135': 'j',
	    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W',  '\u0175': 'w',
	    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017f': 's'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'"
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || Function('return this')();
	
	  /** Detect free variable `exports`. */
	  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;
	
	  /** Detect free variable `process` from Node.js. */
	  var freeProcess = moduleExports && freeGlobal.process;
	
	  /** Used to access faster Node.js helpers. */
	  var nodeUtil = (function() {
	    try {
	      return freeProcess && freeProcess.binding && freeProcess.binding('util');
	    } catch (e) {}
	  }());
	
	  /* Node.js helper references. */
	  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
	      nodeIsDate = nodeUtil && nodeUtil.isDate,
	      nodeIsMap = nodeUtil && nodeUtil.isMap,
	      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
	      nodeIsSet = nodeUtil && nodeUtil.isSet,
	      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Adds the key-value `pair` to `map`.
	   *
	   * @private
	   * @param {Object} map The map to modify.
	   * @param {Array} pair The key-value pair to add.
	   * @returns {Object} Returns `map`.
	   */
	  function addMapEntry(map, pair) {
	    // Don't return `map.set` because it's not chainable in IE 11.
	    map.set(pair[0], pair[1]);
	    return map;
	  }
	
	  /**
	   * Adds `value` to `set`.
	   *
	   * @private
	   * @param {Object} set The set to modify.
	   * @param {*} value The value to add.
	   * @returns {Object} Returns `set`.
	   */
	  function addSetEntry(set, value) {
	    // Don't return `set.add` because it's not chainable in IE 11.
	    set.add(value);
	    return set;
	  }
	
	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    switch (args.length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }
	
	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	
	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array == null ? 0 : array.length;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }
	
	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }
	
	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;
	
	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array == null ? 0 : array.length;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  var asciiSize = baseProperty('length');
	
	  /**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function asciiToArray(string) {
	    return string.split('');
	  }
	
	  /**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function asciiWords(string) {
	    return string.match(reAsciiWord) || [];
	  }
	
	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    return value === value
	      ? strictIndexOf(array, value, fromIndex)
	      : baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	
	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */
	  function baseIsNaN(value) {
	    return value !== value;
	  }
	
	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }
	
	  /**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function baseProperty(key) {
	    return function(object) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function basePropertyOf(object) {
	    return function(key) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;
	
	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }
	
	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }
	
	  /**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }
	
	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }
	
	  /**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;
	
	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;
	
	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;
	
	    while (length--) {
	      if (array[length] === placeholder) {
	        ++result;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  var deburrLetter = basePropertyOf(deburredLetters);
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  var escapeHtmlChar = basePropertyOf(htmlEscapes);
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }
	
	  /**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */
	  function hasUnicode(string) {
	    return reHasUnicode.test(string);
	  }
	
	  /**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */
	  function hasUnicodeWord(string) {
	    return reHasUnicodeWord.test(string);
	  }
	
	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];
	
	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }
	
	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);
	
	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }
	
	  /**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function(arg) {
	      return func(transform(arg));
	    };
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictIndexOf(array, value, fromIndex) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictLastIndexOf(array, value, fromIndex) {
	    var index = fromIndex + 1;
	    while (index--) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return index;
	  }
	
	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    return hasUnicode(string)
	      ? unicodeSize(string)
	      : asciiSize(string);
	  }
	
	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return hasUnicode(string)
	      ? unicodeToArray(string)
	      : asciiToArray(string);
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
	
	  /**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  function unicodeSize(string) {
	    var result = reUnicode.lastIndex = 0;
	    while (reUnicode.test(string)) {
	      ++result;
	    }
	    return result;
	  }
	
	  /**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function unicodeToArray(string) {
	    return string.match(reUnicode) || [];
	  }
	
	  /**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function unicodeWords(string) {
	    return string.match(reUnicodeWord) || [];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  var runInContext = (function runInContext(context) {
	    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
	
	    /** Built-in constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for built-in method references. */
	    var arrayProto = Array.prototype,
	        funcProto = Function.prototype,
	        objectProto = Object.prototype;
	
	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];
	
	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = funcProto.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());
	
	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var nativeObjectToString = objectProto.toString;
	
	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	        getPrototype = overArg(Object.getPrototypeOf, Object),
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice,
	        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
	        symIterator = Symbol ? Symbol.iterator : undefined,
	        symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	    var defineProperty = (function() {
	      try {
	        var func = getNative(Object, 'defineProperty');
	        func({}, '', {});
	        return func;
	      } catch (e) {}
	    }());
	
	    /** Mocked built-ins. */
	    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
	        ctxNow = Date && Date.now !== root.Date.now && Date.now,
	        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
	
	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetSymbols = Object.getOwnPropertySymbols,
	        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = overArg(Object.keys, Object),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = Date.now,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;
	
	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);
	
	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array and iteratees accept only
	     * one argument. The heuristic for whether a section qualifies for shortcut
	     * fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(proto) {
	        if (!isObject(proto)) {
	          return {};
	        }
	        if (objectCreate) {
	          return objectCreate(proto);
	        }
	        object.prototype = proto;
	        var result = new object;
	        object.prototype = undefined;
	        return result;
	      };
	    }());
	
	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
	     * following template settings to use alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      var result = this.has(key) && delete this.__data__[key];
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined;
	    }
	
	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	    }
	
	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      this.size += this.has(key) ? 0 : 1;
	      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }
	
	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      --this.size;
	      return true;
	    }
	
	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      return index < 0 ? undefined : data[index][1];
	    }
	
	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }
	
	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        ++this.size;
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }
	
	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.size = 0;
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }
	
	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      var result = getMapData(this, key)['delete'](key);
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }
	
	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }
	
	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      var data = getMapData(this, key),
	          size = data.size;
	
	      data.set(key, value);
	      this.size += data.size == size ? 0 : 1;
	      return this;
	    }
	
	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values == null ? 0 : values.length;
	
	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.add(values[index]);
	      }
	    }
	
	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }
	
	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }
	
	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      var data = this.__data__ = new ListCache(entries);
	      this.size = data.size;
	    }
	
	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      var data = this.__data__,
	          result = data['delete'](key);
	
	      this.size = data.size;
	      return result;
	    }
	
	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }
	
	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }
	
	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var data = this.__data__;
	      if (data instanceof ListCache) {
	        var pairs = data.__data__;
	        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	          pairs.push([key, value]);
	          this.size = ++data.size;
	          return this;
	        }
	        data = this.__data__ = new MapCache(pairs);
	      }
	      data.set(key, value);
	      this.size = data.size;
	      return this;
	    }
	
	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */
	    function arrayLikeKeys(value, inherited) {
	      var isArr = isArray(value),
	          isArg = !isArr && isArguments(value),
	          isBuff = !isArr && !isArg && isBuffer(value),
	          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	          skipIndexes = isArr || isArg || isBuff || isType,
	          result = skipIndexes ? baseTimes(value.length, String) : [],
	          length = result.length;
	
	      for (var key in value) {
	        if ((inherited || hasOwnProperty.call(value, key)) &&
	            !(skipIndexes && (
	               // Safari 9 has enumerable `arguments.length` in strict mode.
	               key == 'length' ||
	               // Node.js 0.10 has enumerable non-index properties on buffers.
	               (isBuff && (key == 'offset' || key == 'parent')) ||
	               // PhantomJS 2 has enumerable non-index properties on typed arrays.
	               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	               // Skip index properties.
	               isIndex(key, length)
	            ))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */
	    function arraySample(array) {
	      var length = array.length;
	      return length ? array[baseRandom(0, length - 1)] : undefined;
	    }
	
	    /**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function arraySampleSize(array, n) {
	      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function arrayShuffle(array) {
	      return shuffleSelf(copyArray(array));
	    }
	
	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.assignIn` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssignIn(object, source) {
	      return object && copyObject(source, keysIn(source), object);
	    }
	
	    /**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function baseAssignValue(object, key, value) {
	      if (key == '__proto__' && defineProperty) {
	        defineProperty(object, key, {
	          'configurable': true,
	          'enumerable': true,
	          'value': value,
	          'writable': true
	        });
	      } else {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          length = paths.length,
	          result = Array(length),
	          skip = object == null;
	
	      while (++index < length) {
	        result[index] = skip ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }
	
	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Deep clone
	     *  2 - Flatten inherited properties
	     *  4 - Clone symbols
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, bitmask, customizer, key, object, stack) {
	      var result,
	          isDeep = bitmask & CLONE_DEEP_FLAG,
	          isFlat = bitmask & CLONE_FLAT_FLAG,
	          isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;
	
	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = (isFlat || isFunc) ? {} : initCloneObject(value);
	          if (!isDeep) {
	            return isFlat
	              ? copySymbolsIn(value, baseAssignIn(result, value))
	              : copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, baseClone, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);
	
	      var keysFunc = isFull
	        ? (isFlat ? getAllKeysIn : getAllKeys)
	        : (isFlat ? keysIn : keys);
	
	      var props = isArr ? undefined : keysFunc(value);
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        // Recursively populate clone (susceptible to call stack limits).
	        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source);
	      return function(object) {
	        return baseConformsTo(object, source, props);
	      };
	    }
	
	    /**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */
	    function baseConformsTo(object, source, props) {
	      var length = props.length;
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (length--) {
	        var key = props[length],
	            predicate = source[key],
	            value = object[key];
	
	        if ((value === undefined && !(key in object)) || !predicate(value)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;
	
	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee == null ? value : iteratee(value);
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);
	
	        if (current != null && (computed === undefined
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;
	
	      predicate || (predicate = isFlattenable);
	      result || (result = []);
	
	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }
	
	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = castPath(path, object);
	
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }
	
	    /**
	     * The base implementation of `getTag` without fallbacks for buggy environments.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function baseGetTag(value) {
	      if (value == null) {
	        return value === undefined ? undefinedTag : nullTag;
	      }
	      return (symToStringTag && symToStringTag in Object(value))
	        ? getRawTag(value)
	        : objectToString(value);
	    }
	
	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      return object != null && hasOwnProperty.call(object, key);
	    }
	
	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }
	
	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }
	
	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];
	
	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];
	
	      var index = -1,
	          seen = caches[0];
	
	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      var func = object == null ? object : object[toKey(last(path))];
	      return func == null ? undefined : apply(func, object, args);
	    }
	
	    /**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */
	    function baseIsArguments(value) {
	      return isObjectLike(value) && baseGetTag(value) == argsTag;
	    }
	
	    /**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */
	    function baseIsArrayBuffer(value) {
	      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
	    }
	
	    /**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */
	    function baseIsDate(value) {
	      return isObjectLike(value) && baseGetTag(value) == dateTag;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Unordered comparison
	     *  2 - Partial comparison
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, bitmask, customizer, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = objIsArr ? arrayTag : getTag(object),
	          othTag = othIsArr ? arrayTag : getTag(other);
	
	      objTag = objTag == argsTag ? objectTag : objTag;
	      othTag = othTag == argsTag ? objectTag : othTag;
	
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && isBuffer(object)) {
	        if (!isBuffer(other)) {
	          return false;
	        }
	        objIsArr = true;
	        objIsObj = false;
	      }
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	      }
	      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;
	
	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	    }
	
	    /**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */
	    function baseIsMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }
	
	    /**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */
	    function baseIsRegExp(value) {
	      return isObjectLike(value) && baseGetTag(value) == regexpTag;
	    }
	
	    /**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */
	    function baseIsSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }
	
	    /**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */
	    function baseIsTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	    }
	
	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }
	
	    /**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      if (!isPrototype(object)) {
	        return nativeKeys(object);
	      }
	      var result = [];
	      for (var key in Object(object)) {
	        if (hasOwnProperty.call(object, key) && key != 'constructor') {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      if (!isObject(object)) {
	        return nativeKeysIn(object);
	      }
	      var isProto = isPrototype(object),
	          result = [];
	
	      for (var key in object) {
	        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      baseFor(source, function(srcValue, key) {
	        if (isObject(srcValue)) {
	          stack || (stack = new Stack);
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(object[key], srcValue, (key + ''), object, source, stack)
	            : undefined;
	
	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      }, keysIn);
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = object[key],
	          srcValue = source[key],
	          stacked = stack.get(srcValue);
	
	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      var isCommon = newValue === undefined;
	
	      if (isCommon) {
	        var isArr = isArray(srcValue),
	            isBuff = !isArr && isBuffer(srcValue),
	            isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	        newValue = srcValue;
	        if (isArr || isBuff || isTyped) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else if (isBuff) {
	            isCommon = false;
	            newValue = cloneBuffer(srcValue, true);
	          }
	          else if (isTyped) {
	            isCommon = false;
	            newValue = cloneTypedArray(srcValue, true);
	          }
	          else {
	            newValue = [];
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          newValue = objValue;
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
	            newValue = initCloneObject(srcValue);
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, newValue);
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	        stack['delete'](srcValue);
	      }
	      assignMergeValue(object, key, newValue);
	    }
	
	    /**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined;
	    }
	
	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      var index = -1;
	      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));
	
	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, paths) {
	      return basePickBy(object, paths, function(value, path) {
	        return hasIn(object, path);
	      });
	    }
	
	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, paths, predicate) {
	      var index = -1,
	          length = paths.length,
	          result = {};
	
	      while (++index < length) {
	        var path = paths[index],
	            value = baseGet(object, path);
	
	        if (predicate(value, path)) {
	          baseSet(result, castPath(path, object), value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;
	
	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;
	
	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          } else {
	            baseUnset(array, index);
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }
	
	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */
	    function baseRest(func, start) {
	      return setToString(overRest(func, start, identity), func + '');
	    }
	
	    /**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */
	    function baseSample(collection) {
	      return arraySample(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function baseSampleSize(collection, n) {
	      var array = values(collection);
	      return shuffleSelf(array, baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      if (!isObject(object)) {
	        return object;
	      }
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]),
	            newValue = value;
	
	        if (index != lastIndex) {
	          var objValue = nested[key];
	          newValue = customizer ? customizer(objValue, key, nested) : undefined;
	          if (newValue === undefined) {
	            newValue = isObject(objValue)
	              ? objValue
	              : (isIndex(path[index + 1]) ? [] : {});
	          }
	        }
	        assignValue(nested, key, newValue);
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetToString = !defineProperty ? identity : function(func, string) {
	      return defineProperty(func, 'toString', {
	        'configurable': true,
	        'enumerable': false,
	        'value': constant(string),
	        'writable': true
	      });
	    };
	
	    /**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function baseShuffle(collection) {
	      return shuffleSelf(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array == null ? low : array.length;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      value = iteratee(value);
	
	      var low = 0,
	          high = array == null ? 0 : array.length,
	          valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);
	
	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }
	
	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isArray(value)) {
	        // Recursively convert values (susceptible to call stack limits).
	        return arrayMap(value, baseToString) + '';
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;
	
	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The property path to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      return object == null || delete object[toKey(last(path))];
	    }
	
	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }
	
	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}
	
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }
	
	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var length = arrays.length;
	      if (length < 2) {
	        return length ? baseUniq(arrays[0]) : [];
	      }
	      var index = -1,
	          result = Array(length);
	
	      while (++index < length) {
	        var array = arrays[index],
	            othIndex = -1;
	
	        while (++othIndex < length) {
	          if (othIndex != index) {
	            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
	          }
	        }
	      }
	      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
	    }
	
	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};
	
	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }
	
	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }
	
	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }
	
	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value, object) {
	      if (isArray(value)) {
	        return value;
	      }
	      return isKey(value, object) ? [value] : stringToPath(toString(value));
	    }
	
	    /**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    var castRest = baseRest;
	
	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }
	
	    /**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */
	    var clearTimeout = ctxClearTimeout || function(id) {
	      return root.clearTimeout(id);
	    };
	
	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var length = buffer.length,
	          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	      buffer.copy(result);
	      return result;
	    }
	
	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }
	
	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }
	
	    /**
	     * Creates a clone of `map`.
	     *
	     * @private
	     * @param {Object} map The map to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned map.
	     */
	    function cloneMap(map, isDeep, cloneFunc) {
	      var array = isDeep ? cloneFunc(mapToArray(map), CLONE_DEEP_FLAG) : mapToArray(map);
	      return arrayReduce(array, addMapEntry, new map.constructor);
	    }
	
	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }
	
	    /**
	     * Creates a clone of `set`.
	     *
	     * @private
	     * @param {Object} set The set to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned set.
	     */
	    function cloneSet(set, isDeep, cloneFunc) {
	      var array = isDeep ? cloneFunc(setToArray(set), CLONE_DEEP_FLAG) : setToArray(set);
	      return arrayReduce(array, addSetEntry, new set.constructor);
	    }
	
	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }
	
	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }
	
	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);
	
	        var othIsDefined = other !== undefined,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);
	
	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }
	
	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;
	
	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;
	
	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      var isNew = !object;
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	
	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : undefined;
	
	        if (newValue === undefined) {
	          newValue = source[key];
	        }
	        if (isNew) {
	          baseAssignValue(object, key, newValue);
	        } else {
	          assignValue(object, key, newValue);
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Copies own symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }
	
	    /**
	     * Copies own and inherited symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbolsIn(source, object) {
	      return copyObject(source, getSymbolsIn(source), object);
	    }
	
	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};
	
	        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
	      };
	    }
	
	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return baseRest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;
	
	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined;
	
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;
	
	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBind(func, bitmask, thisArg) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);
	
	        var strSymbols = hasUnicode(string)
	          ? stringToArray(string)
	          : undefined;
	
	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);
	
	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);
	
	        return chr[methodName]() + trailing;
	      };
	    }
	
	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtor(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurry(func, bitmask, arity) {
	      var Ctor = createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);
	
	        length -= holders.length;
	        if (length < arity) {
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        if (!isArrayLike(collection)) {
	          var iteratee = getIteratee(predicate, 3);
	          collection = keys(collection);
	          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	        }
	        var index = findIndexFunc(collection, predicate, fromIndex);
	        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return flatRest(function(funcs) {
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;
	
	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) &&
	                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value)) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & WRAP_ARY_FLAG,
	          isBind = bitmask & WRAP_BIND_FLAG,
	          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	          isFlip = bitmask & WRAP_FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length;
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtor(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }
	
	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator, defaultValue) {
	      return function(value, other) {
	        var result;
	        if (value === undefined && other === undefined) {
	          return defaultValue;
	        }
	        if (value !== undefined) {
	          result = value;
	        }
	        if (other !== undefined) {
	          if (result === undefined) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return flatRest(function(iteratees) {
	        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	        return baseRest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }
	
	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : baseToString(chars);
	
	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return hasUnicode(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartial(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toFinite(start);
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toFinite(end);
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	        return baseRange(start, end, step, fromRight);
	      };
	    }
	
	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & WRAP_CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;
	
	      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];
	
	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return setWrapToString(result, func, bitmask);
	    }
	
	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
	        if (precision) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };
	
	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *    1 - `_.bind`
	     *    2 - `_.bindKey`
	     *    4 - `_.curry` or `_.curryRight` of a bound function
	     *    8 - `_.curry`
	     *   16 - `_.curryRight`
	     *   32 - `_.partial`
	     *   64 - `_.partialRight`
	     *  128 - `_.rearg`
	     *  256 - `_.ary`
	     *  512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;
	
	      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);
	
	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];
	
	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] === undefined
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);
	
	      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	        var result = createBind(func, bitmask, thisArg);
	      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	        result = createCurry(func, bitmask, arity);
	      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	        result = createPartial(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybrid.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setWrapToString(setter(result, newData), func, bitmask);
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	     * of source objects to the destination object for all destination properties
	     * that resolve to `undefined`.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsAssignIn(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	     * objects into destination objects that are passed thru.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, objValue);
	        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
	        stack['delete'](srcValue);
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	     * objects.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {string} key The key of the property to inspect.
	     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	     */
	    function customOmitClone(value) {
	      return isPlainObject(value) ? undefined : value;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(array);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	      stack.set(array, other);
	      stack.set(other, array);
	
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!cacheHas(seen, othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	                  return seen.push(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, bitmask, customizer, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;
	
	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;
	
	        case boolTag:
	        case dateTag:
	        case numberTag:
	          // Coerce booleans to `1` or `0` and dates to milliseconds.
	          // Invalid dates are coerced to `NaN`.
	          return eq(+object, +other);
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');
	
	        case mapTag:
	          var convert = mapToArray;
	
	        case setTag:
	          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	          convert || (convert = setToArray);
	
	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= COMPARE_UNORDERED_FLAG;
	
	          // Recursively compare objects (susceptible to call stack limits).
	          stack.set(object, other);
	          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	          stack['delete'](object);
	          return result;
	
	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          objProps = getAllKeys(object),
	          objLength = objProps.length,
	          othProps = getAllKeys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var result = true;
	      stack.set(object, other);
	      stack.set(other, object);
	
	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    function flatRest(func) {
	      return setToString(overRest(func, undefined, flatten), func + '');
	    }
	
	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }
	
	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }
	
	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }
	
	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;
	
	      while (length--) {
	        var key = result[length],
	            value = object[key];
	
	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }
	
	    /**
	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the raw `toStringTag`.
	     */
	    function getRawTag(value) {
	      var isOwn = hasOwnProperty.call(value, symToStringTag),
	          tag = value[symToStringTag];
	
	      try {
	        value[symToStringTag] = undefined;
	        var unmasked = true;
	      } catch (e) {}
	
	      var result = nativeObjectToString.call(value);
	      if (unmasked) {
	        if (isOwn) {
	          value[symToStringTag] = tag;
	        } else {
	          delete value[symToStringTag];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	      if (object == null) {
	        return [];
	      }
	      object = Object(object);
	      return arrayFilter(nativeGetSymbols(object), function(symbol) {
	        return propertyIsEnumerable.call(object, symbol);
	      });
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };
	
	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    var getTag = baseGetTag;
	
	    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = baseGetTag(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : '';
	
	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */
	    function getWrapDetails(source) {
	      var match = source.match(reWrapDetails);
	      return match ? match[1].split(reSplitDetails) : [];
	    }
	
	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          result = false;
	
	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result || ++index != length) {
	        return result;
	      }
	      length = object == null ? 0 : object.length;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isArguments(object));
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = array.constructor(length);
	
	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, cloneFunc, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case dataViewTag:
	          return cloneDataView(object, isDeep);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);
	
	        case mapTag:
	          return cloneMap(object, isDeep, cloneFunc);
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          return cloneRegExp(object);
	
	        case setTag:
	          return cloneSet(object, isDeep, cloneFunc);
	
	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }
	
	    /**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */
	    function insertWrapDetails(source, details) {
	      var length = details.length;
	      if (!length) {
	        return source;
	      }
	      var lastIndex = length - 1;
	      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	      details = details.join(length > 2 ? ', ' : ' ');
	      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	    }
	
	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value) ||
	        !!(spreadableSymbol && value && value[spreadableSymbol]);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      length = length == null ? MAX_SAFE_INTEGER : length;
	      return !!length &&
	        (typeof value == 'number' || reIsUint.test(value)) &&
	        (value > -1 && value % 1 == 0 && value < length);
	    }
	
	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }
	
	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }
	
	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;
	
	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	      return value === proto;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }
	
	    /**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */
	    function memoizeCapped(func) {
	      var result = memoize(func, function(key) {
	        if (cache.size === MAX_MEMOIZE_SIZE) {
	          cache.clear();
	        }
	        return key;
	      });
	
	      var cache = result.cache;
	      return result;
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	      var isCombo =
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & WRAP_BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & WRAP_ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function nativeKeysIn(object) {
	      var result = [];
	      if (object != null) {
	        for (var key in Object(object)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a string using `Object.prototype.toString`.
	     *
	     * @private
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     */
	    function objectToString(value) {
	      return nativeObjectToString.call(value);
	    }
	
	    /**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */
	    function overRest(func, start, transform) {
	      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);
	
	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        index = -1;
	        var otherArgs = Array(start + 1);
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = transform(array);
	        return apply(func, this, otherArgs);
	      };
	    }
	
	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = shortOut(baseSetData);
	
	    /**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    var setTimeout = ctxSetTimeout || function(func, wait) {
	      return root.setTimeout(func, wait);
	    };
	
	    /**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var setToString = shortOut(baseSetToString);
	
	    /**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */
	    function setWrapToString(wrapper, reference, bitmask) {
	      var source = (reference + '');
	      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	    }
	
	    /**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */
	    function shortOut(func) {
	      var count = 0,
	          lastCalled = 0;
	
	      return function() {
	        var stamp = nativeNow(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return arguments[0];
	          }
	        } else {
	          count = 0;
	        }
	        return func.apply(undefined, arguments);
	      };
	    }
	
	    /**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */
	    function shuffleSelf(array, size) {
	      var index = -1,
	          length = array.length,
	          lastIndex = length - 1;
	
	      size = size === undefined ? length : size;
	      while (++index < size) {
	        var rand = baseRandom(index, lastIndex),
	            value = array[rand];
	
	        array[rand] = array[index];
	        array[index] = value;
	      }
	      array.length = size;
	      return array;
	    }
	
	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoizeCapped(function(string) {
	      var result = [];
	      if (reLeadingDot.test(string)) {
	        result.push('');
	      }
	      string.replace(rePropName, function(match, number, quote, string) {
	        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });
	
	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to convert.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }
	
	    /**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */
	    function updateWrapDetails(details, bitmask) {
	      arrayEach(wrapFlags, function(pair) {
	        var value = '_.' + pair[0];
	        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	          details.push(value);
	        }
	      });
	      return details.sort();
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array == null ? 0 : array.length;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array == null ? 0 : array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length;
	      if (!length) {
	        return [];
	      }
	      var args = Array(length - 1),
	          array = arguments[0],
	          index = length;
	
	      while (index--) {
	        args[index - 1] = arguments[index];
	      }
	      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
	    }
	
	    /**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = baseRest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = baseRest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }
	
	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, 1) : [];
	    }
	
	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }
	
	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }
	
	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs == null ? 0 : pairs.length,
	          result = {};
	
	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 0, -1) : [];
	    }
	
	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = baseRest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = baseRest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      if (comparator) {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array == null ? '' : nativeJoin.call(array, separator);
	    }
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
	      }
	      return value === value
	        ? strictLastIndexOf(array, value, index)
	        : baseFindIndex(array, baseIsNaN, index, true);
	    }
	
	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	    }
	
	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = baseRest(pullAll);
	
	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee, 2))
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = flatRest(function(array, indexes) {
	      var length = array == null ? 0 : array.length,
	          result = baseAt(array, indexes);
	
	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));
	
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array == null ? array : nativeReverse.call(array);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }
	
	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
	    }
	
	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 1, length) : [];
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = baseRest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length) ? baseUniq(array) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }
	
	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = baseRest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */
	    var zip = baseRest(unzip);
	
	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }
	
	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = baseRest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }
	
	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = flatRest(function(paths) {
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };
	
	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });
	
	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];
	
	      return { 'done': done, 'value': value };
	    }
	
	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }
	
	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }
	
	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        ++result[key];
	      } else {
	        baseAssignValue(result, key, 1);
	      }
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);
	
	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }
	
	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        baseAssignValue(result, key, [value]);
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = baseRest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      baseAssignValue(result, key, value);
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, negate(getIteratee(predicate, 3)));
	    }
	
	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var func = isArray(collection) ? arraySample : baseSample;
	      return func(collection);
	    }
	
	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
	      return func(collection, n);
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      var func = isArray(collection) ? arrayShuffle : baseShuffle;
	      return func(collection);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        return isString(collection) ? stringSize(collection) : collection.length;
	      }
	      var tag = getTag(collection);
	      if (tag == mapTag || tag == setTag) {
	        return collection.size;
	      }
	      return baseKeys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
	     */
	    var sortBy = baseRest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    var now = ctxNow || function() {
	      return root.Date.now();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = baseRest(function(func, thisArg, partials) {
	      var bitmask = WRAP_BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = baseRest(function(object, key, partials) {
	      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;
	
	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }
	
	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }
	
	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            result = wait - timeSinceLastCall;
	
	        return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	      }
	
	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;
	
	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }
	
	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }
	
	      function trailingEdge(time) {
	        timerId = undefined;
	
	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }
	
	      function cancel() {
	        if (timerId !== undefined) {
	          clearTimeout(timerId);
	        }
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }
	
	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }
	
	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);
	
	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;
	
	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */
	    var defer = baseRest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = baseRest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrap(func, WRAP_FLIP_FLAG);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result) || cache;
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }
	
	    // Expose `MapCache`.
	    memoize.Cache = MapCache;
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        var args = arguments;
	        switch (args.length) {
	          case 0: return !predicate.call(this);
	          case 1: return !predicate.call(this, args[0]);
	          case 2: return !predicate.call(this, args[0], args[1]);
	          case 3: return !predicate.call(this, args[0], args[1], args[2]);
	        }
	        return !predicate.apply(this, args);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = castRest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
	
	      var funcsLength = transforms.length;
	      return baseRest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);
	
	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });
	
	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = flatRest(function(func, indexes) {
	      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? start : toInteger(start);
	      return baseRest(func, start);
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start == null ? 0 : nativeMax(toInteger(start), 0);
	      return baseRest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);
	
	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }
	
	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }
	
	    /**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      return partial(castFunction(wrapper), value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }
	
	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */
	    function conformsTo(object, source) {
	      return source == null || baseConformsTo(object, source, keys(source));
	    }
	
	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });
	
	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	        !propertyIsEnumerable.call(value, 'callee');
	    };
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;
	
	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
	
	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(value.length) && !isFunction(value);
	    }
	
	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && baseGetTag(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = nativeIsBuffer || stubFalse;
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
	
	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) &&
	          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	        return !value.length;
	      }
	      var tag = getTag(value);
	      if (tag == mapTag || tag == setTag) {
	        return !value.size;
	      }
	      if (isPrototype(value)) {
	        return !baseKeys(value).length;
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are compared by strict equality, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }
	
	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      var tag = baseGetTag(value);
	      return tag == errorTag || tag == domExcTag ||
	        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      if (!isObject(value)) {
	        return false;
	      }
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 9 which returns 'object' for typed arrays and other constructors.
	      var tag = baseGetTag(value);
	      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	    }
	
	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return value != null && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return value != null && typeof value == 'object';
	    }
	
	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }
	
	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error(CORE_ERROR_TEXT);
	      }
	      return baseIsNative(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && baseGetTag(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	        funcToString.call(Ctor) == objectCtorString;
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && baseGetTag(value) == symbolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (symIterator && value[symIterator]) {
	        return iteratorToArray(value[symIterator]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	      return func(value);
	    }
	
	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }
	
	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;
	
	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }
	
	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }
	
	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = value.replace(reTrim, '');
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }
	
	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return value
	        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
	        : (value === 0 ? value : 0);
	    }
	
	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });
	
	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      copyObject(source, keysIn(source), object);
	    });
	
	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });
	
	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });
	
	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = flatRest(baseAt);
	
	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties == null ? result : baseAssign(result, properties);
	    }
	
	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var defaults = baseRest(function(args) {
	      args.push(undefined, customDefaultsAssignIn);
	      return apply(assignInWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */
	    var defaultsDeep = baseRest(function(args) {
	      args.push(undefined, customDefaultsMerge);
	      return apply(mergeWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }
	
	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }
	
	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }
	
	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      result[value] = key;
	    }, constant(identity));
	
	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);
	
	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = baseRest(baseInvoke);
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, iteratee(value, key, object), value);
	      });
	      return result;
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, key, iteratee(value, key, object));
	      });
	      return result;
	    }
	
	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });
	
	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable property paths of `object` that are not omitted.
	     *
	     * **Note:** This method is considerably slower than `_.pick`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = flatRest(function(object, paths) {
	      var result = {};
	      if (object == null) {
	        return result;
	      }
	      var isDeep = false;
	      paths = arrayMap(paths, function(path) {
	        path = castPath(path, object);
	        isDeep || (isDeep = path.length > 1);
	        return path;
	      });
	      copyObject(object, getAllKeysIn(object), result);
	      if (isDeep) {
	        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	      }
	      var length = paths.length;
	      while (length--) {
	        baseUnset(result, paths[length]);
	      }
	      return result;
	    });
	
	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      return pickBy(object, negate(getIteratee(predicate)));
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = flatRest(function(object, paths) {
	      return object == null ? {} : basePick(object, paths);
	    });
	
	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      if (object == null) {
	        return {};
	      }
	      var props = arrayMap(getAllKeysIn(object), function(prop) {
	        return [prop];
	      });
	      predicate = getIteratee(predicate);
	      return basePickBy(object, props, function(value, path) {
	        return predicate(value, path[0]);
	      });
	    }
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length;
	
	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        length = 1;
	        object = undefined;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[toKey(path[index])];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }
	
	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }
	
	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }
	
	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);
	
	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object),
	          isArrLike = isArr || isBuffer(object) || isTypedArray(object);
	
	      iteratee = getIteratee(iteratee, 4);
	      if (accumulator == null) {
	        var Ctor = object && object.constructor;
	        if (isArrLike) {
	          accumulator = isArr ? new Ctor : [];
	        }
	        else if (isObject(object)) {
	          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	        }
	        else {
	          accumulator = {};
	        }
	      }
	      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }
	
	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }
	
	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }
	
	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object == null ? [] : baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toFinite(start);
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toFinite(end);
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }
	
	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toFinite(lower);
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toFinite(upper);
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });
	
	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }
	
	    /**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);
	
	      var end = position;
	      position -= target.length;
	      return position >= 0 && string.slice(position, end) == target;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }
	
	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);
	
	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }
	
	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined;
	      }
	      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (!separator && hasUnicode(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return string.split(separator, limit);
	    }
	
	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = position == null
	        ? 0
	        : baseClamp(toInteger(position), 0, string.length);
	
	      target = baseToString(target);
	      return string.slice(position, position + target.length) == target;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, customDefaultsAssignIn);
	
	      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      var sourceURL = '//# sourceURL=' +
	        ('sourceURL' in options
	          ? options.sourceURL
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }
	
	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrim, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	      return castSlice(strSymbols, start, end).join('');
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimEnd, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
	
	      return castSlice(strSymbols, 0, end).join('');
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));
	
	      return castSlice(strSymbols, start).join('');
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);
	
	      var strLength = string.length;
	      if (hasUnicode(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);
	
	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });
	
	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;
	
	      if (pattern === undefined) {
	        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	      }
	      return string.match(pattern) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = baseRest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = flatRest(function(object, methodNames) {
	      arrayEach(methodNames, function(key) {
	        key = toKey(key);
	        baseAssignValue(object, key, bind(object[key], object));
	      });
	      return object;
	    });
	
	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs == null ? 0 : pairs.length,
	          toIteratee = getIteratee();
	
	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });
	
	      return baseRest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }
	
	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */
	    function defaultTo(value, defaultValue) {
	      return (value == null || value !== value) ? defaultValue : value;
	    }
	
	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = baseRest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = baseRest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);
	
	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);
	
	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);
	
	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });
	
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }
	
	    /**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return baseRest(function(args) {
	        return baseNth(args, n);
	      });
	    }
	
	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);
	
	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);
	
	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overSome = createOver(arraySome);
	
	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();
	
	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);
	
	    /**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }
	
	    /**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }
	
	    /**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }
	
	    /**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }
	
	    /**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }
	
	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;
	
	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    }, 0);
	
	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    }, 1);
	
	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
	        : undefined;
	    }
	
	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }
	
	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
	        : undefined;
	    }
	
	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    }, 1);
	
	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    }, 0);
	
	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }
	
	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee, 2))
	        : 0;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;
	
	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.conformsTo = conformsTo;
	    lodash.deburr = deburr;
	    lodash.defaultTo = defaultTo;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;
	
	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
	
	        var result = (this.__filtered__ && !index)
	          ? new LazyWrapper(this)
	          : this.clone();
	
	        if (result.__filtered__) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };
	
	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };
	
	    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });
	
	    LazyWrapper.prototype.reject = function(predicate) {
	      return this.filter(negate(getIteratee(predicate)));
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;
	
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });
	
	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });
	
	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = (lodashFunc.name + ''),
	            names = realNames[key] || (realNames[key] = []);
	
	        names.push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];
	
	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add lazy aliases.
	    lodash.prototype.first = lodash.prototype.head;
	
	    if (symIterator) {
	      lodash.prototype[symIterator] = wrapperToIterator;
	    }
	    return lodash;
	  });
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers, like r.js, check for condition patterns like:
	  if (true) {
	    // Expose Lodash on the global object to prevent errors when Lodash is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    // Use `_.noConflict` to remove Lodash from the global object.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds it.
	  else if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(191)(module)))

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(13);
	var Danger = __webpack_require__(119);
	var ReactDOMComponentTree = __webpack_require__(5);
	var ReactInstrumentation = __webpack_require__(8);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(42);
	var setInnerHTML = __webpack_require__(29);
	var setTextContent = __webpack_require__(74);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation({
	      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
	      type: 'replace text',
	      payload: stringText
	    });
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: prevInstance._debugID,
	        type: 'replace with',
	        payload: markup.toString()
	      });
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: nextInstance._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case 'INSERT_MARKUP':
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'insert child',
	              payload: { toIndex: update.toIndex, content: update.content.toString() }
	            });
	          }
	          break;
	        case 'MOVE_EXISTING':
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'move child',
	              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
	            });
	          }
	          break;
	        case 'SET_MARKUP':
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace children',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'TEXT_CONTENT':
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace text',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'REMOVE_NODE':
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'remove child',
	              payload: { fromIndex: update.fromIndex }
	            });
	          }
	          break;
	      }
	    }
	  }
	
	};
	
	module.exports = DOMChildrenOperations;

/***/ },
/* 34 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var invariant = __webpack_require__(1);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var eventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!eventPluginOrder) {
	    // Wait until an `eventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var pluginModule = namesToPlugins[pluginName];
	    var pluginIndex = eventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
	    var publishedEvents = pluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, pluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	  // Trust the developer to only use possibleRegistrationNames in __DEV__
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (injectedEventPluginOrder) {
	    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var pluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = pluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    if (dispatchConfig.phasedRegistrationNames !== undefined) {
	      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
	      // that it is not undefined.
	      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	
	      for (var phase in phasedRegistrationNames) {
	        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
	          continue;
	        }
	        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
	        if (pluginModule) {
	          return pluginModule;
	        }
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    eventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	
	};
	
	module.exports = EventPluginRegistry;

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var ReactErrorUtils = __webpack_require__(40);
	
	var invariant = __webpack_require__(1);
	var warning = __webpack_require__(2);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	function isEndish(topLevelType) {
	  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
	}
	function isStartish(topLevelType) {
	  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ },
/* 37 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var React = __webpack_require__(16);
	var ReactPropTypesSecret = __webpack_require__(148);
	
	var invariant = __webpack_require__(1);
	var warning = __webpack_require__(2);
	
	var hasReadOnlyValue = {
	  'button': true,
	  'checkbox': true,
	  'image': true,
	  'hidden': true,
	  'radio': true,
	  'reset': true,
	  'submit': true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: React.PropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var invariant = __webpack_require__(1);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	
	};
	
	module.exports = ReactComponentEnvironment;

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a) {
	  try {
	    func(a);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
	      var boundFunc = func.bind(null, a);
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      // $FlowFixMe https://github.com/facebook/flow/issues/2336
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var ReactCurrentOwner = __webpack_require__(11);
	var ReactInstanceMap = __webpack_require__(22);
	var ReactInstrumentation = __webpack_require__(8);
	var ReactUpdates = __webpack_require__(9);
	
	var invariant = __webpack_require__(1);
	var warning = __webpack_require__(2);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + 'within `render` or another component\'s constructor). Render methods ' + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	
	};
	
	module.exports = ReactUpdateQueue;

/***/ },
/* 42 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ },
/* 43 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ },
/* 44 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  'Alt': 'altKey',
	  'Control': 'ctrlKey',
	  'Meta': 'metaKey',
	  'Shift': 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ },
/* 45 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(6);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ },
/* 47 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var emptyFunction = __webpack_require__(7);
	var warning = __webpack_require__(2);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	
	      case 'pre':
	      case 'listing':
	
	      case 'table':
	
	      case 'hr':
	
	      case 'xmp':
	
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    if (childText != null) {
	      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
	      childTag = '#text';
	    }
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      var whitespaceInfo = '';
	      if (childTag === '#text') {
	        if (/\S/.test(childText)) {
	          tagDisplayName = 'Text nodes';
	        } else {
	          tagDisplayName = 'Whitespace text nodes';
	          whitespaceInfo = ' Make sure you don\'t have any extra whitespace between tags on ' + 'each line of your source code.';
	        }
	      } else {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(18);
	
	var ReactNoopUpdateQueue = __webpack_require__(50);
	
	var canDefineProperty = __webpack_require__(79);
	var emptyObject = __webpack_require__(19);
	var invariant = __webpack_require__(1);
	var warning = __webpack_require__(2);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          process.env.NODE_ENV !== 'production' ? warning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]) : void 0;
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	module.exports = ReactComponent;

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(2);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(7);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ },
/* 52 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ },
/* 53 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 */
	function getActiveElement() /*?DOMElement*/{
	  if (typeof document === 'undefined') {
	    return null;
	  }
	  try {
	    return document.activeElement || document.body;
	  } catch (e) {
	    return document.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ },
/* 54 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(81);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  })
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ },
/* 56 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridColumn: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PooledClass = __webpack_require__(12);
	
	var invariant = __webpack_require__(1);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	
	var CallbackQueue = function () {
	  function CallbackQueue(arg) {
	    _classCallCheck(this, CallbackQueue);
	
	    this._callbacks = null;
	    this._contexts = null;
	    this._arg = arg;
	  }
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._callbacks.push(callback);
	    this._contexts = this._contexts || [];
	    this._contexts.push(context);
	  };
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.notifyAll = function notifyAll() {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    var arg = this._arg;
	    if (callbacks && contexts) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i], arg);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  };
	
	  CallbackQueue.prototype.checkpoint = function checkpoint() {
	    return this._callbacks ? this._callbacks.length : 0;
	  };
	
	  CallbackQueue.prototype.rollback = function rollback(len) {
	    if (this._callbacks && this._contexts) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  };
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.reset = function reset() {
	    this._callbacks = null;
	    this._contexts = null;
	  };
	
	  /**
	   * `PooledClass` looks for this.
	   */
	
	
	  CallbackQueue.prototype.destructor = function destructor() {
	    this.reset();
	  };
	
	  return CallbackQueue;
	}();
	
	module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(14);
	var ReactDOMComponentTree = __webpack_require__(5);
	var ReactInstrumentation = __webpack_require__(8);
	
	var quoteAttributeValueForBrowser = __webpack_require__(176);
	var warning = __webpack_require__(2);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  }
	
	};
	
	module.exports = DOMPropertyOperations;

/***/ },
/* 59 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var LinkedValueUtils = __webpack_require__(38);
	var ReactDOMComponentTree = __webpack_require__(5);
	var ReactUpdates = __webpack_require__(9);
	
	var warning = __webpack_require__(2);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    var isArray = Array.isArray(props[propName]);
	    if (props.multiple && !isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else if (!props.multiple && isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ },
/* 61 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ },
/* 62 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var invariant = __webpack_require__(1);
	
	var genericComponentClass = null;
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(135);
	
	var containsNode = __webpack_require__(99);
	var focusNode = __webpack_require__(52);
	var getActiveElement = __webpack_require__(53);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var DOMLazyTree = __webpack_require__(13);
	var DOMProperty = __webpack_require__(14);
	var React = __webpack_require__(16);
	var ReactBrowserEventEmitter = __webpack_require__(25);
	var ReactCurrentOwner = __webpack_require__(11);
	var ReactDOMComponentTree = __webpack_require__(5);
	var ReactDOMContainerInfo = __webpack_require__(129);
	var ReactDOMFeatureFlags = __webpack_require__(131);
	var ReactFeatureFlags = __webpack_require__(62);
	var ReactInstanceMap = __webpack_require__(22);
	var ReactInstrumentation = __webpack_require__(8);
	var ReactMarkupChecksum = __webpack_require__(145);
	var ReactReconciler = __webpack_require__(15);
	var ReactUpdateQueue = __webpack_require__(41);
	var ReactUpdates = __webpack_require__(9);
	
	var emptyObject = __webpack_require__(19);
	var instantiateReactComponent = __webpack_require__(72);
	var invariant = __webpack_require__(1);
	var setInnerHTML = __webpack_require__(29);
	var shouldUpdateReactComponent = __webpack_require__(47);
	var warning = __webpack_require__(2);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props.child;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
	  );
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	/**
	 * True if the supplied DOM node is a React DOM element and
	 * it has been rendered by another copy of React.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM has been rendered by another copy of React
	 * @internal
	 */
	function nodeIsRenderedByOtherInstance(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
	}
	
	/**
	 * True if the supplied DOM node is a valid node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid DOM node.
	 * @internal
	 */
	function isValidContainer(node) {
	  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
	}
	
	/**
	 * True if the supplied DOM node is a valid React node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid React DOM node.
	 * @internal
	 */
	function isReactNode(node) {
	  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  return this.props.child;
	};
	TopLevelWrapper.isReactTopLevelWrapper = true;
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by hooks!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' :
	    // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = React.createElement(TopLevelWrapper, { child: nextElement });
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props.child;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by another copy of React.') : void 0;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: hostNode._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var React = __webpack_require__(16);
	
	var invariant = __webpack_require__(1);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (React.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ },
/* 67 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	
	};
	
	module.exports = ViewportMetrics;

/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var invariant = __webpack_require__(1);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ },
/* 69 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(66);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(6);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3),
	    _assign = __webpack_require__(4);
	
	var ReactCompositeComponent = __webpack_require__(126);
	var ReactEmptyComponent = __webpack_require__(61);
	var ReactHostComponent = __webpack_require__(63);
	
	var getNextDebugID = __webpack_require__(173);
	var invariant = __webpack_require__(1);
	var warning = __webpack_require__(2);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    var type = element.type;
	    if (typeof type !== 'function' && typeof type !== 'string') {
	      var info = '';
	      if (false) {
	        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	          info += ' You likely forgot to export your component from the file ' + 'it\'s defined in.';
	        }
	      }
	      info += getDeclarationErrorAddendum(element._owner);
	       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
	    }
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	module.exports = instantiateReactComponent;

/***/ },
/* 73 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  'color': true,
	  'date': true,
	  'datetime': true,
	  'datetime-local': true,
	  'email': true,
	  'month': true,
	  'number': true,
	  'password': true,
	  'range': true,
	  'search': true,
	  'tel': true,
	  'text': true,
	  'time': true,
	  'url': true,
	  'week': true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(6);
	var escapeTextContentForBrowser = __webpack_require__(28);
	var setInnerHTML = __webpack_require__(29);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      if (node.nodeType === 3) {
	        node.nodeValue = text;
	        return;
	      }
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var ReactCurrentOwner = __webpack_require__(11);
	var REACT_ELEMENT_TYPE = __webpack_require__(141);
	
	var getIteratorFn = __webpack_require__(172);
	var invariant = __webpack_require__(1);
	var KeyEscapeUtils = __webpack_require__(37);
	var warning = __webpack_require__(2);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(18);
	
	var ReactCurrentOwner = __webpack_require__(11);
	
	var invariant = __webpack_require__(1);
	var warning = __webpack_require__(2);
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty)
	  // Strip regex characters so we can use it for regex
	  .replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  // Remove hasOwnProperty from the template to make it generic
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	var setItem;
	var getItem;
	var removeItem;
	var getItemIDs;
	var addRoot;
	var removeRoot;
	var getRootIDs;
	
	if (canUseCollections) {
	  var itemMap = new Map();
	  var rootIDSet = new Set();
	
	  setItem = function (id, item) {
	    itemMap.set(id, item);
	  };
	  getItem = function (id) {
	    return itemMap.get(id);
	  };
	  removeItem = function (id) {
	    itemMap['delete'](id);
	  };
	  getItemIDs = function () {
	    return Array.from(itemMap.keys());
	  };
	
	  addRoot = function (id) {
	    rootIDSet.add(id);
	  };
	  removeRoot = function (id) {
	    rootIDSet['delete'](id);
	  };
	  getRootIDs = function () {
	    return Array.from(rootIDSet.keys());
	  };
	} else {
	  var itemByKey = {};
	  var rootByKey = {};
	
	  // Use non-numeric keys to prevent V8 performance issues:
	  // https://github.com/facebook/react/pull/7232
	  var getKeyFromID = function (id) {
	    return '.' + id;
	  };
	  var getIDFromKey = function (key) {
	    return parseInt(key.substr(1), 10);
	  };
	
	  setItem = function (id, item) {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  };
	  getItem = function (id) {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  };
	  removeItem = function (id) {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  };
	  getItemIDs = function () {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  };
	
	  addRoot = function (id) {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  };
	  removeRoot = function (id) {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  };
	  getRootIDs = function () {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  };
	}
	
	var unmountedIDs = [];
	
	function purgeDeep(id) {
	  var item = getItem(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    removeItem(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function (id, nextChildIDs) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = getItem(nextChildID);
	      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent id is missing.
	      }
	      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function (id, element, parentID) {
	    var item = {
	      element: element,
	      parentID: parentID,
	      text: null,
	      childIDs: [],
	      isMounted: false,
	      updateCount: 0
	    };
	    setItem(id, item);
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function (id) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function (id) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function (id) {
	    var item = getItem(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function (id) {
	    var item = getItem(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var name = getDisplayName(topElement);
	      var owner = topElement._owner;
	      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = getItem(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return getDisplayName(element);
	  },
	  getElement: function (id) {
	    var item = getItem(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function (id) {
	    var item = getItem(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = getItem(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function (id) {
	    var item = getItem(id);
	    return item ? item.updateCount : 0;
	  },
	
	
	  getRootIDs: getRootIDs,
	  getRegisteredIDs: getItemIDs
	};
	
	module.exports = ReactComponentTreeHook;

/***/ },
/* 77 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypeLocationNames = {};
	
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	}
	
	module.exports = ReactPropTypeLocationNames;

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ },
/* 80 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },
/* 81 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(24);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _logo = __webpack_require__(109);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	var _FrankfurtMap = __webpack_require__(85);
	
	var _FrankfurtMap2 = _interopRequireDefault(_FrankfurtMap);
	
	var _DataSetList = __webpack_require__(83);
	
	var _DataSetList2 = _interopRequireDefault(_DataSetList);
	
	var _DistrictInfo = __webpack_require__(84);
	
	var _DistrictInfo2 = _interopRequireDefault(_DistrictInfo);
	
	__webpack_require__(94);
	
	var _lodash = __webpack_require__(32);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _stadtteilprofileBauenWohnen = __webpack_require__(91);
	
	var _bevolkerungsstruktur = __webpack_require__(90);
	
	var _stv2016stadtteile = __webpack_require__(92);
	
	var _districtsInfo = __webpack_require__(87);
	
	var _districtsInfo2 = _interopRequireDefault(_districtsInfo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var dataSets = [(0, _stadtteilprofileBauenWohnen.populationDensity)(),
	//populationDensityDiff(),
	(0, _stadtteilprofileBauenWohnen.spacePerApartment)(), (0, _stadtteilprofileBauenWohnen.newBuildings)(),
	//newBuildingsDiff(),
	(0, _bevolkerungsstruktur.foreigners)(), (0, _bevolkerungsstruktur.averageAge)(), (0, _bevolkerungsstruktur.women)(), (0, _bevolkerungsstruktur.nationalitiesCount)(), (0, _stv2016stadtteile.cdu)(), (0, _stv2016stadtteile.spd)(), (0, _stv2016stadtteile.afd)()];
	
	var App = function (_Component) {
	  _inherits(App, _Component);
	
	  function App() {
	    _classCallCheck(this, App);
	
	    var _this = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this));
	
	    _this.state = {
	      selectedDataSetId: 'Bauen und Wohnen Einwohnerdichte je ha  2012',
	      selectedDistrictId: null
	    };
	    return _this;
	  }
	
	  _createClass(App, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var selectedDataSet = _lodash2.default.find(dataSets, function (dataSet) {
	        return dataSet.id === _this2.state.selectedDataSetId;
	      }) || {};
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_FrankfurtMap2.default, {
	          data: selectedDataSet.data,
	          onDistrictIdSelect: function onDistrictIdSelect(districtId) {
	            return _this2.setState({ selectedDistrictId: districtId });
	          }
	        }),
	        this.state.selectedDistrictId && _react2.default.createElement(_DistrictInfo2.default, {
	          districtId: this.state.selectedDistrictId,
	          districtInfo: _districtsInfo2.default[this.state.selectedDistrictId],
	          dataSetName: selectedDataSet.name,
	          dataSetValue: selectedDataSet.data[this.state.selectedDistrictId]
	        }),
	        _react2.default.createElement(_DataSetList2.default, {
	          selectedDataSetId: this.state.selectedDataSetId,
	          onSelectedDataSetIdSelect: function onSelectedDataSetIdSelect(dataSetId) {
	            return _this2.setState({ selectedDataSetId: dataSetId });
	          },
	          dataSets: dataSets
	        })
	      );
	    }
	  }]);
	
	  return App;
	}(_react.Component);
	
	exports.default = App;

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(24);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DataSetList = function DataSetList(_ref) {
	  var selectedDataSetId = _ref.selectedDataSetId,
	      onSelectedDataSetIdSelect = _ref.onSelectedDataSetIdSelect,
	      _ref$dataSets = _ref.dataSets,
	      dataSets = _ref$dataSets === undefined ? [] : _ref$dataSets;
	
	  return _react2.default.createElement(
	    "ul",
	    { className: "chooses" },
	    dataSets.map(function (dataSet) {
	      return _react2.default.createElement(
	        "li",
	        { key: dataSet.id },
	        _react2.default.createElement(
	          "a",
	          {
	            href: "javascript:;",
	            onClick: function onClick() {
	              return onSelectedDataSetIdSelect(dataSet.id);
	            },
	            className: selectedDataSetId === dataSet.id && 'active'
	          },
	          dataSet.name
	        )
	      );
	    })
	  );
	};
	
	exports.default = DataSetList;

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(24);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(32);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DistrictInfo = function DistrictInfo(_ref) {
	  var districtId = _ref.districtId,
	      _ref$districtInfo = _ref.districtInfo,
	      districtInfo = _ref$districtInfo === undefined ? {} : _ref$districtInfo,
	      dataSetName = _ref.dataSetName,
	      dataSetValue = _ref.dataSetValue;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'info' },
	    _react2.default.createElement(
	      'div',
	      { className: 'districtname' },
	      districtId
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'text' },
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          dataSetName
	        ),
	        ': ',
	        dataSetValue ? dataSetValue : 'no data',
	        ' ',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('br', null),
	        _lodash2.default.get(districtInfo, 'description'),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('br', null),
	        districtInfo.rentUrl && _react2.default.createElement(
	          'a',
	          { target: '_blank', href: districtInfo.rentUrl },
	          'Search flats in ',
	          districtId
	        )
	      )
	    )
	  );
	};
	
	exports.default = DistrictInfo;

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(24);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(110);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _lodash = __webpack_require__(32);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	__webpack_require__(95);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var COLOR = '#661ecb';
	
	var FrankfurtMap = function (_Component) {
	  _inherits(FrankfurtMap, _Component);
	
	  function FrankfurtMap() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, FrankfurtMap);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FrankfurtMap.__proto__ || Object.getPrototypeOf(FrankfurtMap)).call.apply(_ref, [this].concat(args))), _this), _this.colorDistricts = function () {
	      var data = _this.props.data;
	
	      var max = _lodash2.default.max(_lodash2.default.values(data).filter(function (d) {
	        return d;
	      }));
	      var min = _lodash2.default.min(_lodash2.default.values(data).filter(function (d) {
	        return d;
	      }));
	      console.log(min, max);
	      (0, _jquery2.default)('#map .district').map(function (i, el) {
	        var value = data[el.id];
	        if (value) {
	          var opacity = (value - min) / (max - min);
	          el.style.opacity = opacity;
	          el.setAttribute('fill', COLOR);
	          //console.log(el.id);
	          //console.log(value);
	          //console.log(opacity);
	        } else {
	          el.style.opacity = 1;
	          el.setAttribute('fill', '#ccc');
	        }
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(FrankfurtMap, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var onDistrictIdSelect = this.props.onDistrictIdSelect;
	
	
	      (0, _jquery2.default)('#map .district').map(function (i, el) {
	        el.onclick = function () {
	          return onDistrictIdSelect(el.id);
	        };
	      });
	      this.colorDistricts();
	      //document.getElementsByClassName("district").map(el => {
	      //  console.log(2)
	      //
	      //})
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(nextProps) {
	      this.colorDistricts();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement('div', null);
	    }
	  }]);
	
	  return FrankfurtMap;
	}(_react.Component);
	
	exports.default = FrankfurtMap;

/***/ },
/* 86 */
/***/ function(module, exports) {

	"use strict";Object.defineProperty(exports,"__esModule",{value:true});exports.default=[{"Codes":"1","Stadtteil":"Altstadt","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011":"3541","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012":"3601","Bevölkerungsstruktur Frauen in %  2011":"50,1","Bevölkerungsstruktur Frauen in %  2012":"49,8","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011":"1,1","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012":"4,4","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011":"3,9","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012":"5,2","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011":"1848","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012":"1621","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011":"479","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012":"726","Bevölkerungsstruktur Ausländerinnen und Ausländer  2011":"1214","Bevölkerungsstruktur Ausländerinnen und Ausländer  2012":"1254","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011":"34,3","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012":"34,8","Bevölkerungsstruktur Durchschnittsalter  2011":"43,4","Bevölkerungsstruktur Durchschnittsalter  2012":"43,4","Bevölkerungsstruktur Jugendquotient  2011":"16,2","Bevölkerungsstruktur Jugendquotient  2012":"15,8","Bevölkerungsstruktur Altenquotient  2011":"23,9","Bevölkerungsstruktur Altenquotient  2012":"23,7","Bevölkerungsstruktur Kinder bis 5 Jahre  2011":"150","Bevölkerungsstruktur Kinder bis 5 Jahre  2012":"149","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011":"46,0","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012":"47,0","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011":"88","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012":"22","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011":"29","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012":"90","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011":"33","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012":"37","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011":"136","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012":"139","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011":"42,6","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012":"41,7","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011":"58","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012":"19","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011":"35","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012":"81","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011":"43","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012":"39","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011":"72","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012":"74","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011":"44,4","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012":"48,6","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011":"19","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012":"16","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011":"30","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012":"32","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011":"23","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012":"26","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011":"634","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012":"647","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011":"54,9","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012":"54,9","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011":"265","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012":"257","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011":"93","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012":"110","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011":"276","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012":"280","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011":"1945","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012":"1981","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011":"46,4","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012":"46,2","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011":"942","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012":"894","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011":"271","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012":"326","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011":"732","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012":"761","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011":"604","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012":"611","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011":"60,1","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012":"58,6","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011":"476","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012":"413","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011":"21","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012":"87","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011":"107","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012":"111","Bevölkerungsstruktur Ausländerinnen in %  2011":"51,0","Bevölkerungsstruktur Ausländerinnen in %  2012":"51,0","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011":"470","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012":"469","Bevölkerungsstruktur EU-Ausländerinnen in %  2011":"48,1","Bevölkerungsstruktur EU-Ausländerinnen in %  2012":"49,3","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011":"51,4","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012":"48,3","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011":"112","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012":"184","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011":"49,1","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012":"51,1","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011":"851","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012":"836","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011":"65","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012":"71","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011":"64","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012":"70","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011":"230","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012":"272","Bevölkerungsstruktur Staatenlose  2011":"4","Bevölkerungsstruktur Staatenlose  2012":"5","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011":"84","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012":"86","Bevölkerungsstruktur Bosnierinnen und Bosnier  2011":"19","Bevölkerungsstruktur Bosnierinnen und Bosnier  2012":"20","Bevölkerungsstruktur Griechinnen und Griechen  2011":"36","Bevölkerungsstruktur Griechinnen und Griechen  2012":"38","Bevölkerungsstruktur Italienerinnen und Italiener  2011":"109","Bevölkerungsstruktur Italienerinnen und Italiener  2012":"111","Bevölkerungsstruktur Kroatinnen und Kroaten  2011":"95","Bevölkerungsstruktur Kroatinnen und Kroaten  2012":"101","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011":"24","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012":"26","Bevölkerungsstruktur Polinnen und Polen  2011":"76","Bevölkerungsstruktur Polinnen und Polen  2012":"75","Bevölkerungsstruktur Rumäninnen und Rumänen  2011":"13","Bevölkerungsstruktur Rumäninnen und Rumänen  2012":"9","Bevölkerungsstruktur Serbierinnen und Serbier  2011":"84","Bevölkerungsstruktur Serbierinnen und Serbier  2012":"72","Bevölkerungsstruktur Spanierinnen und Spanier  2011":"37","Bevölkerungsstruktur Spanierinnen und Spanier  2012":"34","Bevölkerungsstruktur Türkinnen und Türken  2011":"131","Bevölkerungsstruktur Türkinnen und Türken  2012":"124","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011":"7","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012":"12","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011":"2","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012":"12","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011":"37","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012":"48","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011":"17","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012":"18","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011":"32","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012":"37","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011":"46","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012":"71","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011":"18","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012":"23","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011":"13","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012":"17","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011":"30","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012":"28","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011":"48","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012":"85","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011":"928","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012":"971","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011":"394","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012":"407","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011":"513","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012":"536","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011":"21","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012":"28","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011":"1461","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012":"1457","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011":"137","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012":"131","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011":"785","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012":"788","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011":"539","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012":"538","":""},{"Codes":"2","Stadtteil":"Innenstadt","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011":"6232","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012":"6334","Bevölkerungsstruktur Frauen in %  2011":"46,3","Bevölkerungsstruktur Frauen in %  2012":"46,8","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011":"-0,6","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012":"0,9","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011":"1,9","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012":"4,0","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011":"2791","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012":"2460","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011":"746","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012":"1135","Bevölkerungsstruktur Ausländerinnen und Ausländer  2011":"2695","Bevölkerungsstruktur Ausländerinnen und Ausländer  2012":"2739","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011":"43,2","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012":"43,2","Bevölkerungsstruktur Durchschnittsalter  2011":"41,8","Bevölkerungsstruktur Durchschnittsalter  2012":"41,6","Bevölkerungsstruktur Jugendquotient  2011":"14,4","Bevölkerungsstruktur Jugendquotient  2012":"13,5","Bevölkerungsstruktur Altenquotient  2011":"19,8","Bevölkerungsstruktur Altenquotient  2012":"19,3","Bevölkerungsstruktur Kinder bis 5 Jahre  2011":"244","Bevölkerungsstruktur Kinder bis 5 Jahre  2012":"223","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011":"47,5","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012":"47,1","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011":"110","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012":"33","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011":"55","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012":"124","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011":"79","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012":"66","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011":"206","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012":"225","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011":"48,5","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012":"52,0","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011":"64","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012":"22","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011":"60","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012":"116","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011":"82","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012":"87","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011":"117","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012":"119","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011":"47,9","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012":"43,7","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011":"33","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012":"21","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011":"28","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012":"43","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011":"56","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012":"55","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011":"1428","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012":"1415","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011":"49,4","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012":"50,4","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011":"663","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012":"649","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011":"154","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012":"199","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011":"611","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012":"567","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011":"3318","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012":"3433","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011":"40,7","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012":"41,4","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011":"1273","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012":"1194","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011":"407","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012":"512","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011":"1638","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012":"1727","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011":"919","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012":"919","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011":"60,9","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012":"60,5","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011":"648","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012":"541","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011":"42","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012":"141","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011":"229","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012":"237","Bevölkerungsstruktur Ausländerinnen in %  2011":"46,2","Bevölkerungsstruktur Ausländerinnen in %  2012":"46,9","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011":"1022","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012":"1077","Bevölkerungsstruktur EU-Ausländerinnen in %  2011":"40,8","Bevölkerungsstruktur EU-Ausländerinnen in %  2012":"42,0","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011":"43,8","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012":"47,7","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011":"186","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012":"333","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011":"44,6","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012":"50,5","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011":"1915","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012":"1936","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011":"94","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012":"106","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011":"161","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012":"184","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011":"512","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012":"505","Bevölkerungsstruktur Staatenlose  2011":"13","Bevölkerungsstruktur Staatenlose  2012":"8","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011":"98","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012":"109","Bevölkerungsstruktur Bosnierinnen und Bosnier  2011":"64","Bevölkerungsstruktur Bosnierinnen und Bosnier  2012":"60","Bevölkerungsstruktur Griechinnen und Griechen  2011":"60","Bevölkerungsstruktur Griechinnen und Griechen  2012":"81","Bevölkerungsstruktur Italienerinnen und Italiener  2011":"168","Bevölkerungsstruktur Italienerinnen und Italiener  2012":"171","Bevölkerungsstruktur Kroatinnen und Kroaten  2011":"160","Bevölkerungsstruktur Kroatinnen und Kroaten  2012":"141","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011":"26","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012":"30","Bevölkerungsstruktur Polinnen und Polen  2011":"116","Bevölkerungsstruktur Polinnen und Polen  2012":"138","Bevölkerungsstruktur Rumäninnen und Rumänen  2011":"124","Bevölkerungsstruktur Rumäninnen und Rumänen  2012":"149","Bevölkerungsstruktur Serbierinnen und Serbier  2011":"208","Bevölkerungsstruktur Serbierinnen und Serbier  2012":"206","Bevölkerungsstruktur Spanierinnen und Spanier  2011":"83","Bevölkerungsstruktur Spanierinnen und Spanier  2012":"86","Bevölkerungsstruktur Türkinnen und Türken  2011":"349","Bevölkerungsstruktur Türkinnen und Türken  2012":"324","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011":"18","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012":"26","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011":"7","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012":"15","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011":"46","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012":"66","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011":"20","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012":"24","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011":"65","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012":"78","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011":"61","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012":"110","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011":"31","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012":"53","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011":"28","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012":"33","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011":"40","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012":"45","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011":"85","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012":"115","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011":"2342","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012":"2405","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011":"1064","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012":"1075","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011":"1207","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012":"1268","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011":"71","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012":"62","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011":"2000","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012":"2006","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011":"178","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012":"176","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011":"1066","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012":"1073","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011":"756","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012":"757","":""},{"Codes":"3","Stadtteil":"Bahnhofsviertel","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011":"2662","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012":"3117","Bevölkerungsstruktur Frauen in %  2011":"39,3","Bevölkerungsstruktur Frauen in %  2012":"37,7","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011":"1,6","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012":"21,6","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011":"15,4","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012":"25,5","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011":"1079","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012":"1112","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011":"210","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012":"375","Bevölkerungsstruktur Ausländerinnen und Ausländer  2011":"1373","Bevölkerungsstruktur Ausländerinnen und Ausländer  2012":"1630","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011":"51,6","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012":"52,3","Bevölkerungsstruktur Durchschnittsalter  2011":"38,6","Bevölkerungsstruktur Durchschnittsalter  2012":"37,5","Bevölkerungsstruktur Jugendquotient  2011":"10,7","Bevölkerungsstruktur Jugendquotient  2012":"10,8","Bevölkerungsstruktur Altenquotient  2011":"8,7","Bevölkerungsstruktur Altenquotient  2012":"7,9","Bevölkerungsstruktur Kinder bis 5 Jahre  2011":"79","Bevölkerungsstruktur Kinder bis 5 Jahre  2012":"115","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011":"43,0","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012":"51,3","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011":"37","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012":"26","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011":"10","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012":"48","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011":"32","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012":"41","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011":"64","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012":"81","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011":"48,4","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012":"45,7","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011":"17","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012":"10","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011":"20","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012":"34","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011":"27","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012":"37","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011":"43","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012":"45","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011":"51,2","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012":"37,8","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011":"12","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012":"5","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011":"10","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012":"12","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011":"21","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012":"28","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011":"695","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012":"865","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011":"46,3","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012":"42,9","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011":"277","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012":"328","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011":"62","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012":"94","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011":"356","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012":"443","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011":"1586","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012":"1804","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011":"35,2","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012":"33,8","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011":"665","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012":"673","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011":"101","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012":"171","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011":"820","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012":"960","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011":"195","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012":"207","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011":"40,5","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012":"39,6","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011":"71","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012":"70","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011":"7","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012":"16","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011":"117","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012":"121","Bevölkerungsstruktur Ausländerinnen in %  2011":"41,6","Bevölkerungsstruktur Ausländerinnen in %  2012":"38,2","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011":"718","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012":"861","Bevölkerungsstruktur EU-Ausländerinnen in %  2011":"42,5","Bevölkerungsstruktur EU-Ausländerinnen in %  2012":"40,8","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011":"40,5","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012":"39,2","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011":"65","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012":"99","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011":"44,6","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012":"41,4","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011":"956","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012":"1128","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011":"62","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012":"93","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011":"58","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012":"71","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011":"286","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012":"329","Bevölkerungsstruktur Staatenlose  2011":"11","Bevölkerungsstruktur Staatenlose  2012":"9","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011":"92","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012":"98","Bevölkerungsstruktur Bosnierinnen und Bosnier  2011":"8","Bevölkerungsstruktur Bosnierinnen und Bosnier  2012":"13","Bevölkerungsstruktur Griechinnen und Griechen  2011":"134","Bevölkerungsstruktur Griechinnen und Griechen  2012":"117","Bevölkerungsstruktur Italienerinnen und Italiener  2011":"48","Bevölkerungsstruktur Italienerinnen und Italiener  2012":"51","Bevölkerungsstruktur Kroatinnen und Kroaten  2011":"29","Bevölkerungsstruktur Kroatinnen und Kroaten  2012":"33","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011":"24","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012":"32","Bevölkerungsstruktur Polinnen und Polen  2011":"94","Bevölkerungsstruktur Polinnen und Polen  2012":"109","Bevölkerungsstruktur Rumäninnen und Rumänen  2011":"120","Bevölkerungsstruktur Rumäninnen und Rumänen  2012":"138","Bevölkerungsstruktur Serbierinnen und Serbier  2011":"48","Bevölkerungsstruktur Serbierinnen und Serbier  2012":"60","Bevölkerungsstruktur Spanierinnen und Spanier  2011":"37","Bevölkerungsstruktur Spanierinnen und Spanier  2012":"67","Bevölkerungsstruktur Türkinnen und Türken  2011":"126","Bevölkerungsstruktur Türkinnen und Türken  2012":"124","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011":"4","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012":"3","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011":"1","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012":"10","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011":"10","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012":"11","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011":"9","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012":"12","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011":"15","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012":"16","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011":"14","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012":"17","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011":"8","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012":"8","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011":"8","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012":"4","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011":"13","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012":"11","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011":"15","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012":"26","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011":"1368","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012":"1692","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011":"574","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012":"719","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011":"784","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012":"958","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011":"10","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012":"15","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011":"601","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012":"611","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011":"71","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012":"69","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011":"370","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012":"375","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011":"160","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012":"167","":""},{"Codes":"4","Stadtteil":"Westend-Süd","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011":"16733","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012":"17076","Bevölkerungsstruktur Frauen in %  2011":"50,8","Bevölkerungsstruktur Frauen in %  2012":"51,0","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011":"5,9","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012":"6,4","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011":"4,2","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012":"5,8","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011":"11308","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012":"10066","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011":"1590","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012":"2957","Bevölkerungsstruktur Ausländerinnen und Ausländer  2011":"3835","Bevölkerungsstruktur Ausländerinnen und Ausländer  2012":"4053","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011":"22,9","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012":"23,7","Bevölkerungsstruktur Durchschnittsalter  2011":"40,8","Bevölkerungsstruktur Durchschnittsalter  2012":"40,7","Bevölkerungsstruktur Jugendquotient  2011":"21,6","Bevölkerungsstruktur Jugendquotient  2012":"22,3","Bevölkerungsstruktur Altenquotient  2011":"21,8","Bevölkerungsstruktur Altenquotient  2012":"21,9","Bevölkerungsstruktur Kinder bis 5 Jahre  2011":"1123","Bevölkerungsstruktur Kinder bis 5 Jahre  2012":"1197","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011":"49,2","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012":"49,6","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011":"866","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012":"563","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011":"116","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012":"473","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011":"141","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012":"161","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011":"897","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012":"934","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011":"48,0","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012":"49,0","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011":"574","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012":"403","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011":"151","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012":"374","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011":"172","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012":"157","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011":"321","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012":"322","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011":"53,6","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012":"50,9","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011":"175","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012":"132","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011":"67","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012":"114","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011":"79","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012":"76","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011":"2619","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012":"2597","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011":"52,0","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012":"53,6","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011":"1576","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012":"1479","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011":"289","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012":"335","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011":"754","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012":"783","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011":"9233","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012":"9435","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011":"48,9","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012":"48,9","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011":"5988","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012":"5713","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011":"864","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012":"1183","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011":"2381","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012":"2539","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011":"2540","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012":"2591","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011":"57,9","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012":"57,5","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011":"2129","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012":"1776","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011":"103","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012":"478","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011":"308","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012":"337","Bevölkerungsstruktur Ausländerinnen in %  2011":"51,3","Bevölkerungsstruktur Ausländerinnen in %  2012":"51,9","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011":"2162","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012":"2276","Bevölkerungsstruktur EU-Ausländerinnen in %  2011":"48,9","Bevölkerungsstruktur EU-Ausländerinnen in %  2012":"49,7","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011":"52,8","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012":"52,8","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011":"660","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012":"1354","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011":"52,7","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012":"54,3","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011":"2757","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012":"2911","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011":"71","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012":"71","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011":"362","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012":"368","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011":"640","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012":"698","Bevölkerungsstruktur Staatenlose  2011":"5","Bevölkerungsstruktur Staatenlose  2012":"5","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011":"114","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012":"119","Bevölkerungsstruktur Bosnierinnen und Bosnier  2011":"21","Bevölkerungsstruktur Bosnierinnen und Bosnier  2012":"22","Bevölkerungsstruktur Griechinnen und Griechen  2011":"167","Bevölkerungsstruktur Griechinnen und Griechen  2012":"161","Bevölkerungsstruktur Italienerinnen und Italiener  2011":"355","Bevölkerungsstruktur Italienerinnen und Italiener  2012":"375","Bevölkerungsstruktur Kroatinnen und Kroaten  2011":"92","Bevölkerungsstruktur Kroatinnen und Kroaten  2012":"100","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011":"13","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012":"12","Bevölkerungsstruktur Polinnen und Polen  2011":"206","Bevölkerungsstruktur Polinnen und Polen  2012":"237","Bevölkerungsstruktur Rumäninnen und Rumänen  2011":"72","Bevölkerungsstruktur Rumäninnen und Rumänen  2012":"87","Bevölkerungsstruktur Serbierinnen und Serbier  2011":"99","Bevölkerungsstruktur Serbierinnen und Serbier  2012":"103","Bevölkerungsstruktur Spanierinnen und Spanier  2011":"168","Bevölkerungsstruktur Spanierinnen und Spanier  2012":"190","Bevölkerungsstruktur Türkinnen und Türken  2011":"142","Bevölkerungsstruktur Türkinnen und Türken  2012":"149","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011":"10","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012":"27","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011":"6","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012":"16","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011":"112","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012":"150","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011":"61","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012":"104","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011":"20","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012":"26","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011":"134","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012":"308","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011":"100","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012":"170","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011":"37","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012":"24","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011":"129","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012":"168","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011":"76","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012":"154","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011":"5279","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012":"5304","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011":"1920","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012":"1918","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011":"3229","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012":"3256","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011":"130","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012":"130","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011":"5561","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012":"5543","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011":"458","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012":"419","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011":"2887","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012":"2883","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011":"2216","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012":"2241","":""},{"Codes":"5","Stadtteil":"Westend-Nord","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011":"9012","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012":"9083","Bevölkerungsstruktur Frauen in %  2011":"51,7","Bevölkerungsstruktur Frauen in %  2012":"52,0","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011":"20,0","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012":"20,3","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011":"15,9","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012":"12,1","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011":"5525","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012":"4778","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011":"1208","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012":"1993","Bevölkerungsstruktur Ausländerinnen und Ausländer  2011":"2279","Bevölkerungsstruktur Ausländerinnen und Ausländer  2012":"2312","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011":"25,3","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012":"25,5","Bevölkerungsstruktur Durchschnittsalter  2011":"40,2","Bevölkerungsstruktur Durchschnittsalter  2012":"40,0","Bevölkerungsstruktur Jugendquotient  2011":"25,5","Bevölkerungsstruktur Jugendquotient  2012":"26,0","Bevölkerungsstruktur Altenquotient  2011":"22,6","Bevölkerungsstruktur Altenquotient  2012":"22,4","Bevölkerungsstruktur Kinder bis 5 Jahre  2011":"618","Bevölkerungsstruktur Kinder bis 5 Jahre  2012":"626","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011":"50,8","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012":"52,4","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011":"424","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012":"224","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011":"93","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012":"293","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011":"101","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012":"109","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011":"561","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012":"583","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011":"48,5","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012":"46,8","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011":"298","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012":"179","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011":"152","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012":"307","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011":"111","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012":"97","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011":"247","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012":"239","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011":"52,6","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012":"52,3","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011":"99","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012":"52","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011":"58","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012":"104","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011":"90","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012":"83","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011":"1566","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012":"1604","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011":"52,6","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012":"55,0","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011":"859","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012":"821","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011":"236","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012":"287","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011":"471","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012":"496","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011":"4647","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012":"4661","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011":"49,9","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012":"49,9","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011":"2704","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012":"2538","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011":"614","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012":"779","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011":"1329","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012":"1344","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011":"1373","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012":"1370","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011":"58,3","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012":"57,9","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011":"1141","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012":"964","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011":"55","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012":"223","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011":"177","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012":"183","Bevölkerungsstruktur Ausländerinnen in %  2011":"53,0","Bevölkerungsstruktur Ausländerinnen in %  2012":"53,7","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011":"906","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012":"933","Bevölkerungsstruktur EU-Ausländerinnen in %  2011":"52,1","Bevölkerungsstruktur EU-Ausländerinnen in %  2012":"50,6","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011":"52,6","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012":"51,9","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011":"334","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012":"636","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011":"50,6","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012":"52,4","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011":"1566","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012":"1550","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011":"125","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012":"122","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011":"151","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012":"170","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011":"433","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012":"467","Bevölkerungsstruktur Staatenlose  2011":"4","Bevölkerungsstruktur Staatenlose  2012":"3","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011":"108","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012":"103","Bevölkerungsstruktur Bosnierinnen und Bosnier  2011":"64","Bevölkerungsstruktur Bosnierinnen und Bosnier  2012":"57","Bevölkerungsstruktur Griechinnen und Griechen  2011":"73","Bevölkerungsstruktur Griechinnen und Griechen  2012":"74","Bevölkerungsstruktur Italienerinnen und Italiener  2011":"193","Bevölkerungsstruktur Italienerinnen und Italiener  2012":"188","Bevölkerungsstruktur Kroatinnen und Kroaten  2011":"99","Bevölkerungsstruktur Kroatinnen und Kroaten  2012":"94","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011":"55","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012":"58","Bevölkerungsstruktur Polinnen und Polen  2011":"83","Bevölkerungsstruktur Polinnen und Polen  2012":"84","Bevölkerungsstruktur Rumäninnen und Rumänen  2011":"42","Bevölkerungsstruktur Rumäninnen und Rumänen  2012":"42","Bevölkerungsstruktur Serbierinnen und Serbier  2011":"110","Bevölkerungsstruktur Serbierinnen und Serbier  2012":"92","Bevölkerungsstruktur Spanierinnen und Spanier  2011":"79","Bevölkerungsstruktur Spanierinnen und Spanier  2012":"91","Bevölkerungsstruktur Türkinnen und Türken  2011":"240","Bevölkerungsstruktur Türkinnen und Türken  2012":"236","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011":"40","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012":"64","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011":"16","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012":"38","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011":"90","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012":"106","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011":"49","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012":"78","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011":"102","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012":"147","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011":"93","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012":"163","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011":"57","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012":"86","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011":"38","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012":"28","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011":"93","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012":"100","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011":"95","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012":"163","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011":"2456","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012":"2381","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011":"965","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012":"1001","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011":"1389","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012":"1286","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011":"102","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012":"94","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011":"3304","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012":"3298","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011":"357","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012":"362","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011":"1800","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012":"1787","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011":"1147","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012":"1149","":""},{"Codes":"6","Stadtteil":"Nordend-West","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011":"27715","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012":"28262","Bevölkerungsstruktur Frauen in %  2011":"51,7","Bevölkerungsstruktur Frauen in %  2012":"51,7","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011":"4,5","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012":"7,1","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011":"3,2","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012":"6,3","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011":"20063","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012":"18399","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011":"2293","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012":"4316","Bevölkerungsstruktur Ausländerinnen und Ausländer  2011":"5359","Bevölkerungsstruktur Ausländerinnen und Ausländer  2012":"5547","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011":"19,3","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012":"19,6","Bevölkerungsstruktur Durchschnittsalter  2011":"41,4","Bevölkerungsstruktur Durchschnittsalter  2012":"41,2","Bevölkerungsstruktur Jugendquotient  2011":"19,3","Bevölkerungsstruktur Jugendquotient  2012":"19,7","Bevölkerungsstruktur Altenquotient  2011":"20,1","Bevölkerungsstruktur Altenquotient  2012":"20,2","Bevölkerungsstruktur Kinder bis 5 Jahre  2011":"1662","Bevölkerungsstruktur Kinder bis 5 Jahre  2012":"1697","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011":"48,8","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012":"48,7","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011":"1380","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012":"908","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011":"153","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012":"662","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011":"129","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012":"127","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011":"1369","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012":"1466","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011":"48,7","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012":"48,8","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011":"1031","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012":"781","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011":"192","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012":"550","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011":"146","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012":"135","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011":"495","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012":"510","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011":"43,2","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012":"46,7","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011":"349","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012":"291","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011":"70","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012":"140","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011":"76","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012":"79","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011":"4265","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012":"4389","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011":"54,3","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012":"54,3","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011":"2760","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012":"2698","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011":"475","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012":"584","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011":"1030","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012":"1107","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011":"15934","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012":"16113","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011":"49,9","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012":"49,8","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011":"11220","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012":"10771","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011":"1273","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012":"1825","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011":"3441","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012":"3517","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011":"3990","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012":"4087","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011":"59,5","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012":"59,4","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011":"3323","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012":"2950","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011":"130","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012":"555","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011":"537","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012":"582","Bevölkerungsstruktur Ausländerinnen in %  2011":"50,1","Bevölkerungsstruktur Ausländerinnen in %  2012":"49,8","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011":"2680","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012":"2764","Bevölkerungsstruktur EU-Ausländerinnen in %  2011":"48,2","Bevölkerungsstruktur EU-Ausländerinnen in %  2012":"48,3","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011":"53,2","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012":"52,1","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011":"834","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012":"1808","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011":"55,0","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012":"53,1","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011":"4208","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012":"4308","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011":"176","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012":"166","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011":"347","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012":"383","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011":"615","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012":"676","Bevölkerungsstruktur Staatenlose  2011":"13","Bevölkerungsstruktur Staatenlose  2012":"14","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011":"121","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012":"121","Bevölkerungsstruktur Bosnierinnen und Bosnier  2011":"132","Bevölkerungsstruktur Bosnierinnen und Bosnier  2012":"127","Bevölkerungsstruktur Griechinnen und Griechen  2011":"227","Bevölkerungsstruktur Griechinnen und Griechen  2012":"227","Bevölkerungsstruktur Italienerinnen und Italiener  2011":"491","Bevölkerungsstruktur Italienerinnen und Italiener  2012":"504","Bevölkerungsstruktur Kroatinnen und Kroaten  2011":"462","Bevölkerungsstruktur Kroatinnen und Kroaten  2012":"492","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011":"45","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012":"41","Bevölkerungsstruktur Polinnen und Polen  2011":"370","Bevölkerungsstruktur Polinnen und Polen  2012":"338","Bevölkerungsstruktur Rumäninnen und Rumänen  2011":"159","Bevölkerungsstruktur Rumäninnen und Rumänen  2012":"199","Bevölkerungsstruktur Serbierinnen und Serbier  2011":"248","Bevölkerungsstruktur Serbierinnen und Serbier  2012":"243","Bevölkerungsstruktur Spanierinnen und Spanier  2011":"267","Bevölkerungsstruktur Spanierinnen und Spanier  2012":"292","Bevölkerungsstruktur Türkinnen und Türken  2011":"393","Bevölkerungsstruktur Türkinnen und Türken  2012":"381","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011":"22","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012":"40","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011":"26","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012":"51","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011":"150","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012":"195","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011":"116","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012":"198","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011":"78","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012":"87","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011":"196","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012":"415","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011":"122","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012":"195","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011":"99","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012":"83","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011":"152","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012":"195","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011":"163","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012":"291","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011":"7126","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012":"7285","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011":"2708","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012":"2851","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011":"4234","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012":"4249","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011":"184","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012":"185","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011":"11308","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012":"11380","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011":"1084","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012":"1079","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011":"6662","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012":"6665","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011":"3562","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012":"3636","":""},{"Codes":"7","Stadtteil":"Nordend-Ost","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011":"25111","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012":"25410","Bevölkerungsstruktur Frauen in %  2011":"52,0","Bevölkerungsstruktur Frauen in %  2012":"51,7","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011":"2,3","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012":"3,3","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011":"2,4","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012":"4,0","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011":"17427","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012":"16089","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011":"2418","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012":"3962","Bevölkerungsstruktur Ausländerinnen und Ausländer  2011":"5266","Bevölkerungsstruktur Ausländerinnen und Ausländer  2012":"5359","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011":"21,0","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012":"21,1","Bevölkerungsstruktur Durchschnittsalter  2011":"40,7","Bevölkerungsstruktur Durchschnittsalter  2012":"40,7","Bevölkerungsstruktur Jugendquotient  2011":"18,0","Bevölkerungsstruktur Jugendquotient  2012":"18,4","Bevölkerungsstruktur Altenquotient  2011":"16,7","Bevölkerungsstruktur Altenquotient  2012":"16,6","Bevölkerungsstruktur Kinder bis 5 Jahre  2011":"1386","Bevölkerungsstruktur Kinder bis 5 Jahre  2012":"1434","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011":"49,9","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012":"48,9","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011":"1144","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012":"746","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011":"155","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012":"594","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011":"87","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012":"94","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011":"1218","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012":"1246","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011":"48,3","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012":"47,4","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011":"841","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012":"597","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011":"227","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012":"520","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011":"150","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012":"129","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011":"497","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012":"502","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011":"50,5","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012":"49,8","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011":"297","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012":"234","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011":"91","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012":"167","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011":"109","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012":"101","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011":"4054","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012":"4000","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011":"56,3","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012":"56,0","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011":"2607","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012":"2381","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011":"484","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012":"582","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011":"963","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012":"1037","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011":"14835","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012":"15097","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011":"50,1","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012":"50,1","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011":"10196","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012":"10082","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011":"1300","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012":"1664","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011":"3339","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012":"3351","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011":"3121","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012":"3131","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011":"57,7","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012":"57,2","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011":"2342","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012":"2049","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011":"161","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012":"435","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011":"618","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012":"647","Bevölkerungsstruktur Ausländerinnen in %  2011":"50,9","Bevölkerungsstruktur Ausländerinnen in %  2012":"51,1","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011":"2252","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012":"2352","Bevölkerungsstruktur EU-Ausländerinnen in %  2011":"48,8","Bevölkerungsstruktur EU-Ausländerinnen in %  2012":"49,2","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011":"53,3","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012":"52,2","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011":"722","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012":"1404","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011":"55,4","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012":"54,7","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011":"4142","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012":"4209","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011":"189","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012":"182","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011":"317","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012":"321","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011":"608","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012":"637","Bevölkerungsstruktur Staatenlose  2011":"10","Bevölkerungsstruktur Staatenlose  2012":"10","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011":"114","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012":"112","Bevölkerungsstruktur Bosnierinnen und Bosnier  2011":"177","Bevölkerungsstruktur Bosnierinnen und Bosnier  2012":"182","Bevölkerungsstruktur Griechinnen und Griechen  2011":"177","Bevölkerungsstruktur Griechinnen und Griechen  2012":"180","Bevölkerungsstruktur Italienerinnen und Italiener  2011":"471","Bevölkerungsstruktur Italienerinnen und Italiener  2012":"479","Bevölkerungsstruktur Kroatinnen und Kroaten  2011":"527","Bevölkerungsstruktur Kroatinnen und Kroaten  2012":"521","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011":"77","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012":"73","Bevölkerungsstruktur Polinnen und Polen  2011":"264","Bevölkerungsstruktur Polinnen und Polen  2012":"286","Bevölkerungsstruktur Rumäninnen und Rumänen  2011":"114","Bevölkerungsstruktur Rumäninnen und Rumänen  2012":"128","Bevölkerungsstruktur Serbierinnen und Serbier  2011":"290","Bevölkerungsstruktur Serbierinnen und Serbier  2012":"282","Bevölkerungsstruktur Spanierinnen und Spanier  2011":"248","Bevölkerungsstruktur Spanierinnen und Spanier  2012":"284","Bevölkerungsstruktur Türkinnen und Türken  2011":"658","Bevölkerungsstruktur Türkinnen und Türken  2012":"628","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011":"48","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012":"72","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011":"23","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012":"51","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011":"130","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012":"171","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011":"114","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012":"180","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011":"121","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012":"151","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011":"200","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012":"344","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011":"101","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012":"147","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011":"84","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012":"75","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011":"165","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012":"192","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011":"224","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012":"364","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011":"6204","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012":"6239","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011":"2469","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012":"2495","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011":"3637","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012":"3640","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011":"98","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012":"104","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011":"10596","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012":"10605","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011":"1081","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012":"1051","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011":"6654","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012":"6698","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011":"2861","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012":"2856","":""},{"Codes":"8","Stadtteil":"Ostend","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011":"26140","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012":"26540","Bevölkerungsstruktur Frauen in %  2011":"51,6","Bevölkerungsstruktur Frauen in %  2012":"51,3","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011":"0,5","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012":"1,9","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011":"3,5","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012":"4,7","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011":"15681","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012":"14166","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011":"3212","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012":"4983","Bevölkerungsstruktur Ausländerinnen und Ausländer  2011":"7247","Bevölkerungsstruktur Ausländerinnen und Ausländer  2012":"7391","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011":"27,7","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012":"27,8","Bevölkerungsstruktur Durchschnittsalter  2011":"42,5","Bevölkerungsstruktur Durchschnittsalter  2012":"42,5","Bevölkerungsstruktur Jugendquotient  2011":"18,2","Bevölkerungsstruktur Jugendquotient  2012":"18,4","Bevölkerungsstruktur Altenquotient  2011":"23,3","Bevölkerungsstruktur Altenquotient  2012":"23,3","Bevölkerungsstruktur Kinder bis 5 Jahre  2011":"1294","Bevölkerungsstruktur Kinder bis 5 Jahre  2012":"1351","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011":"48,8","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012":"49,7","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011":"906","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012":"534","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011":"262","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012":"678","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011":"126","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012":"139","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011":"1168","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012":"1170","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011":"48,5","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012":"47,2","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011":"655","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012":"379","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011":"319","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012":"616","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011":"194","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012":"175","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011":"561","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012":"574","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011":"45,8","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012":"46,2","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011":"255","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012":"168","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011":"128","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012":"232","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011":"178","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012":"174","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011":"4381","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012":"4401","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011":"53,8","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012":"54,1","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011":"2328","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012":"2245","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011":"612","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012":"693","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011":"1441","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012":"1463","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011":"14433","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012":"14688","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011":"48,7","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012":"48,4","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011":"8298","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012":"8031","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011":"1661","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012":"2096","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011":"4474","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012":"4561","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011":"4303","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012":"4356","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011":"61,2","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012":"60,7","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011":"3239","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012":"2809","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011":"230","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012":"668","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011":"834","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012":"879","Bevölkerungsstruktur Ausländerinnen in %  2011":"49,2","Bevölkerungsstruktur Ausländerinnen in %  2012":"48,6","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011":"2536","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012":"2677","Bevölkerungsstruktur EU-Ausländerinnen in %  2011":"48,5","Bevölkerungsstruktur EU-Ausländerinnen in %  2012":"47,4","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011":"50,2","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012":"50,8","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011":"802","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012":"1513","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011":"52,2","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012":"53,9","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011":"5730","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012":"5877","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011":"360","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012":"358","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011":"308","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012":"311","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011":"823","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012":"817","Bevölkerungsstruktur Staatenlose  2011":"26","Bevölkerungsstruktur Staatenlose  2012":"28","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011":"116","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012":"118","Bevölkerungsstruktur Bosnierinnen und Bosnier  2011":"250","Bevölkerungsstruktur Bosnierinnen und Bosnier  2012":"253","Bevölkerungsstruktur Griechinnen und Griechen  2011":"221","Bevölkerungsstruktur Griechinnen und Griechen  2012":"220","Bevölkerungsstruktur Italienerinnen und Italiener  2011":"451","Bevölkerungsstruktur Italienerinnen und Italiener  2012":"458","Bevölkerungsstruktur Kroatinnen und Kroaten  2011":"734","Bevölkerungsstruktur Kroatinnen und Kroaten  2012":"764","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011":"172","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012":"155","Bevölkerungsstruktur Polinnen und Polen  2011":"372","Bevölkerungsstruktur Polinnen und Polen  2012":"404","Bevölkerungsstruktur Rumäninnen und Rumänen  2011":"260","Bevölkerungsstruktur Rumäninnen und Rumänen  2012":"328","Bevölkerungsstruktur Serbierinnen und Serbier  2011":"628","Bevölkerungsstruktur Serbierinnen und Serbier  2012":"613","Bevölkerungsstruktur Spanierinnen und Spanier  2011":"211","Bevölkerungsstruktur Spanierinnen und Spanier  2012":"236","Bevölkerungsstruktur Türkinnen und Türken  2011":"1159","Bevölkerungsstruktur Türkinnen und Türken  2012":"1146","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011":"69","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012":"89","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011":"56","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012":"124","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011":"164","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012":"191","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011":"92","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012":"133","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011":"242","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012":"290","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011":"252","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012":"460","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011":"119","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012":"200","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011":"129","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012":"115","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011":"286","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012":"298","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011":"347","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012":"584","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011":"6592","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012":"6630","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011":"2659","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012":"2650","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011":"3738","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012":"3769","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011":"195","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012":"211","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011":"11217","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012":"11303","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011":"1130","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012":"1147","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011":"6279","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012":"6320","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011":"3808","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012":"3836","":""},{"Codes":"9","Stadtteil":"Bornheim","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011":"26130","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012":"26105","Bevölkerungsstruktur Frauen in %  2011":"53,1","Bevölkerungsstruktur Frauen in %  2012":"53,2","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011":"6,4","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012":"6,9","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011":"6,5","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012":"4,6","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011":"17158","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012":"15413","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011":"3041","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012":"4758","Bevölkerungsstruktur Ausländerinnen und Ausländer  2011":"5931","Bevölkerungsstruktur Ausländerinnen und Ausländer  2012":"5934","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011":"22,7","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012":"22,7","Bevölkerungsstruktur Durchschnittsalter  2011":"43,0","Bevölkerungsstruktur Durchschnittsalter  2012":"43,2","Bevölkerungsstruktur Jugendquotient  2011":"20,9","Bevölkerungsstruktur Jugendquotient  2012":"20,7","Bevölkerungsstruktur Altenquotient  2011":"26,5","Bevölkerungsstruktur Altenquotient  2012":"26,8","Bevölkerungsstruktur Kinder bis 5 Jahre  2011":"1452","Bevölkerungsstruktur Kinder bis 5 Jahre  2012":"1421","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011":"49,8","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012":"51,9","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011":"1060","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012":"541","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011":"277","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012":"776","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011":"115","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012":"104","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011":"1344","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012":"1363","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011":"47,4","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012":"47,1","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011":"834","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012":"547","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011":"324","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012":"657","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011":"186","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012":"159","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011":"582","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012":"581","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011":"46,7","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012":"49,1","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011":"318","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012":"246","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011":"121","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012":"189","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011":"143","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012":"146","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011":"3850","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012":"3758","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011":"54,7","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012":"55,3","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011":"2240","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012":"2129","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011":"535","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012":"607","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011":"1075","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012":"1022","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011":"14205","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012":"14243","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011":"51,6","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012":"51,4","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011":"9062","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012":"8682","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011":"1571","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012":"1948","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011":"3572","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012":"3613","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011":"4697","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012":"4739","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011":"60,0","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012":"59,7","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011":"3644","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012":"3268","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011":"213","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012":"581","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011":"840","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012":"890","Bevölkerungsstruktur Ausländerinnen in %  2011":"51,8","Bevölkerungsstruktur Ausländerinnen in %  2012":"52,0","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011":"2143","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012":"2189","Bevölkerungsstruktur EU-Ausländerinnen in %  2011":"50,0","Bevölkerungsstruktur EU-Ausländerinnen in %  2012":"50,3","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011":"52,0","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012":"52,0","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011":"691","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012":"1325","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011":"53,8","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012":"54,7","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011":"4781","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012":"4775","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011":"297","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012":"285","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011":"238","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012":"247","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011":"594","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012":"609","Bevölkerungsstruktur Staatenlose  2011":"21","Bevölkerungsstruktur Staatenlose  2012":"18","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011":"119","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012":"117","Bevölkerungsstruktur Bosnierinnen und Bosnier  2011":"300","Bevölkerungsstruktur Bosnierinnen und Bosnier  2012":"284","Bevölkerungsstruktur Griechinnen und Griechen  2011":"136","Bevölkerungsstruktur Griechinnen und Griechen  2012":"146","Bevölkerungsstruktur Italienerinnen und Italiener  2011":"573","Bevölkerungsstruktur Italienerinnen und Italiener  2012":"582","Bevölkerungsstruktur Kroatinnen und Kroaten  2011":"584","Bevölkerungsstruktur Kroatinnen und Kroaten  2012":"580","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011":"118","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012":"111","Bevölkerungsstruktur Polinnen und Polen  2011":"357","Bevölkerungsstruktur Polinnen und Polen  2012":"347","Bevölkerungsstruktur Rumäninnen und Rumänen  2011":"75","Bevölkerungsstruktur Rumäninnen und Rumänen  2012":"89","Bevölkerungsstruktur Serbierinnen und Serbier  2011":"386","Bevölkerungsstruktur Serbierinnen und Serbier  2012":"377","Bevölkerungsstruktur Spanierinnen und Spanier  2011":"165","Bevölkerungsstruktur Spanierinnen und Spanier  2012":"186","Bevölkerungsstruktur Türkinnen und Türken  2011":"881","Bevölkerungsstruktur Türkinnen und Türken  2012":"860","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011":"42","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012":"52","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011":"48","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012":"122","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011":"160","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012":"196","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011":"115","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012":"144","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011":"215","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012":"272","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011":"220","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012":"429","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011":"58","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012":"89","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011":"130","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012":"114","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011":"237","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012":"274","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011":"325","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012":"579","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011":"4972","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012":"4927","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011":"1924","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012":"1877","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011":"2806","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012":"2811","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011":"242","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012":"239","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011":"12637","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012":"12665","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011":"1324","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012":"1312","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011":"7200","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012":"7212","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011":"4113","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012":"4141","":""},{"Codes":"10","Stadtteil":"Gutleutviertel","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011":"5946","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012":"5952","Bevölkerungsstruktur Frauen in %  2011":"45,4","Bevölkerungsstruktur Frauen in %  2012":"44,9","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011":"10,0","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012":"11,7","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011":"9,0","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012":"3,4","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011":"2950","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012":"2626","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011":"737","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012":"1090","Bevölkerungsstruktur Ausländerinnen und Ausländer  2011":"2259","Bevölkerungsstruktur Ausländerinnen und Ausländer  2012":"2236","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011":"38,0","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012":"37,6","Bevölkerungsstruktur Durchschnittsalter  2011":"40,9","Bevölkerungsstruktur Durchschnittsalter  2012":"41,1","Bevölkerungsstruktur Jugendquotient  2011":"16,7","Bevölkerungsstruktur Jugendquotient  2012":"16,8","Bevölkerungsstruktur Altenquotient  2011":"20,2","Bevölkerungsstruktur Altenquotient  2012":"20,4","Bevölkerungsstruktur Kinder bis 5 Jahre  2011":"288","Bevölkerungsstruktur Kinder bis 5 Jahre  2012":"269","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011":"49,0","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012":"49,1","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011":"162","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012":"71","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011":"87","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012":"166","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011":"39","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012":"32","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011":"237","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012":"240","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011":"53,2","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012":"52,5","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011":"77","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012":"36","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011":"83","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012":"142","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011":"77","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012":"62","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011":"128","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012":"151","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011":"45,3","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012":"43,7","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011":"25","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012":"24","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011":"26","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012":"35","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011":"77","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012":"92","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011":"1199","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012":"1205","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011":"50,0","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012":"49,0","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011":"587","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012":"570","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011":"168","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012":"193","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011":"444","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012":"442","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011":"3217","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012":"3201","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011":"40,4","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012":"40,2","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011":"1542","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012":"1459","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011":"332","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012":"430","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011":"1343","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012":"1312","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011":"877","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012":"886","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011":"54,2","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012":"53,2","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011":"557","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012":"466","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011":"41","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012":"124","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011":"279","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012":"296","Bevölkerungsstruktur Ausländerinnen in %  2011":"44,5","Bevölkerungsstruktur Ausländerinnen in %  2012":"43,4","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011":"899","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012":"881","Bevölkerungsstruktur EU-Ausländerinnen in %  2011":"44,4","Bevölkerungsstruktur EU-Ausländerinnen in %  2012":"44,8","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011":"47,9","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012":"49,2","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011":"162","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012":"289","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011":"56,8","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012":"58,8","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011":"1547","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012":"1486","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011":"249","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012":"238","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011":"47","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012":"55","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011":"408","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012":"448","Bevölkerungsstruktur Staatenlose  2011":"8","Bevölkerungsstruktur Staatenlose  2012":"9","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011":"98","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012":"93","Bevölkerungsstruktur Bosnierinnen und Bosnier  2011":"44","Bevölkerungsstruktur Bosnierinnen und Bosnier  2012":"47","Bevölkerungsstruktur Griechinnen und Griechen  2011":"209","Bevölkerungsstruktur Griechinnen und Griechen  2012":"208","Bevölkerungsstruktur Italienerinnen und Italiener  2011":"128","Bevölkerungsstruktur Italienerinnen und Italiener  2012":"123","Bevölkerungsstruktur Kroatinnen und Kroaten  2011":"177","Bevölkerungsstruktur Kroatinnen und Kroaten  2012":"171","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011":"137","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012":"142","Bevölkerungsstruktur Polinnen und Polen  2011":"158","Bevölkerungsstruktur Polinnen und Polen  2012":"141","Bevölkerungsstruktur Rumäninnen und Rumänen  2011":"40","Bevölkerungsstruktur Rumäninnen und Rumänen  2012":"48","Bevölkerungsstruktur Serbierinnen und Serbier  2011":"94","Bevölkerungsstruktur Serbierinnen und Serbier  2012":"83","Bevölkerungsstruktur Spanierinnen und Spanier  2011":"46","Bevölkerungsstruktur Spanierinnen und Spanier  2012":"35","Bevölkerungsstruktur Türkinnen und Türken  2011":"229","Bevölkerungsstruktur Türkinnen und Türken  2012":"210","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011":"52","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012":"63","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011":"18","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012":"31","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011":"27","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012":"35","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011":"20","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012":"31","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011":"102","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012":"124","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011":"43","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012":"89","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011":"25","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012":"27","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011":"30","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012":"25","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011":"46","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012":"40","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011":"53","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012":"70","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011":"2081","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012":"1983","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011":"813","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012":"858","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011":"1162","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012":"1034","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011":"106","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012":"91","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011":"1851","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012":"1839","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011":"208","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012":"198","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011":"976","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012":"954","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011":"667","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012":"687","":""},{"Codes":"11","Stadtteil":"Gallus","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011":"27318","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012":"28165","Bevölkerungsstruktur Frauen in %  2011":"46,5","Bevölkerungsstruktur Frauen in %  2012":"46,4","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011":"6,8","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012":"11,4","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011":"11,0","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012":"14,4","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011":"11727","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012":"10095","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011":"4134","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012":"6307","Bevölkerungsstruktur Ausländerinnen und Ausländer  2011":"11457","Bevölkerungsstruktur Ausländerinnen und Ausländer  2012":"11763","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011":"41,9","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012":"41,8","Bevölkerungsstruktur Durchschnittsalter  2011":"38,7","Bevölkerungsstruktur Durchschnittsalter  2012":"38,6","Bevölkerungsstruktur Jugendquotient  2011":"22,6","Bevölkerungsstruktur Jugendquotient  2012":"22,6","Bevölkerungsstruktur Altenquotient  2011":"16,2","Bevölkerungsstruktur Altenquotient  2012":"16,0","Bevölkerungsstruktur Kinder bis 5 Jahre  2011":"1627","Bevölkerungsstruktur Kinder bis 5 Jahre  2012":"1730","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011":"48,0","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012":"46,0","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011":"827","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012":"227","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011":"505","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012":"1182","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011":"295","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012":"321","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011":"1586","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012":"1628","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011":"48,7","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012":"49,3","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011":"577","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012":"189","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011":"536","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012":"983","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011":"473","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012":"456","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011":"795","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012":"798","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011":"46,8","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012":"47,5","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011":"212","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012":"108","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011":"183","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012":"312","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011":"400","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012":"378","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011":"5750","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012":"5737","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011":"49,5","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012":"50,2","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011":"2502","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012":"2421","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011":"874","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012":"997","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011":"2374","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012":"2319","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011":"14373","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012":"15024","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011":"43,4","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012":"43,1","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011":"5594","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012":"5370","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011":"1880","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012":"2446","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011":"6899","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012":"7208","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011":"3187","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012":"3248","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011":"53,5","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012":"53,3","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011":"2015","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012":"1780","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011":"156","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012":"387","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011":"1016","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012":"1081","Bevölkerungsstruktur Ausländerinnen in %  2011":"46,1","Bevölkerungsstruktur Ausländerinnen in %  2012":"46,0","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011":"4085","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012":"4333","Bevölkerungsstruktur EU-Ausländerinnen in %  2011":"41,0","Bevölkerungsstruktur EU-Ausländerinnen in %  2012":"41,1","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011":"47,0","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012":"46,5","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011":"702","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012":"1089","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011":"50,1","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012":"48,6","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011":"8667","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012":"8859","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011":"992","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012":"1034","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011":"262","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012":"291","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011":"1469","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012":"1512","Bevölkerungsstruktur Staatenlose  2011":"67","Bevölkerungsstruktur Staatenlose  2012":"67","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011":"133","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012":"138","Bevölkerungsstruktur Bosnierinnen und Bosnier  2011":"483","Bevölkerungsstruktur Bosnierinnen und Bosnier  2012":"482","Bevölkerungsstruktur Griechinnen und Griechen  2011":"687","Bevölkerungsstruktur Griechinnen und Griechen  2012":"665","Bevölkerungsstruktur Italienerinnen und Italiener  2011":"571","Bevölkerungsstruktur Italienerinnen und Italiener  2012":"552","Bevölkerungsstruktur Kroatinnen und Kroaten  2011":"797","Bevölkerungsstruktur Kroatinnen und Kroaten  2012":"761","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011":"443","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012":"442","Bevölkerungsstruktur Polinnen und Polen  2011":"893","Bevölkerungsstruktur Polinnen und Polen  2012":"923","Bevölkerungsstruktur Rumäninnen und Rumänen  2011":"358","Bevölkerungsstruktur Rumäninnen und Rumänen  2012":"442","Bevölkerungsstruktur Serbierinnen und Serbier  2011":"932","Bevölkerungsstruktur Serbierinnen und Serbier  2012":"964","Bevölkerungsstruktur Spanierinnen und Spanier  2011":"254","Bevölkerungsstruktur Spanierinnen und Spanier  2012":"290","Bevölkerungsstruktur Türkinnen und Türken  2011":"1994","Bevölkerungsstruktur Türkinnen und Türken  2012":"1913","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011":"144","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012":"188","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011":"131","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012":"301","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011":"101","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012":"120","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011":"105","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012":"111","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011":"614","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012":"888","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011":"251","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012":"376","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011":"102","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012":"152","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011":"201","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012":"213","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011":"270","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012":"267","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011":"576","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012":"939","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011":"8082","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012":"8469","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011":"3486","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012":"3532","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011":"4472","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012":"4796","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011":"124","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012":"141","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011":"10017","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012":"10041","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011":"1375","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012":"1338","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011":"5796","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012":"5826","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011":"2846","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012":"2877","":""},{"Codes":"12","Stadtteil":"Bockenheim","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011":"34581","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012":"35789","Bevölkerungsstruktur Frauen in %  2011":"50,7","Bevölkerungsstruktur Frauen in %  2012":"50,5","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011":"18,3","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012":"20,9","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011":"12,8","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012":"14,5","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011":"20669","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012":"18699","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011":"4365","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012":"6920","Bevölkerungsstruktur Ausländerinnen und Ausländer  2011":"9547","Bevölkerungsstruktur Ausländerinnen und Ausländer  2012":"10170","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011":"27,6","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012":"28,4","Bevölkerungsstruktur Durchschnittsalter  2011":"39,1","Bevölkerungsstruktur Durchschnittsalter  2012":"38,9","Bevölkerungsstruktur Jugendquotient  2011":"19,7","Bevölkerungsstruktur Jugendquotient  2012":"20,0","Bevölkerungsstruktur Altenquotient  2011":"16,3","Bevölkerungsstruktur Altenquotient  2012":"16,0","Bevölkerungsstruktur Kinder bis 5 Jahre  2011":"2065","Bevölkerungsstruktur Kinder bis 5 Jahre  2012":"2165","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011":"48,8","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012":"49,5","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011":"1388","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012":"742","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011":"438","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012":"1168","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011":"239","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012":"255","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011":"1719","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012":"1825","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011":"48,3","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012":"48,9","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011":"941","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012":"528","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011":"494","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012":"999","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011":"284","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012":"298","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011":"761","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012":"747","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011":"48,1","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012":"47,5","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011":"374","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012":"278","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011":"179","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012":"266","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011":"208","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012":"203","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011":"7204","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012":"7489","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011":"55,5","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012":"54,7","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011":"3936","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012":"3885","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011":"886","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012":"1058","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011":"2382","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012":"2546","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011":"18684","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012":"19357","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011":"47,7","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012":"47,8","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011":"10834","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012":"10451","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011":"2196","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012":"2858","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011":"5654","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012":"6048","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011":"4148","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012":"4206","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011":"58,1","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012":"57,4","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011":"3196","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012":"2815","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011":"172","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012":"571","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011":"780","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012":"820","Bevölkerungsstruktur Ausländerinnen in %  2011":"50,7","Bevölkerungsstruktur Ausländerinnen in %  2012":"50,1","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011":"3907","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012":"4304","Bevölkerungsstruktur EU-Ausländerinnen in %  2011":"48,9","Bevölkerungsstruktur EU-Ausländerinnen in %  2012":"48,3","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011":"49,7","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012":"50,0","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011":"1181","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012":"2052","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011":"52,2","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012":"52,5","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011":"7029","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012":"7464","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011":"608","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012":"605","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011":"462","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012":"487","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011":"1415","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012":"1586","Bevölkerungsstruktur Staatenlose  2011":"33","Bevölkerungsstruktur Staatenlose  2012":"28","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011":"134","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012":"137","Bevölkerungsstruktur Bosnierinnen und Bosnier  2011":"172","Bevölkerungsstruktur Bosnierinnen und Bosnier  2012":"165","Bevölkerungsstruktur Griechinnen und Griechen  2011":"539","Bevölkerungsstruktur Griechinnen und Griechen  2012":"566","Bevölkerungsstruktur Italienerinnen und Italiener  2011":"711","Bevölkerungsstruktur Italienerinnen und Italiener  2012":"729","Bevölkerungsstruktur Kroatinnen und Kroaten  2011":"572","Bevölkerungsstruktur Kroatinnen und Kroaten  2012":"568","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011":"196","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012":"193","Bevölkerungsstruktur Polinnen und Polen  2011":"540","Bevölkerungsstruktur Polinnen und Polen  2012":"570","Bevölkerungsstruktur Rumäninnen und Rumänen  2011":"269","Bevölkerungsstruktur Rumäninnen und Rumänen  2012":"333","Bevölkerungsstruktur Serbierinnen und Serbier  2011":"330","Bevölkerungsstruktur Serbierinnen und Serbier  2012":"321","Bevölkerungsstruktur Spanierinnen und Spanier  2011":"257","Bevölkerungsstruktur Spanierinnen und Spanier  2012":"321","Bevölkerungsstruktur Türkinnen und Türken  2011":"1557","Bevölkerungsstruktur Türkinnen und Türken  2012":"1542","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011":"67","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012":"105","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011":"83","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012":"181","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011":"267","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012":"331","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011":"144","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012":"203","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011":"301","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012":"399","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011":"381","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012":"639","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011":"134","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012":"161","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011":"143","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012":"143","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011":"316","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012":"311","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011":"532","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012":"868","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011":"10801","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012":"11362","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011":"4948","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012":"5210","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011":"5659","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012":"5952","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011":"194","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012":"200","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011":"12388","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012":"12438","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011":"1416","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012":"1421","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011":"7297","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012":"7302","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011":"3675","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012":"3715","":""},{"Codes":"13","Stadtteil":"Sachsenhausen-Nord","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011":"29534","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012":"29789","Bevölkerungsstruktur Frauen in %  2011":"51,3","Bevölkerungsstruktur Frauen in %  2012":"51,3","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011":"11,2","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012":"9,9","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011":"5,4","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012":"6,6","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011":"19646","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012":"17787","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011":"3134","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012":"5248","Bevölkerungsstruktur Ausländerinnen und Ausländer  2011":"6754","Bevölkerungsstruktur Ausländerinnen und Ausländer  2012":"6754","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011":"22,9","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012":"22,7","Bevölkerungsstruktur Durchschnittsalter  2011":"40,5","Bevölkerungsstruktur Durchschnittsalter  2012":"40,6","Bevölkerungsstruktur Jugendquotient  2011":"21,8","Bevölkerungsstruktur Jugendquotient  2012":"22,2","Bevölkerungsstruktur Altenquotient  2011":"19,7","Bevölkerungsstruktur Altenquotient  2012":"20,3","Bevölkerungsstruktur Kinder bis 5 Jahre  2011":"1875","Bevölkerungsstruktur Kinder bis 5 Jahre  2012":"1836","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011":"49,0","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012":"49,1","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011":"1436","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012":"839","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011":"260","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012":"838","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011":"179","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012":"159","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011":"1668","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012":"1717","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011":"48,6","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012":"49,4","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011":"1115","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012":"727","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011":"318","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012":"779","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011":"235","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012":"211","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011":"676","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012":"699","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011":"51,9","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012":"50,1","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011":"391","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012":"310","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011":"141","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012":"246","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011":"144","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012":"143","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011":"4720","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012":"4788","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011":"53,4","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012":"53,0","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011":"2788","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012":"2745","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011":"592","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012":"694","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011":"1340","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012":"1349","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011":"16480","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012":"16513","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011":"49,5","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012":"49,7","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011":"10507","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012":"10064","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011":"1685","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012":"2173","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011":"4288","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012":"4276","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011":"4115","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012":"4236","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011":"57,8","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012":"57,5","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011":"3409","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012":"3102","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011":"138","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012":"518","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011":"568","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012":"616","Bevölkerungsstruktur Ausländerinnen in %  2011":"50,3","Bevölkerungsstruktur Ausländerinnen in %  2012":"50,1","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011":"3024","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012":"3044","Bevölkerungsstruktur EU-Ausländerinnen in %  2011":"47,9","Bevölkerungsstruktur EU-Ausländerinnen in %  2012":"47,8","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011":"53,3","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012":"52,9","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011":"879","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012":"1723","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011":"56,7","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012":"55,3","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011":"5069","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012":"5044","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011":"258","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012":"255","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011":"470","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012":"483","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011":"933","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012":"944","Bevölkerungsstruktur Staatenlose  2011":"24","Bevölkerungsstruktur Staatenlose  2012":"28","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011":"120","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012":"119","Bevölkerungsstruktur Bosnierinnen und Bosnier  2011":"199","Bevölkerungsstruktur Bosnierinnen und Bosnier  2012":"191","Bevölkerungsstruktur Griechinnen und Griechen  2011":"200","Bevölkerungsstruktur Griechinnen und Griechen  2012":"209","Bevölkerungsstruktur Italienerinnen und Italiener  2011":"560","Bevölkerungsstruktur Italienerinnen und Italiener  2012":"551","Bevölkerungsstruktur Kroatinnen und Kroaten  2011":"466","Bevölkerungsstruktur Kroatinnen und Kroaten  2012":"458","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011":"111","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012":"102","Bevölkerungsstruktur Polinnen und Polen  2011":"313","Bevölkerungsstruktur Polinnen und Polen  2012":"340","Bevölkerungsstruktur Rumäninnen und Rumänen  2011":"228","Bevölkerungsstruktur Rumäninnen und Rumänen  2012":"251","Bevölkerungsstruktur Serbierinnen und Serbier  2011":"410","Bevölkerungsstruktur Serbierinnen und Serbier  2012":"395","Bevölkerungsstruktur Spanierinnen und Spanier  2011":"252","Bevölkerungsstruktur Spanierinnen und Spanier  2012":"284","Bevölkerungsstruktur Türkinnen und Türken  2011":"630","Bevölkerungsstruktur Türkinnen und Türken  2012":"607","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011":"83","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012":"138","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011":"45","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012":"122","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011":"196","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012":"236","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011":"125","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012":"200","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011":"179","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012":"252","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011":"231","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012":"421","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011":"118","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012":"169","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011":"122","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012":"126","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011":"225","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012":"235","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011":"279","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012":"446","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011":"7602","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012":"7596","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011":"2896","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012":"3012","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011":"4512","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012":"4369","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011":"194","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012":"215","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011":"11491","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012":"11546","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011":"1218","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012":"1186","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011":"6639","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012":"6628","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011":"3634","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012":"3732","":""},{"Codes":"14","Stadtteil":"Sachsenhausen-Süd","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011":"25509","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012":"25786","Bevölkerungsstruktur Frauen in %  2011":"51,9","Bevölkerungsstruktur Frauen in %  2012":"51,8","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011":"3,9","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012":"5,1","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011":"3,4","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012":"4,1","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011":"17938","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012":"15905","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011":"2441","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012":"4474","Bevölkerungsstruktur Ausländerinnen und Ausländer  2011":"5130","Bevölkerungsstruktur Ausländerinnen und Ausländer  2012":"5407","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011":"20,1","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012":"21,0","Bevölkerungsstruktur Durchschnittsalter  2011":"44,8","Bevölkerungsstruktur Durchschnittsalter  2012":"44,7","Bevölkerungsstruktur Jugendquotient  2011":"21,9","Bevölkerungsstruktur Jugendquotient  2012":"22,8","Bevölkerungsstruktur Altenquotient  2011":"34,4","Bevölkerungsstruktur Altenquotient  2012":"34,6","Bevölkerungsstruktur Kinder bis 5 Jahre  2011":"1329","Bevölkerungsstruktur Kinder bis 5 Jahre  2012":"1397","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011":"46,8","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012":"46,8","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011":"1018","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012":"607","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011":"175","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012":"631","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011":"136","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012":"159","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011":"1341","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012":"1349","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011":"49,3","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012":"47,9","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011":"966","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012":"627","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011":"224","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012":"582","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011":"151","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012":"140","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011":"604","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012":"657","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011":"48,2","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012":"47,9","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011":"395","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012":"326","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011":"95","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012":"213","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011":"114","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012":"118","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011":"3577","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012":"3591","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011":"52,2","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012":"53,2","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011":"2065","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012":"1947","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011":"487","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012":"565","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011":"1025","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012":"1079","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011":"13047","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012":"13122","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011":"50,3","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012":"50,3","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011":"8569","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012":"8057","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011":"1301","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012":"1709","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011":"3177","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012":"3356","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011":"5611","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012":"5670","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011":"57,8","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012":"57,3","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011":"4925","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012":"4341","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011":"159","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012":"774","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011":"527","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012":"555","Bevölkerungsstruktur Ausländerinnen in %  2011":"50,8","Bevölkerungsstruktur Ausländerinnen in %  2012":"50,7","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011":"2187","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012":"2377","Bevölkerungsstruktur EU-Ausländerinnen in %  2011":"49,2","Bevölkerungsstruktur EU-Ausländerinnen in %  2012":"48,3","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011":"52,6","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012":"52,5","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011":"782","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012":"1716","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011":"55,1","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012":"54,7","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011":"3769","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012":"3965","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011":"187","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012":"178","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011":"327","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012":"348","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011":"827","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012":"897","Bevölkerungsstruktur Staatenlose  2011":"20","Bevölkerungsstruktur Staatenlose  2012":"19","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011":"125","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012":"124","Bevölkerungsstruktur Bosnierinnen und Bosnier  2011":"160","Bevölkerungsstruktur Bosnierinnen und Bosnier  2012":"144","Bevölkerungsstruktur Griechinnen und Griechen  2011":"131","Bevölkerungsstruktur Griechinnen und Griechen  2012":"136","Bevölkerungsstruktur Italienerinnen und Italiener  2011":"389","Bevölkerungsstruktur Italienerinnen und Italiener  2012":"434","Bevölkerungsstruktur Kroatinnen und Kroaten  2011":"410","Bevölkerungsstruktur Kroatinnen und Kroaten  2012":"406","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011":"51","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012":"42","Bevölkerungsstruktur Polinnen und Polen  2011":"347","Bevölkerungsstruktur Polinnen und Polen  2012":"408","Bevölkerungsstruktur Rumäninnen und Rumänen  2011":"127","Bevölkerungsstruktur Rumäninnen und Rumänen  2012":"147","Bevölkerungsstruktur Serbierinnen und Serbier  2011":"250","Bevölkerungsstruktur Serbierinnen und Serbier  2012":"238","Bevölkerungsstruktur Spanierinnen und Spanier  2011":"159","Bevölkerungsstruktur Spanierinnen und Spanier  2012":"181","Bevölkerungsstruktur Türkinnen und Türken  2011":"474","Bevölkerungsstruktur Türkinnen und Türken  2012":"465","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011":"66","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012":"99","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011":"17","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012":"54","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011":"200","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012":"253","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011":"88","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012":"150","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011":"101","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012":"163","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011":"212","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012":"537","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011":"125","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012":"221","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011":"81","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012":"77","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011":"184","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012":"205","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011":"186","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012":"342","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011":"5716","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012":"5822","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011":"2.021","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012":"2066","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011":"3.391","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012":"3471","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011":"304","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012":"285","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011":"11868","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012":"11842","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011":"1.132","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012":"1099","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011":"5.851","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012":"5793","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011":"4.885","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012":"4950","":""},{"Codes":"16","Stadtteil":"Oberrad","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011":"12392","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012":"12561","Bevölkerungsstruktur Frauen in %  2011":"50,9","Bevölkerungsstruktur Frauen in %  2012":"50,8","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011":"9,3","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012":"10,9","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011":"4,7","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012":"4,9","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011":"7458","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012":"6517","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011":"1707","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012":"2630","Bevölkerungsstruktur Ausländerinnen und Ausländer  2011":"3227","Bevölkerungsstruktur Ausländerinnen und Ausländer  2012":"3414","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011":"26,0","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012":"27,2","Bevölkerungsstruktur Durchschnittsalter  2011":"42,8","Bevölkerungsstruktur Durchschnittsalter  2012":"42,8","Bevölkerungsstruktur Jugendquotient  2011":"25,1","Bevölkerungsstruktur Jugendquotient  2012":"25,6","Bevölkerungsstruktur Altenquotient  2011":"28,0","Bevölkerungsstruktur Altenquotient  2012":"27,8","Bevölkerungsstruktur Kinder bis 5 Jahre  2011":"659","Bevölkerungsstruktur Kinder bis 5 Jahre  2012":"655","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011":"48,4","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012":"49,3","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011":"431","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012":"171","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011":"144","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012":"380","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011":"84","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012":"104","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011":"809","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012":"838","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011":"48,1","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012":"47,9","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011":"437","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012":"235","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011":"229","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012":"457","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011":"143","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012":"146","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011":"382","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012":"410","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011":"50,8","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012":"51,7","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011":"184","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012":"146","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011":"92","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012":"138","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011":"106","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012":"126","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011":"1797","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012":"1843","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011":"53,8","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012":"52,5","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011":"929","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012":"921","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011":"307","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012":"334","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011":"561","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012":"588","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011":"6479","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012":"6539","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011":"48,4","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012":"48,8","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011":"3586","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012":"3381","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011":"855","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012":"1026","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011":"2038","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012":"2132","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011":"2266","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012":"2276","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011":"57,5","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012":"56,9","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011":"1891","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012":"1663","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011":"80","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012":"295","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011":"295","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012":"318","Bevölkerungsstruktur Ausländerinnen in %  2011":"49,7","Bevölkerungsstruktur Ausländerinnen in %  2012":"48,9","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011":"1168","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012":"1279","Bevölkerungsstruktur EU-Ausländerinnen in %  2011":"49,6","Bevölkerungsstruktur EU-Ausländerinnen in %  2012":"48,0","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011":"50,0","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012":"50,1","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011":"395","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012":"740","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011":"49,9","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012":"51,2","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011":"2481","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012":"2595","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011":"199","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012":"211","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011":"86","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012":"82","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011":"423","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012":"487","Bevölkerungsstruktur Staatenlose  2011":"38","Bevölkerungsstruktur Staatenlose  2012":"39","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011":"100","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012":"103","Bevölkerungsstruktur Bosnierinnen und Bosnier  2011":"90","Bevölkerungsstruktur Bosnierinnen und Bosnier  2012":"92","Bevölkerungsstruktur Griechinnen und Griechen  2011":"72","Bevölkerungsstruktur Griechinnen und Griechen  2012":"75","Bevölkerungsstruktur Italienerinnen und Italiener  2011":"224","Bevölkerungsstruktur Italienerinnen und Italiener  2012":"232","Bevölkerungsstruktur Kroatinnen und Kroaten  2011":"224","Bevölkerungsstruktur Kroatinnen und Kroaten  2012":"227","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011":"82","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012":"88","Bevölkerungsstruktur Polinnen und Polen  2011":"305","Bevölkerungsstruktur Polinnen und Polen  2012":"352","Bevölkerungsstruktur Rumäninnen und Rumänen  2011":"144","Bevölkerungsstruktur Rumäninnen und Rumänen  2012":"168","Bevölkerungsstruktur Serbierinnen und Serbier  2011":"215","Bevölkerungsstruktur Serbierinnen und Serbier  2012":"211","Bevölkerungsstruktur Spanierinnen und Spanier  2011":"58","Bevölkerungsstruktur Spanierinnen und Spanier  2012":"66","Bevölkerungsstruktur Türkinnen und Türken  2011":"608","Bevölkerungsstruktur Türkinnen und Türken  2012":"611","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011":"113","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012":"152","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011":"28","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012":"60","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011":"96","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012":"112","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011":"77","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012":"86","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011":"114","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012":"167","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011":"107","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012":"240","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011":"83","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012":"122","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011":"70","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012":"66","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011":"89","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012":"98","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011":"242","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012":"427","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011":"2383","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012":"2474","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011":"884","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012":"953","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011":"1421","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012":"1438","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011":"78","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012":"83","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011":"5876","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012":"5859","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011":"621","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012":"598","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011":"3238","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012":"3224","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011":"2017","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012":"2037","":""},{"Codes":"17","Stadtteil":"Niederrad","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011":"22108","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012":"22396","Bevölkerungsstruktur Frauen in %  2011":"50,9","Bevölkerungsstruktur Frauen in %  2012":"50,6","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011":"2,2","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012":"3,5","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011":"3,9","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012":"4,0","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011":"12691","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012":"10953","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011":"2974","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012":"4565","Bevölkerungsstruktur Ausländerinnen und Ausländer  2011":"6443","Bevölkerungsstruktur Ausländerinnen und Ausländer  2012":"6878","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011":"29,1","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012":"30,7","Bevölkerungsstruktur Durchschnittsalter  2011":"41,9","Bevölkerungsstruktur Durchschnittsalter  2012":"41,7","Bevölkerungsstruktur Jugendquotient  2011":"23,2","Bevölkerungsstruktur Jugendquotient  2012":"22,8","Bevölkerungsstruktur Altenquotient  2011":"24,9","Bevölkerungsstruktur Altenquotient  2012":"24,3","Bevölkerungsstruktur Kinder bis 5 Jahre  2011":"1220","Bevölkerungsstruktur Kinder bis 5 Jahre  2012":"1242","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011":"49,6","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012":"49,9","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011":"736","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012":"271","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011":"319","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012":"779","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011":"165","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012":"192","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011":"1264","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012":"1220","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011":"51,1","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012":"50,6","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011":"634","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012":"315","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011":"400","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012":"693","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011":"230","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012":"212","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011":"628","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012":"632","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011":"47,6","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012":"50,5","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011":"278","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012":"215","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011":"136","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012":"210","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011":"214","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012":"207","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011":"3914","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012":"4170","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011":"54,0","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012":"53,4","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011":"2046","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012":"2036","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011":"571","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012":"693","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011":"1297","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012":"1441","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011":"11358","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012":"11437","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011":"48,4","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012":"48,0","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011":"6045","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012":"5575","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011":"1413","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012":"1722","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011":"3900","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012":"4140","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011":"3724","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012":"3695","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011":"56,2","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012":"55,8","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011":"2952","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012":"2541","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011":"135","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012":"468","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011":"637","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012":"686","Bevölkerungsstruktur Ausländerinnen in %  2011":"48,6","Bevölkerungsstruktur Ausländerinnen in %  2012":"47,6","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011":"2419","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012":"2700","Bevölkerungsstruktur EU-Ausländerinnen in %  2011":"45,0","Bevölkerungsstruktur EU-Ausländerinnen in %  2012":"44,8","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011":"49,6","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012":"50,3","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011":"682","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012":"1212","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011":"51,3","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012":"53,6","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011":"4884","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012":"5258","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011":"430","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012":"446","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011":"235","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012":"228","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011":"874","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012":"929","Bevölkerungsstruktur Staatenlose  2011":"20","Bevölkerungsstruktur Staatenlose  2012":"17","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011":"124","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012":"121","Bevölkerungsstruktur Bosnierinnen und Bosnier  2011":"164","Bevölkerungsstruktur Bosnierinnen und Bosnier  2012":"204","Bevölkerungsstruktur Griechinnen und Griechen  2011":"154","Bevölkerungsstruktur Griechinnen und Griechen  2012":"163","Bevölkerungsstruktur Italienerinnen und Italiener  2011":"356","Bevölkerungsstruktur Italienerinnen und Italiener  2012":"363","Bevölkerungsstruktur Kroatinnen und Kroaten  2011":"702","Bevölkerungsstruktur Kroatinnen und Kroaten  2012":"709","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011":"190","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012":"199","Bevölkerungsstruktur Polinnen und Polen  2011":"334","Bevölkerungsstruktur Polinnen und Polen  2012":"373","Bevölkerungsstruktur Rumäninnen und Rumänen  2011":"152","Bevölkerungsstruktur Rumäninnen und Rumänen  2012":"212","Bevölkerungsstruktur Serbierinnen und Serbier  2011":"397","Bevölkerungsstruktur Serbierinnen und Serbier  2012":"432","Bevölkerungsstruktur Spanierinnen und Spanier  2011":"275","Bevölkerungsstruktur Spanierinnen und Spanier  2012":"295","Bevölkerungsstruktur Türkinnen und Türken  2011":"955","Bevölkerungsstruktur Türkinnen und Türken  2012":"943","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011":"91","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012":"136","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011":"66","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012":"141","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011":"109","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012":"136","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011":"84","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012":"123","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011":"312","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012":"400","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011":"228","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012":"398","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011":"98","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012":"126","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011":"99","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012":"116","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011":"166","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012":"184","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011":"377","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012":"618","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011":"4936","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012":"5355","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011":"2170","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012":"2421","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011":"2634","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012":"2787","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011":"132","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012":"147","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011":"10390","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012":"10277","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011":"1264","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012":"1269","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011":"5733","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012":"5661","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011":"3393","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012":"3347","":""},{"Codes":"18","Stadtteil":"Schwanheim","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011":"20209","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012":"20480","Bevölkerungsstruktur Frauen in %  2011":"51,4","Bevölkerungsstruktur Frauen in %  2012":"51,3","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011":"0,2","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012":"1,5","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011":"0,4","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012":"2,3","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011":"12803","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012":"10997","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011":"3365","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012":"5176","Bevölkerungsstruktur Ausländerinnen und Ausländer  2011":"4041","Bevölkerungsstruktur Ausländerinnen und Ausländer  2012":"4307","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011":"20,0","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012":"21,0","Bevölkerungsstruktur Durchschnittsalter  2011":"42,6","Bevölkerungsstruktur Durchschnittsalter  2012":"42,4","Bevölkerungsstruktur Jugendquotient  2011":"35,2","Bevölkerungsstruktur Jugendquotient  2012":"35,4","Bevölkerungsstruktur Altenquotient  2011":"34,5","Bevölkerungsstruktur Altenquotient  2012":"33,9","Bevölkerungsstruktur Kinder bis 5 Jahre  2011":"1282","Bevölkerungsstruktur Kinder bis 5 Jahre  2012":"1315","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011":"49,8","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012":"49,0","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011":"869","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012":"334","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011":"314","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012":"861","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011":"99","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012":"120","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011":"1713","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012":"1747","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011":"48,6","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012":"49,1","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011":"990","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012":"567","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011":"511","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012":"990","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011":"212","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012":"190","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011":"769","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012":"815","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011":"46,2","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012":"46,0","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011":"381","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012":"303","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011":"215","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012":"322","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011":"173","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012":"190","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011":"2871","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012":"2911","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011":"50,8","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012":"51,1","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011":"1498","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012":"1455","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011":"642","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012":"660","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011":"731","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012":"796","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011":"9467","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012":"9588","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011":"50,2","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012":"50,3","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011":"5488","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012":"5206","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011":"1512","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012":"1775","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011":"2467","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012":"2607","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011":"4107","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012":"4104","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011":"57,0","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012":"56,6","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011":"3577","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012":"3132","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011":"171","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012":"568","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011":"359","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012":"404","Bevölkerungsstruktur Ausländerinnen in %  2011":"50,7","Bevölkerungsstruktur Ausländerinnen in %  2012":"50,4","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011":"1119","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012":"1285","Bevölkerungsstruktur EU-Ausländerinnen in %  2011":"48,2","Bevölkerungsstruktur EU-Ausländerinnen in %  2012":"47,8","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011":"48,6","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012":"49,3","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011":"735","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012":"1328","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011":"52,2","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012":"54,4","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011":"2930","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012":"3090","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011":"494","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012":"534","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011":"117","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012":"120","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011":"453","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012":"518","Bevölkerungsstruktur Staatenlose  2011":"47","Bevölkerungsstruktur Staatenlose  2012":"45","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011":"105","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012":"108","Bevölkerungsstruktur Bosnierinnen und Bosnier  2011":"68","Bevölkerungsstruktur Bosnierinnen und Bosnier  2012":"70","Bevölkerungsstruktur Griechinnen und Griechen  2011":"72","Bevölkerungsstruktur Griechinnen und Griechen  2012":"87","Bevölkerungsstruktur Italienerinnen und Italiener  2011":"264","Bevölkerungsstruktur Italienerinnen und Italiener  2012":"274","Bevölkerungsstruktur Kroatinnen und Kroaten  2011":"264","Bevölkerungsstruktur Kroatinnen und Kroaten  2012":"270","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011":"241","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012":"256","Bevölkerungsstruktur Polinnen und Polen  2011":"193","Bevölkerungsstruktur Polinnen und Polen  2012":"232","Bevölkerungsstruktur Rumäninnen und Rumänen  2011":"48","Bevölkerungsstruktur Rumäninnen und Rumänen  2012":"102","Bevölkerungsstruktur Serbierinnen und Serbier  2011":"179","Bevölkerungsstruktur Serbierinnen und Serbier  2012":"179","Bevölkerungsstruktur Spanierinnen und Spanier  2011":"135","Bevölkerungsstruktur Spanierinnen und Spanier  2012":"144","Bevölkerungsstruktur Türkinnen und Türken  2011":"1139","Bevölkerungsstruktur Türkinnen und Türken  2012":"1116","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011":"176","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012":"250","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011":"73","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012":"178","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011":"35","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012":"43","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011":"101","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012":"140","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011":"530","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012":"768","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011":"346","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012":"616","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011":"98","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012":"141","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011":"112","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012":"112","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011":"290","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012":"262","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011":"467","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012":"756","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011":"2169","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012":"2303","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011":"841","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012":"915","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011":"1221","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012":"1282","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011":"107","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012":"106","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011":"11656","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012":"11600","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011":"1645","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012":"1625","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011":"6186","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012":"6157","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011":"3825","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012":"3818","":""},{"Codes":"19","Stadtteil":"Griesheim","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011":"22629","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012":"23124","Bevölkerungsstruktur Frauen in %  2011":"45,6","Bevölkerungsstruktur Frauen in %  2012":"45,2","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011":"10,5","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012":"13,0","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011":"7,7","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012":"8,9","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011":"9670","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012":"8175","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011":"4264","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012":"5870","Bevölkerungsstruktur Ausländerinnen und Ausländer  2011":"8695","Bevölkerungsstruktur Ausländerinnen und Ausländer  2012":"9079","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011":"38,4","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012":"39,3","Bevölkerungsstruktur Durchschnittsalter  2011":"40,0","Bevölkerungsstruktur Durchschnittsalter  2012":"40,0","Bevölkerungsstruktur Jugendquotient  2011":"27,9","Bevölkerungsstruktur Jugendquotient  2012":"27,3","Bevölkerungsstruktur Altenquotient  2011":"20,2","Bevölkerungsstruktur Altenquotient  2012":"19,5","Bevölkerungsstruktur Kinder bis 5 Jahre  2011":"1337","Bevölkerungsstruktur Kinder bis 5 Jahre  2012":"1348","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011":"52,1","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012":"51,3","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011":"664","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012":"181","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011":"427","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012":"934","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011":"246","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012":"233","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011":"1665","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012":"1657","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011":"50,2","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012":"50,3","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011":"654","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012":"279","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011":"564","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012":"965","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011":"447","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012":"413","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011":"811","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012":"843","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011":"46,6","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012":"49,2","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011":"266","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012":"175","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011":"232","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012":"345","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011":"313","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012":"323","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011":"4017","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012":"4084","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011":"47,0","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012":"45,9","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011":"1407","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012":"1397","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011":"844","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012":"871","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011":"1766","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012":"1816","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011":"11717","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012":"12128","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011":"41,1","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012":"40,9","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011":"4334","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012":"4110","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011":"2065","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012":"2375","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011":"5318","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012":"5643","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011":"3082","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012":"3064","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011":"55,7","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012":"55,1","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011":"2345","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012":"2033","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011":"132","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012":"380","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011":"605","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012":"651","Bevölkerungsstruktur Ausländerinnen in %  2011":"42,8","Bevölkerungsstruktur Ausländerinnen in %  2012":"42,0","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011":"3723","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012":"4113","Bevölkerungsstruktur EU-Ausländerinnen in %  2011":"35,1","Bevölkerungsstruktur EU-Ausländerinnen in %  2012":"34,3","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011":"39,2","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012":"42,4","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011":"1505","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012":"1866","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011":"24,5","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012":"32,0","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011":"6900","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012":"7253","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011":"902","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012":"891","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011":"118","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012":"111","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011":"725","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012":"773","Bevölkerungsstruktur Staatenlose  2011":"50","Bevölkerungsstruktur Staatenlose  2012":"51","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011":"114","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012":"117","Bevölkerungsstruktur Bosnierinnen und Bosnier  2011":"346","Bevölkerungsstruktur Bosnierinnen und Bosnier  2012":"330","Bevölkerungsstruktur Griechinnen und Griechen  2011":"401","Bevölkerungsstruktur Griechinnen und Griechen  2012":"415","Bevölkerungsstruktur Italienerinnen und Italiener  2011":"737","Bevölkerungsstruktur Italienerinnen und Italiener  2012":"741","Bevölkerungsstruktur Kroatinnen und Kroaten  2011":"405","Bevölkerungsstruktur Kroatinnen und Kroaten  2012":"415","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011":"376","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012":"373","Bevölkerungsstruktur Polinnen und Polen  2011":"947","Bevölkerungsstruktur Polinnen und Polen  2012":"1059","Bevölkerungsstruktur Rumäninnen und Rumänen  2011":"572","Bevölkerungsstruktur Rumäninnen und Rumänen  2012":"646","Bevölkerungsstruktur Serbierinnen und Serbier  2011":"487","Bevölkerungsstruktur Serbierinnen und Serbier  2012":"487","Bevölkerungsstruktur Spanierinnen und Spanier  2011":"134","Bevölkerungsstruktur Spanierinnen und Spanier  2012":"147","Bevölkerungsstruktur Türkinnen und Türken  2011":"1666","Bevölkerungsstruktur Türkinnen und Türken  2012":"1622","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011":"116","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012":"163","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011":"106","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012":"238","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011":"57","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012":"64","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011":"115","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012":"152","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011":"625","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012":"848","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011":"1057","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012":"1168","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011":"115","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012":"150","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011":"134","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012":"137","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011":"146","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012":"157","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011":"572","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012":"857","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011":"5412","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012":"5680","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011":"1976","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012":"2045","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011":"3350","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012":"3540","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011":"86","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012":"95","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011":"9769","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012":"9843","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011":"1399","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012":"1414","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011":"5499","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012":"5591","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011":"2871","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012":"2838","":""},{"Codes":"20","Stadtteil":"Rödelheim","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011":"16890","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012":"17026","Bevölkerungsstruktur Frauen in %  2011":"50,3","Bevölkerungsstruktur Frauen in %  2012":"50,3","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011":"2,0","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012":"2,4","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011":"2,2","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012":"3,7","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011":"9911","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012":"8765","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011":"2315","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012":"3481","Bevölkerungsstruktur Ausländerinnen und Ausländer  2011":"4664","Bevölkerungsstruktur Ausländerinnen und Ausländer  2012":"4780","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011":"27,6","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012":"28,1","Bevölkerungsstruktur Durchschnittsalter  2011":"41,8","Bevölkerungsstruktur Durchschnittsalter  2012":"41,8","Bevölkerungsstruktur Jugendquotient  2011":"26,1","Bevölkerungsstruktur Jugendquotient  2012":"25,9","Bevölkerungsstruktur Altenquotient  2011":"26,1","Bevölkerungsstruktur Altenquotient  2012":"26,1","Bevölkerungsstruktur Kinder bis 5 Jahre  2011":"1027","Bevölkerungsstruktur Kinder bis 5 Jahre  2012":"986","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011":"47,7","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012":"48,0","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011":"639","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012":"286","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011":"228","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012":"545","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011":"160","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012":"155","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011":"1127","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012":"1149","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011":"47,6","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012":"46,8","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011":"586","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012":"349","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011":"303","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012":"578","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011":"238","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012":"222","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011":"466","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012":"503","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011":"50,6","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012":"52,1","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011":"203","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012":"162","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011":"118","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012":"186","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011":"145","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012":"155","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011":"2735","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012":"2776","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011":"52,1","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012":"51,5","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011":"1344","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012":"1321","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011":"485","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012":"520","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011":"906","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012":"935","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011":"8640","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012":"8691","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011":"48,8","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012":"49,0","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011":"4789","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012":"4542","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011":"1076","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012":"1298","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011":"2775","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012":"2851","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011":"2895","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012":"2921","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011":"54,8","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012":"54,8","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011":"2350","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012":"2105","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011":"105","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012":"354","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011":"440","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012":"462","Bevölkerungsstruktur Ausländerinnen in %  2011":"48,7","Bevölkerungsstruktur Ausländerinnen in %  2012":"49,0","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011":"1912","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012":"2022","Bevölkerungsstruktur EU-Ausländerinnen in %  2011":"48,0","Bevölkerungsstruktur EU-Ausländerinnen in %  2012":"47,4","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011":"49,0","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012":"48,8","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011":"509","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012":"899","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011":"48,9","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012":"50,9","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011":"3453","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012":"3547","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011":"321","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012":"322","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011":"139","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012":"156","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011":"700","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012":"704","Bevölkerungsstruktur Staatenlose  2011":"51","Bevölkerungsstruktur Staatenlose  2012":"51","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011":"115","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012":"116","Bevölkerungsstruktur Bosnierinnen und Bosnier  2011":"106","Bevölkerungsstruktur Bosnierinnen und Bosnier  2012":"101","Bevölkerungsstruktur Griechinnen und Griechen  2011":"157","Bevölkerungsstruktur Griechinnen und Griechen  2012":"155","Bevölkerungsstruktur Italienerinnen und Italiener  2011":"404","Bevölkerungsstruktur Italienerinnen und Italiener  2012":"408","Bevölkerungsstruktur Kroatinnen und Kroaten  2011":"251","Bevölkerungsstruktur Kroatinnen und Kroaten  2012":"255","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011":"122","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012":"113","Bevölkerungsstruktur Polinnen und Polen  2011":"367","Bevölkerungsstruktur Polinnen und Polen  2012":"371","Bevölkerungsstruktur Rumäninnen und Rumänen  2011":"110","Bevölkerungsstruktur Rumäninnen und Rumänen  2012":"136","Bevölkerungsstruktur Serbierinnen und Serbier  2011":"195","Bevölkerungsstruktur Serbierinnen und Serbier  2012":"192","Bevölkerungsstruktur Spanierinnen und Spanier  2011":"154","Bevölkerungsstruktur Spanierinnen und Spanier  2012":"175","Bevölkerungsstruktur Türkinnen und Türken  2011":"755","Bevölkerungsstruktur Türkinnen und Türken  2012":"738","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011":"69","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012":"112","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011":"75","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012":"145","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011":"96","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012":"113","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011":"81","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012":"89","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011":"243","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012":"301","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011":"159","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012":"293","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011":"62","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012":"100","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011":"93","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012":"84","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011":"141","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012":"149","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011":"271","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012":"425","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011":"3411","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012":"3521","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011":"1433","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012":"1474","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011":"1881","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012":"1941","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011":"97","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012":"106","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011":"7935","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012":"7927","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011":"906","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012":"918","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011":"4377","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012":"4335","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011":"2652","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012":"2674","":""},{"Codes":"21","Stadtteil":"Hausen","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011":"7025","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012":"7172","Bevölkerungsstruktur Frauen in %  2011":"50,9","Bevölkerungsstruktur Frauen in %  2012":"51,3","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011":"8,4","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012":"9,4","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011":"3,4","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012":"5,3","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011":"3543","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012":"2977","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011":"1317","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012":"1928","Bevölkerungsstruktur Ausländerinnen und Ausländer  2011":"2165","Bevölkerungsstruktur Ausländerinnen und Ausländer  2012":"2267","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011":"30,8","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012":"31,6","Bevölkerungsstruktur Durchschnittsalter  2011":"40,8","Bevölkerungsstruktur Durchschnittsalter  2012":"40,8","Bevölkerungsstruktur Jugendquotient  2011":"30,4","Bevölkerungsstruktur Jugendquotient  2012":"29,6","Bevölkerungsstruktur Altenquotient  2011":"27,0","Bevölkerungsstruktur Altenquotient  2012":"26,8","Bevölkerungsstruktur Kinder bis 5 Jahre  2011":"446","Bevölkerungsstruktur Kinder bis 5 Jahre  2012":"433","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011":"46,4","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012":"48,5","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011":"209","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012":"62","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011":"135","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012":"270","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011":"102","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012":"101","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011":"536","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012":"539","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011":"49,6","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012":"49,2","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011":"212","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012":"85","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011":"172","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012":"304","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011":"152","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012":"150","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011":"239","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012":"237","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011":"48,5","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012":"46,8","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011":"100","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012":"63","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011":"85","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012":"121","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011":"54","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012":"53","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011":"1347","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012":"1431","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011":"50,4","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012":"51,4","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011":"454","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012":"449","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011":"251","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012":"290","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011":"642","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012":"692","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011":"3253","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012":"3304","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011":"50,3","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012":"50,8","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011":"1528","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012":"1423","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011":"615","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012":"732","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011":"1110","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012":"1149","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011":"1204","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012":"1228","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011":"55,6","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012":"55,5","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011":"1040","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012":"895","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011":"59","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012":"211","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011":"105","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012":"122","Bevölkerungsstruktur Ausländerinnen in %  2011":"50,4","Bevölkerungsstruktur Ausländerinnen in %  2012":"50,6","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011":"506","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012":"549","Bevölkerungsstruktur EU-Ausländerinnen in %  2011":"48,6","Bevölkerungsstruktur EU-Ausländerinnen in %  2012":"47,9","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011":"49,8","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012":"49,7","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011":"197","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012":"424","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011":"53,3","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012":"52,4","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011":"1087","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012":"1127","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011":"184","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012":"200","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011":"65","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012":"55","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011":"819","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012":"876","Bevölkerungsstruktur Staatenlose  2011":"10","Bevölkerungsstruktur Staatenlose  2012":"9","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011":"106","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012":"105","Bevölkerungsstruktur Bosnierinnen und Bosnier  2011":"24","Bevölkerungsstruktur Bosnierinnen und Bosnier  2012":"24","Bevölkerungsstruktur Griechinnen und Griechen  2011":"58","Bevölkerungsstruktur Griechinnen und Griechen  2012":"60","Bevölkerungsstruktur Italienerinnen und Italiener  2011":"100","Bevölkerungsstruktur Italienerinnen und Italiener  2012":"108","Bevölkerungsstruktur Kroatinnen und Kroaten  2011":"43","Bevölkerungsstruktur Kroatinnen und Kroaten  2012":"49","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011":"80","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012":"85","Bevölkerungsstruktur Polinnen und Polen  2011":"78","Bevölkerungsstruktur Polinnen und Polen  2012":"90","Bevölkerungsstruktur Rumäninnen und Rumänen  2011":"25","Bevölkerungsstruktur Rumäninnen und Rumänen  2012":"33","Bevölkerungsstruktur Serbierinnen und Serbier  2011":"65","Bevölkerungsstruktur Serbierinnen und Serbier  2012":"63","Bevölkerungsstruktur Spanierinnen und Spanier  2011":"33","Bevölkerungsstruktur Spanierinnen und Spanier  2012":"44","Bevölkerungsstruktur Türkinnen und Türken  2011":"316","Bevölkerungsstruktur Türkinnen und Türken  2012":"296","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011":"80","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012":"115","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011":"62","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012":"92","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011":"88","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012":"103","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011":"23","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012":"29","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011":"265","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012":"298","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011":"75","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012":"179","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011":"16","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012":"20","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011":"40","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012":"27","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011":"68","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012":"81","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011":"119","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012":"206","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011":"1472","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012":"1600","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011":"746","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012":"827","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011":"698","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012":"732","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011":"28","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012":"41","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011":"3265","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012":"3310","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011":"423","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012":"439","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011":"1737","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012":"1757","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011":"1105","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012":"1114","":""},{"Codes":"22","Stadtteil":"Praunheim","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011":"15494","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012":"15700","Bevölkerungsstruktur Frauen in %  2011":"52,3","Bevölkerungsstruktur Frauen in %  2012":"52,3","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011":"0,5","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012":"1,9","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011":"1,0","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012":"3,2","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011":"9795","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012":"8681","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011":"2318","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012":"3479","Bevölkerungsstruktur Ausländerinnen und Ausländer  2011":"3381","Bevölkerungsstruktur Ausländerinnen und Ausländer  2012":"3540","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011":"21,8","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012":"22,5","Bevölkerungsstruktur Durchschnittsalter  2011":"43,3","Bevölkerungsstruktur Durchschnittsalter  2012":"43,2","Bevölkerungsstruktur Jugendquotient  2011":"32,3","Bevölkerungsstruktur Jugendquotient  2012":"32,3","Bevölkerungsstruktur Altenquotient  2011":"34,1","Bevölkerungsstruktur Altenquotient  2012":"33,8","Bevölkerungsstruktur Kinder bis 5 Jahre  2011":"896","Bevölkerungsstruktur Kinder bis 5 Jahre  2012":"923","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011":"47,9","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012":"47,3","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011":"543","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012":"238","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011":"244","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012":"559","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011":"109","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012":"126","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011":"1176","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012":"1192","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011":"48,0","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012":"47,7","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011":"637","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012":"357","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011":"304","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012":"611","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011":"235","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012":"224","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011":"668","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012":"642","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011":"47,6","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012":"46,1","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011":"365","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012":"293","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011":"166","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012":"206","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011":"137","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012":"143","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011":"2051","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012":"2146","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011":"51,6","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012":"52,1","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011":"1068","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012":"1070","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011":"401","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012":"456","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011":"582","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012":"620","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011":"7531","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012":"7601","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011":"51,5","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012":"51,6","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011":"4449","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012":"4282","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011":"1089","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012":"1242","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011":"1993","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012":"2077","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011":"3172","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012":"3196","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011":"58,8","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012":"58,6","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011":"2733","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012":"2441","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011":"114","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012":"405","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011":"325","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012":"350","Bevölkerungsstruktur Ausländerinnen in %  2011":"52,1","Bevölkerungsstruktur Ausländerinnen in %  2012":"52,0","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011":"1028","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012":"1159","Bevölkerungsstruktur EU-Ausländerinnen in %  2011":"49,9","Bevölkerungsstruktur EU-Ausländerinnen in %  2012":"48,8","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011":"47,5","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012":"49,4","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011":"515","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012":"954","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011":"46,8","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012":"50,8","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011":"2364","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012":"2513","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011":"315","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012":"312","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011":"87","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012":"100","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011":"596","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012":"594","Bevölkerungsstruktur Staatenlose  2011":"19","Bevölkerungsstruktur Staatenlose  2012":"21","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011":"109","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012":"102","Bevölkerungsstruktur Bosnierinnen und Bosnier  2011":"63","Bevölkerungsstruktur Bosnierinnen und Bosnier  2012":"78","Bevölkerungsstruktur Griechinnen und Griechen  2011":"80","Bevölkerungsstruktur Griechinnen und Griechen  2012":"78","Bevölkerungsstruktur Italienerinnen und Italiener  2011":"196","Bevölkerungsstruktur Italienerinnen und Italiener  2012":"217","Bevölkerungsstruktur Kroatinnen und Kroaten  2011":"231","Bevölkerungsstruktur Kroatinnen und Kroaten  2012":"238","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011":"146","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012":"141","Bevölkerungsstruktur Polinnen und Polen  2011":"225","Bevölkerungsstruktur Polinnen und Polen  2012":"238","Bevölkerungsstruktur Rumäninnen und Rumänen  2011":"66","Bevölkerungsstruktur Rumäninnen und Rumänen  2012":"111","Bevölkerungsstruktur Serbierinnen und Serbier  2011":"126","Bevölkerungsstruktur Serbierinnen und Serbier  2012":"129","Bevölkerungsstruktur Spanierinnen und Spanier  2011":"68","Bevölkerungsstruktur Spanierinnen und Spanier  2012":"73","Bevölkerungsstruktur Türkinnen und Türken  2011":"710","Bevölkerungsstruktur Türkinnen und Türken  2012":"701","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011":"69","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012":"90","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011":"73","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012":"138","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011":"114","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012":"128","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011":"74","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012":"104","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011":"364","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012":"420","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011":"246","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012":"431","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011":"43","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012":"78","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011":"85","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012":"74","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011":"139","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012":"182","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011":"256","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012":"417","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011":"1975","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012":"2070","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011":"740","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012":"772","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011":"1164","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012":"1212","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011":"71","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012":"86","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011":"8625","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012":"8712","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011":"1006","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012":"1066","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011":"4689","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012":"4696","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011":"2930","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012":"2950","":""},{"Codes":"24","Stadtteil":"Heddernheim","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011":"16625","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012":"16747","Bevölkerungsstruktur Frauen in %  2011":"53,0","Bevölkerungsstruktur Frauen in %  2012":"52,9","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011":"3,0","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012":"2,5","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011":"2,2","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012":"2,1","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011":"10349","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012":"9165","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011":"2835","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012":"4040","Bevölkerungsstruktur Ausländerinnen und Ausländer  2011":"3441","Bevölkerungsstruktur Ausländerinnen und Ausländer  2012":"3542","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011":"20,7","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012":"21,2","Bevölkerungsstruktur Durchschnittsalter  2011":"42,0","Bevölkerungsstruktur Durchschnittsalter  2012":"42,1","Bevölkerungsstruktur Jugendquotient  2011":"32,9","Bevölkerungsstruktur Jugendquotient  2012":"32,8","Bevölkerungsstruktur Altenquotient  2011":"30,6","Bevölkerungsstruktur Altenquotient  2012":"30,1","Bevölkerungsstruktur Kinder bis 5 Jahre  2011":"1033","Bevölkerungsstruktur Kinder bis 5 Jahre  2012":"1020","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011":"50,9","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012":"48,1","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011":"620","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012":"280","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011":"339","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012":"659","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011":"74","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012":"81","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011":"1288","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012":"1306","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011":"49,5","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012":"50,1","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011":"689","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012":"426","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011":"426","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012":"718","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011":"173","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012":"162","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011":"665","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012":"691","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011":"50,5","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012":"50,7","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011":"382","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012":"314","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011":"162","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012":"246","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011":"121","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012":"131","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011":"2448","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012":"2482","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011":"53,1","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012":"53,7","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011":"1312","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012":"1304","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011":"507","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012":"537","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011":"629","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012":"641","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011":"8077","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012":"8151","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011":"51,9","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012":"51,9","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011":"4735","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012":"4524","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011":"1261","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012":"1468","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011":"2081","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012":"2159","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011":"3114","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012":"3097","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011":"58,5","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012":"58,2","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011":"2611","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012":"2317","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011":"140","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012":"412","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011":"363","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012":"368","Bevölkerungsstruktur Ausländerinnen in %  2011":"52,2","Bevölkerungsstruktur Ausländerinnen in %  2012":"52,6","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011":"1133","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012":"1214","Bevölkerungsstruktur EU-Ausländerinnen in %  2011":"50,4","Bevölkerungsstruktur EU-Ausländerinnen in %  2012":"50,6","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011":"51,3","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012":"51,4","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011":"646","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012":"1080","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011":"52,3","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012":"56,7","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011":"2501","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012":"2585","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011":"380","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012":"388","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011":"114","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012":"103","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011":"435","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012":"456","Bevölkerungsstruktur Staatenlose  2011":"11","Bevölkerungsstruktur Staatenlose  2012":"10","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011":"108","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012":"104","Bevölkerungsstruktur Bosnierinnen und Bosnier  2011":"75","Bevölkerungsstruktur Bosnierinnen und Bosnier  2012":"75","Bevölkerungsstruktur Griechinnen und Griechen  2011":"106","Bevölkerungsstruktur Griechinnen und Griechen  2012":"109","Bevölkerungsstruktur Italienerinnen und Italiener  2011":"405","Bevölkerungsstruktur Italienerinnen und Italiener  2012":"405","Bevölkerungsstruktur Kroatinnen und Kroaten  2011":"224","Bevölkerungsstruktur Kroatinnen und Kroaten  2012":"242","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011":"197","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012":"198","Bevölkerungsstruktur Polinnen und Polen  2011":"170","Bevölkerungsstruktur Polinnen und Polen  2012":"192","Bevölkerungsstruktur Rumäninnen und Rumänen  2011":"45","Bevölkerungsstruktur Rumäninnen und Rumänen  2012":"63","Bevölkerungsstruktur Serbierinnen und Serbier  2011":"143","Bevölkerungsstruktur Serbierinnen und Serbier  2012":"143","Bevölkerungsstruktur Spanierinnen und Spanier  2011":"75","Bevölkerungsstruktur Spanierinnen und Spanier  2012":"90","Bevölkerungsstruktur Türkinnen und Türken  2011":"760","Bevölkerungsstruktur Türkinnen und Türken  2012":"733","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011":"92","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012":"111","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011":"104","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012":"151","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011":"148","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012":"166","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011":"134","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012":"170","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011":"481","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012":"552","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011":"242","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012":"421","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011":"77","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012":"105","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011":"92","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012":"81","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011":"142","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012":"162","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011":"333","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012":"565","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011":"1966","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012":"2079","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011":"790","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012":"830","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011":"1119","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012":"1193","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011":"57","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012":"56","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011":"9311","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012":"9286","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011":"1336","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012":"1312","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011":"5051","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012":"5060","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011":"2924","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012":"2914","":""},{"Codes":"25","Stadtteil":"Niederursel","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011":"14975","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012":"15081","Bevölkerungsstruktur Frauen in %  2011":"51,7","Bevölkerungsstruktur Frauen in %  2012":"51,9","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011":"4,2","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012":"3,4","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011":"3,5","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012":"3,6","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011":"8759","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012":"7625","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011":"2789","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012":"4008","Bevölkerungsstruktur Ausländerinnen und Ausländer  2011":"3427","Bevölkerungsstruktur Ausländerinnen und Ausländer  2012":"3448","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011":"22,9","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012":"22,9","Bevölkerungsstruktur Durchschnittsalter  2011":"42,9","Bevölkerungsstruktur Durchschnittsalter  2012":"42,9","Bevölkerungsstruktur Jugendquotient  2011":"35,2","Bevölkerungsstruktur Jugendquotient  2012":"35,0","Bevölkerungsstruktur Altenquotient  2011":"36,8","Bevölkerungsstruktur Altenquotient  2012":"35,8","Bevölkerungsstruktur Kinder bis 5 Jahre  2011":"903","Bevölkerungsstruktur Kinder bis 5 Jahre  2012":"951","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011":"49,7","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012":"49,0","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011":"500","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012":"200","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011":"310","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012":"648","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011":"93","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012":"103","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011":"1286","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012":"1256","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011":"44,8","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012":"45,1","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011":"636","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012":"341","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011":"431","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012":"730","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011":"219","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012":"185","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011":"595","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012":"572","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011":"47,1","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012":"45,5","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011":"296","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012":"205","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011":"155","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012":"248","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011":"144","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012":"119","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011":"1952","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012":"1994","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011":"51,5","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012":"53,3","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011":"928","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012":"932","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011":"460","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012":"500","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011":"564","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012":"562","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011":"7037","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012":"7149","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011":"50,2","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012":"50,5","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011":"3652","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012":"3541","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011":"1283","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012":"1459","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011":"2102","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012":"2149","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011":"3202","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012":"3159","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011":"59,1","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012":"59,0","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011":"2747","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012":"2406","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011":"150","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012":"423","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011":"305","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012":"330","Bevölkerungsstruktur Ausländerinnen in %  2011":"52,3","Bevölkerungsstruktur Ausländerinnen in %  2012":"52,8","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011":"953","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012":"1007","Bevölkerungsstruktur EU-Ausländerinnen in %  2011":"52,5","Bevölkerungsstruktur EU-Ausländerinnen in %  2012":"51,8","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011":"48,4","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012":"49,2","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011":"541","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012":"991","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011":"51,0","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012":"51,2","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011":"2378","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012":"2367","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011":"280","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012":"281","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011":"84","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012":"92","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011":"672","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012":"694","Bevölkerungsstruktur Staatenlose  2011":"13","Bevölkerungsstruktur Staatenlose  2012":"14","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011":"107","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012":"107","Bevölkerungsstruktur Bosnierinnen und Bosnier  2011":"78","Bevölkerungsstruktur Bosnierinnen und Bosnier  2012":"78","Bevölkerungsstruktur Griechinnen und Griechen  2011":"87","Bevölkerungsstruktur Griechinnen und Griechen  2012":"86","Bevölkerungsstruktur Italienerinnen und Italiener  2011":"245","Bevölkerungsstruktur Italienerinnen und Italiener  2012":"260","Bevölkerungsstruktur Kroatinnen und Kroaten  2011":"218","Bevölkerungsstruktur Kroatinnen und Kroaten  2012":"191","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011":"153","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012":"156","Bevölkerungsstruktur Polinnen und Polen  2011":"147","Bevölkerungsstruktur Polinnen und Polen  2012":"180","Bevölkerungsstruktur Rumäninnen und Rumänen  2011":"31","Bevölkerungsstruktur Rumäninnen und Rumänen  2012":"39","Bevölkerungsstruktur Serbierinnen und Serbier  2011":"96","Bevölkerungsstruktur Serbierinnen und Serbier  2012":"100","Bevölkerungsstruktur Spanierinnen und Spanier  2011":"49","Bevölkerungsstruktur Spanierinnen und Spanier  2012":"54","Bevölkerungsstruktur Türkinnen und Türken  2011":"850","Bevölkerungsstruktur Türkinnen und Türken  2012":"810","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011":"92","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012":"112","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011":"63","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012":"115","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011":"136","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012":"149","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011":"52","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012":"72","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011":"417","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012":"502","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011":"262","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012":"432","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011":"48","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012":"76","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011":"78","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012":"78","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011":"174","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012":"227","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011":"381","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012":"537","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011":"1954","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012":"2000","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011":"707","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012":"715","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011":"1175","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012":"1197","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011":"72","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012":"88","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011":"7954","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012":"7966","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011":"975","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012":"968","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011":"4021","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012":"4089","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011":"2958","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012":"2909","":""},{"Codes":"26","Stadtteil":"Ginnheim","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011":"16153","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012":"16346","Bevölkerungsstruktur Frauen in %  2011":"52,8","Bevölkerungsstruktur Frauen in %  2012":"52,6","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011":"5,3","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012":"5,9","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011":"1,3","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012":"2,6","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011":"9343","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012":"8017","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011":"3221","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012":"4674","Bevölkerungsstruktur Ausländerinnen und Ausländer  2011":"3589","Bevölkerungsstruktur Ausländerinnen und Ausländer  2012":"3655","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011":"22,2","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012":"22,4","Bevölkerungsstruktur Durchschnittsalter  2011":"40,3","Bevölkerungsstruktur Durchschnittsalter  2012":"40,4","Bevölkerungsstruktur Jugendquotient  2011":"37,5","Bevölkerungsstruktur Jugendquotient  2012":"36,5","Bevölkerungsstruktur Altenquotient  2011":"27,0","Bevölkerungsstruktur Altenquotient  2012":"26,7","Bevölkerungsstruktur Kinder bis 5 Jahre  2011":"1005","Bevölkerungsstruktur Kinder bis 5 Jahre  2012":"987","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011":"48,9","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012":"50,8","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011":"677","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012":"270","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011":"242","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012":"624","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011":"86","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012":"93","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011":"1438","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012":"1430","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011":"49,9","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012":"49,9","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011":"778","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012":"411","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011":"467","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012":"857","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011":"193","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012":"162","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011":"811","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012":"803","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011":"49,9","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012":"49,4","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011":"363","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012":"251","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011":"268","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012":"372","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011":"180","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012":"180","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011":"2479","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012":"2609","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011":"51,8","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012":"51,0","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011":"1187","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012":"1200","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011":"665","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012":"781","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011":"627","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012":"628","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011":"7768","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012":"7844","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011":"52,4","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012":"52,2","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011":"4172","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012":"3944","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011":"1444","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012":"1682","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011":"2152","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012":"2218","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011":"2652","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012":"2673","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011":"59,0","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012":"58,6","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011":"2166","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012":"1941","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011":"135","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012":"358","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011":"351","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012":"374","Bevölkerungsstruktur Ausländerinnen in %  2011":"52,8","Bevölkerungsstruktur Ausländerinnen in %  2012":"52,5","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011":"1102","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012":"1182","Bevölkerungsstruktur EU-Ausländerinnen in %  2011":"53,4","Bevölkerungsstruktur EU-Ausländerinnen in %  2012":"52,5","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011":"50,5","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012":"50,8","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011":"554","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012":"972","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011":"56,1","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012":"57,8","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011":"2565","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012":"2640","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011":"309","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012":"309","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011":"124","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012":"128","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011":"577","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012":"567","Bevölkerungsstruktur Staatenlose  2011":"14","Bevölkerungsstruktur Staatenlose  2012":"11","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011":"113","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012":"112","Bevölkerungsstruktur Bosnierinnen und Bosnier  2011":"65","Bevölkerungsstruktur Bosnierinnen und Bosnier  2012":"70","Bevölkerungsstruktur Griechinnen und Griechen  2011":"124","Bevölkerungsstruktur Griechinnen und Griechen  2012":"144","Bevölkerungsstruktur Italienerinnen und Italiener  2011":"242","Bevölkerungsstruktur Italienerinnen und Italiener  2012":"252","Bevölkerungsstruktur Kroatinnen und Kroaten  2011":"293","Bevölkerungsstruktur Kroatinnen und Kroaten  2012":"272","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011":"132","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012":"125","Bevölkerungsstruktur Polinnen und Polen  2011":"209","Bevölkerungsstruktur Polinnen und Polen  2012":"220","Bevölkerungsstruktur Rumäninnen und Rumänen  2011":"32","Bevölkerungsstruktur Rumäninnen und Rumänen  2012":"62","Bevölkerungsstruktur Serbierinnen und Serbier  2011":"172","Bevölkerungsstruktur Serbierinnen und Serbier  2012":"190","Bevölkerungsstruktur Spanierinnen und Spanier  2011":"80","Bevölkerungsstruktur Spanierinnen und Spanier  2012":"68","Bevölkerungsstruktur Türkinnen und Türken  2011":"638","Bevölkerungsstruktur Türkinnen und Türken  2012":"628","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011":"184","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012":"232","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011":"109","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012":"225","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011":"262","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012":"296","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011":"95","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012":"117","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011":"387","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012":"524","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011":"193","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012":"333","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011":"51","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012":"75","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011":"82","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012":"87","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011":"174","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012":"188","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011":"354","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012":"580","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011":"2132","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012":"2191","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011":"807","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012":"880","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011":"1251","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012":"1243","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011":"74","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012":"68","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011":"8063","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012":"8215","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011":"1297","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012":"1381","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011":"4388","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012":"4430","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011":"2378","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012":"2404","":""},{"Codes":"27","Stadtteil":"Dornbusch","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011":"17688","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012":"17817","Bevölkerungsstruktur Frauen in %  2011":"53,9","Bevölkerungsstruktur Frauen in %  2012":"53,9","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011":"4,8","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012":"4,2","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011":"3,2","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012":"2,7","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011":"12110","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012":"10847","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011":"2140","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012":"3474","Bevölkerungsstruktur Ausländerinnen und Ausländer  2011":"3438","Bevölkerungsstruktur Ausländerinnen und Ausländer  2012":"3496","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011":"19,4","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012":"19,6","Bevölkerungsstruktur Durchschnittsalter  2011":"44,0","Bevölkerungsstruktur Durchschnittsalter  2012":"44,0","Bevölkerungsstruktur Jugendquotient  2011":"26,6","Bevölkerungsstruktur Jugendquotient  2012":"26,3","Bevölkerungsstruktur Altenquotient  2011":"35,2","Bevölkerungsstruktur Altenquotient  2012":"35,0","Bevölkerungsstruktur Kinder bis 5 Jahre  2011":"961","Bevölkerungsstruktur Kinder bis 5 Jahre  2012":"953","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011":"50,3","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012":"49,6","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011":"666","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012":"350","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011":"196","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012":"510","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011":"99","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012":"93","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011":"1204","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012":"1197","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011":"47,6","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012":"47,4","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011":"822","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012":"563","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011":"229","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012":"488","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011":"153","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012":"146","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011":"485","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012":"492","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011":"49,9","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012":"52,2","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011":"303","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012":"245","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011":"85","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012":"144","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011":"97","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012":"103","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011":"2599","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012":"2604","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011":"53,9","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012":"53,2","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011":"1467","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012":"1453","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011":"422","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012":"476","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011":"710","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012":"675","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011":"8589","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012":"8705","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011":"52,3","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012":"52,4","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011":"5476","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012":"5266","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011":"1080","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012":"1333","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011":"2033","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012":"2106","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011":"3850","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012":"3866","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011":"60,9","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012":"61,0","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011":"3376","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012":"2970","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011":"128","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012":"523","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011":"346","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012":"373","Bevölkerungsstruktur Ausländerinnen in %  2011":"52,4","Bevölkerungsstruktur Ausländerinnen in %  2012":"53,6","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011":"1335","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012":"1377","Bevölkerungsstruktur EU-Ausländerinnen in %  2011":"51,4","Bevölkerungsstruktur EU-Ausländerinnen in %  2012":"52,8","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011":"51,7","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012":"52,6","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011":"576","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012":"1136","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011":"56,3","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012":"56,6","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011":"2440","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012":"2501","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011":"209","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012":"217","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011":"194","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012":"205","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011":"585","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012":"564","Bevölkerungsstruktur Staatenlose  2011":"10","Bevölkerungsstruktur Staatenlose  2012":"9","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011":"112","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012":"118","Bevölkerungsstruktur Bosnierinnen und Bosnier  2011":"87","Bevölkerungsstruktur Bosnierinnen und Bosnier  2012":"87","Bevölkerungsstruktur Griechinnen und Griechen  2011":"115","Bevölkerungsstruktur Griechinnen und Griechen  2012":"122","Bevölkerungsstruktur Italienerinnen und Italiener  2011":"309","Bevölkerungsstruktur Italienerinnen und Italiener  2012":"290","Bevölkerungsstruktur Kroatinnen und Kroaten  2011":"265","Bevölkerungsstruktur Kroatinnen und Kroaten  2012":"261","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011":"83","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012":"84","Bevölkerungsstruktur Polinnen und Polen  2011":"190","Bevölkerungsstruktur Polinnen und Polen  2012":"211","Bevölkerungsstruktur Rumäninnen und Rumänen  2011":"55","Bevölkerungsstruktur Rumäninnen und Rumänen  2012":"68","Bevölkerungsstruktur Serbierinnen und Serbier  2011":"168","Bevölkerungsstruktur Serbierinnen und Serbier  2012":"167","Bevölkerungsstruktur Spanierinnen und Spanier  2011":"104","Bevölkerungsstruktur Spanierinnen und Spanier  2012":"124","Bevölkerungsstruktur Türkinnen und Türken  2011":"406","Bevölkerungsstruktur Türkinnen und Türken  2012":"409","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011":"29","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012":"51","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011":"43","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012":"77","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011":"155","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012":"190","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011":"72","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012":"118","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011":"141","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012":"225","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011":"163","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012":"359","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011":"90","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012":"135","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011":"74","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012":"91","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011":"118","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012":"153","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011":"229","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012":"386","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011":"3080","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012":"3107","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011":"1276","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012":"1263","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011":"1657","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012":"1690","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011":"147","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012":"154","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011":"8866","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012":"8920","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011":"963","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012":"975","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011":"4432","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012":"4470","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011":"3471","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012":"3475","":""},{"Codes":"28","Stadtteil":"Eschersheim","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011":"14234","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012":"14381","Bevölkerungsstruktur Frauen in %  2011":"53,1","Bevölkerungsstruktur Frauen in %  2012":"53,0","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011":"7,4","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012":"8,3","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011":"5,4","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012":"4,4","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011":"10057","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012":"9169","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011":"1591","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012":"2538","Bevölkerungsstruktur Ausländerinnen und Ausländer  2011":"2586","Bevölkerungsstruktur Ausländerinnen und Ausländer  2012":"2674","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011":"18,2","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012":"18,6","Bevölkerungsstruktur Durchschnittsalter  2011":"42,4","Bevölkerungsstruktur Durchschnittsalter  2012":"42,4","Bevölkerungsstruktur Jugendquotient  2011":"27,5","Bevölkerungsstruktur Jugendquotient  2012":"27,6","Bevölkerungsstruktur Altenquotient  2011":"29,2","Bevölkerungsstruktur Altenquotient  2012":"29,1","Bevölkerungsstruktur Kinder bis 5 Jahre  2011":"828","Bevölkerungsstruktur Kinder bis 5 Jahre  2012":"832","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011":"51,6","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012":"51,1","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011":"590","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012":"355","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011":"139","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012":"374","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011":"99","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012":"103","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011":"964","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012":"967","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011":"47,9","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012":"47,4","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011":"675","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012":"493","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011":"178","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012":"353","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011":"111","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012":"121","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011":"472","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012":"489","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011":"50,8","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012":"50,5","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011":"300","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012":"254","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011":"81","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012":"144","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011":"91","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012":"91","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011":"2262","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012":"2259","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011":"52,4","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012":"53,5","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011":"1346","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012":"1323","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011":"362","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012":"389","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011":"554","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012":"547","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011":"7057","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012":"7164","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011":"51,8","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012":"51,5","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011":"4765","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012":"4599","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011":"770","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012":"970","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011":"1522","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012":"1595","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011":"2651","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012":"2670","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011":"59,7","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012":"59,4","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011":"2381","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012":"2145","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011":"61","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012":"308","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011":"209","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012":"217","Bevölkerungsstruktur Ausländerinnen in %  2011":"51,0","Bevölkerungsstruktur Ausländerinnen in %  2012":"52,0","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011":"1022","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012":"1120","Bevölkerungsstruktur EU-Ausländerinnen in %  2011":"50,7","Bevölkerungsstruktur EU-Ausländerinnen in %  2012":"50,6","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011":"50,7","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012":"50,1","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011":"420","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012":"845","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011":"52,6","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012":"53,7","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011":"1926","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012":"2017","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011":"158","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012":"147","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011":"141","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012":"136","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011":"349","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012":"358","Bevölkerungsstruktur Staatenlose  2011":"12","Bevölkerungsstruktur Staatenlose  2012":"16","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011":"103","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012":"100","Bevölkerungsstruktur Bosnierinnen und Bosnier  2011":"84","Bevölkerungsstruktur Bosnierinnen und Bosnier  2012":"88","Bevölkerungsstruktur Griechinnen und Griechen  2011":"56","Bevölkerungsstruktur Griechinnen und Griechen  2012":"59","Bevölkerungsstruktur Italienerinnen und Italiener  2011":"231","Bevölkerungsstruktur Italienerinnen und Italiener  2012":"232","Bevölkerungsstruktur Kroatinnen und Kroaten  2011":"168","Bevölkerungsstruktur Kroatinnen und Kroaten  2012":"164","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011":"66","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012":"69","Bevölkerungsstruktur Polinnen und Polen  2011":"230","Bevölkerungsstruktur Polinnen und Polen  2012":"263","Bevölkerungsstruktur Rumäninnen und Rumänen  2011":"44","Bevölkerungsstruktur Rumäninnen und Rumänen  2012":"81","Bevölkerungsstruktur Serbierinnen und Serbier  2011":"132","Bevölkerungsstruktur Serbierinnen und Serbier  2012":"124","Bevölkerungsstruktur Spanierinnen und Spanier  2011":"52","Bevölkerungsstruktur Spanierinnen und Spanier  2012":"60","Bevölkerungsstruktur Türkinnen und Türken  2011":"396","Bevölkerungsstruktur Türkinnen und Türken  2012":"366","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011":"52","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012":"78","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011":"29","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012":"56","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011":"84","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012":"106","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011":"50","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012":"87","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011":"126","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012":"185","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011":"156","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012":"302","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011":"57","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012":"97","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011":"48","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012":"51","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011":"120","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012":"130","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011":"160","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012":"248","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011":"2577","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012":"2594","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011":"1058","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012":"1073","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011":"1428","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012":"1429","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011":"91","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012":"92","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011":"6960","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012":"6961","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011":"875","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012":"858","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011":"3659","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012":"3682","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011":"2426","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012":"2421","":""},{"Codes":"29","Stadtteil":"Eckenheim","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011":"13994","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012":"14062","Bevölkerungsstruktur Frauen in %  2011":"52,1","Bevölkerungsstruktur Frauen in %  2012":"51,8","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011":"3,0","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012":"4,0","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011":"2,5","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012":"2,8","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011":"7716","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012":"6611","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011":"2528","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012":"3635","Bevölkerungsstruktur Ausländerinnen und Ausländer  2011":"3750","Bevölkerungsstruktur Ausländerinnen und Ausländer  2012":"3816","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011":"26,8","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012":"27,1","Bevölkerungsstruktur Durchschnittsalter  2011":"41,7","Bevölkerungsstruktur Durchschnittsalter  2012":"41,9","Bevölkerungsstruktur Jugendquotient  2011":"29,1","Bevölkerungsstruktur Jugendquotient  2012":"28,7","Bevölkerungsstruktur Altenquotient  2011":"27,6","Bevölkerungsstruktur Altenquotient  2012":"27,8","Bevölkerungsstruktur Kinder bis 5 Jahre  2011":"825","Bevölkerungsstruktur Kinder bis 5 Jahre  2012":"813","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011":"50,5","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012":"48,6","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011":"506","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012":"188","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011":"236","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012":"541","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011":"83","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012":"84","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011":"1004","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012":"983","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011":"49,1","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012":"48,9","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011":"521","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012":"267","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011":"322","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012":"581","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011":"161","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012":"135","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011":"492","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012":"495","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011":"47,0","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012":"46,3","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011":"206","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012":"155","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011":"144","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012":"208","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011":"142","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012":"132","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011":"2392","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012":"2398","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011":"50,8","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012":"51,0","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011":"1111","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012":"1065","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011":"520","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012":"560","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011":"761","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012":"773","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011":"6815","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012":"6875","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011":"51,0","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012":"50,9","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011":"3464","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012":"3288","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011":"1160","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012":"1343","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011":"2191","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012":"2244","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011":"2466","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012":"2498","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011":"59,3","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012":"58,3","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011":"1908","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012":"1648","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011":"146","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012":"402","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011":"412","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012":"448","Bevölkerungsstruktur Ausländerinnen in %  2011":"51,8","Bevölkerungsstruktur Ausländerinnen in %  2012":"51,3","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011":"1037","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012":"1104","Bevölkerungsstruktur EU-Ausländerinnen in %  2011":"47,3","Bevölkerungsstruktur EU-Ausländerinnen in %  2012":"46,2","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011":"49,0","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012":"49,9","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011":"428","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012":"743","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011":"51,9","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012":"54,5","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011":"2651","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012":"2672","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011":"350","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012":"360","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011":"144","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012":"157","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011":"592","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012":"617","Bevölkerungsstruktur Staatenlose  2011":"13","Bevölkerungsstruktur Staatenlose  2012":"10","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011":"109","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012":"107","Bevölkerungsstruktur Bosnierinnen und Bosnier  2011":"82","Bevölkerungsstruktur Bosnierinnen und Bosnier  2012":"95","Bevölkerungsstruktur Griechinnen und Griechen  2011":"69","Bevölkerungsstruktur Griechinnen und Griechen  2012":"75","Bevölkerungsstruktur Italienerinnen und Italiener  2011":"260","Bevölkerungsstruktur Italienerinnen und Italiener  2012":"254","Bevölkerungsstruktur Kroatinnen und Kroaten  2011":"303","Bevölkerungsstruktur Kroatinnen und Kroaten  2012":"298","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011":"147","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012":"141","Bevölkerungsstruktur Polinnen und Polen  2011":"175","Bevölkerungsstruktur Polinnen und Polen  2012":"202","Bevölkerungsstruktur Rumäninnen und Rumänen  2011":"78","Bevölkerungsstruktur Rumäninnen und Rumänen  2012":"82","Bevölkerungsstruktur Serbierinnen und Serbier  2011":"160","Bevölkerungsstruktur Serbierinnen und Serbier  2012":"148","Bevölkerungsstruktur Spanierinnen und Spanier  2011":"65","Bevölkerungsstruktur Spanierinnen und Spanier  2012":"71","Bevölkerungsstruktur Türkinnen und Türken  2011":"861","Bevölkerungsstruktur Türkinnen und Türken  2012":"829","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011":"118","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012":"184","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011":"78","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012":"156","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011":"146","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012":"162","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011":"68","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012":"71","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011":"276","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012":"377","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011":"155","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012":"297","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011":"51","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012":"70","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011":"68","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012":"54","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011":"157","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012":"183","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011":"327","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012":"471","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011":"2273","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012":"2351","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011":"1003","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012":"1020","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011":"1166","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012":"1210","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011":"104","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012":"121","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011":"7033","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012":"7040","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011":"1031","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012":"1011","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011":"3811","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012":"3824","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011":"2191","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012":"2205","":""},{"Codes":"30","Stadtteil":"Preungesheim","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011":"13534","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012":"13934","Bevölkerungsstruktur Frauen in %  2011":"51,5","Bevölkerungsstruktur Frauen in %  2012":"51,2","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011":"70,9","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012":"71,9","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011":"18,7","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012":"16,2","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011":"7719","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012":"6671","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011":"2330","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012":"3667","Bevölkerungsstruktur Ausländerinnen und Ausländer  2011":"3485","Bevölkerungsstruktur Ausländerinnen und Ausländer  2012":"3596","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011":"25,7","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012":"25,8","Bevölkerungsstruktur Durchschnittsalter  2011":"38,5","Bevölkerungsstruktur Durchschnittsalter  2012":"38,7","Bevölkerungsstruktur Jugendquotient  2011":"38,5","Bevölkerungsstruktur Jugendquotient  2012":"37,3","Bevölkerungsstruktur Altenquotient  2011":"22,1","Bevölkerungsstruktur Altenquotient  2012":"21,6","Bevölkerungsstruktur Kinder bis 5 Jahre  2011":"1125","Bevölkerungsstruktur Kinder bis 5 Jahre  2012":"1082","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011":"49,3","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012":"48,7","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011":"738","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012":"320","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011":"276","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012":"647","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011":"111","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012":"115","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011":"1326","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012":"1393","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011":"49,0","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012":"49,1","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011":"758","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012":"429","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011":"383","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012":"793","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011":"185","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012":"171","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011":"510","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012":"532","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011":"49,4","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012":"50,8","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011":"228","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012":"180","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011":"134","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012":"206","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011":"148","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012":"146","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011":"1923","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012":"1948","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011":"53,7","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012":"52,8","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011":"910","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012":"899","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011":"380","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012":"442","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011":"633","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012":"607","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011":"6790","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012":"7082","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011":"50,3","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012":"49,8","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011":"3572","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012":"3524","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011":"1079","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012":"1297","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011":"2139","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012":"2261","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011":"1860","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012":"1897","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011":"57,2","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012":"57,6","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011":"1513","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012":"1319","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011":"78","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012":"282","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011":"269","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012":"296","Bevölkerungsstruktur Ausländerinnen in %  2011":"51,5","Bevölkerungsstruktur Ausländerinnen in %  2012":"50,4","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011":"1156","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012":"1274","Bevölkerungsstruktur EU-Ausländerinnen in %  2011":"51,0","Bevölkerungsstruktur EU-Ausländerinnen in %  2012":"49,9","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011":"50,4","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012":"50,7","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011":"522","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012":"936","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011":"54,6","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012":"53,5","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011":"2604","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012":"2708","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011":"395","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012":"372","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011":"95","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012":"102","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011":"385","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012":"407","Bevölkerungsstruktur Staatenlose  2011":"6","Bevölkerungsstruktur Staatenlose  2012":"7","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011":"104","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012":"106","Bevölkerungsstruktur Bosnierinnen und Bosnier  2011":"124","Bevölkerungsstruktur Bosnierinnen und Bosnier  2012":"122","Bevölkerungsstruktur Griechinnen und Griechen  2011":"89","Bevölkerungsstruktur Griechinnen und Griechen  2012":"83","Bevölkerungsstruktur Italienerinnen und Italiener  2011":"304","Bevölkerungsstruktur Italienerinnen und Italiener  2012":"308","Bevölkerungsstruktur Kroatinnen und Kroaten  2011":"325","Bevölkerungsstruktur Kroatinnen und Kroaten  2012":"335","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011":"123","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012":"114","Bevölkerungsstruktur Polinnen und Polen  2011":"219","Bevölkerungsstruktur Polinnen und Polen  2012":"250","Bevölkerungsstruktur Rumäninnen und Rumänen  2011":"56","Bevölkerungsstruktur Rumäninnen und Rumänen  2012":"67","Bevölkerungsstruktur Serbierinnen und Serbier  2011":"203","Bevölkerungsstruktur Serbierinnen und Serbier  2012":"202","Bevölkerungsstruktur Spanierinnen und Spanier  2011":"56","Bevölkerungsstruktur Spanierinnen und Spanier  2012":"64","Bevölkerungsstruktur Türkinnen und Türken  2011":"660","Bevölkerungsstruktur Türkinnen und Türken  2012":"633","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011":"71","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012":"101","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011":"43","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012":"101","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011":"102","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012":"137","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011":"82","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012":"124","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011":"206","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012":"296","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011":"197","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012":"349","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011":"64","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012":"90","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011":"126","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012":"118","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011":"145","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012":"184","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011":"315","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012":"551","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011":"2145","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012":"2234","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011":"746","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012":"767","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011":"1291","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012":"1362","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011":"108","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012":"105","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011":"5866","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012":"6015","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011":"823","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012":"840","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011":"3434","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012":"3547","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011":"1609","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012":"1628","":""},{"Codes":"31","Stadtteil":"Bonames","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011":"6103","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012":"6139","Bevölkerungsstruktur Frauen in %  2011":"51,7","Bevölkerungsstruktur Frauen in %  2012":"52,1","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011":"-0,7","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012":"0,0","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011":"1,2","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012":"1,9","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011":"3697","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012":"3078","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011":"1141","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012":"1797","Bevölkerungsstruktur Ausländerinnen und Ausländer  2011":"1265","Bevölkerungsstruktur Ausländerinnen und Ausländer  2012":"1264","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011":"20,7","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012":"20,6","Bevölkerungsstruktur Durchschnittsalter  2011":"43,2","Bevölkerungsstruktur Durchschnittsalter  2012":"43,1","Bevölkerungsstruktur Jugendquotient  2011":"30,8","Bevölkerungsstruktur Jugendquotient  2012":"31,5","Bevölkerungsstruktur Altenquotient  2011":"31,6","Bevölkerungsstruktur Altenquotient  2012":"31,3","Bevölkerungsstruktur Kinder bis 5 Jahre  2011":"335","Bevölkerungsstruktur Kinder bis 5 Jahre  2012":"360","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011":"45,7","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012":"49,4","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011":"227","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012":"85","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011":"78","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012":"242","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011":"30","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012":"33","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011":"450","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012":"439","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011":"51,8","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012":"50,1","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011":"292","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012":"129","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011":"109","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012":"266","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011":"49","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012":"44","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011":"256","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012":"269","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011":"50,4","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012":"52,0","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011":"141","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012":"105","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011":"62","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012":"118","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011":"53","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012":"46","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011":"848","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012":"844","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011":"50,6","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012":"52,3","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011":"441","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012":"411","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011":"207","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012":"226","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011":"200","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012":"207","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011":"3028","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012":"3048","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011":"50,4","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012":"50,6","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011":"1652","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012":"1572","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011":"594","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012":"707","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011":"782","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012":"769","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011":"1186","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012":"1179","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011":"57,7","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012":"57,4","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011":"944","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012":"776","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011":"91","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012":"238","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011":"151","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012":"165","Bevölkerungsstruktur Ausländerinnen in %  2011":"50,1","Bevölkerungsstruktur Ausländerinnen in %  2012":"52,1","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011":"534","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012":"497","Bevölkerungsstruktur EU-Ausländerinnen in %  2011":"48,5","Bevölkerungsstruktur EU-Ausländerinnen in %  2012":"50,9","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011":"50,0","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012":"51,1","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011":"297","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012":"543","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011":"54,5","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012":"53,6","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011":"936","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012":"901","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011":"137","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012":"148","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011":"24","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012":"33","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011":"159","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012":"173","Bevölkerungsstruktur Staatenlose  2011":"9","Bevölkerungsstruktur Staatenlose  2012":"9","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011":"77","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012":"80","Bevölkerungsstruktur Bosnierinnen und Bosnier  2011":"26","Bevölkerungsstruktur Bosnierinnen und Bosnier  2012":"26","Bevölkerungsstruktur Griechinnen und Griechen  2011":"104","Bevölkerungsstruktur Griechinnen und Griechen  2012":"119","Bevölkerungsstruktur Italienerinnen und Italiener  2011":"74","Bevölkerungsstruktur Italienerinnen und Italiener  2012":"80","Bevölkerungsstruktur Kroatinnen und Kroaten  2011":"72","Bevölkerungsstruktur Kroatinnen und Kroaten  2012":"71","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011":"74","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012":"77","Bevölkerungsstruktur Polinnen und Polen  2011":"102","Bevölkerungsstruktur Polinnen und Polen  2012":"100","Bevölkerungsstruktur Rumäninnen und Rumänen  2011":"74","Bevölkerungsstruktur Rumäninnen und Rumänen  2012":"31","Bevölkerungsstruktur Serbierinnen und Serbier  2011":"45","Bevölkerungsstruktur Serbierinnen und Serbier  2012":"43","Bevölkerungsstruktur Spanierinnen und Spanier  2011":"48","Bevölkerungsstruktur Spanierinnen und Spanier  2012":"44","Bevölkerungsstruktur Türkinnen und Türken  2011":"192","Bevölkerungsstruktur Türkinnen und Türken  2012":"181","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011":"78","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012":"107","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011":"34","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012":"67","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011":"25","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012":"30","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011":"21","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012":"31","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011":"101","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012":"137","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011":"183","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012":"311","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011":"34","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012":"47","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011":"24","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012":"16","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011":"98","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012":"134","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011":"91","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012":"138","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011":"822","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012":"835","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011":"280","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012":"282","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011":"506","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012":"512","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011":"36","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012":"41","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011":"3319","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012":"3322","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011":"439","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012":"430","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011":"1803","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012":"1822","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011":"1077","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012":"1070","":""},{"Codes":"32","Stadtteil":"Berkersheim","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011":"3473","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012":"3643","Bevölkerungsstruktur Frauen in %  2011":"51,6","Bevölkerungsstruktur Frauen in %  2012":"51,4","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011":"15,6","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012":"18,5","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011":"7,7","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012":"12,4","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011":"2320","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012":"2073","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011":"591","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012":"959","Bevölkerungsstruktur Ausländerinnen und Ausländer  2011":"562","Bevölkerungsstruktur Ausländerinnen und Ausländer  2012":"611","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011":"16,2","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012":"16,8","Bevölkerungsstruktur Durchschnittsalter  2011":"39,3","Bevölkerungsstruktur Durchschnittsalter  2012":"38,9","Bevölkerungsstruktur Jugendquotient  2011":"44,5","Bevölkerungsstruktur Jugendquotient  2012":"45,8","Bevölkerungsstruktur Altenquotient  2011":"27,3","Bevölkerungsstruktur Altenquotient  2012":"25,9","Bevölkerungsstruktur Kinder bis 5 Jahre  2011":"234","Bevölkerungsstruktur Kinder bis 5 Jahre  2012":"252","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011":"51,3","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012":"50,8","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011":"176","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012":"94","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011":"41","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012":"138","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011":"17","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012":"20","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011":"403","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012":"417","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011":"49,1","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012":"48,4","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011":"260","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012":"173","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011":"97","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012":"207","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011":"46","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012":"37","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011":"184","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012":"210","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011":"38,6","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012":"40,0","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011":"100","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012":"83","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011":"55","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012":"92","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011":"29","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012":"35","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011":"444","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012":"463","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011":"52,7","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012":"52,9","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011":"246","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012":"244","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011":"101","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012":"118","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011":"97","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012":"101","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011":"1657","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012":"1752","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011":"52,7","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012":"52,5","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011":"1049","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012":"1032","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011":"278","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012":"344","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011":"330","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012":"376","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011":"551","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012":"549","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011":"53,5","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012":"53,4","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011":"489","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012":"447","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011":"19","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012":"60","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011":"43","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012":"42","Bevölkerungsstruktur Ausländerinnen in %  2011":"53,6","Bevölkerungsstruktur Ausländerinnen in %  2012":"53,5","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011":"228","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012":"248","Bevölkerungsstruktur EU-Ausländerinnen in %  2011":"50,4","Bevölkerungsstruktur EU-Ausländerinnen in %  2012":"52,0","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011":"52,8","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012":"50,3","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011":"108","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012":"216","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011":"51,9","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012":"48,1","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011":"370","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012":"390","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011":"54","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012":"53","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011":"40","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012":"41","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011":"98","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012":"127","Bevölkerungsstruktur Staatenlose  2011":"0","Bevölkerungsstruktur Staatenlose  2012":"0","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011":"61","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012":"72","Bevölkerungsstruktur Bosnierinnen und Bosnier  2011":"9","Bevölkerungsstruktur Bosnierinnen und Bosnier  2012":"8","Bevölkerungsstruktur Griechinnen und Griechen  2011":"17","Bevölkerungsstruktur Griechinnen und Griechen  2012":"17","Bevölkerungsstruktur Italienerinnen und Italiener  2011":"36","Bevölkerungsstruktur Italienerinnen und Italiener  2012":"41","Bevölkerungsstruktur Kroatinnen und Kroaten  2011":"33","Bevölkerungsstruktur Kroatinnen und Kroaten  2012":"35","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011":"29","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012":"27","Bevölkerungsstruktur Polinnen und Polen  2011":"57","Bevölkerungsstruktur Polinnen und Polen  2012":"56","Bevölkerungsstruktur Rumäninnen und Rumänen  2011":"3","Bevölkerungsstruktur Rumäninnen und Rumänen  2012":"5","Bevölkerungsstruktur Serbierinnen und Serbier  2011":"12","Bevölkerungsstruktur Serbierinnen und Serbier  2012":"10","Bevölkerungsstruktur Spanierinnen und Spanier  2011":"10","Bevölkerungsstruktur Spanierinnen und Spanier  2012":"10","Bevölkerungsstruktur Türkinnen und Türken  2011":"69","Bevölkerungsstruktur Türkinnen und Türken  2012":"69","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011":"44","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012":"66","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011":"13","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012":"29","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011":"54","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012":"71","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011":"20","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012":"22","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011":"119","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012":"149","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011":"51","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012":"106","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011":"13","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012":"19","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011":"9","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012":"19","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011":"31","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012":"35","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011":"45","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012":"75","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011":"399","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012":"432","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011":"149","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012":"141","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011":"230","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012":"270","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011":"20","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012":"21","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011":"1764","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012":"1794","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011":"242","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012":"257","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011":"1022","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012":"1035","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011":"500","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012":"502","":""},{"Codes":"33","Stadtteil":"Riederwald","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011":"4670","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012":"4664","Bevölkerungsstruktur Frauen in %  2011":"51,4","Bevölkerungsstruktur Frauen in %  2012":"51,0","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011":"0,3","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012":"-0,9","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011":"1,0","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012":"1,9","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011":"2802","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012":"2458","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011":"753","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012":"1052","Bevölkerungsstruktur Ausländerinnen und Ausländer  2011":"1115","Bevölkerungsstruktur Ausländerinnen und Ausländer  2012":"1154","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011":"23,9","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012":"24,7","Bevölkerungsstruktur Durchschnittsalter  2011":"41,1","Bevölkerungsstruktur Durchschnittsalter  2012":"42,6","Bevölkerungsstruktur Jugendquotient  2011":"29,2","Bevölkerungsstruktur Jugendquotient  2012":"27,6","Bevölkerungsstruktur Altenquotient  2011":"27,2","Bevölkerungsstruktur Altenquotient  2012":"28,2","Bevölkerungsstruktur Kinder bis 5 Jahre  2011":"309","Bevölkerungsstruktur Kinder bis 5 Jahre  2012":"291","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011":"52,1","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012":"49,5","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011":"187","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012":"75","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011":"86","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012":"180","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011":"36","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012":"36","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011":"329","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012":"310","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011":"48,9","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012":"51,0","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011":"182","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012":"94","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011":"104","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012":"182","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011":"43","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012":"34","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011":"148","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012":"155","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011":"46,6","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012":"48,4","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011":"60","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012":"60","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011":"48","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012":"61","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011":"40","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012":"34","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011":"676","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012":"648","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011":"52,2","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012":"51,7","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011":"342","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012":"309","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011":"143","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012":"147","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011":"191","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012":"192","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011":"2395","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012":"2415","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011":"49,7","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012":"49,2","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011":"1377","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012":"1299","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011":"329","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012":"385","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011":"689","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012":"731","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011":"813","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012":"845","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011":"57,3","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012":"56,8","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011":"654","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012":"621","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011":"43","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012":"97","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011":"116","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012":"127","Bevölkerungsstruktur Ausländerinnen in %  2011":"51,4","Bevölkerungsstruktur Ausländerinnen in %  2012":"51,7","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011":"291","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012":"304","Bevölkerungsstruktur EU-Ausländerinnen in %  2011":"48,1","Bevölkerungsstruktur EU-Ausländerinnen in %  2012":"50,7","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011":"45,3","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012":"46,7","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011":"125","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012":"202","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011":"56,8","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012":"55,4","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011":"784","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012":"812","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011":"181","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012":"191","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011":"37","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012":"38","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011":"109","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012":"109","Bevölkerungsstruktur Staatenlose  2011":"4","Bevölkerungsstruktur Staatenlose  2012":"4","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011":"79","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012":"80","Bevölkerungsstruktur Bosnierinnen und Bosnier  2011":"33","Bevölkerungsstruktur Bosnierinnen und Bosnier  2012":"44","Bevölkerungsstruktur Griechinnen und Griechen  2011":"15","Bevölkerungsstruktur Griechinnen und Griechen  2012":"17","Bevölkerungsstruktur Italienerinnen und Italiener  2011":"102","Bevölkerungsstruktur Italienerinnen und Italiener  2012":"101","Bevölkerungsstruktur Kroatinnen und Kroaten  2011":"87","Bevölkerungsstruktur Kroatinnen und Kroaten  2012":"85","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011":"89","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012":"92","Bevölkerungsstruktur Polinnen und Polen  2011":"49","Bevölkerungsstruktur Polinnen und Polen  2012":"44","Bevölkerungsstruktur Rumäninnen und Rumänen  2011":"10","Bevölkerungsstruktur Rumäninnen und Rumänen  2012":"9","Bevölkerungsstruktur Serbierinnen und Serbier  2011":"63","Bevölkerungsstruktur Serbierinnen und Serbier  2012":"65","Bevölkerungsstruktur Spanierinnen und Spanier  2011":"13","Bevölkerungsstruktur Spanierinnen und Spanier  2012":"20","Bevölkerungsstruktur Türkinnen und Türken  2011":"261","Bevölkerungsstruktur Türkinnen und Türken  2012":"257","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011":"16","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012":"20","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011":"40","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012":"67","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011":"25","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012":"23","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011":"34","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012":"36","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011":"149","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012":"156","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011":"47","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012":"83","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011":"4","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012":"6","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011":"24","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012":"22","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011":"36","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012":"36","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011":"110","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012":"153","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011":"612","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012":"626","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011":"223","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012":"219","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011":"368","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012":"386","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011":"21","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012":"21","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011":"2459","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012":"2433","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011":"319","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012":"300","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011":"1388","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012":"1359","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011":"752","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012":"774","":""},{"Codes":"34","Stadtteil":"Seckbach","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011":"9706","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012":"9938","Bevölkerungsstruktur Frauen in %  2011":"51,6","Bevölkerungsstruktur Frauen in %  2012":"51,6","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011":"4,7","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012":"7,9","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011":"3,9","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012":"6,1","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011":"6479","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012":"5836","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011":"1142","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012":"1775","Bevölkerungsstruktur Ausländerinnen und Ausländer  2011":"2085","Bevölkerungsstruktur Ausländerinnen und Ausländer  2012":"2327","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011":"21,5","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012":"23,4","Bevölkerungsstruktur Durchschnittsalter  2011":"44,8","Bevölkerungsstruktur Durchschnittsalter  2012":"44,4","Bevölkerungsstruktur Jugendquotient  2011":"28,8","Bevölkerungsstruktur Jugendquotient  2012":"28,5","Bevölkerungsstruktur Altenquotient  2011":"37,2","Bevölkerungsstruktur Altenquotient  2012":"35,8","Bevölkerungsstruktur Kinder bis 5 Jahre  2011":"521","Bevölkerungsstruktur Kinder bis 5 Jahre  2012":"530","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011":"52,4","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012":"54,7","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011":"369","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012":"208","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011":"103","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012":"269","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011":"49","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012":"53","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011":"691","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012":"704","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011":"48,8","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012":"48,7","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011":"443","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012":"316","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011":"142","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012":"283","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011":"106","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012":"105","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011":"304","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012":"330","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011":"48,7","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012":"50,3","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011":"202","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012":"177","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011":"51","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012":"80","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011":"51","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012":"73","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011":"1295","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012":"1348","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011":"50,5","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012":"50,0","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011":"718","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012":"685","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011":"210","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012":"225","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011":"367","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012":"438","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011":"4720","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012":"4860","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011":"48,3","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012":"48,5","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011":"2852","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012":"2766","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011":"566","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012":"669","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011":"1302","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012":"1425","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011":"2175","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012":"2166","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011":"60,4","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012":"59,8","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011":"1895","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012":"1684","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011":"70","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012":"249","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011":"210","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012":"233","Bevölkerungsstruktur Ausländerinnen in %  2011":"46,1","Bevölkerungsstruktur Ausländerinnen in %  2012":"46,0","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011":"842","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012":"1046","Bevölkerungsstruktur EU-Ausländerinnen in %  2011":"41,9","Bevölkerungsstruktur EU-Ausländerinnen in %  2012":"41,1","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011":"46,1","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012":"48,6","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011":"342","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012":"624","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011":"42,7","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012":"47,6","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011":"1680","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012":"1891","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011":"128","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012":"150","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011":"72","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012":"74","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011":"184","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012":"191","Bevölkerungsstruktur Staatenlose  2011":"21","Bevölkerungsstruktur Staatenlose  2012":"21","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011":"96","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012":"97","Bevölkerungsstruktur Bosnierinnen und Bosnier  2011":"99","Bevölkerungsstruktur Bosnierinnen und Bosnier  2012":"82","Bevölkerungsstruktur Griechinnen und Griechen  2011":"34","Bevölkerungsstruktur Griechinnen und Griechen  2012":"40","Bevölkerungsstruktur Italienerinnen und Italiener  2011":"166","Bevölkerungsstruktur Italienerinnen und Italiener  2012":"173","Bevölkerungsstruktur Kroatinnen und Kroaten  2011":"160","Bevölkerungsstruktur Kroatinnen und Kroaten  2012":"174","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011":"41","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012":"53","Bevölkerungsstruktur Polinnen und Polen  2011":"164","Bevölkerungsstruktur Polinnen und Polen  2012":"222","Bevölkerungsstruktur Rumäninnen und Rumänen  2011":"90","Bevölkerungsstruktur Rumäninnen und Rumänen  2012":"156","Bevölkerungsstruktur Serbierinnen und Serbier  2011":"125","Bevölkerungsstruktur Serbierinnen und Serbier  2012":"119","Bevölkerungsstruktur Spanierinnen und Spanier  2011":"40","Bevölkerungsstruktur Spanierinnen und Spanier  2012":"43","Bevölkerungsstruktur Türkinnen und Türken  2011":"345","Bevölkerungsstruktur Türkinnen und Türken  2012":"359","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011":"19","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012":"23","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011":"21","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012":"39","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011":"37","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012":"46","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011":"49","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012":"64","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011":"70","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012":"113","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011":"165","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012":"264","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011":"33","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012":"60","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011":"51","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012":"41","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011":"55","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012":"72","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011":"143","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012":"215","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011":"1584","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012":"1685","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011":"553","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012":"596","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011":"933","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012":"992","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011":"98","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012":"97","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011":"5139","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012":"5134","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011":"549","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012":"552","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011":"2637","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012":"2634","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011":"1953","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012":"1948","":""},{"Codes":"35","Stadtteil":"Fechenheim","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011":"15615","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012":"15913","Bevölkerungsstruktur Frauen in %  2011":"49,6","Bevölkerungsstruktur Frauen in %  2012":"49,2","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011":"2,1","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012":"3,8","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011":"2,3","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012":"4,3","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011":"7398","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012":"6214","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011":"2591","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012":"3834","Bevölkerungsstruktur Ausländerinnen und Ausländer  2011":"5626","Bevölkerungsstruktur Ausländerinnen und Ausländer  2012":"5865","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011":"36,0","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012":"36,9","Bevölkerungsstruktur Durchschnittsalter  2011":"39,8","Bevölkerungsstruktur Durchschnittsalter  2012":"39,7","Bevölkerungsstruktur Jugendquotient  2011":"35,2","Bevölkerungsstruktur Jugendquotient  2012":"35,0","Bevölkerungsstruktur Altenquotient  2011":"25,0","Bevölkerungsstruktur Altenquotient  2012":"24,4","Bevölkerungsstruktur Kinder bis 5 Jahre  2011":"1071","Bevölkerungsstruktur Kinder bis 5 Jahre  2012":"1085","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011":"49,7","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012":"48,5","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011":"522","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012":"176","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011":"351","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012":"694","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011":"198","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012":"215","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011":"1342","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012":"1415","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011":"48,9","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012":"49,3","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011":"534","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012":"234","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011":"476","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012":"844","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011":"332","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012":"337","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011":"676","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012":"659","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011":"46,9","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012":"48,4","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011":"240","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012":"173","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011":"182","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012":"245","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011":"254","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012":"241","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011":"2595","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012":"2674","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011":"50,3","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012":"50,0","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011":"972","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012":"942","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011":"442","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012":"517","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011":"1181","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012":"1215","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011":"7493","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012":"7641","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011":"47,3","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012":"46,6","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011":"3203","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012":"2973","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011":"1049","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012":"1256","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011":"3241","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012":"3412","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011":"2438","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012":"2439","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011":"57,0","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012":"56,7","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011":"1927","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012":"1716","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011":"91","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012":"278","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011":"420","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012":"445","Bevölkerungsstruktur Ausländerinnen in %  2011":"48,1","Bevölkerungsstruktur Ausländerinnen in %  2012":"47,1","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011":"1886","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012":"2131","Bevölkerungsstruktur EU-Ausländerinnen in %  2011":"44,6","Bevölkerungsstruktur EU-Ausländerinnen in %  2012":"43,1","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011":"47,5","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012":"48,5","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011":"437","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012":"790","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011":"46,7","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012":"50,5","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011":"4279","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012":"4512","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011":"553","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012":"545","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011":"99","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012":"94","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011":"619","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012":"640","Bevölkerungsstruktur Staatenlose  2011":"76","Bevölkerungsstruktur Staatenlose  2012":"74","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011":"107","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012":"105","Bevölkerungsstruktur Bosnierinnen und Bosnier  2011":"196","Bevölkerungsstruktur Bosnierinnen und Bosnier  2012":"192","Bevölkerungsstruktur Griechinnen und Griechen  2011":"88","Bevölkerungsstruktur Griechinnen und Griechen  2012":"93","Bevölkerungsstruktur Italienerinnen und Italiener  2011":"551","Bevölkerungsstruktur Italienerinnen und Italiener  2012":"548","Bevölkerungsstruktur Kroatinnen und Kroaten  2011":"262","Bevölkerungsstruktur Kroatinnen und Kroaten  2012":"284","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011":"201","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012":"196","Bevölkerungsstruktur Polinnen und Polen  2011":"374","Bevölkerungsstruktur Polinnen und Polen  2012":"403","Bevölkerungsstruktur Rumäninnen und Rumänen  2011":"258","Bevölkerungsstruktur Rumäninnen und Rumänen  2012":"337","Bevölkerungsstruktur Serbierinnen und Serbier  2011":"394","Bevölkerungsstruktur Serbierinnen und Serbier  2012":"412","Bevölkerungsstruktur Spanierinnen und Spanier  2011":"71","Bevölkerungsstruktur Spanierinnen und Spanier  2012":"77","Bevölkerungsstruktur Türkinnen und Türken  2011":"1415","Bevölkerungsstruktur Türkinnen und Türken  2012":"1351","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011":"130","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012":"218","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011":"51","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012":"134","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011":"68","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012":"78","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011":"100","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012":"116","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011":"276","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012":"365","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011":"163","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012":"312","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011":"36","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012":"64","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011":"113","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012":"120","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011":"114","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012":"117","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011":"507","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012":"768","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011":"2960","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012":"3196","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011":"1182","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012":"1246","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011":"1703","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012":"1861","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011":"75","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012":"89","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011":"7061","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012":"7016","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011":"981","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012":"1007","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011":"3834","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012":"3780","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011":"2246","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012":"2229","":""},{"Codes":"36","Stadtteil":"Höchst","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011":"13751","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012":"14143","Bevölkerungsstruktur Frauen in %  2011":"48,8","Bevölkerungsstruktur Frauen in %  2012":"48,8","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011":"16,0","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012":"16,3","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011":"4,8","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012":"6,2","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011":"6339","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012":"5398","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011":"2253","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012":"3379","Bevölkerungsstruktur Ausländerinnen und Ausländer  2011":"5159","Bevölkerungsstruktur Ausländerinnen und Ausländer  2012":"5366","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011":"37,5","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012":"37,9","Bevölkerungsstruktur Durchschnittsalter  2011":"37,1","Bevölkerungsstruktur Durchschnittsalter  2012":"37,0","Bevölkerungsstruktur Jugendquotient  2011":"31,8","Bevölkerungsstruktur Jugendquotient  2012":"31,6","Bevölkerungsstruktur Altenquotient  2011":"14,6","Bevölkerungsstruktur Altenquotient  2012":"14,2","Bevölkerungsstruktur Kinder bis 5 Jahre  2011":"922","Bevölkerungsstruktur Kinder bis 5 Jahre  2012":"931","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011":"47,3","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012":"50,1","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011":"529","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012":"190","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011":"241","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012":"568","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011":"152","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012":"173","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011":"1212","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012":"1243","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011":"47,9","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012":"48,2","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011":"506","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012":"224","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011":"389","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012":"697","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011":"317","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012":"322","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011":"534","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012":"591","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011":"46,1","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012":"46,9","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011":"176","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012":"115","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011":"140","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012":"245","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011":"218","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012":"231","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011":"2708","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012":"2782","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011":"50,3","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012":"50,1","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011":"1159","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012":"1157","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011":"461","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012":"512","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011":"1088","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012":"1113","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011":"7008","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012":"7219","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011":"47,5","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012":"47,3","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011":"3045","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012":"2888","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011":"967","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012":"1204","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011":"2996","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012":"3127","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011":"1367","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012":"1377","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011":"55,0","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012":"53,9","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011":"924","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012":"824","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011":"55","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012":"153","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011":"388","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012":"400","Bevölkerungsstruktur Ausländerinnen in %  2011":"47,9","Bevölkerungsstruktur Ausländerinnen in %  2012":"47,5","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011":"2184","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012":"2349","Bevölkerungsstruktur EU-Ausländerinnen in %  2011":"46,3","Bevölkerungsstruktur EU-Ausländerinnen in %  2012":"46,9","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011":"46,7","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012":"46,6","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011":"438","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012":"733","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011":"50,7","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012":"50,3","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011":"3935","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012":"4114","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011":"463","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012":"473","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011":"89","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012":"88","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011":"642","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012":"666","Bevölkerungsstruktur Staatenlose  2011":"30","Bevölkerungsstruktur Staatenlose  2012":"25","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011":"105","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012":"111","Bevölkerungsstruktur Bosnierinnen und Bosnier  2011":"183","Bevölkerungsstruktur Bosnierinnen und Bosnier  2012":"195","Bevölkerungsstruktur Griechinnen und Griechen  2011":"211","Bevölkerungsstruktur Griechinnen und Griechen  2012":"217","Bevölkerungsstruktur Italienerinnen und Italiener  2011":"467","Bevölkerungsstruktur Italienerinnen und Italiener  2012":"464","Bevölkerungsstruktur Kroatinnen und Kroaten  2011":"259","Bevölkerungsstruktur Kroatinnen und Kroaten  2012":"257","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011":"231","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012":"225","Bevölkerungsstruktur Polinnen und Polen  2011":"279","Bevölkerungsstruktur Polinnen und Polen  2012":"312","Bevölkerungsstruktur Rumäninnen und Rumänen  2011":"184","Bevölkerungsstruktur Rumäninnen und Rumänen  2012":"241","Bevölkerungsstruktur Serbierinnen und Serbier  2011":"282","Bevölkerungsstruktur Serbierinnen und Serbier  2012":"299","Bevölkerungsstruktur Spanierinnen und Spanier  2011":"192","Bevölkerungsstruktur Spanierinnen und Spanier  2012":"195","Bevölkerungsstruktur Türkinnen und Türken  2011":"876","Bevölkerungsstruktur Türkinnen und Türken  2012":"854","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011":"124","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012":"184","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011":"55","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012":"126","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011":"31","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012":"43","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011":"83","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012":"105","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011":"291","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012":"363","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011":"159","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012":"275","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011":"31","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012":"38","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011":"109","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012":"96","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011":"171","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012":"192","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011":"287","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012":"448","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011":"3277","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012":"3375","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011":"1361","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012":"1405","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011":"1848","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012":"1892","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011":"68","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012":"78","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011":"5039","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012":"5119","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011":"824","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012":"841","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011":"3017","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012":"3088","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011":"1198","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012":"1190","":""},{"Codes":"37","Stadtteil":"Nied","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011":"18056","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012":"18294","Bevölkerungsstruktur Frauen in %  2011":"50,1","Bevölkerungsstruktur Frauen in %  2012":"50,0","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011":"8,5","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012":"9,3","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011":"6,1","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012":"5,7","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011":"9381","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012":"7980","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011":"2996","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012":"4505","Bevölkerungsstruktur Ausländerinnen und Ausländer  2011":"5679","Bevölkerungsstruktur Ausländerinnen und Ausländer  2012":"5809","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011":"31,5","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012":"31,8","Bevölkerungsstruktur Durchschnittsalter  2011":"41,0","Bevölkerungsstruktur Durchschnittsalter  2012":"41,1","Bevölkerungsstruktur Jugendquotient  2011":"31,0","Bevölkerungsstruktur Jugendquotient  2012":"30,8","Bevölkerungsstruktur Altenquotient  2011":"25,8","Bevölkerungsstruktur Altenquotient  2012":"25,8","Bevölkerungsstruktur Kinder bis 5 Jahre  2011":"1102","Bevölkerungsstruktur Kinder bis 5 Jahre  2012":"1139","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011":"48,5","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012":"48,6","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011":"607","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012":"228","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011":"317","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012":"735","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011":"178","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012":"176","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011":"1435","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012":"1434","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011":"51,5","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012":"52,2","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011":"688","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012":"342","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011":"434","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012":"793","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011":"313","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012":"299","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011":"670","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012":"652","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011":"46,3","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012":"47,5","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011":"273","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012":"198","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011":"163","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012":"248","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011":"234","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012":"206","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011":"2845","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012":"2878","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011":"51,4","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012":"50,2","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011":"1218","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012":"1157","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011":"537","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012":"617","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011":"1090","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012":"1104","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011":"9037","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012":"9180","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011":"48,3","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012":"48,5","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011":"4275","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012":"4035","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011":"1380","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012":"1624","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011":"3382","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012":"3521","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011":"2967","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012":"3011","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011":"55,3","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012":"54,5","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011":"2320","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012":"2020","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011":"165","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012":"488","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011":"482","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012":"503","Bevölkerungsstruktur Ausländerinnen in %  2011":"48,5","Bevölkerungsstruktur Ausländerinnen in %  2012":"48,5","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011":"2176","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012":"2333","Bevölkerungsstruktur EU-Ausländerinnen in %  2011":"46,5","Bevölkerungsstruktur EU-Ausländerinnen in %  2012":"46,4","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011":"49,7","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012":"49,4","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011":"730","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012":"1283","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011":"54,9","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012":"53,2","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011":"4506","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012":"4669","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011":"490","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012":"484","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011":"85","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012":"73","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011":"557","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012":"549","Bevölkerungsstruktur Staatenlose  2011":"41","Bevölkerungsstruktur Staatenlose  2012":"34","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011":"107","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012":"102","Bevölkerungsstruktur Bosnierinnen und Bosnier  2011":"171","Bevölkerungsstruktur Bosnierinnen und Bosnier  2012":"168","Bevölkerungsstruktur Griechinnen und Griechen  2011":"209","Bevölkerungsstruktur Griechinnen und Griechen  2012":"212","Bevölkerungsstruktur Italienerinnen und Italiener  2011":"397","Bevölkerungsstruktur Italienerinnen und Italiener  2012":"416","Bevölkerungsstruktur Kroatinnen und Kroaten  2011":"332","Bevölkerungsstruktur Kroatinnen und Kroaten  2012":"322","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011":"275","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012":"281","Bevölkerungsstruktur Polinnen und Polen  2011":"563","Bevölkerungsstruktur Polinnen und Polen  2012":"615","Bevölkerungsstruktur Rumäninnen und Rumänen  2011":"212","Bevölkerungsstruktur Rumäninnen und Rumänen  2012":"237","Bevölkerungsstruktur Serbierinnen und Serbier  2011":"248","Bevölkerungsstruktur Serbierinnen und Serbier  2012":"257","Bevölkerungsstruktur Spanierinnen und Spanier  2011":"113","Bevölkerungsstruktur Spanierinnen und Spanier  2012":"124","Bevölkerungsstruktur Türkinnen und Türken  2011":"1370","Bevölkerungsstruktur Türkinnen und Türken  2012":"1373","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011":"138","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012":"186","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011":"51","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012":"109","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011":"30","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012":"47","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011":"66","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012":"101","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011":"459","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012":"613","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011":"406","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012":"662","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011":"106","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012":"153","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011":"80","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012":"88","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011":"163","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012":"196","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011":"490","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012":"773","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011":"3093","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012":"3138","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011":"1191","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012":"1220","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011":"1819","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012":"1830","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011":"83","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012":"88","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011":"8936","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012":"8983","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011":"1247","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012":"1228","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011":"4967","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012":"4989","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011":"2722","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012":"2766","":""},{"Codes":"38","Stadtteil":"Sindlingen","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011":"8852","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012":"8881","Bevölkerungsstruktur Frauen in %  2011":"48,8","Bevölkerungsstruktur Frauen in %  2012":"48,8","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011":"4,5","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012":"4,2","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011":"3,3","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012":"3,2","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011":"5099","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012":"4333","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011":"1413","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012":"2131","Bevölkerungsstruktur Ausländerinnen und Ausländer  2011":"2340","Bevölkerungsstruktur Ausländerinnen und Ausländer  2012":"2417","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011":"26,4","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012":"27,2","Bevölkerungsstruktur Durchschnittsalter  2011":"41,3","Bevölkerungsstruktur Durchschnittsalter  2012":"41,4","Bevölkerungsstruktur Jugendquotient  2011":"32,8","Bevölkerungsstruktur Jugendquotient  2012":"32,4","Bevölkerungsstruktur Altenquotient  2011":"29,2","Bevölkerungsstruktur Altenquotient  2012":"28,8","Bevölkerungsstruktur Kinder bis 5 Jahre  2011":"576","Bevölkerungsstruktur Kinder bis 5 Jahre  2012":"568","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011":"48,8","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012":"49,6","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011":"349","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012":"124","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011":"137","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012":"358","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011":"90","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012":"86","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011":"694","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012":"702","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011":"48,3","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012":"47,9","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011":"365","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012":"170","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011":"197","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012":"397","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011":"132","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012":"135","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011":"339","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012":"336","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011":"45,4","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012":"45,5","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011":"170","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012":"100","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011":"78","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012":"147","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011":"91","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012":"89","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011":"1414","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012":"1405","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011":"47,3","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012":"48,0","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011":"641","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012":"620","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011":"301","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012":"313","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011":"472","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012":"472","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011":"4233","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012":"4285","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011":"47,0","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012":"46,8","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011":"2212","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012":"2092","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011":"646","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012":"749","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011":"1375","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012":"1444","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011":"1596","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012":"1585","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011":"55,8","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012":"55,5","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011":"1362","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012":"1227","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011":"54","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012":"167","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011":"180","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012":"191","Bevölkerungsstruktur Ausländerinnen in %  2011":"45,1","Bevölkerungsstruktur Ausländerinnen in %  2012":"45,3","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011":"715","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012":"772","Bevölkerungsstruktur EU-Ausländerinnen in %  2011":"40,1","Bevölkerungsstruktur EU-Ausländerinnen in %  2012":"41,6","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011":"47,8","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012":"48,5","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011":"274","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012":"468","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011":"50,7","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012":"51,1","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011":"1651","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012":"1687","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011":"353","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012":"363","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011":"32","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012":"31","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011":"281","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012":"312","Bevölkerungsstruktur Staatenlose  2011":"23","Bevölkerungsstruktur Staatenlose  2012":"24","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011":"85","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012":"84","Bevölkerungsstruktur Bosnierinnen und Bosnier  2011":"45","Bevölkerungsstruktur Bosnierinnen und Bosnier  2012":"46","Bevölkerungsstruktur Griechinnen und Griechen  2011":"48","Bevölkerungsstruktur Griechinnen und Griechen  2012":"46","Bevölkerungsstruktur Italienerinnen und Italiener  2011":"198","Bevölkerungsstruktur Italienerinnen und Italiener  2012":"201","Bevölkerungsstruktur Kroatinnen und Kroaten  2011":"100","Bevölkerungsstruktur Kroatinnen und Kroaten  2012":"108","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011":"181","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012":"178","Bevölkerungsstruktur Polinnen und Polen  2011":"162","Bevölkerungsstruktur Polinnen und Polen  2012":"169","Bevölkerungsstruktur Rumäninnen und Rumänen  2011":"32","Bevölkerungsstruktur Rumäninnen und Rumänen  2012":"45","Bevölkerungsstruktur Serbierinnen und Serbier  2011":"98","Bevölkerungsstruktur Serbierinnen und Serbier  2012":"95","Bevölkerungsstruktur Spanierinnen und Spanier  2011":"69","Bevölkerungsstruktur Spanierinnen und Spanier  2012":"74","Bevölkerungsstruktur Türkinnen und Türken  2011":"622","Bevölkerungsstruktur Türkinnen und Türken  2012":"586","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011":"51","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012":"69","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011":"42","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012":"77","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011":"10","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012":"10","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011":"53","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012":"81","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011":"287","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012":"417","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011":"127","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012":"200","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011":"32","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012":"46","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011":"36","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012":"43","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011":"153","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012":"180","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011":"206","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012":"322","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011":"1436","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012":"1478","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011":"579","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012":"599","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011":"814","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012":"839","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011":"43","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012":"40","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011":"4563","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012":"4532","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011":"633","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012":"619","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011":"2441","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012":"2443","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011":"1489","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012":"1470","":""},{"Codes":"39","Stadtteil":"Zeilsheim","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011":"12024","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012":"11927","Bevölkerungsstruktur Frauen in %  2011":"50,5","Bevölkerungsstruktur Frauen in %  2012":"50,3","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011":"3,5","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012":"3,1","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011":"4,1","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012":"2,9","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011":"7345","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012":"6249","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011":"1812","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012":"2769","Bevölkerungsstruktur Ausländerinnen und Ausländer  2011":"2867","Bevölkerungsstruktur Ausländerinnen und Ausländer  2012":"2909","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011":"23,8","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012":"24,4","Bevölkerungsstruktur Durchschnittsalter  2011":"41,9","Bevölkerungsstruktur Durchschnittsalter  2012":"42,0","Bevölkerungsstruktur Jugendquotient  2011":"35,1","Bevölkerungsstruktur Jugendquotient  2012":"35,3","Bevölkerungsstruktur Altenquotient  2011":"32,9","Bevölkerungsstruktur Altenquotient  2012":"33,0","Bevölkerungsstruktur Kinder bis 5 Jahre  2011":"854","Bevölkerungsstruktur Kinder bis 5 Jahre  2012":"834","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011":"48,8","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012":"48,3","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011":"524","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012":"217","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011":"240","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012":"524","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011":"90","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012":"93","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011":"959","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012":"981","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011":"47,4","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012":"47,7","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011":"508","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012":"284","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011":"283","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012":"552","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011":"168","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012":"145","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011":"445","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012":"451","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011":"47,9","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012":"48,3","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011":"216","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012":"156","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011":"89","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012":"162","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011":"140","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012":"133","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011":"1757","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012":"1685","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011":"52,6","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012":"50,6","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011":"846","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012":"747","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011":"363","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012":"374","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011":"548","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012":"564","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011":"5656","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012":"5637","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011":"49,0","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012":"49,0","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011":"3239","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012":"3041","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011":"765","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012":"904","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011":"1652","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012":"1692","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011":"2353","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012":"2339","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011":"55,1","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012":"55,3","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011":"2012","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012":"1804","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011":"72","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012":"253","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011":"269","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012":"282","Bevölkerungsstruktur Ausländerinnen in %  2011":"48,8","Bevölkerungsstruktur Ausländerinnen in %  2012":"48,9","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011":"873","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012":"963","Bevölkerungsstruktur EU-Ausländerinnen in %  2011":"45,8","Bevölkerungsstruktur EU-Ausländerinnen in %  2012":"46,2","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011":"50,2","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012":"48,6","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011":"327","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012":"625","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011":"53,2","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012":"52,5","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011":"2125","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012":"2176","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011":"493","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012":"487","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011":"41","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012":"42","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011":"187","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012":"189","Bevölkerungsstruktur Staatenlose  2011":"21","Bevölkerungsstruktur Staatenlose  2012":"15","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011":"86","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012":"85","Bevölkerungsstruktur Bosnierinnen und Bosnier  2011":"84","Bevölkerungsstruktur Bosnierinnen und Bosnier  2012":"83","Bevölkerungsstruktur Griechinnen und Griechen  2011":"117","Bevölkerungsstruktur Griechinnen und Griechen  2012":"120","Bevölkerungsstruktur Italienerinnen und Italiener  2011":"306","Bevölkerungsstruktur Italienerinnen und Italiener  2012":"301","Bevölkerungsstruktur Kroatinnen und Kroaten  2011":"132","Bevölkerungsstruktur Kroatinnen und Kroaten  2012":"131","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011":"281","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012":"275","Bevölkerungsstruktur Polinnen und Polen  2011":"125","Bevölkerungsstruktur Polinnen und Polen  2012":"136","Bevölkerungsstruktur Rumäninnen und Rumänen  2011":"28","Bevölkerungsstruktur Rumäninnen und Rumänen  2012":"45","Bevölkerungsstruktur Serbierinnen und Serbier  2011":"110","Bevölkerungsstruktur Serbierinnen und Serbier  2012":"110","Bevölkerungsstruktur Spanierinnen und Spanier  2011":"157","Bevölkerungsstruktur Spanierinnen und Spanier  2012":"158","Bevölkerungsstruktur Türkinnen und Türken  2011":"811","Bevölkerungsstruktur Türkinnen und Türken  2012":"775","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011":"82","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012":"112","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011":"38","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012":"81","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011":"14","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012":"20","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011":"63","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012":"81","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011":"350","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012":"498","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011":"126","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012":"226","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011":"35","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012":"54","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011":"74","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012":"58","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011":"114","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012":"124","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011":"311","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012":"489","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011":"1576","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012":"1594","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011":"589","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012":"577","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011":"938","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012":"956","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011":"49","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012":"61","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011":"6448","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012":"6395","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011":"880","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012":"837","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011":"3368","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012":"3373","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011":"2200","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012":"2185","":""},{"Codes":"40","Stadtteil":"Unterliederbach","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011":"14269","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012":"14609","Bevölkerungsstruktur Frauen in %  2011":"51,2","Bevölkerungsstruktur Frauen in %  2012":"50,9","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011":"2,9","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012":"6,2","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011":"4,9","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012":"7,8","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011":"8471","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012":"7365","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011":"2094","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012":"3310","Bevölkerungsstruktur Ausländerinnen und Ausländer  2011":"3704","Bevölkerungsstruktur Ausländerinnen und Ausländer  2012":"3934","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011":"26,0","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012":"26,9","Bevölkerungsstruktur Durchschnittsalter  2011":"41,9","Bevölkerungsstruktur Durchschnittsalter  2012":"40,6","Bevölkerungsstruktur Jugendquotient  2011":"32,8","Bevölkerungsstruktur Jugendquotient  2012":"33,2","Bevölkerungsstruktur Altenquotient  2011":"26,4","Bevölkerungsstruktur Altenquotient  2012":"26,0","Bevölkerungsstruktur Kinder bis 5 Jahre  2011":"944","Bevölkerungsstruktur Kinder bis 5 Jahre  2012":"967","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011":"48,7","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012":"49,0","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011":"621","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012":"257","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011":"216","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012":"589","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011":"107","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012":"121","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011":"1159","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012":"1179","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011":"49,6","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012":"49,0","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011":"650","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012":"365","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011":"328","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012":"640","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011":"181","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012":"174","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011":"567","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012":"629","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011":"48,0","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012":"46,1","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011":"276","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012":"247","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011":"98","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012":"175","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011":"193","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012":"207","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011":"2318","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012":"2295","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011":"55,0","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012":"54,5","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011":"1116","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012":"1024","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011":"446","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012":"467","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011":"756","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012":"804","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011":"6918","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012":"7154","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011":"48,8","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012":"49,0","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011":"3863","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012":"3740","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011":"936","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012":"1165","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011":"2119","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012":"2249","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011":"2363","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012":"2385","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011":"56,9","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012":"56,4","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011":"1945","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012":"1732","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011":"70","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012":"274","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011":"348","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012":"379","Bevölkerungsstruktur Ausländerinnen in %  2011":"49,9","Bevölkerungsstruktur Ausländerinnen in %  2012":"50,0","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011":"1320","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012":"1426","Bevölkerungsstruktur EU-Ausländerinnen in %  2011":"46,5","Bevölkerungsstruktur EU-Ausländerinnen in %  2012":"47,5","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011":"50,2","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012":"49,4","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011":"440","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012":"815","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011":"50,0","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012":"50,1","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011":"2830","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012":"2957","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011":"428","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012":"476","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011":"77","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012":"84","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011":"350","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012":"401","Bevölkerungsstruktur Staatenlose  2011":"19","Bevölkerungsstruktur Staatenlose  2012":"16","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011":"99","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012":"101","Bevölkerungsstruktur Bosnierinnen und Bosnier  2011":"163","Bevölkerungsstruktur Bosnierinnen und Bosnier  2012":"154","Bevölkerungsstruktur Griechinnen und Griechen  2011":"125","Bevölkerungsstruktur Griechinnen und Griechen  2012":"151","Bevölkerungsstruktur Italienerinnen und Italiener  2011":"391","Bevölkerungsstruktur Italienerinnen und Italiener  2012":"414","Bevölkerungsstruktur Kroatinnen und Kroaten  2011":"219","Bevölkerungsstruktur Kroatinnen und Kroaten  2012":"224","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011":"220","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012":"241","Bevölkerungsstruktur Polinnen und Polen  2011":"169","Bevölkerungsstruktur Polinnen und Polen  2012":"175","Bevölkerungsstruktur Rumäninnen und Rumänen  2011":"87","Bevölkerungsstruktur Rumäninnen und Rumänen  2012":"108","Bevölkerungsstruktur Serbierinnen und Serbier  2011":"222","Bevölkerungsstruktur Serbierinnen und Serbier  2012":"229","Bevölkerungsstruktur Spanierinnen und Spanier  2011":"171","Bevölkerungsstruktur Spanierinnen und Spanier  2012":"197","Bevölkerungsstruktur Türkinnen und Türken  2011":"760","Bevölkerungsstruktur Türkinnen und Türken  2012":"773","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011":"115","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012":"153","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011":"53","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012":"112","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011":"35","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012":"52","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011":"96","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012":"135","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011":"326","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012":"472","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011":"149","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012":"298","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011":"41","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012":"46","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011":"76","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012":"80","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011":"125","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012":"137","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011":"277","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012":"467","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011":"2181","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012":"2290","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011":"928","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012":"931","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011":"1180","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012":"1282","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011":"73","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012":"77","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011":"7109","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012":"7128","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011":"1015","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012":"958","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011":"3940","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012":"4006","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011":"2154","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012":"2164","":""},{"Codes":"41","Stadtteil":"Sossenheim","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011":"15225","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012":"15252","Bevölkerungsstruktur Frauen in %  2011":"50,5","Bevölkerungsstruktur Frauen in %  2012":"51,0","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011":"2,2","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012":"1,1","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011":"1,0","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012":"1,1","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011":"7993","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012":"6561","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011":"2906","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012":"4303","Bevölkerungsstruktur Ausländerinnen und Ausländer  2011":"4326","Bevölkerungsstruktur Ausländerinnen und Ausländer  2012":"4388","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011":"28,4","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012":"28,8","Bevölkerungsstruktur Durchschnittsalter  2011":"40,5","Bevölkerungsstruktur Durchschnittsalter  2012":"40,7","Bevölkerungsstruktur Jugendquotient  2011":"34,5","Bevölkerungsstruktur Jugendquotient  2012":"34,4","Bevölkerungsstruktur Altenquotient  2011":"26,8","Bevölkerungsstruktur Altenquotient  2012":"26,9","Bevölkerungsstruktur Kinder bis 5 Jahre  2011":"1015","Bevölkerungsstruktur Kinder bis 5 Jahre  2012":"1030","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011":"48,3","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012":"48,6","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011":"605","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012":"186","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011":"285","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012":"716","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011":"125","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012":"128","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011":"1238","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012":"1252","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011":"48,4","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012":"49,4","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011":"574","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012":"240","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011":"402","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012":"755","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011":"262","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012":"257","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011":"647","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012":"630","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011":"46,1","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012":"47,9","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011":"238","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012":"147","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011":"222","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012":"285","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011":"187","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012":"198","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011":"2492","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012":"2461","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011":"50,8","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012":"50,9","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011":"1000","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012":"920","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011":"581","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012":"653","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011":"911","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012":"888","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011":"7306","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012":"7336","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011":"49,0","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012":"49,9","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011":"3532","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012":"3276","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011":"1284","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012":"1524","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011":"2490","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012":"2536","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011":"2527","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012":"2543","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011":"57,9","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012":"56,9","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011":"2044","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012":"1792","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011":"132","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012":"370","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011":"351","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012":"381","Bevölkerungsstruktur Ausländerinnen in %  2011":"50,3","Bevölkerungsstruktur Ausländerinnen in %  2012":"51,4","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011":"1435","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012":"1509","Bevölkerungsstruktur EU-Ausländerinnen in %  2011":"46,6","Bevölkerungsstruktur EU-Ausländerinnen in %  2012":"47,6","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011":"48,0","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012":"48,8","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011":"518","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012":"853","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011":"51,7","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012":"51,3","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011":"3324","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012":"3354","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011":"375","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012":"391","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011":"54","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012":"64","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011":"527","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012":"528","Bevölkerungsstruktur Staatenlose  2011":"46","Bevölkerungsstruktur Staatenlose  2012":"51","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011":"94","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012":"98","Bevölkerungsstruktur Bosnierinnen und Bosnier  2011":"110","Bevölkerungsstruktur Bosnierinnen und Bosnier  2012":"110","Bevölkerungsstruktur Griechinnen und Griechen  2011":"86","Bevölkerungsstruktur Griechinnen und Griechen  2012":"91","Bevölkerungsstruktur Italienerinnen und Italiener  2011":"351","Bevölkerungsstruktur Italienerinnen und Italiener  2012":"359","Bevölkerungsstruktur Kroatinnen und Kroaten  2011":"183","Bevölkerungsstruktur Kroatinnen und Kroaten  2012":"186","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011":"185","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012":"197","Bevölkerungsstruktur Polinnen und Polen  2011":"295","Bevölkerungsstruktur Polinnen und Polen  2012":"310","Bevölkerungsstruktur Rumäninnen und Rumänen  2011":"108","Bevölkerungsstruktur Rumäninnen und Rumänen  2012":"154","Bevölkerungsstruktur Serbierinnen und Serbier  2011":"192","Bevölkerungsstruktur Serbierinnen und Serbier  2012":"185","Bevölkerungsstruktur Spanierinnen und Spanier  2011":"48","Bevölkerungsstruktur Spanierinnen und Spanier  2012":"65","Bevölkerungsstruktur Türkinnen und Türken  2011":"1223","Bevölkerungsstruktur Türkinnen und Türken  2012":"1166","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011":"230","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012":"359","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011":"62","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012":"115","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011":"56","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012":"66","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011":"73","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012":"90","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011":"353","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012":"512","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011":"261","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012":"405","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011":"63","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012":"90","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011":"97","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012":"97","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011":"270","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012":"319","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011":"442","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012":"659","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011":"2375","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012":"2394","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011":"945","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012":"930","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011":"1342","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012":"1375","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011":"88","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012":"89","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011":"7427","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012":"7481","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011":"1092","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012":"1112","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011":"4053","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012":"4072","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011":"2282","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012":"2297","":""},{"Codes":"42","Stadtteil":"Nieder-Erlenbach","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011":"4370","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012":"4588","Bevölkerungsstruktur Frauen in %  2011":"51,0","Bevölkerungsstruktur Frauen in %  2012":"50,8","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011":"11,8","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012":"16,4","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011":"1,1","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012":"5,3","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011":"3608","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012":"3478","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011":"294","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012":"600","Bevölkerungsstruktur Ausländerinnen und Ausländer  2011":"468","Bevölkerungsstruktur Ausländerinnen und Ausländer  2012":"510","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011":"10,7","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012":"11,1","Bevölkerungsstruktur Durchschnittsalter  2011":"43,0","Bevölkerungsstruktur Durchschnittsalter  2012":"42,5","Bevölkerungsstruktur Jugendquotient  2011":"33,7","Bevölkerungsstruktur Jugendquotient  2012":"33,6","Bevölkerungsstruktur Altenquotient  2011":"30,7","Bevölkerungsstruktur Altenquotient  2012":"30,2","Bevölkerungsstruktur Kinder bis 5 Jahre  2011":"260","Bevölkerungsstruktur Kinder bis 5 Jahre  2012":"297","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011":"49,2","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012":"48,1","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011":"213","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012":"186","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011":"34","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012":"94","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011":"13","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012":"17","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011":"390","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012":"381","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011":"45,9","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012":"44,6","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011":"333","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012":"266","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011":"36","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012":"101","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011":"21","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012":"14","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011":"163","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012":"189","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011":"52,8","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012":"51,3","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011":"130","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012":"138","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011":"15","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012":"31","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011":"18","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012":"20","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011":"489","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012":"538","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011":"49,3","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012":"51,3","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011":"365","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012":"390","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011":"51","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012":"64","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011":"73","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012":"84","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011":"2251","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012":"2338","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011":"50,6","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012":"50,2","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011":"1809","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012":"1820","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011":"142","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012":"191","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011":"300","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012":"327","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011":"817","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012":"845","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011":"55,8","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012":"55,9","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011":"758","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012":"678","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011":"16","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012":"119","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011":"43","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012":"48","Bevölkerungsstruktur Ausländerinnen in %  2011":"51,9","Bevölkerungsstruktur Ausländerinnen in %  2012":"50,4","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011":"274","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012":"302","Bevölkerungsstruktur EU-Ausländerinnen in %  2011":"47,4","Bevölkerungsstruktur EU-Ausländerinnen in %  2012":"45,4","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011":"49,7","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012":"48,8","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011":"111","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012":"289","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011":"48,6","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012":"51,2","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011":"367","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012":"399","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011":"30","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012":"30","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011":"23","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012":"24","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011":"48","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012":"57","Bevölkerungsstruktur Staatenlose  2011":"0","Bevölkerungsstruktur Staatenlose  2012":"0","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011":"61","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012":"62","Bevölkerungsstruktur Bosnierinnen und Bosnier  2011":"7","Bevölkerungsstruktur Bosnierinnen und Bosnier  2012":"5","Bevölkerungsstruktur Griechinnen und Griechen  2011":"6","Bevölkerungsstruktur Griechinnen und Griechen  2012":"12","Bevölkerungsstruktur Italienerinnen und Italiener  2011":"40","Bevölkerungsstruktur Italienerinnen und Italiener  2012":"38","Bevölkerungsstruktur Kroatinnen und Kroaten  2011":"25","Bevölkerungsstruktur Kroatinnen und Kroaten  2012":"26","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011":"16","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012":"16","Bevölkerungsstruktur Polinnen und Polen  2011":"55","Bevölkerungsstruktur Polinnen und Polen  2012":"67","Bevölkerungsstruktur Rumäninnen und Rumänen  2011":"21","Bevölkerungsstruktur Rumäninnen und Rumänen  2012":"23","Bevölkerungsstruktur Serbierinnen und Serbier  2011":"10","Bevölkerungsstruktur Serbierinnen und Serbier  2012":"10","Bevölkerungsstruktur Spanierinnen und Spanier  2011":"14","Bevölkerungsstruktur Spanierinnen und Spanier  2012":"23","Bevölkerungsstruktur Türkinnen und Türken  2011":"26","Bevölkerungsstruktur Türkinnen und Türken  2012":"25","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011":"3","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012":"5","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011":"0","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012":"3","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011":"29","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012":"33","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011":"18","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012":"28","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011":"10","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012":"17","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011":"25","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012":"90","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011":"6","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012":"11","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011":"9","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012":"7","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011":"24","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012":"35","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011":"18","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012":"43","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011":"584","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012":"679","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011":"139","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012":"184","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011":"410","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012":"464","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011":"35","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012":"31","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011":"2222","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012":"2255","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011":"276","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012":"283","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011":"1226","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012":"1222","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011":"720","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012":"750","":""},{"Codes":"43","Stadtteil":"Kalbach-Riedberg","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011":"10279","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012":"12019","Bevölkerungsstruktur Frauen in %  2011":"50,6","Bevölkerungsstruktur Frauen in %  2012":"50,4","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011":"104,3","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012":"125,9","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011":"58,8","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012":"73,0","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011":"7159","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012":"7051","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011":"1435","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012":"2867","Bevölkerungsstruktur Ausländerinnen und Ausländer  2011":"1685","Bevölkerungsstruktur Ausländerinnen und Ausländer  2012":"2101","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011":"16,4","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012":"17,5","Bevölkerungsstruktur Durchschnittsalter  2011":"36,3","Bevölkerungsstruktur Durchschnittsalter  2012":"35,9","Bevölkerungsstruktur Jugendquotient  2011":"38,9","Bevölkerungsstruktur Jugendquotient  2012":"39,5","Bevölkerungsstruktur Altenquotient  2011":"14,8","Bevölkerungsstruktur Altenquotient  2012":"14,2","Bevölkerungsstruktur Kinder bis 5 Jahre  2011":"1010","Bevölkerungsstruktur Kinder bis 5 Jahre  2012":"1223","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011":"50,0","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012":"50,5","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011":"804","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012":"561","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011":"132","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012":"558","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011":"74","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012":"104","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011":"1060","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012":"1256","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011":"50,7","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012":"49,5","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011":"737","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012":"555","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011":"192","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012":"538","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011":"131","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012":"163","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011":"350","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012":"405","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011":"50,0","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012":"50,4","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011":"234","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012":"206","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011":"67","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012":"129","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011":"49","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012":"70","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011":"1324","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012":"1501","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011":"53,2","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012":"53,0","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011":"809","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012":"869","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011":"227","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012":"297","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011":"288","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012":"335","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011":"5546","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012":"6521","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011":"49,6","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012":"49,6","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011":"3700","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012":"4032","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011":"779","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012":"1155","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011":"1067","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012":"1334","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011":"989","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012":"1113","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011":"53,6","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012":"52,6","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011":"875","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012":"828","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011":"38","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012":"190","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011":"76","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012":"95","Bevölkerungsstruktur Ausländerinnen in %  2011":"52,5","Bevölkerungsstruktur Ausländerinnen in %  2012":"52,7","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011":"806","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012":"935","Bevölkerungsstruktur EU-Ausländerinnen in %  2011":"49,5","Bevölkerungsstruktur EU-Ausländerinnen in %  2012":"49,2","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011":"52,6","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012":"52,1","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011":"475","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012":"994","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011":"56,0","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012":"53,9","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011":"1184","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012":"1409","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011":"67","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012":"77","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011":"85","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012":"112","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011":"349","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012":"499","Bevölkerungsstruktur Staatenlose  2011":"0","Bevölkerungsstruktur Staatenlose  2012":"4","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011":"87","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012":"91","Bevölkerungsstruktur Bosnierinnen und Bosnier  2011":"42","Bevölkerungsstruktur Bosnierinnen und Bosnier  2012":"37","Bevölkerungsstruktur Griechinnen und Griechen  2011":"31","Bevölkerungsstruktur Griechinnen und Griechen  2012":"29","Bevölkerungsstruktur Italienerinnen und Italiener  2011":"178","Bevölkerungsstruktur Italienerinnen und Italiener  2012":"190","Bevölkerungsstruktur Kroatinnen und Kroaten  2011":"69","Bevölkerungsstruktur Kroatinnen und Kroaten  2012":"77","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011":"33","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012":"37","Bevölkerungsstruktur Polinnen und Polen  2011":"122","Bevölkerungsstruktur Polinnen und Polen  2012":"132","Bevölkerungsstruktur Rumäninnen und Rumänen  2011":"46","Bevölkerungsstruktur Rumäninnen und Rumänen  2012":"105","Bevölkerungsstruktur Serbierinnen und Serbier  2011":"43","Bevölkerungsstruktur Serbierinnen und Serbier  2012":"62","Bevölkerungsstruktur Spanierinnen und Spanier  2011":"72","Bevölkerungsstruktur Spanierinnen und Spanier  2012":"81","Bevölkerungsstruktur Türkinnen und Türken  2011":"138","Bevölkerungsstruktur Türkinnen und Türken  2012":"162","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011":"72","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012":"106","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011":"9","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012":"17","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011":"114","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012":"168","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011":"55","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012":"94","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011":"81","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012":"144","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011":"220","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012":"391","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011":"49","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012":"99","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011":"35","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012":"40","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011":"118","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012":"180","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011":"103","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012":"204","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011":"2101","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012":"2647","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011":"599","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012":"696","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011":"1426","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012":"1843","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011":"76","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012":"108","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011":"3729","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012":"4089","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011":"544","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012":"593","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011":"2339","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012":"2570","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011":"846","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012":"926","":""},{"Codes":"44","Stadtteil":"Harheim","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011":"4258","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012":"4304","Bevölkerungsstruktur Frauen in %  2011":"51,2","Bevölkerungsstruktur Frauen in %  2012":"51,2","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011":"12,6","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012":"14,3","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011":"14,0","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012":"12,0","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011":"3547","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012":"3367","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011":"243","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012":"481","Bevölkerungsstruktur Ausländerinnen und Ausländer  2011":"468","Bevölkerungsstruktur Ausländerinnen und Ausländer  2012":"456","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011":"11,0","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012":"10,6","Bevölkerungsstruktur Durchschnittsalter  2011":"42,1","Bevölkerungsstruktur Durchschnittsalter  2012":"42,4","Bevölkerungsstruktur Jugendquotient  2011":"33,7","Bevölkerungsstruktur Jugendquotient  2012":"33,5","Bevölkerungsstruktur Altenquotient  2011":"29,6","Bevölkerungsstruktur Altenquotient  2012":"30,8","Bevölkerungsstruktur Kinder bis 5 Jahre  2011":"293","Bevölkerungsstruktur Kinder bis 5 Jahre  2012":"280","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011":"46,8","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012":"46,4","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011":"252","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012":"193","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011":"30","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012":"83","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011":"11","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012":"4","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011":"360","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012":"367","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011":"49,2","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012":"48,2","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011":"287","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012":"249","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011":"42","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012":"92","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011":"31","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012":"26","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011":"154","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012":"151","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011":"51,9","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012":"51,0","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011":"118","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012":"104","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011":"9","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012":"23","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011":"27","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012":"24","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011":"492","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012":"531","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011":"52,6","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012":"50,7","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011":"365","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012":"377","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011":"45","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012":"58","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011":"82","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012":"96","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011":"2187","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012":"2168","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011":"50,9","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012":"51,7","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011":"1785","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012":"1749","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011":"112","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012":"150","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011":"290","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012":"269","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011":"772","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012":"807","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011":"53,5","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012":"53,4","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011":"740","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012":"695","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011":"5","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012":"75","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011":"27","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012":"37","Bevölkerungsstruktur Ausländerinnen in %  2011":"49,6","Bevölkerungsstruktur Ausländerinnen in %  2012":"48,7","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011":"289","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012":"303","Bevölkerungsstruktur EU-Ausländerinnen in %  2011":"46,7","Bevölkerungsstruktur EU-Ausländerinnen in %  2012":"47,5","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011":"51,4","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012":"54,1","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011":"97","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012":"236","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011":"55,7","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012":"56,8","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011":"361","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012":"365","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011":"32","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012":"25","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011":"29","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012":"26","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011":"46","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012":"40","Bevölkerungsstruktur Staatenlose  2011":"0","Bevölkerungsstruktur Staatenlose  2012":"0","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011":"49","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012":"51","Bevölkerungsstruktur Bosnierinnen und Bosnier  2011":"3","Bevölkerungsstruktur Bosnierinnen und Bosnier  2012":"3","Bevölkerungsstruktur Griechinnen und Griechen  2011":"5","Bevölkerungsstruktur Griechinnen und Griechen  2012":"5","Bevölkerungsstruktur Italienerinnen und Italiener  2011":"33","Bevölkerungsstruktur Italienerinnen und Italiener  2012":"30","Bevölkerungsstruktur Kroatinnen und Kroaten  2011":"10","Bevölkerungsstruktur Kroatinnen und Kroaten  2012":"9","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011":"23","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012":"17","Bevölkerungsstruktur Polinnen und Polen  2011":"39","Bevölkerungsstruktur Polinnen und Polen  2012":"44","Bevölkerungsstruktur Rumäninnen und Rumänen  2011":"13","Bevölkerungsstruktur Rumäninnen und Rumänen  2012":"10","Bevölkerungsstruktur Serbierinnen und Serbier  2011":"8","Bevölkerungsstruktur Serbierinnen und Serbier  2012":"6","Bevölkerungsstruktur Spanierinnen und Spanier  2011":"15","Bevölkerungsstruktur Spanierinnen und Spanier  2012":"19","Bevölkerungsstruktur Türkinnen und Türken  2011":"39","Bevölkerungsstruktur Türkinnen und Türken  2012":"35","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011":"8","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012":"12","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011":"1","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012":"3","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011":"7","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012":"9","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011":"18","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012":"33","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011":"25","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012":"30","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011":"27","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012":"74","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011":"8","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012":"16","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011":"8","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012":"8","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011":"13","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012":"25","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011":"14","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012":"27","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011":"590","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012":"584","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011":"173","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012":"204","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011":"396","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012":"354","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011":"21","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012":"26","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011":"2331","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012":"2342","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011":"264","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012":"263","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011":"1334","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012":"1320","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011":"733","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012":"759","":""},{"Codes":"45","Stadtteil":"Nieder-Eschbach","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011":"11247","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012":"11351","Bevölkerungsstruktur Frauen in %  2011":"52,0","Bevölkerungsstruktur Frauen in %  2012":"52,2","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011":"-1,4","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012":"-1,0","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011":"-0,2","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012":"1,4","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011":"7069","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012":"5889","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011":"2182","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012":"3337","Bevölkerungsstruktur Ausländerinnen und Ausländer  2011":"1996","Bevölkerungsstruktur Ausländerinnen und Ausländer  2012":"2125","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011":"17,7","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012":"18,7","Bevölkerungsstruktur Durchschnittsalter  2011":"42,4","Bevölkerungsstruktur Durchschnittsalter  2012":"42,5","Bevölkerungsstruktur Jugendquotient  2011":"32,0","Bevölkerungsstruktur Jugendquotient  2012":"32,2","Bevölkerungsstruktur Altenquotient  2011":"31,1","Bevölkerungsstruktur Altenquotient  2012":"31,1","Bevölkerungsstruktur Kinder bis 5 Jahre  2011":"670","Bevölkerungsstruktur Kinder bis 5 Jahre  2012":"700","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011":"48,5","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012":"50,4","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011":"491","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012":"195","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011":"125","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012":"438","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011":"54","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012":"67","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011":"860","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012":"846","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011":"49,1","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012":"48,3","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011":"523","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012":"268","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011":"227","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012":"478","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011":"110","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012":"100","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011":"451","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012":"452","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011":"47,2","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012":"47,6","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011":"255","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012":"161","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011":"123","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012":"205","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011":"73","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012":"86","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011":"1709","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012":"1716","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011":"52,2","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012":"52,4","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011":"922","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012":"868","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011":"433","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012":"448","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011":"354","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012":"400","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011":"5414","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012":"5478","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011":"51,0","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012":"51,0","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011":"3085","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012":"2933","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011":"1128","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012":"1280","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011":"1201","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012":"1265","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011":"2143","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012":"2159","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011":"57,9","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012":"58,0","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011":"1793","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012":"1464","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011":"146","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012":"488","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011":"204","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012":"207","Bevölkerungsstruktur Ausländerinnen in %  2011":"53,4","Bevölkerungsstruktur Ausländerinnen in %  2012":"52,7","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011":"716","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012":"750","Bevölkerungsstruktur EU-Ausländerinnen in %  2011":"51,5","Bevölkerungsstruktur EU-Ausländerinnen in %  2012":"52,1","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011":"50,0","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012":"50,1","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011":"595","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012":"1044","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011":"50,4","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012":"53,2","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011":"1352","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012":"1398","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011":"169","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012":"181","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011":"61","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012":"62","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011":"398","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012":"465","Bevölkerungsstruktur Staatenlose  2011":"16","Bevölkerungsstruktur Staatenlose  2012":"19","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011":"91","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012":"92","Bevölkerungsstruktur Bosnierinnen und Bosnier  2011":"31","Bevölkerungsstruktur Bosnierinnen und Bosnier  2012":"38","Bevölkerungsstruktur Griechinnen und Griechen  2011":"99","Bevölkerungsstruktur Griechinnen und Griechen  2012":"95","Bevölkerungsstruktur Italienerinnen und Italiener  2011":"151","Bevölkerungsstruktur Italienerinnen und Italiener  2012":"156","Bevölkerungsstruktur Kroatinnen und Kroaten  2011":"98","Bevölkerungsstruktur Kroatinnen und Kroaten  2012":"106","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011":"92","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012":"91","Bevölkerungsstruktur Polinnen und Polen  2011":"149","Bevölkerungsstruktur Polinnen und Polen  2012":"148","Bevölkerungsstruktur Rumäninnen und Rumänen  2011":"43","Bevölkerungsstruktur Rumäninnen und Rumänen  2012":"69","Bevölkerungsstruktur Serbierinnen und Serbier  2011":"57","Bevölkerungsstruktur Serbierinnen und Serbier  2012":"70","Bevölkerungsstruktur Spanierinnen und Spanier  2011":"22","Bevölkerungsstruktur Spanierinnen und Spanier  2012":"29","Bevölkerungsstruktur Türkinnen und Türken  2011":"319","Bevölkerungsstruktur Türkinnen und Türken  2012":"289","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011":"191","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012":"285","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011":"77","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012":"120","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011":"66","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012":"77","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011":"47","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012":"62","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011":"151","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012":"211","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011":"329","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012":"525","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011":"75","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012":"117","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011":"43","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012":"36","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011":"217","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012":"265","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011":"119","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012":"223","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011":"1610","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012":"1692","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011":"633","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012":"674","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011":"896","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012":"933","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011":"81","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012":"85","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011":"5843","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012":"5876","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011":"810","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012":"787","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011":"3114","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012":"3139","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011":"1919","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012":"1950","":""},{"Codes":"46","Stadtteil":"Bergen-Enkheim","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011":"17512","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012":"17563","Bevölkerungsstruktur Frauen in %  2011":"51,9","Bevölkerungsstruktur Frauen in %  2012":"51,9","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011":"7,4","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012":"6,9","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011":"3,8","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012":"3,9","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011":"13003","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012":"11797","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011":"1801","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012":"2924","Bevölkerungsstruktur Ausländerinnen und Ausländer  2011":"2708","Bevölkerungsstruktur Ausländerinnen und Ausländer  2012":"2842","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011":"15,5","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012":"16,2","Bevölkerungsstruktur Durchschnittsalter  2011":"44,3","Bevölkerungsstruktur Durchschnittsalter  2012":"44,3","Bevölkerungsstruktur Jugendquotient  2011":"27,5","Bevölkerungsstruktur Jugendquotient  2012":"28,0","Bevölkerungsstruktur Altenquotient  2011":"33,4","Bevölkerungsstruktur Altenquotient  2012":"33,7","Bevölkerungsstruktur Kinder bis 5 Jahre  2011":"892","Bevölkerungsstruktur Kinder bis 5 Jahre  2012":"921","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011":"50,1","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012":"49,1","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011":"681","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012":"434","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011":"150","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012":"418","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011":"61","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012":"69","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011":"1223","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012":"1222","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011":"51,7","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012":"52,5","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011":"885","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012":"609","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011":"253","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012":"527","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011":"85","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012":"86","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011":"598","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012":"590","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011":"47,7","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012":"48,6","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011":"428","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012":"356","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011":"89","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012":"155","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011":"81","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012":"79","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011":"2189","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012":"2229","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011":"50,4","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012":"50,7","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011":"1390","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012":"1367","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011":"315","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012":"330","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011":"484","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012":"532","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011":"8974","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012":"8942","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011":"51,4","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012":"51,2","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011":"6366","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012":"6135","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011":"903","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012":"1044","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011":"1705","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012":"1763","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011":"3636","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012":"3659","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011":"55,1","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012":"55,3","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011":"3253","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012":"2896","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011":"91","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012":"450","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011":"292","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012":"313","Bevölkerungsstruktur Ausländerinnen in %  2011":"51,0","Bevölkerungsstruktur Ausländerinnen in %  2012":"50,9","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011":"1153","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012":"1296","Bevölkerungsstruktur EU-Ausländerinnen in %  2011":"52,0","Bevölkerungsstruktur EU-Ausländerinnen in %  2012":"51,2","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011":"50,4","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012":"51,9","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011":"529","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012":"1058","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011":"51,2","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012":"52,5","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011":"2212","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012":"2350","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011":"129","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012":"124","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011":"97","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012":"100","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011":"260","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012":"254","Bevölkerungsstruktur Staatenlose  2011":"10","Bevölkerungsstruktur Staatenlose  2012":"14","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011":"96","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012":"97","Bevölkerungsstruktur Bosnierinnen und Bosnier  2011":"99","Bevölkerungsstruktur Bosnierinnen und Bosnier  2012":"98","Bevölkerungsstruktur Griechinnen und Griechen  2011":"100","Bevölkerungsstruktur Griechinnen und Griechen  2012":"99","Bevölkerungsstruktur Italienerinnen und Italiener  2011":"338","Bevölkerungsstruktur Italienerinnen und Italiener  2012":"379","Bevölkerungsstruktur Kroatinnen und Kroaten  2011":"274","Bevölkerungsstruktur Kroatinnen und Kroaten  2012":"277","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011":"55","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012":"58","Bevölkerungsstruktur Polinnen und Polen  2011":"188","Bevölkerungsstruktur Polinnen und Polen  2012":"243","Bevölkerungsstruktur Rumäninnen und Rumänen  2011":"49","Bevölkerungsstruktur Rumäninnen und Rumänen  2012":"46","Bevölkerungsstruktur Serbierinnen und Serbier  2011":"135","Bevölkerungsstruktur Serbierinnen und Serbier  2012":"129","Bevölkerungsstruktur Spanierinnen und Spanier  2011":"87","Bevölkerungsstruktur Spanierinnen und Spanier  2012":"90","Bevölkerungsstruktur Türkinnen und Türken  2011":"416","Bevölkerungsstruktur Türkinnen und Türken  2012":"403","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011":"44","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012":"66","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011":"14","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012":"34","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011":"138","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012":"133","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011":"107","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012":"130","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011":"95","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012":"146","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011":"176","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012":"386","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011":"50","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012":"75","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011":"67","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012":"61","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011":"96","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012":"113","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011":"217","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012":"365","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011":"2249","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012":"2308","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011":"732","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012":"810","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011":"1428","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012":"1415","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011":"89","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012":"83","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011":"9761","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012":"9758","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011":"1137","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012":"1132","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011":"5297","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012":"5274","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011":"3327","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012":"3352","":""},{"Codes":"47","Stadtteil":"Frankfurter Berg","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011":"7551","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012":"7627","Bevölkerungsstruktur Frauen in %  2011":"51,0","Bevölkerungsstruktur Frauen in %  2012":"50,9","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011":"48,0","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012":"38,6","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011":"14,6","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012":"13,1","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011":"4219","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012":"3537","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011":"1552","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012":"2274","Bevölkerungsstruktur Ausländerinnen und Ausländer  2011":"1780","Bevölkerungsstruktur Ausländerinnen und Ausländer  2012":"1816","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011":"23,6","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012":"23,8","Bevölkerungsstruktur Durchschnittsalter  2011":"38,6","Bevölkerungsstruktur Durchschnittsalter  2012":"39,0","Bevölkerungsstruktur Jugendquotient  2011":"37,8","Bevölkerungsstruktur Jugendquotient  2012":"38,1","Bevölkerungsstruktur Altenquotient  2011":"18,9","Bevölkerungsstruktur Altenquotient  2012":"19,9","Bevölkerungsstruktur Kinder bis 5 Jahre  2011":"581","Bevölkerungsstruktur Kinder bis 5 Jahre  2012":"563","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011":"49,2","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012":"50,1","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011":"404","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012":"181","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011":"112","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012":"316","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011":"65","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012":"66","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011":"703","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012":"715","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011":"47,7","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012":"47,1","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011":"434","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012":"234","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011":"173","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012":"396","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011":"96","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012":"85","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011":"358","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012":"362","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011":"53,6","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012":"53,0","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011":"162","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012":"127","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011":"103","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012":"149","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011":"93","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012":"86","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011":"1087","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012":"1070","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011":"52,5","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012":"51,5","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011":"459","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012":"442","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011":"304","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012":"306","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011":"324","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012":"322","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011":"3912","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012":"3958","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011":"50,0","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012":"50,1","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011":"2032","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012":"1930","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011":"803","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012":"917","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011":"1077","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012":"1111","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011":"910","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012":"959","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011":"56,3","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012":"55,9","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011":"728","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012":"623","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011":"57","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012":"190","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011":"125","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012":"146","Bevölkerungsstruktur Ausländerinnen in %  2011":"51,8","Bevölkerungsstruktur Ausländerinnen in %  2012":"51,7","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011":"558","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012":"591","Bevölkerungsstruktur EU-Ausländerinnen in %  2011":"47,7","Bevölkerungsstruktur EU-Ausländerinnen in %  2012":"47,4","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011":"48,8","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012":"49,8","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011":"344","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012":"557","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011":"48,0","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012":"51,5","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011":"1207","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012":"1236","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011":"156","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012":"157","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011":"42","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012":"42","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011":"363","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012":"370","Bevölkerungsstruktur Staatenlose  2011":"12","Bevölkerungsstruktur Staatenlose  2012":"11","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011":"85","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012":"93","Bevölkerungsstruktur Bosnierinnen und Bosnier  2011":"67","Bevölkerungsstruktur Bosnierinnen und Bosnier  2012":"62","Bevölkerungsstruktur Griechinnen und Griechen  2011":"50","Bevölkerungsstruktur Griechinnen und Griechen  2012":"47","Bevölkerungsstruktur Italienerinnen und Italiener  2011":"174","Bevölkerungsstruktur Italienerinnen und Italiener  2012":"168","Bevölkerungsstruktur Kroatinnen und Kroaten  2011":"104","Bevölkerungsstruktur Kroatinnen und Kroaten  2012":"108","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011":"51","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012":"49","Bevölkerungsstruktur Polinnen und Polen  2011":"105","Bevölkerungsstruktur Polinnen und Polen  2012":"133","Bevölkerungsstruktur Rumäninnen und Rumänen  2011":"48","Bevölkerungsstruktur Rumäninnen und Rumänen  2012":"56","Bevölkerungsstruktur Serbierinnen und Serbier  2011":"74","Bevölkerungsstruktur Serbierinnen und Serbier  2012":"65","Bevölkerungsstruktur Spanierinnen und Spanier  2011":"26","Bevölkerungsstruktur Spanierinnen und Spanier  2012":"28","Bevölkerungsstruktur Türkinnen und Türken  2011":"289","Bevölkerungsstruktur Türkinnen und Türken  2012":"288","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011":"116","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012":"147","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011":"48","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012":"75","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011":"84","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012":"103","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011":"38","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012":"49","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011":"88","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012":"107","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011":"151","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012":"237","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011":"36","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012":"55","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011":"67","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012":"54","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011":"103","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012":"120","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011":"154","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012":"241","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011":"1091","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012":"1122","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011":"388","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012":"375","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011":"668","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012":"707","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011":"35","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012":"40","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011":"3467","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012":"3503","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011":"542","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012":"542","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011":"2135","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012":"2132","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011":"790","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012":"829","":""},{"Codes":"#Frankfurt","Stadtteil":"Frankfurt am Main","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011":"667075","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012":"678691","Bevölkerungsstruktur Frauen in %  2011":"50,9","Bevölkerungsstruktur Frauen in %  2012":"50,8","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011":"7,7","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012":"9,0","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011":"5,5","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012":"6,6","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011":"403663","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012":"357050","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011":"92901","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012":"144706","Bevölkerungsstruktur Ausländerinnen und Ausländer  2011":"170511","Bevölkerungsstruktur Ausländerinnen und Ausländer  2012":"176935","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011":"25,6","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012":"26,1","Bevölkerungsstruktur Durchschnittsalter  2011":"41,3","Bevölkerungsstruktur Durchschnittsalter  2012":"41,3","Bevölkerungsstruktur Jugendquotient  2011":"26,6","Bevölkerungsstruktur Jugendquotient  2012":"26,6","Bevölkerungsstruktur Altenquotient  2011":"24,9","Bevölkerungsstruktur Altenquotient  2012":"24,6","Bevölkerungsstruktur Kinder bis 5 Jahre  2011":"40328","Bevölkerungsstruktur Kinder bis 5 Jahre  2012":"41121","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011":"49,2","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012":"49,2","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011":"26795","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012":"13179","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011":"8842","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012":"22974","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011":"4691","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012":"4968","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011":"44822","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012":"45703","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011":"48,8","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012":"48,8","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011":"25278","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012":"14913","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011":"11938","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012":"23606","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011":"7606","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012":"7184","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011":"20736","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012":"21235","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011":"48,1","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012":"48,5","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011":"10228","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012":"7825","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011":"4894","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012":"7751","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011":"5614","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012":"5659","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011":"107411","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012":"109209","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011":"52,3","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012":"52,2","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011":"55469","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012":"53909","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011":"17931","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012":"20179","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011":"34011","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012":"35121","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011":"344250","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012":"350862","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011":"48,9","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012":"48,9","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011":"196525","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012":"188497","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011":"44819","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012":"55110","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011":"102906","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012":"107255","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011":"109528","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012":"110561","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011":"57,6","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012":"57,3","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011":"89368","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012":"78727","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011":"4477","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012":"15086","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011":"15683","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012":"16748","Bevölkerungsstruktur Ausländerinnen in %  2011":"49,4","Bevölkerungsstruktur Ausländerinnen in %  2012":"49,3","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011":"64884","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012":"69677","Bevölkerungsstruktur EU-Ausländerinnen in %  2011":"46,9","Bevölkerungsstruktur EU-Ausländerinnen in %  2012":"46,6","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011":"49,4","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012":"49,9","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011":"22524","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012":"40981","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011":"50,5","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012":"52,2","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011":"127254","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012":"131841","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011":"12897","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012":"13109","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011":"6304","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012":"6592","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011":"23155","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012":"24511","Bevölkerungsstruktur Staatenlose  2011":"901","Bevölkerungsstruktur Staatenlose  2012":"882","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011":"170","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012":"173","Bevölkerungsstruktur Bosnierinnen und Bosnier  2011":"4917","Bevölkerungsstruktur Bosnierinnen und Bosnier  2012":"4912","Bevölkerungsstruktur Griechinnen und Griechen  2011":"5982","Bevölkerungsstruktur Griechinnen und Griechen  2012":"6149","Bevölkerungsstruktur Italienerinnen und Italiener  2011":"13448","Bevölkerungsstruktur Italienerinnen und Italiener  2012":"13711","Bevölkerungsstruktur Kroatinnen und Kroaten  2011":"11539","Bevölkerungsstruktur Kroatinnen und Kroaten  2012":"11596","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011":"5707","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012":"5711","Bevölkerungsstruktur Polinnen und Polen  2011":"10975","Bevölkerungsstruktur Polinnen und Polen  2012":"11942","Bevölkerungsstruktur Rumäninnen und Rumänen  2011":"4765","Bevölkerungsstruktur Rumäninnen und Rumänen  2012":"5937","Bevölkerungsstruktur Serbierinnen und Serbier  2011":"8973","Bevölkerungsstruktur Serbierinnen und Serbier  2012":"8982","Bevölkerungsstruktur Spanierinnen und Spanier  2011":"4769","Bevölkerungsstruktur Spanierinnen und Spanier  2012":"5329","Bevölkerungsstruktur Türkinnen und Türken  2011":"28854","Bevölkerungsstruktur Türkinnen und Türken  2012":"28090","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011":"3485","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012":"4983","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011":"2.040","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012":"4209","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011":"4141","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012":"5023","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011":"3124","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012":"4326","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011":"9905","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012":"13243","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011":"8685","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012":"15042","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011":"2723","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012":"4082","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011":"3266","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012":"3139","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011":"6156","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012":"6989","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011":"10941","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012":"17680","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011":"137974","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012":"142700","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011":"54662","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012":"56715","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011":"79094","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012":"81562","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011":"4218","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012":"4423","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011":"304486","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012":"305665","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011":"37527","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012":"37403","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011":"168432","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012":"169085","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011":"98527","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012":"99177","":""},{"Codes":"","Stadtteil":"","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2011":"","Bevölkerungsstruktur Einwohnerinnen und Einwohner  2012":"","Bevölkerungsstruktur Frauen in %  2011":"","Bevölkerungsstruktur Frauen in %  2012":"","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2011":"","Bevölkerungsstruktur Einwohnerentwicklung (10-Jahres-Vergeich)  2012":"","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2011":"","Bevölkerungsstruktur Einwohnerentwicklung (5-Jahres-Vergeich)  2012":"","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2011":"","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund  2012":"","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2011":"","Bevölkerungsstruktur Deutsche mit Migrationshintergrund  2012":"","Bevölkerungsstruktur Ausländerinnen und Ausländer  2011":"","Bevölkerungsstruktur Ausländerinnen und Ausländer  2012":"","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2011":"","Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012":"","Bevölkerungsstruktur Durchschnittsalter  2011":"","Bevölkerungsstruktur Durchschnittsalter  2012":"","Bevölkerungsstruktur Jugendquotient  2011":"","Bevölkerungsstruktur Jugendquotient  2012":"","Bevölkerungsstruktur Altenquotient  2011":"","Bevölkerungsstruktur Altenquotient  2012":"","Bevölkerungsstruktur Kinder bis 5 Jahre  2011":"","Bevölkerungsstruktur Kinder bis 5 Jahre  2012":"","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2011":"","Bevölkerungsstruktur Mädchen bis 5 Jahre in %  2012":"","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2011":"","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund bis 5 Jahre  2012":"","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2011":"","Bevölkerungsstruktur Deutsche mit Migrationshintergrund bis 5 Jahre  2012":"","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2011":"","Bevölkerungsstruktur Ausländerinnen und Ausländer bis 5 Jahre  2012":"","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2011":"","Bevölkerungsstruktur Kinder von 6 bis 13 Jahren  2012":"","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2011":"","Bevölkerungsstruktur Mädchen von 6 bis 13 Jahren in %  2012":"","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2011":"","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 6 bis 13 Jahren  2012":"","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2011":"","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 6 bis 13 Jahren  2012":"","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2011":"","Bevölkerungsstruktur Ausländerinnen und Ausländer von 6 bis 13 Jahren  2012":"","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2011":"","Bevölkerungsstruktur Jugendliche von 14 bis 17 Jahren  2012":"","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2011":"","Bevölkerungsstruktur Junge Frauen von 14 bis 17 Jahren in %  2012":"","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2011":"","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 14 bis 17 Jahren  2012":"","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2011":"","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 14 bis 17 Jahren  2012":"","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2011":"","Bevölkerungsstruktur Ausländerinnen und Ausländer von 14 bis 17 Jahren  2012":"","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2011":"","Bevölkerungsstruktur Junge Erwachsene von 18 bis 29 Jahren  2012":"","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2011":"","Bevölkerungsstruktur Frauen von 18 bis 29 Jahren in %  2012":"","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2011":"","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 18 bis 29 Jahren  2012":"","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2011":"","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 18 bis 29 Jahren  2012":"","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2011":"","Bevölkerungsstruktur Ausländerinnen und Ausländer von 18 bis 29 Jahren  2012":"","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2011":"","Bevölkerungsstruktur Einwohnerinnen und Einwohner von 30 bis 64 Jahren  2012":"","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2011":"","Bevölkerungsstruktur Frauen von 30 bis 64 Jahren in %  2012":"","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2011":"","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund von 30 bis 64 Jahren  2012":"","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2011":"","Bevölkerungsstruktur Deutsche mit Migrationshintergrund von 30 bis 64 Jahren  2012":"","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2011":"","Bevölkerungsstruktur Ausländerinnen und Ausländer von 30 bis 64 Jahren  2012":"","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2011":"","Bevölkerungsstruktur Seniorinnen und Senioren ab 65 Jahren  2012":"","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2011":"","Bevölkerungsstruktur Frauen ab 65 Jahren in %  2012":"","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2011":"","Bevölkerungsstruktur Deutsche ohne Migrationshintergrund ab 65 Jahren  2012":"","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2011":"","Bevölkerungsstruktur Deutsche mit Migrationshintergrund ab 65 Jahren  2012":"","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2011":"","Bevölkerungsstruktur Ausländerinnen und Ausländer ab 65 Jahren  2012":"","Bevölkerungsstruktur Ausländerinnen in %  2011":"","Bevölkerungsstruktur Ausländerinnen in %  2012":"","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2011":"","Bevölkerungsstruktur EU-Ausländerinnen und EU-Ausländer  2012":"","Bevölkerungsstruktur EU-Ausländerinnen in %  2011":"","Bevölkerungsstruktur EU-Ausländerinnen in %  2012":"","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2011":"","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund in %  2012":"","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2011":"","Bevölkerungsstruktur Deutsche mit Migrationshintergrund aus der EU  2012":"","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2011":"","Bevölkerungsstruktur Deutsche Frauen mit Migrationshintergrund aus der EU in %  2012":"","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2011":"","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Europa  2012":"","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2011":"","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Afrika  2012":"","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2011":"","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Amerika  2012":"","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2011":"","Bevölkerungsstruktur Ausländerinnen und Ausländer aus Asien und Australien  2012":"","Bevölkerungsstruktur Staatenlose  2011":"","Bevölkerungsstruktur Staatenlose  2012":"","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2011":"","Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012":"","Bevölkerungsstruktur Bosnierinnen und Bosnier  2011":"","Bevölkerungsstruktur Bosnierinnen und Bosnier  2012":"","Bevölkerungsstruktur Griechinnen und Griechen  2011":"","Bevölkerungsstruktur Griechinnen und Griechen  2012":"","Bevölkerungsstruktur Italienerinnen und Italiener  2011":"","Bevölkerungsstruktur Italienerinnen und Italiener  2012":"","Bevölkerungsstruktur Kroatinnen und Kroaten  2011":"","Bevölkerungsstruktur Kroatinnen und Kroaten  2012":"","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2011":"","Bevölkerungsstruktur Marokkanerinnen und Marokkaner  2012":"","Bevölkerungsstruktur Polinnen und Polen  2011":"","Bevölkerungsstruktur Polinnen und Polen  2012":"","Bevölkerungsstruktur Rumäninnen und Rumänen  2011":"","Bevölkerungsstruktur Rumäninnen und Rumänen  2012":"","Bevölkerungsstruktur Serbierinnen und Serbier  2011":"","Bevölkerungsstruktur Serbierinnen und Serbier  2012":"","Bevölkerungsstruktur Spanierinnen und Spanier  2011":"","Bevölkerungsstruktur Spanierinnen und Spanier  2012":"","Bevölkerungsstruktur Türkinnen und Türken  2011":"","Bevölkerungsstruktur Türkinnen und Türken  2012":"","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2011":"","Bevölkerungsstruktur Deutsche mit afghanischem Migrationshintergrund  2012":"","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2011":"","Bevölkerungsstruktur Deutsche mit eritreischem Migrationshintergrund  2012":"","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2011":"","Bevölkerungsstruktur Deutsche mit iranischem Migrationshintergrund  2012":"","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2011":"","Bevölkerungsstruktur Deutsche mit italienischem Migrationshintergrund  2012":"","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2011":"","Bevölkerungsstruktur Deutsche mit marokkanischem Migrationshintergrund  2012":"","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2011":"","Bevölkerungsstruktur Deutsche mit polnischem Migrationshintergrund  2012":"","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2011":"","Bevölkerungsstruktur Deutsche mit rumänischem Migrationshintergrund  2012":"","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2011":"","Bevölkerungsstruktur Deutsche mit serbischem Migrationshintergrund  2012":"","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2011":"","Bevölkerungsstruktur Deutsche mit russischem Migrationshintergrund  2012":"","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2011":"","Bevölkerungsstruktur Deutsche mit türkischem Migrationshintergrund  2012":"","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2011":"","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer unter 5 Jahre  2012":"","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2011":"","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer unter 5 Jahre  2012":"","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2011":"","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer unter 5 Jahre  2012":"","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2011":"","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer unter 5 Jahre  2012":"","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2011":"","Bevölkerungsstruktur Volljährige Einwohnerinnen und Einwohner mit Wohndauer 15 Jahre und länger  2012":"","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2011":"","Bevölkerungsstruktur Junge Erwachsene mit Wohndauer 15 Jahre und länger  2012":"","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2011":"","Bevölkerungsstruktur 30- bis 64-Jährige mit Wohndauer 15 Jahre und länger  2012":"","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2011":"","Bevölkerungsstruktur Seniorinnen und Senioren mit Wohndauer 15 Jahre und länger  2012":"","":""}];

/***/ },
/* 87 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  "Altstadt": {
	    description: "As the historical center of Frankfurt, the Altstadt has existed from Frankfurt's beginnings, dating back to 794. It used to be part of the original Innenstadt area, which lay inside of the city walls. The Altstadt contains many of Frankfurt's most important sights.",
	    rentUrl: "https://www.immobilienscout24.de/Suche/S-T/Wohnung-Miete/Hessen/Frankfurt-am-Main/Altstadt?enteredFrom=one_step_search"
	  },
	  "Nordend ": {
	    description: "As a whole, the Nordend is the second largest district by population in Frankfurt after Sachsenhausen. The Nordend is popular for its bohemian mix of restaurants, cafés and bars.",
	    rentUrl: "https://www.immobilienscout24.de/Suche/S-T/Wohnung-Miete/Hessen/Frankfurt-am-Main/Nordend-West?enteredFrom=one_step_search"
	  },
	  "Bergen-Enkheim": {
	    description: "Bergen-Enkheim were first mentioned as a common village in the thirteenth century. The two locations were administered together for centuries in 1936, but Bergen-Enkheim only officially became a town in 1968. In 1977 it was incorporated into the city of Frankfurt.",
	    rentUrl: "https://www.immobilienscout24.de/Suche/S-T/Wohnung-Miete/Hessen/Frankfurt-am-Main/Bergen-Enkheim?enteredFrom=one_step_search"
	  },
	  "Niederrad": {
	    description: "The district is mainly designated as residential area. Niederrad is the site of the western part of the University Hospital Frankfurt, Frankfurt naming of some important institutions.",
	    rentUrl: "hhttps://www.immobilienscout24.de/Suche/S-T/Wohnung-Miete/Hessen/Frankfurt-am-Main/Niederrad?enteredFrom=one_step_search"
	  }
	};

/***/ },
/* 88 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = [{
	  "Codes": "1",
	  "Stadtteil": "Altstadt",
	  "Bauen und Wohnen Einwohnerdichte je ha  2012": "48,7",
	  "Bauen und Wohnen Einwohnerdichte je ha  diff": "21,4",
	  "Bauen und Wohnen Einwohnerdichte je ha  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "65",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "-5,8",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "38,9",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "0,8",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
	  "Bauen und Wohnen Neubauquotient  2012": "0,0",
	  "Bauen und Wohnen Neubauquotient  diff": "-12,7",
	  "Bauen und Wohnen Neubauquotient  target": ""
	}, {
	  "Codes": "2",
	  "Stadtteil": "Innenstadt",
	  "Bauen und Wohnen Einwohnerdichte je ha  2012": "",
	  "Bauen und Wohnen Einwohnerdichte je ha  diff": "",
	  "Bauen und Wohnen Einwohnerdichte je ha  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "58",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "-12,4",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "38,3",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "0,2",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
	  "Bauen und Wohnen Neubauquotient  2012": "0,0",
	  "Bauen und Wohnen Neubauquotient  diff": "-12,7",
	  "Bauen und Wohnen Neubauquotient  target": ""
	}, {
	  "Codes": "3",
	  "Stadtteil": "Bahnhofsviertel",
	  "Bauen und Wohnen Einwohnerdichte je ha  2012": "59,3",
	  "Bauen und Wohnen Einwohnerdichte je ha  diff": "31,9",
	  "Bauen und Wohnen Einwohnerdichte je ha  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "62",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "-8,5",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "40,2",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "2,1",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
	  "Bauen und Wohnen Neubauquotient  2012": "0,0",
	  "Bauen und Wohnen Neubauquotient  diff": "-12,7",
	  "Bauen und Wohnen Neubauquotient  target": ""
	}, {
	  "Codes": "4",
	  "Stadtteil": "Westend-Süd",
	  "Bauen und Wohnen Einwohnerdichte je ha  2012": "70,6",
	  "Bauen und Wohnen Einwohnerdichte je ha  diff": "43,2",
	  "Bauen und Wohnen Einwohnerdichte je ha  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "77",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "6,1",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "49,1",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "11,0",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
	  "Bauen und Wohnen Neubauquotient  2012": "2,1",
	  "Bauen und Wohnen Neubauquotient  diff": "-10,6",
	  "Bauen und Wohnen Neubauquotient  target": ""
	}, {
	  "Codes": "5",
	  "Stadtteil": "Westend-Nord",
	  "Bauen und Wohnen Einwohnerdichte je ha  2012": "54,3",
	  "Bauen und Wohnen Einwohnerdichte je ha  diff": "27,0",
	  "Bauen und Wohnen Einwohnerdichte je ha  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "77",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "5,9",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "43,2",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "5,1",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
	  "Bauen und Wohnen Neubauquotient  2012": "0,2",
	  "Bauen und Wohnen Neubauquotient  diff": "-12,5",
	  "Bauen und Wohnen Neubauquotient  target": ""
	}, {
	  "Codes": "6",
	  "Stadtteil": "Nordend-West",
	  "Bauen und Wohnen Einwohnerdichte je ha  2012": "92,0",
	  "Bauen und Wohnen Einwohnerdichte je ha  diff": "64,7",
	  "Bauen und Wohnen Einwohnerdichte je ha  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "73",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "2,5",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "44,0",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "5,9",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
	  "Bauen und Wohnen Neubauquotient  2012": "12,2",
	  "Bauen und Wohnen Neubauquotient  diff": "-0,5",
	  "Bauen und Wohnen Neubauquotient  target": ""
	}, {
	  "Codes": "7",
	  "Stadtteil": "Nordend-Ost",
	  "Bauen und Wohnen Einwohnerdichte je ha  2012": "150,6",
	  "Bauen und Wohnen Einwohnerdichte je ha  diff": "123,3",
	  "Bauen und Wohnen Einwohnerdichte je ha  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "65",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "-6,1",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "40,8",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "2,7",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
	  "Bauen und Wohnen Neubauquotient  2012": "0,1",
	  "Bauen und Wohnen Neubauquotient  diff": "-12,6",
	  "Bauen und Wohnen Neubauquotient  target": ""
	}, {
	  "Codes": "8",
	  "Stadtteil": "Ostend",
	  "Bauen und Wohnen Einwohnerdichte je ha  2012": "48,5",
	  "Bauen und Wohnen Einwohnerdichte je ha  diff": "21,2",
	  "Bauen und Wohnen Einwohnerdichte je ha  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "64",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "-6,5",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "39,2",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "1,1",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
	  "Bauen und Wohnen Neubauquotient  2012": "0,0",
	  "Bauen und Wohnen Neubauquotient  diff": "-12,7",
	  "Bauen und Wohnen Neubauquotient  target": ""
	}, {
	  "Codes": "9",
	  "Stadtteil": "Bornheim",
	  "Bauen und Wohnen Einwohnerdichte je ha  2012": "120,7",
	  "Bauen und Wohnen Einwohnerdichte je ha  diff": "93,4",
	  "Bauen und Wohnen Einwohnerdichte je ha  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "64",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "-7,0",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "38,4",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "0,3",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
	  "Bauen und Wohnen Neubauquotient  2012": "0,0",
	  "Bauen und Wohnen Neubauquotient  diff": "-12,7",
	  "Bauen und Wohnen Neubauquotient  target": ""
	}, {
	  "Codes": "10",
	  "Stadtteil": "Gutleutviertel",
	  "Bauen und Wohnen Einwohnerdichte je ha  2012": "",
	  "Bauen und Wohnen Einwohnerdichte je ha  diff": "",
	  "Bauen und Wohnen Einwohnerdichte je ha  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "65",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "-5,9",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "39,3",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "1,2",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
	  "Bauen und Wohnen Neubauquotient  2012": "3,9",
	  "Bauen und Wohnen Neubauquotient  diff": "-8,8",
	  "Bauen und Wohnen Neubauquotient  target": ""
	}, {
	  "Codes": "11",
	  "Stadtteil": "Gallus",
	  "Bauen und Wohnen Einwohnerdichte je ha  2012": "31,0",
	  "Bauen und Wohnen Einwohnerdichte je ha  diff": "3,7",
	  "Bauen und Wohnen Einwohnerdichte je ha  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "57",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "-13,7",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "32,3",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "-5,8",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
	  "Bauen und Wohnen Neubauquotient  2012": "12,6",
	  "Bauen und Wohnen Neubauquotient  diff": "-0,1",
	  "Bauen und Wohnen Neubauquotient  target": ""
	}, {
	  "Codes": "12",
	  "Stadtteil": "Bockenheim",
	  "Bauen und Wohnen Einwohnerdichte je ha  2012": "66,1",
	  "Bauen und Wohnen Einwohnerdichte je ha  diff": "38,8",
	  "Bauen und Wohnen Einwohnerdichte je ha  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "65",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "-5,7",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "39,8",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "1,7",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
	  "Bauen und Wohnen Neubauquotient  2012": "15,1",
	  "Bauen und Wohnen Neubauquotient  diff": "2,4",
	  "Bauen und Wohnen Neubauquotient  target": ""
	}, {
	  "Codes": "13",
	  "Stadtteil": "Sachsenhausen-Nord",
	  "Bauen und Wohnen Einwohnerdichte je ha  2012": "",
	  "Bauen und Wohnen Einwohnerdichte je ha  diff": "",
	  "Bauen und Wohnen Einwohnerdichte je ha  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "72",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "0,9",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "42,4",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "4,3",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
	  "Bauen und Wohnen Neubauquotient  2012": "7,4",
	  "Bauen und Wohnen Neubauquotient  diff": "-5,4",
	  "Bauen und Wohnen Neubauquotient  target": ""
	}, {
	  "Codes": "14",
	  "Stadtteil": "Sachsenhausen-Süd",
	  "Bauen und Wohnen Einwohnerdichte je ha  2012": "9,4",
	  "Bauen und Wohnen Einwohnerdichte je ha  diff": "-17,9",
	  "Bauen und Wohnen Einwohnerdichte je ha  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "77",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "6,1",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "47,5",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "9,4",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
	  "Bauen und Wohnen Neubauquotient  2012": "3,1",
	  "Bauen und Wohnen Neubauquotient  diff": "-9,6",
	  "Bauen und Wohnen Neubauquotient  target": ""
	}, {
	  "Codes": "16",
	  "Stadtteil": "Oberrad",
	  "Bauen und Wohnen Einwohnerdichte je ha  2012": "45,9",
	  "Bauen und Wohnen Einwohnerdichte je ha  diff": "18,5",
	  "Bauen und Wohnen Einwohnerdichte je ha  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "68",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "-2,4",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "37,4",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "-0,7",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
	  "Bauen und Wohnen Neubauquotient  2012": "0,2",
	  "Bauen und Wohnen Neubauquotient  diff": "-12,5",
	  "Bauen und Wohnen Neubauquotient  target": ""
	}, {
	  "Codes": "17",
	  "Stadtteil": "Niederrad",
	  "Bauen und Wohnen Einwohnerdichte je ha  2012": "76,5",
	  "Bauen und Wohnen Einwohnerdichte je ha  diff": "49,2",
	  "Bauen und Wohnen Einwohnerdichte je ha  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "63",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "-7,5",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "36,0",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "-2,1",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
	  "Bauen und Wohnen Neubauquotient  2012": "0,2",
	  "Bauen und Wohnen Neubauquotient  diff": "-12,6",
	  "Bauen und Wohnen Neubauquotient  target": ""
	}, {
	  "Codes": "18",
	  "Stadtteil": "Schwanheim",
	  "Bauen und Wohnen Einwohnerdichte je ha  2012": "11,5",
	  "Bauen und Wohnen Einwohnerdichte je ha  diff": "-15,8",
	  "Bauen und Wohnen Einwohnerdichte je ha  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "75",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "4,3",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "37,1",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "-1,0",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
	  "Bauen und Wohnen Neubauquotient  2012": "0,5",
	  "Bauen und Wohnen Neubauquotient  diff": "-12,2",
	  "Bauen und Wohnen Neubauquotient  target": ""
	}, {
	  "Codes": "19",
	  "Stadtteil": "Griesheim",
	  "Bauen und Wohnen Einwohnerdichte je ha  2012": "47,2",
	  "Bauen und Wohnen Einwohnerdichte je ha  diff": "19,8",
	  "Bauen und Wohnen Einwohnerdichte je ha  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "66",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "-4,9",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "28,5",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "-9,6",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
	  "Bauen und Wohnen Neubauquotient  2012": "5,2",
	  "Bauen und Wohnen Neubauquotient  diff": "-7,5",
	  "Bauen und Wohnen Neubauquotient  target": ""
	}, {
	  "Codes": "20",
	  "Stadtteil": "Rödelheim",
	  "Bauen und Wohnen Einwohnerdichte je ha  2012": "33,1",
	  "Bauen und Wohnen Einwohnerdichte je ha  diff": "5,7",
	  "Bauen und Wohnen Einwohnerdichte je ha  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "66",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "-4,3",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "38,3",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "0,2",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
	  "Bauen und Wohnen Neubauquotient  2012": "3,4",
	  "Bauen und Wohnen Neubauquotient  diff": "-9,3",
	  "Bauen und Wohnen Neubauquotient  target": ""
	}, {
	  "Codes": "21",
	  "Stadtteil": "Hausen",
	  "Bauen und Wohnen Einwohnerdichte je ha  2012": "57,1",
	  "Bauen und Wohnen Einwohnerdichte je ha  diff": "29,8",
	  "Bauen und Wohnen Einwohnerdichte je ha  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "70",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "-0,6",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "35,1",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "-3,0",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
	  "Bauen und Wohnen Neubauquotient  2012": "1,2",
	  "Bauen und Wohnen Neubauquotient  diff": "-11,5",
	  "Bauen und Wohnen Neubauquotient  target": ""
	}, {
	  "Codes": "22",
	  "Stadtteil": "Praunheim",
	  "Bauen und Wohnen Einwohnerdichte je ha  2012": "34,5",
	  "Bauen und Wohnen Einwohnerdichte je ha  diff": "7,2",
	  "Bauen und Wohnen Einwohnerdichte je ha  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "71",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "0,5",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "36,6",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "-1,5",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
	  "Bauen und Wohnen Neubauquotient  2012": "0,8",
	  "Bauen und Wohnen Neubauquotient  diff": "-11,9",
	  "Bauen und Wohnen Neubauquotient  target": ""
	}, {
	  "Codes": "24",
	  "Stadtteil": "Heddernheim",
	  "Bauen und Wohnen Einwohnerdichte je ha  2012": "67,3",
	  "Bauen und Wohnen Einwohnerdichte je ha  diff": "40,0",
	  "Bauen und Wohnen Einwohnerdichte je ha  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "70",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "-0,2",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "35,3",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "-2,8",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
	  "Bauen und Wohnen Neubauquotient  2012": "0,0",
	  "Bauen und Wohnen Neubauquotient  diff": "-12,7",
	  "Bauen und Wohnen Neubauquotient  target": ""
	}, {
	  "Codes": "25",
	  "Stadtteil": "Niederursel",
	  "Bauen und Wohnen Einwohnerdichte je ha  2012": "20,9",
	  "Bauen und Wohnen Einwohnerdichte je ha  diff": "-6,4",
	  "Bauen und Wohnen Einwohnerdichte je ha  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "75",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "4,0",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "36,3",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "-1,8",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
	  "Bauen und Wohnen Neubauquotient  2012": "1,8",
	  "Bauen und Wohnen Neubauquotient  diff": "-10,9",
	  "Bauen und Wohnen Neubauquotient  target": ""
	}, {
	  "Codes": "26",
	  "Stadtteil": "Ginnheim",
	  "Bauen und Wohnen Einwohnerdichte je ha  2012": "45,9",
	  "Bauen und Wohnen Einwohnerdichte je ha  diff": "18,6",
	  "Bauen und Wohnen Einwohnerdichte je ha  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "75",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "4,3",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "37,0",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "-1,1",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
	  "Bauen und Wohnen Neubauquotient  2012": "2,0",
	  "Bauen und Wohnen Neubauquotient  diff": "-10,7",
	  "Bauen und Wohnen Neubauquotient  target": ""
	}, {
	  "Codes": "27",
	  "Stadtteil": "Dornbusch",
	  "Bauen und Wohnen Einwohnerdichte je ha  2012": "84,5",
	  "Bauen und Wohnen Einwohnerdichte je ha  diff": "57,1",
	  "Bauen und Wohnen Einwohnerdichte je ha  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "77",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "6,3",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "42,6",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "4,5",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
	  "Bauen und Wohnen Neubauquotient  2012": "0,4",
	  "Bauen und Wohnen Neubauquotient  diff": "-12,3",
	  "Bauen und Wohnen Neubauquotient  target": ""
	}, {
	  "Codes": "28",
	  "Stadtteil": "Eschersheim",
	  "Bauen und Wohnen Einwohnerdichte je ha  2012": "43,1",
	  "Bauen und Wohnen Einwohnerdichte je ha  diff": "15,7",
	  "Bauen und Wohnen Einwohnerdichte je ha  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "76",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "5,1",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "42,4",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "4,3",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
	  "Bauen und Wohnen Neubauquotient  2012": "0,7",
	  "Bauen und Wohnen Neubauquotient  diff": "-12,0",
	  "Bauen und Wohnen Neubauquotient  target": ""
	}, {
	  "Codes": "29",
	  "Stadtteil": "Eckenheim",
	  "Bauen und Wohnen Einwohnerdichte je ha  2012": "",
	  "Bauen und Wohnen Einwohnerdichte je ha  diff": "",
	  "Bauen und Wohnen Einwohnerdichte je ha  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "69",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "-2,1",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "34,7",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "-3,4",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
	  "Bauen und Wohnen Neubauquotient  2012": "11,2",
	  "Bauen und Wohnen Neubauquotient  diff": "-1,5",
	  "Bauen und Wohnen Neubauquotient  target": ""
	}, {
	  "Codes": "30",
	  "Stadtteil": "Preungesheim",
	  "Bauen und Wohnen Einwohnerdichte je ha  2012": "37,3",
	  "Bauen und Wohnen Einwohnerdichte je ha  diff": "9,9",
	  "Bauen und Wohnen Einwohnerdichte je ha  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "78",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "7,2",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "34,0",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "-4,1",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
	  "Bauen und Wohnen Neubauquotient  2012": "0,4",
	  "Bauen und Wohnen Neubauquotient  diff": "-12,3",
	  "Bauen und Wohnen Neubauquotient  target": ""
	}, {
	  "Codes": "31",
	  "Stadtteil": "Bonames",
	  "Bauen und Wohnen Einwohnerdichte je ha  2012": "40,5",
	  "Bauen und Wohnen Einwohnerdichte je ha  diff": "13,2",
	  "Bauen und Wohnen Einwohnerdichte je ha  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "73",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "2,3",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "34,4",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "-3,7",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
	  "Bauen und Wohnen Neubauquotient  2012": "21,0",
	  "Bauen und Wohnen Neubauquotient  diff": "8,3",
	  "Bauen und Wohnen Neubauquotient  target": ""
	}, {
	  "Codes": "32",
	  "Stadtteil": "Berkersheim",
	  "Bauen und Wohnen Einwohnerdichte je ha  2012": "11,5",
	  "Bauen und Wohnen Einwohnerdichte je ha  diff": "-15,9",
	  "Bauen und Wohnen Einwohnerdichte je ha  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "96",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "25,0",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "37,7",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "-0,4",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
	  "Bauen und Wohnen Neubauquotient  2012": "1,7",
	  "Bauen und Wohnen Neubauquotient  diff": "-11,0",
	  "Bauen und Wohnen Neubauquotient  target": ""
	}, {
	  "Codes": "33",
	  "Stadtteil": "Riederwald",
	  "Bauen und Wohnen Einwohnerdichte je ha  2012": "",
	  "Bauen und Wohnen Einwohnerdichte je ha  diff": "",
	  "Bauen und Wohnen Einwohnerdichte je ha  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "60",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "-10,7",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "32,3",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "-5,8",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
	  "Bauen und Wohnen Neubauquotient  2012": "9,8",
	  "Bauen und Wohnen Neubauquotient  diff": "-3,0",
	  "Bauen und Wohnen Neubauquotient  target": ""
	}, {
	  "Codes": "34",
	  "Stadtteil": "Seckbach",
	  "Bauen und Wohnen Einwohnerdichte je ha  2012": "12,4",
	  "Bauen und Wohnen Einwohnerdichte je ha  diff": "-15,0",
	  "Bauen und Wohnen Einwohnerdichte je ha  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "78",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "7,1",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "38,5",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "0,4",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
	  "Bauen und Wohnen Neubauquotient  2012": "0,0",
	  "Bauen und Wohnen Neubauquotient  diff": "-12,7",
	  "Bauen und Wohnen Neubauquotient  target": ""
	}, {
	  "Codes": "35",
	  "Stadtteil": "Fechenheim",
	  "Bauen und Wohnen Einwohnerdichte je ha  2012": "22,2",
	  "Bauen und Wohnen Einwohnerdichte je ha  diff": "-5,2",
	  "Bauen und Wohnen Einwohnerdichte je ha  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "66",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "-4,9",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "31,3",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "-6,8",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
	  "Bauen und Wohnen Neubauquotient  2012": "3,7",
	  "Bauen und Wohnen Neubauquotient  diff": "-9,0",
	  "Bauen und Wohnen Neubauquotient  target": ""
	}, {
	  "Codes": "36",
	  "Stadtteil": "Höchst",
	  "Bauen und Wohnen Einwohnerdichte je ha  2012": "29,9",
	  "Bauen und Wohnen Einwohnerdichte je ha  diff": "2,5",
	  "Bauen und Wohnen Einwohnerdichte je ha  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "70",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "-1,0",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "33,2",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "-4,9",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
	  "Bauen und Wohnen Neubauquotient  2012": "1,2",
	  "Bauen und Wohnen Neubauquotient  diff": "-11,5",
	  "Bauen und Wohnen Neubauquotient  target": ""
	}, {
	  "Codes": "37",
	  "Stadtteil": "Nied",
	  "Bauen und Wohnen Einwohnerdichte je ha  2012": "47,9",
	  "Bauen und Wohnen Einwohnerdichte je ha  diff": "20,6",
	  "Bauen und Wohnen Einwohnerdichte je ha  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "66",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "-4,5",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "32,1",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "-6,0",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
	  "Bauen und Wohnen Neubauquotient  2012": "5,2",
	  "Bauen und Wohnen Neubauquotient  diff": "-7,5",
	  "Bauen und Wohnen Neubauquotient  target": ""
	}, {
	  "Codes": "38",
	  "Stadtteil": "Sindlingen",
	  "Bauen und Wohnen Einwohnerdichte je ha  2012": "17,2",
	  "Bauen und Wohnen Einwohnerdichte je ha  diff": "-10,1",
	  "Bauen und Wohnen Einwohnerdichte je ha  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "67",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "-3,9",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "32,6",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "-5,5",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
	  "Bauen und Wohnen Neubauquotient  2012": "2,8",
	  "Bauen und Wohnen Neubauquotient  diff": "-9,9",
	  "Bauen und Wohnen Neubauquotient  target": ""
	}, {
	  "Codes": "39",
	  "Stadtteil": "Zeilsheim",
	  "Bauen und Wohnen Einwohnerdichte je ha  2012": "27,7",
	  "Bauen und Wohnen Einwohnerdichte je ha  diff": "0,4",
	  "Bauen und Wohnen Einwohnerdichte je ha  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "71",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "0,1",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "33,5",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "-4,6",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
	  "Bauen und Wohnen Neubauquotient  2012": "1,9",
	  "Bauen und Wohnen Neubauquotient  diff": "-10,9",
	  "Bauen und Wohnen Neubauquotient  target": ""
	}, {
	  "Codes": "40",
	  "Stadtteil": "Unterliederbach",
	  "Bauen und Wohnen Einwohnerdichte je ha  2012": "25,0",
	  "Bauen und Wohnen Einwohnerdichte je ha  diff": "-2,4",
	  "Bauen und Wohnen Einwohnerdichte je ha  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "71",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "0,8",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "35,4",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "-2,7",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
	  "Bauen und Wohnen Neubauquotient  2012": "0,5",
	  "Bauen und Wohnen Neubauquotient  diff": "-12,2",
	  "Bauen und Wohnen Neubauquotient  target": ""
	}, {
	  "Codes": "41",
	  "Stadtteil": "Sossenheim",
	  "Bauen und Wohnen Einwohnerdichte je ha  2012": "25,6",
	  "Bauen und Wohnen Einwohnerdichte je ha  diff": "-1,8",
	  "Bauen und Wohnen Einwohnerdichte je ha  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "70",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "-0,2",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "33,5",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "-4,6",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
	  "Bauen und Wohnen Neubauquotient  2012": "6,6",
	  "Bauen und Wohnen Neubauquotient  diff": "-6,1",
	  "Bauen und Wohnen Neubauquotient  target": ""
	}, {
	  "Codes": "42",
	  "Stadtteil": "Nieder-Erlenbach",
	  "Bauen und Wohnen Einwohnerdichte je ha  2012": "5,5",
	  "Bauen und Wohnen Einwohnerdichte je ha  diff": "-21,8",
	  "Bauen und Wohnen Einwohnerdichte je ha  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "103",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "32,0",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "43,8",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "5,7",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
	  "Bauen und Wohnen Neubauquotient  2012": "3,0",
	  "Bauen und Wohnen Neubauquotient  diff": "-9,7",
	  "Bauen und Wohnen Neubauquotient  target": ""
	}, {
	  "Codes": "43",
	  "Stadtteil": "Kalbach-Riedberg",
	  "Bauen und Wohnen Einwohnerdichte je ha  2012": "17,4",
	  "Bauen und Wohnen Einwohnerdichte je ha  diff": "-9,9",
	  "Bauen und Wohnen Einwohnerdichte je ha  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "105",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "34,0",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "38,3",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "0,2",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
	  "Bauen und Wohnen Neubauquotient  2012": "5,6",
	  "Bauen und Wohnen Neubauquotient  diff": "-7,1",
	  "Bauen und Wohnen Neubauquotient  target": ""
	}, {
	  "Codes": "44",
	  "Stadtteil": "Harheim",
	  "Bauen und Wohnen Einwohnerdichte je ha  2012": "8,6",
	  "Bauen und Wohnen Einwohnerdichte je ha  diff": "-18,8",
	  "Bauen und Wohnen Einwohnerdichte je ha  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "97",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "26,6",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "44,2",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "6,1",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
	  "Bauen und Wohnen Neubauquotient  2012": "82,0",
	  "Bauen und Wohnen Neubauquotient  diff": "69,3",
	  "Bauen und Wohnen Neubauquotient  target": ""
	}, {
	  "Codes": "45",
	  "Stadtteil": "Nieder-Eschbach",
	  "Bauen und Wohnen Einwohnerdichte je ha  2012": "17,9",
	  "Bauen und Wohnen Einwohnerdichte je ha  diff": "-9,5",
	  "Bauen und Wohnen Einwohnerdichte je ha  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "82",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "11,8",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "38,4",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "0,3",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
	  "Bauen und Wohnen Neubauquotient  2012": "1,0",
	  "Bauen und Wohnen Neubauquotient  diff": "-11,7",
	  "Bauen und Wohnen Neubauquotient  target": ""
	}, {
	  "Codes": "46",
	  "Stadtteil": "Bergen-Enkheim",
	  "Bauen und Wohnen Einwohnerdichte je ha  2012": "14,0",
	  "Bauen und Wohnen Einwohnerdichte je ha  diff": "-13,3",
	  "Bauen und Wohnen Einwohnerdichte je ha  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "86",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "15,5",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "44,8",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "6,7",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
	  "Bauen und Wohnen Neubauquotient  2012": "0,0",
	  "Bauen und Wohnen Neubauquotient  diff": "-12,7",
	  "Bauen und Wohnen Neubauquotient  target": ""
	}, {
	  "Codes": "47",
	  "Stadtteil": "Frankfurter Berg",
	  "Bauen und Wohnen Einwohnerdichte je ha  2012": "",
	  "Bauen und Wohnen Einwohnerdichte je ha  diff": "",
	  "Bauen und Wohnen Einwohnerdichte je ha  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "86",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "15,2",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "33,7",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "-4,4",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
	  "Bauen und Wohnen Neubauquotient  2012": "2,3",
	  "Bauen und Wohnen Neubauquotient  diff": "-10,4",
	  "Bauen und Wohnen Neubauquotient  target": ""
	}, {
	  "Codes": "#Frankfurt",
	  "Stadtteil": "Frankfurt am Main",
	  "Bauen und Wohnen Einwohnerdichte je ha  2012": "27,3",
	  "Bauen und Wohnen Einwohnerdichte je ha  diff": "",
	  "Bauen und Wohnen Einwohnerdichte je ha  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  2012": "71",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  diff": "",
	  "Bauen und Wohnen Wohnfläche in m² je Wohnung  target": "",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  2012": "38,1",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  diff": "",
	  "Bauen und Wohnen Wohnfläche in m² je Einwohner/in  target": "",
	  "Bauen und Wohnen Neubauquotient  2012": "12,7",
	  "Bauen und Wohnen Neubauquotient  diff": "",
	  "Bauen und Wohnen Neubauquotient  target": ""
	}];

/***/ },
/* 89 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = [{
	  "Stadtteilnummer": "1",
	  "Stadtteil": "Altstadt",
	  "Wahlberechtigte insgesamt": "2702",
	  "Wähler/innen": "1051",
	  "Wähler/innen in %": "38,9",
	  "darunter Wähler mit Wahlschein": "333",
	  "darunter Wähler mit Wahlschein in %": "31,7",
	  "gültige Stimmen": "89031",
	  "CDU": "19442",
	  "CDU in %": "21,8",
	  "SPD": "20706",
	  "SPD in %": "23,3",
	  "GRÜNE": "12540",
	  "GRÜNE in %": "14,1",
	  "DIE LINKE": "7506",
	  "DIE LINKE in %": "8,4",
	  "FDP": "7716",
	  "FDP in %": "8,7",
	  "BFF": "3640",
	  "BFF in %": "4,1",
	  "PIRATEN": "484",
	  "PIRATEN in %": "0,5",
	  "ÖkoLinX-ARL": "2210",
	  "ÖkoLinX-ARL in %": "2,5",
	  "ELF": "1323",
	  "ELF in %": "1,5",
	  "REP": "168",
	  "REP in %": "0,2",
	  "Graue Panther": "350",
	  "Graue Panther in %": "0,4",
	  "ALFA": "490",
	  "ALFA in %": "0,6",
	  "IBF": "1186",
	  "IBF in %": "1,3",
	  "Liberale": "804",
	  "Liberale in %": "0,9",
	  "P.O.P.": "104",
	  "P.O.P. in %": "0,1",
	  "FREIE WÄHLER": "512",
	  "FREIE WÄHLER in %": "0,6",
	  "AfD": "7914",
	  "AfD in %": "8,9",
	  "NPD": "84",
	  "NPD in %": "0,1",
	  "DIE PARTEI": "1218",
	  "DIE PARTEI in %": "1,4",
	  "dFfm": "634",
	  "dFfm in %": "0,7"
	}, {
	  "Stadtteilnummer": "2",
	  "Stadtteil": "Innenstadt",
	  "Wahlberechtigte insgesamt": "4476",
	  "Wähler/innen": "1118",
	  "Wähler/innen in %": "25",
	  "darunter Wähler mit Wahlschein": "346",
	  "darunter Wähler mit Wahlschein in %": "30,9",
	  "gültige Stimmen": "96181",
	  "CDU": "22247",
	  "CDU in %": "23,1",
	  "SPD": "18380",
	  "SPD in %": "19,1",
	  "GRÜNE": "16702",
	  "GRÜNE in %": "17,4",
	  "DIE LINKE": "8754",
	  "DIE LINKE in %": "9,1",
	  "FDP": "7713",
	  "FDP in %": "8",
	  "BFF": "2355",
	  "BFF in %": "2,4",
	  "PIRATEN": "1189",
	  "PIRATEN in %": "1,2",
	  "ÖkoLinX-ARL": "2348",
	  "ÖkoLinX-ARL in %": "2,4",
	  "ELF": "3264",
	  "ELF in %": "3,4",
	  "REP": "408",
	  "REP in %": "0,4",
	  "Graue Panther": "280",
	  "Graue Panther in %": "0,3",
	  "ALFA": "460",
	  "ALFA in %": "0,5",
	  "IBF": "554",
	  "IBF in %": "0,6",
	  "Liberale": "693",
	  "Liberale in %": "0,7",
	  "P.O.P.": "290",
	  "P.O.P. in %": "0,3",
	  "FREIE WÄHLER": "400",
	  "FREIE WÄHLER in %": "0,4",
	  "AfD": "7886",
	  "AfD in %": "8,2",
	  "NPD": "300",
	  "NPD in %": "0,3",
	  "DIE PARTEI": "1577",
	  "DIE PARTEI in %": "1,6",
	  "dFfm": "381",
	  "dFfm in %": "0,4"
	}, {
	  "Stadtteilnummer": "4",
	  "Stadtteil": "Westend-Süd",
	  "Wahlberechtigte insgesamt": "13160",
	  "Wähler/innen": "5661",
	  "Wähler/innen in %": "43",
	  "darunter Wähler mit Wahlschein": "1824",
	  "darunter Wähler mit Wahlschein in %": "32,2",
	  "gültige Stimmen": "498890",
	  "CDU": "167895",
	  "CDU in %": "33,7",
	  "SPD": "85511",
	  "SPD in %": "17,1",
	  "GRÜNE": "72859",
	  "GRÜNE in %": "14,6",
	  "DIE LINKE": "26462",
	  "DIE LINKE in %": "5,3",
	  "FDP": "75484",
	  "FDP in %": "15,1",
	  "BFF": "9975",
	  "BFF in %": "2",
	  "PIRATEN": "2944",
	  "PIRATEN in %": "0,6",
	  "ÖkoLinX-ARL": "6569",
	  "ÖkoLinX-ARL in %": "1,3",
	  "ELF": "3542",
	  "ELF in %": "0,7",
	  "REP": "190",
	  "REP in %": "0",
	  "Graue Panther": "1405",
	  "Graue Panther in %": "0,3",
	  "ALFA": "2924",
	  "ALFA in %": "0,6",
	  "IBF": "935",
	  "IBF in %": "0,2",
	  "Liberale": "1879",
	  "Liberale in %": "0,4",
	  "P.O.P.": "957",
	  "P.O.P. in %": "0,2",
	  "FREIE WÄHLER": "847",
	  "FREIE WÄHLER in %": "0,2",
	  "AfD": "33076",
	  "AfD in %": "6,6",
	  "NPD": "261",
	  "NPD in %": "0,1",
	  "DIE PARTEI": "4345",
	  "DIE PARTEI in %": "0,9",
	  "dFfm": "830",
	  "dFfm in %": "0,2"
	}, {
	  "Stadtteilnummer": "5",
	  "Stadtteil": "Westend-Nord",
	  "Wahlberechtigte insgesamt": "6743",
	  "Wähler/innen": "2701",
	  "Wähler/innen in %": "40,1",
	  "darunter Wähler mit Wahlschein": "829",
	  "darunter Wähler mit Wahlschein in %": "30,7",
	  "gültige Stimmen": "238276",
	  "CDU": "68807",
	  "CDU in %": "28,9",
	  "SPD": "49043",
	  "SPD in %": "20,6",
	  "GRÜNE": "37050",
	  "GRÜNE in %": "15,5",
	  "DIE LINKE": "13533",
	  "DIE LINKE in %": "5,7",
	  "FDP": "32905",
	  "FDP in %": "13,8",
	  "BFF": "4006",
	  "BFF in %": "1,7",
	  "PIRATEN": "1880",
	  "PIRATEN in %": "0,8",
	  "ÖkoLinX-ARL": "5607",
	  "ÖkoLinX-ARL in %": "2,4",
	  "ELF": "1887",
	  "ELF in %": "0,8",
	  "REP": "302",
	  "REP in %": "0,1",
	  "Graue Panther": "763",
	  "Graue Panther in %": "0,3",
	  "ALFA": "942",
	  "ALFA in %": "0,4",
	  "IBF": "996",
	  "IBF in %": "0,4",
	  "Liberale": "654",
	  "Liberale in %": "0,3",
	  "P.O.P.": "858",
	  "P.O.P. in %": "0,4",
	  "FREIE WÄHLER": "822",
	  "FREIE WÄHLER in %": "0,3",
	  "AfD": "13370",
	  "AfD in %": "5,6",
	  "NPD": "489",
	  "NPD in %": "0,2",
	  "DIE PARTEI": "3509",
	  "DIE PARTEI in %": "1,5",
	  "dFfm": "853",
	  "dFfm in %": "0,4"
	}, {
	  "Stadtteilnummer": "6",
	  "Stadtteil": "Nordend-West",
	  "Wahlberechtigte insgesamt": "22949",
	  "Wähler/innen": "10855",
	  "Wähler/innen in %": "47,3",
	  "darunter Wähler mit Wahlschein": "2865",
	  "darunter Wähler mit Wahlschein in %": "26,4",
	  "gültige Stimmen": "960751",
	  "CDU": "215612",
	  "CDU in %": "22,4",
	  "SPD": "202369",
	  "SPD in %": "21,1",
	  "GRÜNE": "207211",
	  "GRÜNE in %": "21,6",
	  "DIE LINKE": "79295",
	  "DIE LINKE in %": "8,3",
	  "FDP": "93488",
	  "FDP in %": "9,7",
	  "BFF": "16164",
	  "BFF in %": "1,7",
	  "PIRATEN": "8504",
	  "PIRATEN in %": "0,9",
	  "ÖkoLinX-ARL": "40731",
	  "ÖkoLinX-ARL in %": "4,2",
	  "ELF": "5103",
	  "ELF in %": "0,5",
	  "REP": "793",
	  "REP in %": "0,1",
	  "Graue Panther": "2009",
	  "Graue Panther in %": "0,2",
	  "ALFA": "3243",
	  "ALFA in %": "0,3",
	  "IBF": "4115",
	  "IBF in %": "0,4",
	  "Liberale": "4235",
	  "Liberale in %": "0,4",
	  "P.O.P.": "3773",
	  "P.O.P. in %": "0,4",
	  "FREIE WÄHLER": "1711",
	  "FREIE WÄHLER in %": "0,2",
	  "AfD": "49097",
	  "AfD in %": "5,1",
	  "NPD": "1046",
	  "NPD in %": "0,1",
	  "DIE PARTEI": "16120",
	  "DIE PARTEI in %": "1,7",
	  "dFfm": "6132",
	  "dFfm in %": "0,6"
	}, {
	  "Stadtteilnummer": "7",
	  "Stadtteil": "Nordend-Ost",
	  "Wahlberechtigte insgesamt": "17670",
	  "Wähler/innen": "8185",
	  "Wähler/innen in %": "46,3",
	  "darunter Wähler mit Wahlschein": "1887",
	  "darunter Wähler mit Wahlschein in %": "23,1",
	  "gültige Stimmen": "716643",
	  "CDU": "112992",
	  "CDU in %": "15,8",
	  "SPD": "163751",
	  "SPD in %": "22,8",
	  "GRÜNE": "178353",
	  "GRÜNE in %": "24,9",
	  "DIE LINKE": "91357",
	  "DIE LINKE in %": "12,7",
	  "FDP": "40889",
	  "FDP in %": "5,7",
	  "BFF": "10550",
	  "BFF in %": "1,5",
	  "PIRATEN": "6417",
	  "PIRATEN in %": "0,9",
	  "ÖkoLinX-ARL": "38920",
	  "ÖkoLinX-ARL in %": "5,4",
	  "ELF": "4190",
	  "ELF in %": "0,6",
	  "REP": "288",
	  "REP in %": "0",
	  "Graue Panther": "3082",
	  "Graue Panther in %": "0,4",
	  "ALFA": "2258",
	  "ALFA in %": "0,3",
	  "IBF": "1478",
	  "IBF in %": "0,2",
	  "Liberale": "4140",
	  "Liberale in %": "0,6",
	  "P.O.P.": "3214",
	  "P.O.P. in %": "0,4",
	  "FREIE WÄHLER": "2953",
	  "FREIE WÄHLER in %": "0,4",
	  "AfD": "30340",
	  "AfD in %": "4,2",
	  "NPD": "298",
	  "NPD in %": "0",
	  "DIE PARTEI": "12993",
	  "DIE PARTEI in %": "1,8",
	  "dFfm": "8180",
	  "dFfm in %": "1,1"
	}, {
	  "Stadtteilnummer": "8",
	  "Stadtteil": "Ostend",
	  "Wahlberechtigte insgesamt": "20330",
	  "Wähler/innen": "8315",
	  "Wähler/innen in %": "40,9",
	  "darunter Wähler mit Wahlschein": "2147",
	  "darunter Wähler mit Wahlschein in %": "25,8",
	  "gültige Stimmen": "728340",
	  "CDU": "147434",
	  "CDU in %": "20,2",
	  "SPD": "180696",
	  "SPD in %": "24,8",
	  "GRÜNE": "141398",
	  "GRÜNE in %": "19,4",
	  "DIE LINKE": "69811",
	  "DIE LINKE in %": "9,6",
	  "FDP": "45733",
	  "FDP in %": "6,3",
	  "BFF": "12453",
	  "BFF in %": "1,7",
	  "PIRATEN": "7428",
	  "PIRATEN in %": "1",
	  "ÖkoLinX-ARL": "22894",
	  "ÖkoLinX-ARL in %": "3,1",
	  "ELF": "6293",
	  "ELF in %": "0,9",
	  "REP": "915",
	  "REP in %": "0,1",
	  "Graue Panther": "3576",
	  "Graue Panther in %": "0,5",
	  "ALFA": "2830",
	  "ALFA in %": "0,4",
	  "IBF": "2652",
	  "IBF in %": "0,4",
	  "Liberale": "2832",
	  "Liberale in %": "0,4",
	  "P.O.P.": "5096",
	  "P.O.P. in %": "0,7",
	  "FREIE WÄHLER": "3814",
	  "FREIE WÄHLER in %": "0,5",
	  "AfD": "47792",
	  "AfD in %": "6,6",
	  "NPD": "1441",
	  "NPD in %": "0,2",
	  "DIE PARTEI": "14151",
	  "DIE PARTEI in %": "1,9",
	  "dFfm": "9101",
	  "dFfm in %": "1,2"
	}, {
	  "Stadtteilnummer": "9",
	  "Stadtteil": "Bornheim",
	  "Wahlberechtigte insgesamt": "22425",
	  "Wähler/innen": "9756",
	  "Wähler/innen in %": "43,5",
	  "darunter Wähler mit Wahlschein": "2440",
	  "darunter Wähler mit Wahlschein in %": "25",
	  "gültige Stimmen": "843478",
	  "CDU": "142384",
	  "CDU in %": "16,9",
	  "SPD": "225667",
	  "SPD in %": "26,8",
	  "GRÜNE": "161424",
	  "GRÜNE in %": "19,1",
	  "DIE LINKE": "90450",
	  "DIE LINKE in %": "10,7",
	  "FDP": "40057",
	  "FDP in %": "4,7",
	  "BFF": "12616",
	  "BFF in %": "1,5",
	  "PIRATEN": "7176",
	  "PIRATEN in %": "0,9",
	  "ÖkoLinX-ARL": "28453",
	  "ÖkoLinX-ARL in %": "3,4",
	  "ELF": "9599",
	  "ELF in %": "1,1",
	  "REP": "1039",
	  "REP in %": "0,1",
	  "Graue Panther": "5132",
	  "Graue Panther in %": "0,6",
	  "ALFA": "3206",
	  "ALFA in %": "0,4",
	  "IBF": "3462",
	  "IBF in %": "0,4",
	  "Liberale": "2603",
	  "Liberale in %": "0,3",
	  "P.O.P.": "4201",
	  "P.O.P. in %": "0,5",
	  "FREIE WÄHLER": "6489",
	  "FREIE WÄHLER in %": "0,8",
	  "AfD": "55405",
	  "AfD in %": "6,6",
	  "NPD": "1396",
	  "NPD in %": "0,2",
	  "DIE PARTEI": "15900",
	  "DIE PARTEI in %": "1,9",
	  "dFfm": "26819",
	  "dFfm in %": "3,2"
	}, {
	  "Stadtteilnummer": "10",
	  "Stadtteil": "Gutleut-/Bahnhofsviertel",
	  "Wahlberechtigte insgesamt": "7013",
	  "Wähler/innen": "2147",
	  "Wähler/innen in %": "30,6",
	  "darunter Wähler mit Wahlschein": "521",
	  "darunter Wähler mit Wahlschein in %": "24,3",
	  "gültige Stimmen": "182466",
	  "CDU": "32661",
	  "CDU in %": "17,9",
	  "SPD": "36719",
	  "SPD in %": "20,1",
	  "GRÜNE": "34320",
	  "GRÜNE in %": "18,8",
	  "DIE LINKE": "20746",
	  "DIE LINKE in %": "11,4",
	  "FDP": "14807",
	  "FDP in %": "8,1",
	  "BFF": "3463",
	  "BFF in %": "1,9",
	  "PIRATEN": "1568",
	  "PIRATEN in %": "0,9",
	  "ÖkoLinX-ARL": "9653",
	  "ÖkoLinX-ARL in %": "5,3",
	  "ELF": "2459",
	  "ELF in %": "1,3",
	  "REP": "316",
	  "REP in %": "0,2",
	  "Graue Panther": "726",
	  "Graue Panther in %": "0,4",
	  "ALFA": "555",
	  "ALFA in %": "0,3",
	  "IBF": "1292",
	  "IBF in %": "0,7",
	  "Liberale": "1190",
	  "Liberale in %": "0,7",
	  "P.O.P.": "847",
	  "P.O.P. in %": "0,5",
	  "FREIE WÄHLER": "932",
	  "FREIE WÄHLER in %": "0,5",
	  "AfD": "12714",
	  "AfD in %": "7",
	  "NPD": "284",
	  "NPD in %": "0,2",
	  "DIE PARTEI": "6453",
	  "DIE PARTEI in %": "3,5",
	  "dFfm": "761",
	  "dFfm in %": "0,4"
	}, {
	  "Stadtteilnummer": "11",
	  "Stadtteil": "Gallus",
	  "Wahlberechtigte insgesamt": "22411",
	  "Wähler/innen": "6148",
	  "Wähler/innen in %": "27,4",
	  "darunter Wähler mit Wahlschein": "1588",
	  "darunter Wähler mit Wahlschein in %": "25,8",
	  "gültige Stimmen": "529404",
	  "CDU": "104404",
	  "CDU in %": "19,7",
	  "SPD": "115440",
	  "SPD in %": "21,8",
	  "GRÜNE": "81399",
	  "GRÜNE in %": "15,4",
	  "DIE LINKE": "55106",
	  "DIE LINKE in %": "10,4",
	  "FDP": "38872",
	  "FDP in %": "7,3",
	  "BFF": "12104",
	  "BFF in %": "2,3",
	  "PIRATEN": "6797",
	  "PIRATEN in %": "1,3",
	  "ÖkoLinX-ARL": "16624",
	  "ÖkoLinX-ARL in %": "3,1",
	  "ELF": "9411",
	  "ELF in %": "1,8",
	  "REP": "1833",
	  "REP in %": "0,3",
	  "Graue Panther": "2777",
	  "Graue Panther in %": "0,5",
	  "ALFA": "2064",
	  "ALFA in %": "0,4",
	  "IBF": "3437",
	  "IBF in %": "0,6",
	  "Liberale": "2770",
	  "Liberale in %": "0,5",
	  "P.O.P.": "1501",
	  "P.O.P. in %": "0,3",
	  "FREIE WÄHLER": "1801",
	  "FREIE WÄHLER in %": "0,3",
	  "AfD": "57240",
	  "AfD in %": "10,8",
	  "NPD": "1835",
	  "NPD in %": "0,3",
	  "DIE PARTEI": "10453",
	  "DIE PARTEI in %": "2",
	  "dFfm": "3536",
	  "dFfm in %": "0,7"
	}, {
	  "Stadtteilnummer": "12",
	  "Stadtteil": "Bockenheim",
	  "Wahlberechtigte insgesamt": "27017",
	  "Wähler/innen": "10378",
	  "Wähler/innen in %": "38,4",
	  "darunter Wähler mit Wahlschein": "2571",
	  "darunter Wähler mit Wahlschein in %": "24,8",
	  "gültige Stimmen": "909893",
	  "CDU": "172964",
	  "CDU in %": "19",
	  "SPD": "215617",
	  "SPD in %": "23,7",
	  "GRÜNE": "182992",
	  "GRÜNE in %": "20,1",
	  "DIE LINKE": "98744",
	  "DIE LINKE in %": "10,9",
	  "FDP": "68322",
	  "FDP in %": "7,5",
	  "BFF": "18572",
	  "BFF in %": "2",
	  "PIRATEN": "10520",
	  "PIRATEN in %": "1,2",
	  "ÖkoLinX-ARL": "29869",
	  "ÖkoLinX-ARL in %": "3,3",
	  "ELF": "11149",
	  "ELF in %": "1,2",
	  "REP": "1516",
	  "REP in %": "0,2",
	  "Graue Panther": "4195",
	  "Graue Panther in %": "0,5",
	  "ALFA": "4566",
	  "ALFA in %": "0,5",
	  "IBF": "3095",
	  "IBF in %": "0,3",
	  "Liberale": "4092",
	  "Liberale in %": "0,4",
	  "P.O.P.": "2210",
	  "P.O.P. in %": "0,2",
	  "FREIE WÄHLER": "2528",
	  "FREIE WÄHLER in %": "0,3",
	  "AfD": "55242",
	  "AfD in %": "6,1",
	  "NPD": "1598",
	  "NPD in %": "0,2",
	  "DIE PARTEI": "17415",
	  "DIE PARTEI in %": "1,9",
	  "dFfm": "4687",
	  "dFfm in %": "0,5"
	}, {
	  "Stadtteilnummer": "13",
	  "Stadtteil": "Sachsenhausen-Nord",
	  "Wahlberechtigte insgesamt": "23458",
	  "Wähler/innen": "9922",
	  "Wähler/innen in %": "42,3",
	  "darunter Wähler mit Wahlschein": "2675",
	  "darunter Wähler mit Wahlschein in %": "27",
	  "gültige Stimmen": "870967",
	  "CDU": "210574",
	  "CDU in %": "24,2",
	  "SPD": "185761",
	  "SPD in %": "21,3",
	  "GRÜNE": "171572",
	  "GRÜNE in %": "19,7",
	  "DIE LINKE": "64964",
	  "DIE LINKE in %": "7,5",
	  "FDP": "94714",
	  "FDP in %": "10,9",
	  "BFF": "19745",
	  "BFF in %": "2,3",
	  "PIRATEN": "6135",
	  "PIRATEN in %": "0,7",
	  "ÖkoLinX-ARL": "15645",
	  "ÖkoLinX-ARL in %": "1,8",
	  "ELF": "5385",
	  "ELF in %": "0,6",
	  "REP": "959",
	  "REP in %": "0,1",
	  "Graue Panther": "5115",
	  "Graue Panther in %": "0,6",
	  "ALFA": "4005",
	  "ALFA in %": "0,5",
	  "IBF": "2640",
	  "IBF in %": "0,3",
	  "Liberale": "3680",
	  "Liberale in %": "0,4",
	  "P.O.P.": "3429",
	  "P.O.P. in %": "0,4",
	  "FREIE WÄHLER": "3532",
	  "FREIE WÄHLER in %": "0,4",
	  "AfD": "55572",
	  "AfD in %": "6,4",
	  "NPD": "1000",
	  "NPD in %": "0,1",
	  "DIE PARTEI": "11549",
	  "DIE PARTEI in %": "1,3",
	  "dFfm": "4991",
	  "dFfm in %": "0,6"
	}, {
	  "Stadtteilnummer": "14",
	  "Stadtteil": "Sachsenhausen-Süd",
	  "Wahlberechtigte insgesamt": "20275",
	  "Wähler/innen": "8523",
	  "Wähler/innen in %": "42",
	  "darunter Wähler mit Wahlschein": "2906",
	  "darunter Wähler mit Wahlschein in %": "34,1",
	  "gültige Stimmen": "738742",
	  "CDU": "188407",
	  "CDU in %": "25,5",
	  "SPD": "183531",
	  "SPD in %": "24,8",
	  "GRÜNE": "99135",
	  "GRÜNE in %": "13,4",
	  "DIE LINKE": "51165",
	  "DIE LINKE in %": "6,9",
	  "FDP": "74898",
	  "FDP in %": "10,1",
	  "BFF": "23306",
	  "BFF in %": "3,2",
	  "PIRATEN": "6311",
	  "PIRATEN in %": "0,9",
	  "ÖkoLinX-ARL": "8531",
	  "ÖkoLinX-ARL in %": "1,2",
	  "ELF": "3891",
	  "ELF in %": "0,5",
	  "REP": "1286",
	  "REP in %": "0,2",
	  "Graue Panther": "5967",
	  "Graue Panther in %": "0,8",
	  "ALFA": "4919",
	  "ALFA in %": "0,7",
	  "IBF": "2280",
	  "IBF in %": "0,3",
	  "Liberale": "1697",
	  "Liberale in %": "0,2",
	  "P.O.P.": "2722",
	  "P.O.P. in %": "0,4",
	  "FREIE WÄHLER": "2652",
	  "FREIE WÄHLER in %": "0,4",
	  "AfD": "63850",
	  "AfD in %": "8,6",
	  "NPD": "1693",
	  "NPD in %": "0,2",
	  "DIE PARTEI": "7674",
	  "DIE PARTEI in %": "1",
	  "dFfm": "4827",
	  "dFfm in %": "0,7"
	}, {
	  "Stadtteilnummer": "16",
	  "Stadtteil": "Oberrad",
	  "Wahlberechtigte insgesamt": "9215",
	  "Wähler/innen": "3348",
	  "Wähler/innen in %": "36,3",
	  "darunter Wähler mit Wahlschein": "919",
	  "darunter Wähler mit Wahlschein in %": "27,4",
	  "gültige Stimmen": "282242",
	  "CDU": "78905",
	  "CDU in %": "28",
	  "SPD": "67944",
	  "SPD in %": "24,1",
	  "GRÜNE": "33350",
	  "GRÜNE in %": "11,8",
	  "DIE LINKE": "19627",
	  "DIE LINKE in %": "7",
	  "FDP": "16364",
	  "FDP in %": "5,8",
	  "BFF": "7631",
	  "BFF in %": "2,7",
	  "PIRATEN": "2315",
	  "PIRATEN in %": "0,8",
	  "ÖkoLinX-ARL": "4311",
	  "ÖkoLinX-ARL in %": "1,5",
	  "ELF": "2866",
	  "ELF in %": "1",
	  "REP": "1609",
	  "REP in %": "0,6",
	  "Graue Panther": "3527",
	  "Graue Panther in %": "1,2",
	  "ALFA": "803",
	  "ALFA in %": "0,3",
	  "IBF": "404",
	  "IBF in %": "0,1",
	  "Liberale": "346",
	  "Liberale in %": "0,1",
	  "P.O.P.": "1107",
	  "P.O.P. in %": "0,4",
	  "FREIE WÄHLER": "1087",
	  "FREIE WÄHLER in %": "0,4",
	  "AfD": "34359",
	  "AfD in %": "12,2",
	  "NPD": "893",
	  "NPD in %": "0,3",
	  "DIE PARTEI": "3720",
	  "DIE PARTEI in %": "1,3",
	  "dFfm": "1074",
	  "dFfm in %": "0,4"
	}, {
	  "Stadtteilnummer": "17",
	  "Stadtteil": "Niederrad",
	  "Wahlberechtigte insgesamt": "16743",
	  "Wähler/innen": "5635",
	  "Wähler/innen in %": "33,7",
	  "darunter Wähler mit Wahlschein": "1523",
	  "darunter Wähler mit Wahlschein in %": "27",
	  "gültige Stimmen": "482337",
	  "CDU": "108445",
	  "CDU in %": "22,5",
	  "SPD": "124650",
	  "SPD in %": "25,8",
	  "GRÜNE": "54986",
	  "GRÜNE in %": "11,4",
	  "DIE LINKE": "38250",
	  "DIE LINKE in %": "7,9",
	  "FDP": "32487",
	  "FDP in %": "6,7",
	  "BFF": "35176",
	  "BFF in %": "7,3",
	  "PIRATEN": "4186",
	  "PIRATEN in %": "0,9",
	  "ÖkoLinX-ARL": "4872",
	  "ÖkoLinX-ARL in %": "1",
	  "ELF": "4731",
	  "ELF in %": "1",
	  "REP": "1545",
	  "REP in %": "0,3",
	  "Graue Panther": "3513",
	  "Graue Panther in %": "0,7",
	  "ALFA": "1908",
	  "ALFA in %": "0,4",
	  "IBF": "2094",
	  "IBF in %": "0,4",
	  "Liberale": "912",
	  "Liberale in %": "0,2",
	  "P.O.P.": "996",
	  "P.O.P. in %": "0,2",
	  "FREIE WÄHLER": "3020",
	  "FREIE WÄHLER in %": "0,6",
	  "AfD": "48421",
	  "AfD in %": "10",
	  "NPD": "1780",
	  "NPD in %": "0,4",
	  "DIE PARTEI": "6526",
	  "DIE PARTEI in %": "1,4",
	  "dFfm": "3839",
	  "dFfm in %": "0,8"
	}, {
	  "Stadtteilnummer": "18",
	  "Stadtteil": "Schwanheim",
	  "Wahlberechtigte insgesamt": "14008",
	  "Wähler/innen": "5319",
	  "Wähler/innen in %": "38",
	  "darunter Wähler mit Wahlschein": "1290",
	  "darunter Wähler mit Wahlschein in %": "24,3",
	  "gültige Stimmen": "452460",
	  "CDU": "126464",
	  "CDU in %": "28",
	  "SPD": "117312",
	  "SPD in %": "25,9",
	  "GRÜNE": "45140",
	  "GRÜNE in %": "10",
	  "DIE LINKE": "20725",
	  "DIE LINKE in %": "4,6",
	  "FDP": "25968",
	  "FDP in %": "5,7",
	  "BFF": "19651",
	  "BFF in %": "4,3",
	  "PIRATEN": "2876",
	  "PIRATEN in %": "0,6",
	  "ÖkoLinX-ARL": "2304",
	  "ÖkoLinX-ARL in %": "0,5",
	  "ELF": "3839",
	  "ELF in %": "0,8",
	  "REP": "3176",
	  "REP in %": "0,7",
	  "Graue Panther": "5385",
	  "Graue Panther in %": "1,2",
	  "ALFA": "1382",
	  "ALFA in %": "0,3",
	  "IBF": "2823",
	  "IBF in %": "0,6",
	  "Liberale": "484",
	  "Liberale in %": "0,1",
	  "P.O.P.": "1836",
	  "P.O.P. in %": "0,4",
	  "FREIE WÄHLER": "3047",
	  "FREIE WÄHLER in %": "0,7",
	  "AfD": "60558",
	  "AfD in %": "13,4",
	  "NPD": "2070",
	  "NPD in %": "0,5",
	  "DIE PARTEI": "4377",
	  "DIE PARTEI in %": "1",
	  "dFfm": "3043",
	  "dFfm in %": "0,7"
	}, {
	  "Stadtteilnummer": "19",
	  "Stadtteil": "Griesheim",
	  "Wahlberechtigte insgesamt": "15049",
	  "Wähler/innen": "3869",
	  "Wähler/innen in %": "25,7",
	  "darunter Wähler mit Wahlschein": "917",
	  "darunter Wähler mit Wahlschein in %": "23,7",
	  "gültige Stimmen": "321802",
	  "CDU": "70952",
	  "CDU in %": "22",
	  "SPD": "87808",
	  "SPD in %": "27,3",
	  "GRÜNE": "34152",
	  "GRÜNE in %": "10,6",
	  "DIE LINKE": "18856",
	  "DIE LINKE in %": "5,9",
	  "FDP": "16485",
	  "FDP in %": "5,1",
	  "BFF": "7600",
	  "BFF in %": "2,4",
	  "PIRATEN": "3096",
	  "PIRATEN in %": "1",
	  "ÖkoLinX-ARL": "3698",
	  "ÖkoLinX-ARL in %": "1,1",
	  "ELF": "12414",
	  "ELF in %": "3,9",
	  "REP": "2368",
	  "REP in %": "0,7",
	  "Graue Panther": "2059",
	  "Graue Panther in %": "0,6",
	  "ALFA": "732",
	  "ALFA in %": "0,2",
	  "IBF": "2085",
	  "IBF in %": "0,6",
	  "Liberale": "463",
	  "Liberale in %": "0,1",
	  "P.O.P.": "948",
	  "P.O.P. in %": "0,3",
	  "FREIE WÄHLER": "4251",
	  "FREIE WÄHLER in %": "1,3",
	  "AfD": "44663",
	  "AfD in %": "13,9",
	  "NPD": "3071",
	  "NPD in %": "1",
	  "DIE PARTEI": "4243",
	  "DIE PARTEI in %": "1,3",
	  "dFfm": "1858",
	  "dFfm in %": "0,6"
	}, {
	  "Stadtteilnummer": "20",
	  "Stadtteil": "Rödelheim",
	  "Wahlberechtigte insgesamt": "12359",
	  "Wähler/innen": "4644",
	  "Wähler/innen in %": "37,6",
	  "darunter Wähler mit Wahlschein": "1045",
	  "darunter Wähler mit Wahlschein in %": "22,5",
	  "gültige Stimmen": "398695",
	  "CDU": "78047",
	  "CDU in %": "19,6",
	  "SPD": "89373",
	  "SPD in %": "22,4",
	  "GRÜNE": "54543",
	  "GRÜNE in %": "13,7",
	  "DIE LINKE": "48152",
	  "DIE LINKE in %": "12,1",
	  "FDP": "27385",
	  "FDP in %": "6,9",
	  "BFF": "7976",
	  "BFF in %": "2",
	  "PIRATEN": "5060",
	  "PIRATEN in %": "1,3",
	  "ÖkoLinX-ARL": "16411",
	  "ÖkoLinX-ARL in %": "4,1",
	  "ELF": "4489",
	  "ELF in %": "1,1",
	  "REP": "2433",
	  "REP in %": "0,6",
	  "Graue Panther": "3576",
	  "Graue Panther in %": "0,9",
	  "ALFA": "1469",
	  "ALFA in %": "0,4",
	  "IBF": "2421",
	  "IBF in %": "0,6",
	  "Liberale": "1369",
	  "Liberale in %": "0,3",
	  "P.O.P.": "1238",
	  "P.O.P. in %": "0,3",
	  "FREIE WÄHLER": "2420",
	  "FREIE WÄHLER in %": "0,6",
	  "AfD": "42937",
	  "AfD in %": "10,8",
	  "NPD": "748",
	  "NPD in %": "0,2",
	  "DIE PARTEI": "6524",
	  "DIE PARTEI in %": "1,6",
	  "dFfm": "2124",
	  "dFfm in %": "0,5"
	}, {
	  "Stadtteilnummer": "21",
	  "Stadtteil": "Hausen",
	  "Wahlberechtigte insgesamt": "4460",
	  "Wähler/innen": "1916",
	  "Wähler/innen in %": "43",
	  "darunter Wähler mit Wahlschein": "587",
	  "darunter Wähler mit Wahlschein in %": "30,6",
	  "gültige Stimmen": "166919",
	  "CDU": "37041",
	  "CDU in %": "22,2",
	  "SPD": "47032",
	  "SPD in %": "28,2",
	  "GRÜNE": "20023",
	  "GRÜNE in %": "12",
	  "DIE LINKE": "12728",
	  "DIE LINKE in %": "7,6",
	  "FDP": "13816",
	  "FDP in %": "8,3",
	  "BFF": "4444",
	  "BFF in %": "2,7",
	  "PIRATEN": "1273",
	  "PIRATEN in %": "0,8",
	  "ÖkoLinX-ARL": "2912",
	  "ÖkoLinX-ARL in %": "1,7",
	  "ELF": "1605",
	  "ELF in %": "1",
	  "REP": "992",
	  "REP in %": "0,6",
	  "Graue Panther": "1142",
	  "Graue Panther in %": "0,7",
	  "ALFA": "729",
	  "ALFA in %": "0,4",
	  "IBF": "4480",
	  "IBF in %": "2,7",
	  "Liberale": "435",
	  "Liberale in %": "0,3",
	  "P.O.P.": "234",
	  "P.O.P. in %": "0,1",
	  "FREIE WÄHLER": "515",
	  "FREIE WÄHLER in %": "0,3",
	  "AfD": "14170",
	  "AfD in %": "8,5",
	  "NPD": "276",
	  "NPD in %": "0,2",
	  "DIE PARTEI": "2397",
	  "DIE PARTEI in %": "1,4",
	  "dFfm": "675",
	  "dFfm in %": "0,4"
	}, {
	  "Stadtteilnummer": "22",
	  "Stadtteil": "Praunheim",
	  "Wahlberechtigte insgesamt": "11155",
	  "Wähler/innen": "4673",
	  "Wähler/innen in %": "41,9",
	  "darunter Wähler mit Wahlschein": "1225",
	  "darunter Wähler mit Wahlschein in %": "26,2",
	  "gültige Stimmen": "397679",
	  "CDU": "88156",
	  "CDU in %": "22,2",
	  "SPD": "110066",
	  "SPD in %": "27,7",
	  "GRÜNE": "47578",
	  "GRÜNE in %": "12",
	  "DIE LINKE": "31319",
	  "DIE LINKE in %": "7,9",
	  "FDP": "28300",
	  "FDP in %": "7,1",
	  "BFF": "11330",
	  "BFF in %": "2,8",
	  "PIRATEN": "3784",
	  "PIRATEN in %": "1",
	  "ÖkoLinX-ARL": "4765",
	  "ÖkoLinX-ARL in %": "1,2",
	  "ELF": "4614",
	  "ELF in %": "1,2",
	  "REP": "3557",
	  "REP in %": "0,9",
	  "Graue Panther": "4123",
	  "Graue Panther in %": "1",
	  "ALFA": "2334",
	  "ALFA in %": "0,6",
	  "IBF": "1573",
	  "IBF in %": "0,4",
	  "Liberale": "460",
	  "Liberale in %": "0,1",
	  "P.O.P.": "1636",
	  "P.O.P. in %": "0,4",
	  "FREIE WÄHLER": "1596",
	  "FREIE WÄHLER in %": "0,4",
	  "AfD": "43101",
	  "AfD in %": "10,8",
	  "NPD": "1961",
	  "NPD in %": "0,5",
	  "DIE PARTEI": "4531",
	  "DIE PARTEI in %": "1,1",
	  "dFfm": "2895",
	  "dFfm in %": "0,7"
	}, {
	  "Stadtteilnummer": "24",
	  "Stadtteil": "Heddernheim",
	  "Wahlberechtigte insgesamt": "11998",
	  "Wähler/innen": "4820",
	  "Wähler/innen in %": "40,2",
	  "darunter Wähler mit Wahlschein": "1141",
	  "darunter Wähler mit Wahlschein in %": "23,7",
	  "gültige Stimmen": "413383",
	  "CDU": "91626",
	  "CDU in %": "22,2",
	  "SPD": "104126",
	  "SPD in %": "25,2",
	  "GRÜNE": "56062",
	  "GRÜNE in %": "13,6",
	  "DIE LINKE": "39267",
	  "DIE LINKE in %": "9,5",
	  "FDP": "23900",
	  "FDP in %": "5,8",
	  "BFF": "10664",
	  "BFF in %": "2,6",
	  "PIRATEN": "3803",
	  "PIRATEN in %": "0,9",
	  "ÖkoLinX-ARL": "5840",
	  "ÖkoLinX-ARL in %": "1,4",
	  "ELF": "8419",
	  "ELF in %": "2",
	  "REP": "2490",
	  "REP in %": "0,6",
	  "Graue Panther": "1949",
	  "Graue Panther in %": "0,5",
	  "ALFA": "1994",
	  "ALFA in %": "0,5",
	  "IBF": "937",
	  "IBF in %": "0,2",
	  "Liberale": "666",
	  "Liberale in %": "0,2",
	  "P.O.P.": "2295",
	  "P.O.P. in %": "0,6",
	  "FREIE WÄHLER": "6060",
	  "FREIE WÄHLER in %": "1,5",
	  "AfD": "44762",
	  "AfD in %": "10,8",
	  "NPD": "1590",
	  "NPD in %": "0,4",
	  "DIE PARTEI": "4913",
	  "DIE PARTEI in %": "1,2",
	  "dFfm": "2020",
	  "dFfm in %": "0,5"
	}, {
	  "Stadtteilnummer": "25",
	  "Stadtteil": "Niederursel",
	  "Wahlberechtigte insgesamt": "10458",
	  "Wähler/innen": "3955",
	  "Wähler/innen in %": "37,8",
	  "darunter Wähler mit Wahlschein": "886",
	  "darunter Wähler mit Wahlschein in %": "22,4",
	  "gültige Stimmen": "339385",
	  "CDU": "83061",
	  "CDU in %": "24,5",
	  "SPD": "91633",
	  "SPD in %": "27",
	  "GRÜNE": "46376",
	  "GRÜNE in %": "13,7",
	  "DIE LINKE": "22482",
	  "DIE LINKE in %": "6,6",
	  "FDP": "22708",
	  "FDP in %": "6,7",
	  "BFF": "7939",
	  "BFF in %": "2,3",
	  "PIRATEN": "2935",
	  "PIRATEN in %": "0,9",
	  "ÖkoLinX-ARL": "4843",
	  "ÖkoLinX-ARL in %": "1,4",
	  "ELF": "4378",
	  "ELF in %": "1,3",
	  "REP": "1332",
	  "REP in %": "0,4",
	  "Graue Panther": "2608",
	  "Graue Panther in %": "0,8",
	  "ALFA": "1400",
	  "ALFA in %": "0,4",
	  "IBF": "1513",
	  "IBF in %": "0,4",
	  "Liberale": "985",
	  "Liberale in %": "0,3",
	  "P.O.P.": "1678",
	  "P.O.P. in %": "0,5",
	  "FREIE WÄHLER": "1920",
	  "FREIE WÄHLER in %": "0,6",
	  "AfD": "35198",
	  "AfD in %": "10,4",
	  "NPD": "1625",
	  "NPD in %": "0,5",
	  "DIE PARTEI": "3141",
	  "DIE PARTEI in %": "0,9",
	  "dFfm": "1630",
	  "dFfm in %": "0,5"
	}, {
	  "Stadtteilnummer": "26",
	  "Stadtteil": "Ginnheim",
	  "Wahlberechtigte insgesamt": "11367",
	  "Wähler/innen": "4600",
	  "Wähler/innen in %": "40,5",
	  "darunter Wähler mit Wahlschein": "1183",
	  "darunter Wähler mit Wahlschein in %": "25,7",
	  "gültige Stimmen": "397356",
	  "CDU": "84642",
	  "CDU in %": "21,3",
	  "SPD": "105997",
	  "SPD in %": "26,7",
	  "GRÜNE": "58077",
	  "GRÜNE in %": "14,6",
	  "DIE LINKE": "35842",
	  "DIE LINKE in %": "9",
	  "FDP": "28101",
	  "FDP in %": "7,1",
	  "BFF": "15215",
	  "BFF in %": "3,8",
	  "PIRATEN": "2498",
	  "PIRATEN in %": "0,6",
	  "ÖkoLinX-ARL": "7949",
	  "ÖkoLinX-ARL in %": "2",
	  "ELF": "5022",
	  "ELF in %": "1,3",
	  "REP": "1900",
	  "REP in %": "0,5",
	  "Graue Panther": "2144",
	  "Graue Panther in %": "0,5",
	  "ALFA": "2437",
	  "ALFA in %": "0,6",
	  "IBF": "1244",
	  "IBF in %": "0,3",
	  "Liberale": "1177",
	  "Liberale in %": "0,3",
	  "P.O.P.": "1298",
	  "P.O.P. in %": "0,3",
	  "FREIE WÄHLER": "1664",
	  "FREIE WÄHLER in %": "0,4",
	  "AfD": "32651",
	  "AfD in %": "8,2",
	  "NPD": "709",
	  "NPD in %": "0,2",
	  "DIE PARTEI": "5703",
	  "DIE PARTEI in %": "1,4",
	  "dFfm": "3086",
	  "dFfm in %": "0,8"
	}, {
	  "Stadtteilnummer": "27",
	  "Stadtteil": "Dornbusch",
	  "Wahlberechtigte insgesamt": "13558",
	  "Wähler/innen": "6356",
	  "Wähler/innen in %": "46,9",
	  "darunter Wähler mit Wahlschein": "1653",
	  "darunter Wähler mit Wahlschein in %": "26",
	  "gültige Stimmen": "558256",
	  "CDU": "139404",
	  "CDU in %": "25",
	  "SPD": "127277",
	  "SPD in %": "22,8",
	  "GRÜNE": "86536",
	  "GRÜNE in %": "15,5",
	  "DIE LINKE": "40635",
	  "DIE LINKE in %": "7,3",
	  "FDP": "59951",
	  "FDP in %": "10,7",
	  "BFF": "16729",
	  "BFF in %": "3",
	  "PIRATEN": "4412",
	  "PIRATEN in %": "0,8",
	  "ÖkoLinX-ARL": "11193",
	  "ÖkoLinX-ARL in %": "2",
	  "ELF": "3738",
	  "ELF in %": "0,7",
	  "REP": "880",
	  "REP in %": "0,2",
	  "Graue Panther": "3389",
	  "Graue Panther in %": "0,6",
	  "ALFA": "2121",
	  "ALFA in %": "0,4",
	  "IBF": "1301",
	  "IBF in %": "0,2",
	  "Liberale": "1752",
	  "Liberale in %": "0,3",
	  "P.O.P.": "2260",
	  "P.O.P. in %": "0,4",
	  "FREIE WÄHLER": "3274",
	  "FREIE WÄHLER in %": "0,6",
	  "AfD": "42501",
	  "AfD in %": "7,6",
	  "NPD": "1138",
	  "NPD in %": "0,2",
	  "DIE PARTEI": "6382",
	  "DIE PARTEI in %": "1,1",
	  "dFfm": "3383",
	  "dFfm in %": "0,6"
	}, {
	  "Stadtteilnummer": "28",
	  "Stadtteil": "Eschersheim",
	  "Wahlberechtigte insgesamt": "11195",
	  "Wähler/innen": "5105",
	  "Wähler/innen in %": "45,6",
	  "darunter Wähler mit Wahlschein": "1303",
	  "darunter Wähler mit Wahlschein in %": "25,5",
	  "gültige Stimmen": "445483",
	  "CDU": "117916",
	  "CDU in %": "26,5",
	  "SPD": "105875",
	  "SPD in %": "23,8",
	  "GRÜNE": "69063",
	  "GRÜNE in %": "15,5",
	  "DIE LINKE": "33480",
	  "DIE LINKE in %": "7,5",
	  "FDP": "42084",
	  "FDP in %": "9,4",
	  "BFF": "11673",
	  "BFF in %": "2,6",
	  "PIRATEN": "3133",
	  "PIRATEN in %": "0,7",
	  "ÖkoLinX-ARL": "6891",
	  "ÖkoLinX-ARL in %": "1,5",
	  "ELF": "3165",
	  "ELF in %": "0,7",
	  "REP": "1066",
	  "REP in %": "0,2",
	  "Graue Panther": "1900",
	  "Graue Panther in %": "0,4",
	  "ALFA": "2277",
	  "ALFA in %": "0,5",
	  "IBF": "1462",
	  "IBF in %": "0,3",
	  "Liberale": "877",
	  "Liberale in %": "0,2",
	  "P.O.P.": "1827",
	  "P.O.P. in %": "0,4",
	  "FREIE WÄHLER": "1718",
	  "FREIE WÄHLER in %": "0,4",
	  "AfD": "32477",
	  "AfD in %": "7,3",
	  "NPD": "602",
	  "NPD in %": "0,1",
	  "DIE PARTEI": "5135",
	  "DIE PARTEI in %": "1,2",
	  "dFfm": "2862",
	  "dFfm in %": "0,6"
	}, {
	  "Stadtteilnummer": "29",
	  "Stadtteil": "Eckenheim",
	  "Wahlberechtigte insgesamt": "9608",
	  "Wähler/innen": "3524",
	  "Wähler/innen in %": "36,7",
	  "darunter Wähler mit Wahlschein": "821",
	  "darunter Wähler mit Wahlschein in %": "23,3",
	  "gültige Stimmen": "303786",
	  "CDU": "65552",
	  "CDU in %": "21,6",
	  "SPD": "83184",
	  "SPD in %": "27,4",
	  "GRÜNE": "36400",
	  "GRÜNE in %": "12",
	  "DIE LINKE": "29636",
	  "DIE LINKE in %": "9,8",
	  "FDP": "18310",
	  "FDP in %": "6",
	  "BFF": "10660",
	  "BFF in %": "3,5",
	  "PIRATEN": "3664",
	  "PIRATEN in %": "1,2",
	  "ÖkoLinX-ARL": "6889",
	  "ÖkoLinX-ARL in %": "2,3",
	  "ELF": "3882",
	  "ELF in %": "1,3",
	  "REP": "844",
	  "REP in %": "0,3",
	  "Graue Panther": "2295",
	  "Graue Panther in %": "0,8",
	  "ALFA": "1687",
	  "ALFA in %": "0,6",
	  "IBF": "1045",
	  "IBF in %": "0,3",
	  "Liberale": "966",
	  "Liberale in %": "0,3",
	  "P.O.P.": "1581",
	  "P.O.P. in %": "0,5",
	  "FREIE WÄHLER": "1332",
	  "FREIE WÄHLER in %": "0,4",
	  "AfD": "29211",
	  "AfD in %": "9,6",
	  "NPD": "1232",
	  "NPD in %": "0,4",
	  "DIE PARTEI": "3005",
	  "DIE PARTEI in %": "1",
	  "dFfm": "2411",
	  "dFfm in %": "0,8"
	}, {
	  "Stadtteilnummer": "30",
	  "Stadtteil": "Preungesheim",
	  "Wahlberechtigte insgesamt": "9975",
	  "Wähler/innen": "4033",
	  "Wähler/innen in %": "40,4",
	  "darunter Wähler mit Wahlschein": "928",
	  "darunter Wähler mit Wahlschein in %": "23",
	  "gültige Stimmen": "351663",
	  "CDU": "81047",
	  "CDU in %": "23",
	  "SPD": "91469",
	  "SPD in %": "26",
	  "GRÜNE": "50847",
	  "GRÜNE in %": "14,5",
	  "DIE LINKE": "29870",
	  "DIE LINKE in %": "8,5",
	  "FDP": "24871",
	  "FDP in %": "7,1",
	  "BFF": "9208",
	  "BFF in %": "2,6",
	  "PIRATEN": "2185",
	  "PIRATEN in %": "0,6",
	  "ÖkoLinX-ARL": "6581",
	  "ÖkoLinX-ARL in %": "1,9",
	  "ELF": "6300",
	  "ELF in %": "1,8",
	  "REP": "726",
	  "REP in %": "0,2",
	  "Graue Panther": "1999",
	  "Graue Panther in %": "0,6",
	  "ALFA": "2265",
	  "ALFA in %": "0,6",
	  "IBF": "1375",
	  "IBF in %": "0,4",
	  "Liberale": "222",
	  "Liberale in %": "0,1",
	  "P.O.P.": "2259",
	  "P.O.P. in %": "0,6",
	  "FREIE WÄHLER": "2210",
	  "FREIE WÄHLER in %": "0,6",
	  "AfD": "31778",
	  "AfD in %": "9",
	  "NPD": "738",
	  "NPD in %": "0,2",
	  "DIE PARTEI": "3694",
	  "DIE PARTEI in %": "1,1",
	  "dFfm": "2019",
	  "dFfm in %": "0,6"
	}, {
	  "Stadtteilnummer": "31",
	  "Stadtteil": "Bonames",
	  "Wahlberechtigte insgesamt": "4550",
	  "Wähler/innen": "1610",
	  "Wähler/innen in %": "35,4",
	  "darunter Wähler mit Wahlschein": "381",
	  "darunter Wähler mit Wahlschein in %": "23,7",
	  "gültige Stimmen": "135916",
	  "CDU": "30537",
	  "CDU in %": "22,5",
	  "SPD": "34782",
	  "SPD in %": "25,6",
	  "GRÜNE": "13755",
	  "GRÜNE in %": "10,1",
	  "DIE LINKE": "10223",
	  "DIE LINKE in %": "7,5",
	  "FDP": "6684",
	  "FDP in %": "4,9",
	  "BFF": "9611",
	  "BFF in %": "7,1",
	  "PIRATEN": "998",
	  "PIRATEN in %": "0,7",
	  "ÖkoLinX-ARL": "2176",
	  "ÖkoLinX-ARL in %": "1,6",
	  "ELF": "1649",
	  "ELF in %": "1,2",
	  "REP": "628",
	  "REP in %": "0,5",
	  "Graue Panther": "618",
	  "Graue Panther in %": "0,5",
	  "ALFA": "605",
	  "ALFA in %": "0,4",
	  "IBF": "950",
	  "IBF in %": "0,7",
	  "Liberale": "361",
	  "Liberale in %": "0,3",
	  "P.O.P.": "317",
	  "P.O.P. in %": "0,2",
	  "FREIE WÄHLER": "1908",
	  "FREIE WÄHLER in %": "1,4",
	  "AfD": "16834",
	  "AfD in %": "12,4",
	  "NPD": "527",
	  "NPD in %": "0,4",
	  "DIE PARTEI": "1161",
	  "DIE PARTEI in %": "0,9",
	  "dFfm": "1592",
	  "dFfm in %": "1,2"
	}, {
	  "Stadtteilnummer": "32",
	  "Stadtteil": "Berkersheim",
	  "Wahlberechtigte insgesamt": "2598",
	  "Wähler/innen": "1264",
	  "Wähler/innen in %": "48,7",
	  "darunter Wähler mit Wahlschein": "347",
	  "darunter Wähler mit Wahlschein in %": "27,5",
	  "gültige Stimmen": "109268",
	  "CDU": "31003",
	  "CDU in %": "28,4",
	  "SPD": "24063",
	  "SPD in %": "22",
	  "GRÜNE": "13096",
	  "GRÜNE in %": "12",
	  "DIE LINKE": "7514",
	  "DIE LINKE in %": "6,9",
	  "FDP": "9879",
	  "FDP in %": "9",
	  "BFF": "3090",
	  "BFF in %": "2,8",
	  "PIRATEN": "896",
	  "PIRATEN in %": "0,8",
	  "ÖkoLinX-ARL": "1653",
	  "ÖkoLinX-ARL in %": "1,5",
	  "ELF": "2101",
	  "ELF in %": "1,9",
	  "REP": "390",
	  "REP in %": "0,4",
	  "Graue Panther": "239",
	  "Graue Panther in %": "0,2",
	  "ALFA": "551",
	  "ALFA in %": "0,5",
	  "IBF": "459",
	  "IBF in %": "0,4",
	  "Liberale": "322",
	  "Liberale in %": "0,3",
	  "P.O.P.": "618",
	  "P.O.P. in %": "0,6",
	  "FREIE WÄHLER": "113",
	  "FREIE WÄHLER in %": "0,1",
	  "AfD": "11569",
	  "AfD in %": "10,6",
	  "NPD": "181",
	  "NPD in %": "0,2",
	  "DIE PARTEI": "1019",
	  "DIE PARTEI in %": "0,9",
	  "dFfm": "512",
	  "dFfm in %": "0,5"
	}, {
	  "Stadtteilnummer": "33",
	  "Stadtteil": "Riederwald",
	  "Wahlberechtigte insgesamt": "3085",
	  "Wähler/innen": "1108",
	  "Wähler/innen in %": "35,9",
	  "darunter Wähler mit Wahlschein": "263",
	  "darunter Wähler mit Wahlschein in %": "23,7",
	  "gültige Stimmen": "92905",
	  "CDU": "11713",
	  "CDU in %": "12,6",
	  "SPD": "28070",
	  "SPD in %": "30,2",
	  "GRÜNE": "6055",
	  "GRÜNE in %": "6,5",
	  "DIE LINKE": "12460",
	  "DIE LINKE in %": "13,4",
	  "FDP": "3644",
	  "FDP in %": "3,9",
	  "BFF": "2440",
	  "BFF in %": "2,6",
	  "PIRATEN": "855",
	  "PIRATEN in %": "0,9",
	  "ÖkoLinX-ARL": "1590",
	  "ÖkoLinX-ARL in %": "1,7",
	  "ELF": "2745",
	  "ELF in %": "3",
	  "REP": "890",
	  "REP in %": "1",
	  "Graue Panther": "1134",
	  "Graue Panther in %": "1,2",
	  "ALFA": "106",
	  "ALFA in %": "0,1",
	  "IBF": "551",
	  "IBF in %": "0,6",
	  "Liberale": "114",
	  "Liberale in %": "0,1",
	  "P.O.P.": "5160",
	  "P.O.P. in %": "5,6",
	  "FREIE WÄHLER": "443",
	  "FREIE WÄHLER in %": "0,5",
	  "AfD": "12666",
	  "AfD in %": "13,6",
	  "NPD": "148",
	  "NPD in %": "0,2",
	  "DIE PARTEI": "1485",
	  "DIE PARTEI in %": "1,6",
	  "dFfm": "636",
	  "dFfm in %": "0,7"
	}, {
	  "Stadtteilnummer": "34",
	  "Stadtteil": "Seckbach",
	  "Wahlberechtigte insgesamt": "7506",
	  "Wähler/innen": "3013",
	  "Wähler/innen in %": "40,1",
	  "darunter Wähler mit Wahlschein": "794",
	  "darunter Wähler mit Wahlschein in %": "26,4",
	  "gültige Stimmen": "260806",
	  "CDU": "64562",
	  "CDU in %": "24,8",
	  "SPD": "67815",
	  "SPD in %": "26",
	  "GRÜNE": "37593",
	  "GRÜNE in %": "14,4",
	  "DIE LINKE": "20273",
	  "DIE LINKE in %": "7,8",
	  "FDP": "17881",
	  "FDP in %": "6,9",
	  "BFF": "7220",
	  "BFF in %": "2,8",
	  "PIRATEN": "1104",
	  "PIRATEN in %": "0,4",
	  "ÖkoLinX-ARL": "4793",
	  "ÖkoLinX-ARL in %": "1,8",
	  "ELF": "3022",
	  "ELF in %": "1,2",
	  "REP": "774",
	  "REP in %": "0,3",
	  "Graue Panther": "1332",
	  "Graue Panther in %": "0,5",
	  "ALFA": "919",
	  "ALFA in %": "0,4",
	  "IBF": "755",
	  "IBF in %": "0,3",
	  "Liberale": "230",
	  "Liberale in %": "0,1",
	  "P.O.P.": "1755",
	  "P.O.P. in %": "0,7",
	  "FREIE WÄHLER": "1120",
	  "FREIE WÄHLER in %": "0,4",
	  "AfD": "22771",
	  "AfD in %": "8,7",
	  "NPD": "771",
	  "NPD in %": "0,3",
	  "DIE PARTEI": "3022",
	  "DIE PARTEI in %": "1,2",
	  "dFfm": "3094",
	  "dFfm in %": "1,2"
	}, {
	  "Stadtteilnummer": "35",
	  "Stadtteil": "Fechenheim",
	  "Wahlberechtigte insgesamt": "10257",
	  "Wähler/innen": "2809",
	  "Wähler/innen in %": "27,4",
	  "darunter Wähler mit Wahlschein": "714",
	  "darunter Wähler mit Wahlschein in %": "25,4",
	  "gültige Stimmen": "234606",
	  "CDU": "51446",
	  "CDU in %": "21,9",
	  "SPD": "67452",
	  "SPD in %": "28,8",
	  "GRÜNE": "23899",
	  "GRÜNE in %": "10,2",
	  "DIE LINKE": "19205",
	  "DIE LINKE in %": "8,2",
	  "FDP": "9518",
	  "FDP in %": "4,1",
	  "BFF": "7443",
	  "BFF in %": "3,2",
	  "PIRATEN": "1418",
	  "PIRATEN in %": "0,6",
	  "ÖkoLinX-ARL": "2522",
	  "ÖkoLinX-ARL in %": "1,1",
	  "ELF": "5133",
	  "ELF in %": "2,2",
	  "REP": "1479",
	  "REP in %": "0,6",
	  "Graue Panther": "1352",
	  "Graue Panther in %": "0,6",
	  "ALFA": "1225",
	  "ALFA in %": "0,5",
	  "IBF": "1088",
	  "IBF in %": "0,5",
	  "Liberale": "280",
	  "Liberale in %": "0,1",
	  "P.O.P.": "2389",
	  "P.O.P. in %": "1",
	  "FREIE WÄHLER": "1218",
	  "FREIE WÄHLER in %": "0,5",
	  "AfD": "31974",
	  "AfD in %": "13,6",
	  "NPD": "1010",
	  "NPD in %": "0,4",
	  "DIE PARTEI": "2271",
	  "DIE PARTEI in %": "1",
	  "dFfm": "2284",
	  "dFfm in %": "1"
	}, {
	  "Stadtteilnummer": "36",
	  "Stadtteil": "Höchst",
	  "Wahlberechtigte insgesamt": "9842",
	  "Wähler/innen": "2645",
	  "Wähler/innen in %": "26,9",
	  "darunter Wähler mit Wahlschein": "568",
	  "darunter Wähler mit Wahlschein in %": "21,5",
	  "gültige Stimmen": "224771",
	  "CDU": "43130",
	  "CDU in %": "19,2",
	  "SPD": "60066",
	  "SPD in %": "26,7",
	  "GRÜNE": "28828",
	  "GRÜNE in %": "12,8",
	  "DIE LINKE": "25957",
	  "DIE LINKE in %": "11,5",
	  "FDP": "10381",
	  "FDP in %": "4,6",
	  "BFF": "4832",
	  "BFF in %": "2,1",
	  "PIRATEN": "3782",
	  "PIRATEN in %": "1,7",
	  "ÖkoLinX-ARL": "4145",
	  "ÖkoLinX-ARL in %": "1,8",
	  "ELF": "6747",
	  "ELF in %": "3",
	  "REP": "1096",
	  "REP in %": "0,5",
	  "Graue Panther": "996",
	  "Graue Panther in %": "0,4",
	  "ALFA": "1188",
	  "ALFA in %": "0,5",
	  "IBF": "879",
	  "IBF in %": "0,4",
	  "Liberale": "363",
	  "Liberale in %": "0,2",
	  "P.O.P.": "505",
	  "P.O.P. in %": "0,2",
	  "FREIE WÄHLER": "2039",
	  "FREIE WÄHLER in %": "0,9",
	  "AfD": "22784",
	  "AfD in %": "10,1",
	  "NPD": "868",
	  "NPD in %": "0,4",
	  "DIE PARTEI": "5218",
	  "DIE PARTEI in %": "2,3",
	  "dFfm": "967",
	  "dFfm in %": "0,4"
	}, {
	  "Stadtteilnummer": "37",
	  "Stadtteil": "Nied",
	  "Wahlberechtigte insgesamt": "12646",
	  "Wähler/innen": "3919",
	  "Wähler/innen in %": "31",
	  "darunter Wähler mit Wahlschein": "856",
	  "darunter Wähler mit Wahlschein in %": "21,8",
	  "gültige Stimmen": "329545",
	  "CDU": "73777",
	  "CDU in %": "22,4",
	  "SPD": "88783",
	  "SPD in %": "26,9",
	  "GRÜNE": "29702",
	  "GRÜNE in %": "9",
	  "DIE LINKE": "23148",
	  "DIE LINKE in %": "7",
	  "FDP": "20108",
	  "FDP in %": "6,1",
	  "BFF": "9293",
	  "BFF in %": "2,8",
	  "PIRATEN": "2404",
	  "PIRATEN in %": "0,7",
	  "ÖkoLinX-ARL": "3028",
	  "ÖkoLinX-ARL in %": "0,9",
	  "ELF": "7126",
	  "ELF in %": "2,2",
	  "REP": "2507",
	  "REP in %": "0,8",
	  "Graue Panther": "2553",
	  "Graue Panther in %": "0,8",
	  "ALFA": "1500",
	  "ALFA in %": "0,5",
	  "IBF": "2132",
	  "IBF in %": "0,6",
	  "Liberale": "599",
	  "Liberale in %": "0,2",
	  "P.O.P.": "625",
	  "P.O.P. in %": "0,2",
	  "FREIE WÄHLER": "3604",
	  "FREIE WÄHLER in %": "1,1",
	  "AfD": "50376",
	  "AfD in %": "15,3",
	  "NPD": "2460",
	  "NPD in %": "0,7",
	  "DIE PARTEI": "4680",
	  "DIE PARTEI in %": "1,4",
	  "dFfm": "1140",
	  "dFfm in %": "0,3"
	}, {
	  "Stadtteilnummer": "38",
	  "Stadtteil": "Sindlingen",
	  "Wahlberechtigte insgesamt": "5983",
	  "Wähler/innen": "2031",
	  "Wähler/innen in %": "33,9",
	  "darunter Wähler mit Wahlschein": "403",
	  "darunter Wähler mit Wahlschein in %": "19,8",
	  "gültige Stimmen": "165071",
	  "CDU": "51383",
	  "CDU in %": "31,1",
	  "SPD": "49384",
	  "SPD in %": "29,9",
	  "GRÜNE": "11597",
	  "GRÜNE in %": "7",
	  "DIE LINKE": "8372",
	  "DIE LINKE in %": "5,1",
	  "FDP": "5219",
	  "FDP in %": "3,2",
	  "BFF": "5162",
	  "BFF in %": "3,1",
	  "PIRATEN": "821",
	  "PIRATEN in %": "0,5",
	  "ÖkoLinX-ARL": "762",
	  "ÖkoLinX-ARL in %": "0,5",
	  "ELF": "1668",
	  "ELF in %": "1",
	  "REP": "1120",
	  "REP in %": "0,7",
	  "Graue Panther": "797",
	  "Graue Panther in %": "0,5",
	  "ALFA": "501",
	  "ALFA in %": "0,3",
	  "IBF": "522",
	  "IBF in %": "0,3",
	  "Liberale": "27",
	  "Liberale in %": "0",
	  "P.O.P.": "576",
	  "P.O.P. in %": "0,3",
	  "FREIE WÄHLER": "1284",
	  "FREIE WÄHLER in %": "0,8",
	  "AfD": "23677",
	  "AfD in %": "14,3",
	  "NPD": "392",
	  "NPD in %": "0,2",
	  "DIE PARTEI": "1581",
	  "DIE PARTEI in %": "1",
	  "dFfm": "226",
	  "dFfm in %": "0,1"
	}, {
	  "Stadtteilnummer": "39",
	  "Stadtteil": "Zeilsheim",
	  "Wahlberechtigte insgesamt": "8133",
	  "Wähler/innen": "2757",
	  "Wähler/innen in %": "33,9",
	  "darunter Wähler mit Wahlschein": "662",
	  "darunter Wähler mit Wahlschein in %": "24",
	  "gültige Stimmen": "229529",
	  "CDU": "81211",
	  "CDU in %": "35,4",
	  "SPD": "54475",
	  "SPD in %": "23,7",
	  "GRÜNE": "16516",
	  "GRÜNE in %": "7,2",
	  "DIE LINKE": "12663",
	  "DIE LINKE in %": "5,5",
	  "FDP": "7635",
	  "FDP in %": "3,3",
	  "BFF": "6840",
	  "BFF in %": "3",
	  "PIRATEN": "2162",
	  "PIRATEN in %": "0,9",
	  "ÖkoLinX-ARL": "822",
	  "ÖkoLinX-ARL in %": "0,4",
	  "ELF": "2147",
	  "ELF in %": "0,9",
	  "REP": "1467",
	  "REP in %": "0,6",
	  "Graue Panther": "2079",
	  "Graue Panther in %": "0,9",
	  "ALFA": "840",
	  "ALFA in %": "0,4",
	  "IBF": "1017",
	  "IBF in %": "0,4",
	  "Liberale": "212",
	  "Liberale in %": "0,1",
	  "P.O.P.": "239",
	  "P.O.P. in %": "0,1",
	  "FREIE WÄHLER": "2160",
	  "FREIE WÄHLER in %": "0,9",
	  "AfD": "32366",
	  "AfD in %": "14,1",
	  "NPD": "1380",
	  "NPD in %": "0,6",
	  "DIE PARTEI": "1992",
	  "DIE PARTEI in %": "0,9",
	  "dFfm": "1306",
	  "dFfm in %": "0,6"
	}, {
	  "Stadtteilnummer": "40",
	  "Stadtteil": "Unterliederbach",
	  "Wahlberechtigte insgesamt": "10383",
	  "Wähler/innen": "3600",
	  "Wähler/innen in %": "34,7",
	  "darunter Wähler mit Wahlschein": "749",
	  "darunter Wähler mit Wahlschein in %": "20,8",
	  "gültige Stimmen": "306242",
	  "CDU": "87348",
	  "CDU in %": "28,5",
	  "SPD": "73586",
	  "SPD in %": "24",
	  "GRÜNE": "34220",
	  "GRÜNE in %": "11,2",
	  "DIE LINKE": "17270",
	  "DIE LINKE in %": "5,6",
	  "FDP": "17124",
	  "FDP in %": "5,6",
	  "BFF": "7160",
	  "BFF in %": "2,3",
	  "PIRATEN": "2467",
	  "PIRATEN in %": "0,8",
	  "ÖkoLinX-ARL": "2353",
	  "ÖkoLinX-ARL in %": "0,8",
	  "ELF": "8162",
	  "ELF in %": "2,7",
	  "REP": "2827",
	  "REP in %": "0,9",
	  "Graue Panther": "2009",
	  "Graue Panther in %": "0,7",
	  "ALFA": "1846",
	  "ALFA in %": "0,6",
	  "IBF": "1854",
	  "IBF in %": "0,6",
	  "Liberale": "509",
	  "Liberale in %": "0,2",
	  "P.O.P.": "509",
	  "P.O.P. in %": "0,2",
	  "FREIE WÄHLER": "3030",
	  "FREIE WÄHLER in %": "1",
	  "AfD": "36685",
	  "AfD in %": "12",
	  "NPD": "1406",
	  "NPD in %": "0,5",
	  "DIE PARTEI": "4505",
	  "DIE PARTEI in %": "1,5",
	  "dFfm": "1372",
	  "dFfm in %": "0,4"
	}, {
	  "Stadtteilnummer": "41",
	  "Stadtteil": "Sossenheim",
	  "Wahlberechtigte insgesamt": "10297",
	  "Wähler/innen": "3110",
	  "Wähler/innen in %": "30,2",
	  "darunter Wähler mit Wahlschein": "647",
	  "darunter Wähler mit Wahlschein in %": "20,8",
	  "gültige Stimmen": "261779",
	  "CDU": "85177",
	  "CDU in %": "32,5",
	  "SPD": "60810",
	  "SPD in %": "23,2",
	  "GRÜNE": "21255",
	  "GRÜNE in %": "8,1",
	  "DIE LINKE": "15218",
	  "DIE LINKE in %": "5,8",
	  "FDP": "12340",
	  "FDP in %": "4,7",
	  "BFF": "6937",
	  "BFF in %": "2,6",
	  "PIRATEN": "1266",
	  "PIRATEN in %": "0,5",
	  "ÖkoLinX-ARL": "2165",
	  "ÖkoLinX-ARL in %": "0,8",
	  "ELF": "4451",
	  "ELF in %": "1,7",
	  "REP": "2971",
	  "REP in %": "1,1",
	  "Graue Panther": "1949",
	  "Graue Panther in %": "0,7",
	  "ALFA": "1133",
	  "ALFA in %": "0,4",
	  "IBF": "1150",
	  "IBF in %": "0,4",
	  "Liberale": "333",
	  "Liberale in %": "0,1",
	  "P.O.P.": "334",
	  "P.O.P. in %": "0,1",
	  "FREIE WÄHLER": "1742",
	  "FREIE WÄHLER in %": "0,7",
	  "AfD": "36042",
	  "AfD in %": "13,8",
	  "NPD": "1652",
	  "NPD in %": "0,6",
	  "DIE PARTEI": "3683",
	  "DIE PARTEI in %": "1,4",
	  "dFfm": "1171",
	  "dFfm in %": "0,4"
	}, {
	  "Stadtteilnummer": "42",
	  "Stadtteil": "Nieder-Erlenbach",
	  "Wahlberechtigte insgesamt": "3564",
	  "Wähler/innen": "2024",
	  "Wähler/innen in %": "56,8",
	  "darunter Wähler mit Wahlschein": "488",
	  "darunter Wähler mit Wahlschein in %": "24,1",
	  "gültige Stimmen": "176176",
	  "CDU": "78614",
	  "CDU in %": "44,6",
	  "SPD": "26776",
	  "SPD in %": "15,2",
	  "GRÜNE": "26207",
	  "GRÜNE in %": "14,9",
	  "DIE LINKE": "5028",
	  "DIE LINKE in %": "2,9",
	  "FDP": "12077",
	  "FDP in %": "6,9",
	  "BFF": "6104",
	  "BFF in %": "3,5",
	  "PIRATEN": "790",
	  "PIRATEN in %": "0,4",
	  "ÖkoLinX-ARL": "1023",
	  "ÖkoLinX-ARL in %": "0,6",
	  "ELF": "555",
	  "ELF in %": "0,3",
	  "REP": "167",
	  "REP in %": "0,1",
	  "Graue Panther": "505",
	  "Graue Panther in %": "0,3",
	  "ALFA": "1003",
	  "ALFA in %": "0,6",
	  "IBF": "29",
	  "IBF in %": "0",
	  "Liberale": "307",
	  "Liberale in %": "0,2",
	  "P.O.P.": "370",
	  "P.O.P. in %": "0,2",
	  "FREIE WÄHLER": "1119",
	  "FREIE WÄHLER in %": "0,6",
	  "AfD": "13005",
	  "AfD in %": "7,4",
	  "NPD": "210",
	  "NPD in %": "0,1",
	  "DIE PARTEI": "1620",
	  "DIE PARTEI in %": "0,9",
	  "dFfm": "667",
	  "dFfm in %": "0,4"
	}, {
	  "Stadtteilnummer": "43",
	  "Stadtteil": "Kalbach-Riedberg",
	  "Wahlberechtigte insgesamt": "10819",
	  "Wähler/innen": "5181",
	  "Wähler/innen in %": "47,9",
	  "darunter Wähler mit Wahlschein": "1043",
	  "darunter Wähler mit Wahlschein in %": "20,1",
	  "gültige Stimmen": "455513",
	  "CDU": "154466",
	  "CDU in %": "33,9",
	  "SPD": "89958",
	  "SPD in %": "19,7",
	  "GRÜNE": "69968",
	  "GRÜNE in %": "15,4",
	  "DIE LINKE": "16573",
	  "DIE LINKE in %": "3,6",
	  "FDP": "48722",
	  "FDP in %": "10,7",
	  "BFF": "9667",
	  "BFF in %": "2,1",
	  "PIRATEN": "3561",
	  "PIRATEN in %": "0,8",
	  "ÖkoLinX-ARL": "1307",
	  "ÖkoLinX-ARL in %": "0,3",
	  "ELF": "3686",
	  "ELF in %": "0,8",
	  "REP": "823",
	  "REP in %": "0,2",
	  "Graue Panther": "1766",
	  "Graue Panther in %": "0,4",
	  "ALFA": "4045",
	  "ALFA in %": "0,9",
	  "IBF": "1496",
	  "IBF in %": "0,3",
	  "Liberale": "618",
	  "Liberale in %": "0,1",
	  "P.O.P.": "1338",
	  "P.O.P. in %": "0,3",
	  "FREIE WÄHLER": "2085",
	  "FREIE WÄHLER in %": "0,5",
	  "AfD": "38418",
	  "AfD in %": "8,4",
	  "NPD": "754",
	  "NPD in %": "0,2",
	  "DIE PARTEI": "3985",
	  "DIE PARTEI in %": "0,9",
	  "dFfm": "2277",
	  "dFfm in %": "0,5"
	}, {
	  "Stadtteilnummer": "44",
	  "Stadtteil": "Harheim",
	  "Wahlberechtigte insgesamt": "3584",
	  "Wähler/innen": "2060",
	  "Wähler/innen in %": "57,5",
	  "darunter Wähler mit Wahlschein": "477",
	  "darunter Wähler mit Wahlschein in %": "23,2",
	  "gültige Stimmen": "177173",
	  "CDU": "69497",
	  "CDU in %": "39,2",
	  "SPD": "28631",
	  "SPD in %": "16,2",
	  "GRÜNE": "29044",
	  "GRÜNE in %": "16,4",
	  "DIE LINKE": "6807",
	  "DIE LINKE in %": "3,8",
	  "FDP": "8987",
	  "FDP in %": "5,1",
	  "BFF": "5753",
	  "BFF in %": "3,2",
	  "PIRATEN": "595",
	  "PIRATEN in %": "0,3",
	  "ÖkoLinX-ARL": "1065",
	  "ÖkoLinX-ARL in %": "0,6",
	  "ELF": "553",
	  "ELF in %": "0,3",
	  "REP": "601",
	  "REP in %": "0,3",
	  "Graue Panther": "428",
	  "Graue Panther in %": "0,2",
	  "ALFA": "2026",
	  "ALFA in %": "1,1",
	  "IBF": "209",
	  "IBF in %": "0,1",
	  "Liberale": "347",
	  "Liberale in %": "0,2",
	  "P.O.P.": "472",
	  "P.O.P. in %": "0,3",
	  "FREIE WÄHLER": "639",
	  "FREIE WÄHLER in %": "0,4",
	  "AfD": "18964",
	  "AfD in %": "10,7",
	  "NPD": "296",
	  "NPD in %": "0,2",
	  "DIE PARTEI": "1378",
	  "DIE PARTEI in %": "0,8",
	  "dFfm": "881",
	  "dFfm in %": "0,5"
	}, {
	  "Stadtteilnummer": "45",
	  "Stadtteil": "Nieder-Eschbach",
	  "Wahlberechtigte insgesamt": "8083",
	  "Wähler/innen": "3300",
	  "Wähler/innen in %": "40,8",
	  "darunter Wähler mit Wahlschein": "849",
	  "darunter Wähler mit Wahlschein in %": "25,7",
	  "gültige Stimmen": "276469",
	  "CDU": "94102",
	  "CDU in %": "34",
	  "SPD": "49997",
	  "SPD in %": "18,1",
	  "GRÜNE": "39554",
	  "GRÜNE in %": "14,3",
	  "DIE LINKE": "13797",
	  "DIE LINKE in %": "5",
	  "FDP": "15789",
	  "FDP in %": "5,7",
	  "BFF": "10304",
	  "BFF in %": "3,7",
	  "PIRATEN": "1776",
	  "PIRATEN in %": "0,6",
	  "ÖkoLinX-ARL": "1966",
	  "ÖkoLinX-ARL in %": "0,7",
	  "ELF": "3044",
	  "ELF in %": "1,1",
	  "REP": "479",
	  "REP in %": "0,2",
	  "Graue Panther": "924",
	  "Graue Panther in %": "0,3",
	  "ALFA": "1900",
	  "ALFA in %": "0,7",
	  "IBF": "1309",
	  "IBF in %": "0,5",
	  "Liberale": "360",
	  "Liberale in %": "0,1",
	  "P.O.P.": "526",
	  "P.O.P. in %": "0,2",
	  "FREIE WÄHLER": "4255",
	  "FREIE WÄHLER in %": "1,5",
	  "AfD": "31161",
	  "AfD in %": "11,3",
	  "NPD": "1204",
	  "NPD in %": "0,4",
	  "DIE PARTEI": "3284",
	  "DIE PARTEI in %": "1,2",
	  "dFfm": "738",
	  "dFfm in %": "0,3"
	}, {
	  "Stadtteilnummer": "46",
	  "Stadtteil": "Bergen-Enkheim",
	  "Wahlberechtigte insgesamt": "13638",
	  "Wähler/innen": "6571",
	  "Wähler/innen in %": "48,2",
	  "darunter Wähler mit Wahlschein": "1708",
	  "darunter Wähler mit Wahlschein in %": "26",
	  "gültige Stimmen": "568365",
	  "CDU": "163634",
	  "CDU in %": "28,8",
	  "SPD": "133465",
	  "SPD in %": "23,5",
	  "GRÜNE": "70209",
	  "GRÜNE in %": "12,4",
	  "DIE LINKE": "29201",
	  "DIE LINKE in %": "5,1",
	  "FDP": "37372",
	  "FDP in %": "6,6",
	  "BFF": "28041",
	  "BFF in %": "4,9",
	  "PIRATEN": "3410",
	  "PIRATEN in %": "0,6",
	  "ÖkoLinX-ARL": "7156",
	  "ÖkoLinX-ARL in %": "1,3",
	  "ELF": "4037",
	  "ELF in %": "0,7",
	  "REP": "1074",
	  "REP in %": "0,2",
	  "Graue Panther": "2492",
	  "Graue Panther in %": "0,4",
	  "ALFA": "3878",
	  "ALFA in %": "0,7",
	  "IBF": "1933",
	  "IBF in %": "0,3",
	  "Liberale": "758",
	  "Liberale in %": "0,1",
	  "P.O.P.": "4172",
	  "P.O.P. in %": "0,7",
	  "FREIE WÄHLER": "3696",
	  "FREIE WÄHLER in %": "0,7",
	  "AfD": "63306",
	  "AfD in %": "11,1",
	  "NPD": "1640",
	  "NPD in %": "0,3",
	  "DIE PARTEI": "5333",
	  "DIE PARTEI in %": "0,9",
	  "dFfm": "3558",
	  "dFfm in %": "0,6"
	}, {
	  "Stadtteilnummer": "47",
	  "Stadtteil": "Frankfurter Berg",
	  "Wahlberechtigte insgesamt": "5362",
	  "Wähler/innen": "2211",
	  "Wähler/innen in %": "41,2",
	  "darunter Wähler mit Wahlschein": "493",
	  "darunter Wähler mit Wahlschein in %": "22,3",
	  "gültige Stimmen": "189602",
	  "CDU": "47009",
	  "CDU in %": "24,8",
	  "SPD": "48304",
	  "SPD in %": "25,5",
	  "GRÜNE": "21681",
	  "GRÜNE in %": "11,4",
	  "DIE LINKE": "13595",
	  "DIE LINKE in %": "7,2",
	  "FDP": "13770",
	  "FDP in %": "7,3",
	  "BFF": "6324",
	  "BFF in %": "3,3",
	  "PIRATEN": "1349",
	  "PIRATEN in %": "0,7",
	  "ÖkoLinX-ARL": "3490",
	  "ÖkoLinX-ARL in %": "1,8",
	  "ELF": "4706",
	  "ELF in %": "2,5",
	  "REP": "894",
	  "REP in %": "0,5",
	  "Graue Panther": "666",
	  "Graue Panther in %": "0,4",
	  "ALFA": "695",
	  "ALFA in %": "0,4",
	  "IBF": "373",
	  "IBF in %": "0,2",
	  "Liberale": "393",
	  "Liberale in %": "0,2",
	  "P.O.P.": "1415",
	  "P.O.P. in %": "0,7",
	  "FREIE WÄHLER": "469",
	  "FREIE WÄHLER in %": "0,2",
	  "AfD": "19968",
	  "AfD in %": "10,5",
	  "NPD": "990",
	  "NPD in %": "0,5",
	  "DIE PARTEI": "1967",
	  "DIE PARTEI in %": "1",
	  "dFfm": "1544",
	  "dFfm in %": "0,8"
	}, {
	  "Stadtteilnummer": "",
	  "Stadtteil": "Stadt insgesamt",
	  "Wahlberechtigte insgesamt": "502107",
	  "Wähler/innen": "195770",
	  "Wähler/innen in %": "39",
	  "darunter Wähler mit Wahlschein": "49795",
	  "darunter Wähler mit Wahlschein in %": "25,4",
	  "gültige Stimmen": "16908244",
	  "CDU": "4075690",
	  "CDU in %": "24,1",
	  "SPD": "4023354",
	  "SPD in %": "23,8",
	  "GRÜNE": "2583267",
	  "GRÜNE in %": "15,3",
	  "DIE LINKE": "1356066",
	  "DIE LINKE in %": "8",
	  "FDP": "1273458",
	  "FDP in %": "7,5",
	  "BFF": "461066",
	  "BFF in %": "2,7",
	  "PIRATEN": "142227",
	  "PIRATEN in %": "0,8",
	  "ÖkoLinX-ARL": "359529",
	  "ÖkoLinX-ARL in %": "2,1",
	  "ELF": "198490",
	  "ELF in %": "1,2",
	  "REP": "55118",
	  "REP in %": "0,3",
	  "Graue Panther": "96825",
	  "Graue Panther in %": "0,6",
	  "ALFA": "79961",
	  "ALFA in %": "0,5",
	  "IBF": "69585",
	  "IBF in %": "0,4",
	  "Liberale": "48516",
	  "Liberale in %": "0,3",
	  "P.O.P.": "71715",
	  "P.O.P. in %": "0,4",
	  "FREIE WÄHLER": "94031",
	  "FREIE WÄHLER in %": "0,6",
	  "AfD": "1508851",
	  "AfD in %": "8,9",
	  "NPD": "46047",
	  "NPD in %": "0,3",
	  "DIE PARTEI": "235832",
	  "DIE PARTEI in %": "1,4",
	  "dFfm": "128616",
	  "dFfm in %": "0,8"
	}];

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.nationalitiesCount = exports.women = exports.averageAge = exports.foreigners = undefined;
	
	var _bevolkerungsstruktur = __webpack_require__(86);
	
	var _bevolkerungsstruktur2 = _interopRequireDefault(_bevolkerungsstruktur);
	
	var _helpers = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// http://daten.frankfurt.de/dataset/bevoelkerung
	
	var foreigners = exports.foreigners = function foreigners() {
	  return (0, _helpers.extractDataHelper)(_bevolkerungsstruktur2.default, "Bevölkerungsstruktur Ausländerinnen und Ausländer in %  2012", 'Percentage of foreigners');
	};
	
	var averageAge = exports.averageAge = function averageAge() {
	  return (0, _helpers.extractDataHelper)(_bevolkerungsstruktur2.default, "Bevölkerungsstruktur Durchschnittsalter  2012", 'Average age');
	};
	
	var women = exports.women = function women() {
	  return (0, _helpers.extractDataHelper)(_bevolkerungsstruktur2.default, "Bevölkerungsstruktur Frauen in %  2012", 'Percentage of women');
	};
	
	var nationalitiesCount = exports.nationalitiesCount = function nationalitiesCount() {
	  return (0, _helpers.extractDataHelper)(_bevolkerungsstruktur2.default, "Bevölkerungsstruktur Zahl der Staatsangehörigkeiten  2012", 'Amount of different nationalities');
	};

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.newBuildingsDiff = exports.newBuildings = exports.spacePerApartment = exports.populationDensityDiff = exports.populationDensity = undefined;
	
	var _stadtteilprofileBauenWohnen = __webpack_require__(88);
	
	var _stadtteilprofileBauenWohnen2 = _interopRequireDefault(_stadtteilprofileBauenWohnen);
	
	var _helpers = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var populationDensity = exports.populationDensity = function populationDensity() {
	  return (0, _helpers.extractDataHelper)(_stadtteilprofileBauenWohnen2.default, "Bauen und Wohnen Einwohnerdichte je ha  2012", 'Population density');
	};
	
	var populationDensityDiff = exports.populationDensityDiff = function populationDensityDiff() {
	  return (0, _helpers.extractDataHelper)(_stadtteilprofileBauenWohnen2.default, 'Bauen und Wohnen Einwohnerdichte je ha  diff', 'Population density diff');
	};
	
	var spacePerApartment = exports.spacePerApartment = function spacePerApartment() {
	  return (0, _helpers.extractDataHelper)(_stadtteilprofileBauenWohnen2.default, 'Bauen und Wohnen Wohnfläche in m² je Wohnung  2012', 'Space per apartment');
	};
	
	var newBuildings = exports.newBuildings = function newBuildings() {
	  return (0, _helpers.extractDataHelper)(_stadtteilprofileBauenWohnen2.default, 'Bauen und Wohnen Neubauquotient  2012', 'New buildings');
	};
	
	var newBuildingsDiff = exports.newBuildingsDiff = function newBuildingsDiff() {
	  return (0, _helpers.extractDataHelper)(_stadtteilprofileBauenWohnen2.default, 'Bauen und Wohnen Neubauquotient  diff', 'New buildings diff');
	};

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.afd = exports.spd = exports.cdu = undefined;
	
	var _stv2016stadtteile = __webpack_require__(89);
	
	var _stv2016stadtteile2 = _interopRequireDefault(_stv2016stadtteile);
	
	var _helpers = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// http://daten.frankfurt.de/dataset/kommunalwahlen-2016
	// Stadtverordnetenwahl 2016 Stadtteile JSON
	
	var cdu = exports.cdu = function cdu() {
	  return (0, _helpers.extractDataHelper)(_stv2016stadtteile2.default, "CDU in %", 'CDU voters');
	};
	var spd = exports.spd = function spd() {
	  return (0, _helpers.extractDataHelper)(_stv2016stadtteile2.default, "SPD in %", 'SPD voters');
	};
	
	var afd = exports.afd = function afd() {
	  return (0, _helpers.extractDataHelper)(_stv2016stadtteile2.default, "AfD in %", 'AfD voters');
	};

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(24);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(113);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _App = __webpack_require__(82);
	
	var _App2 = _interopRequireDefault(_App);
	
	__webpack_require__(96);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_reactDom2.default.render(_react2.default.createElement(_App2.default, null), document.getElementById('root'));

/***/ },
/* 94 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 95 */
94,
/* 96 */
94,
/* 97 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(97);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(107);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(1);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(6);
	
	var createArrayFromMixed = __webpack_require__(100);
	var getMarkupWrap = __webpack_require__(102);
	var invariant = __webpack_require__(1);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(6);
	
	var invariant = __webpack_require__(1);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ },
/* 103 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable === window) {
	    return {
	      x: window.pageXOffset || document.documentElement.scrollLeft,
	      y: window.pageYOffset || document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ },
/* 104 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(104);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ },
/* 106 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  return !!(object && (typeof Node === 'function' ? object instanceof Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(106);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ },
/* 108 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/logo.5d5d9eef.svg";

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery JavaScript Library v3.1.1
	 * https://jquery.com/
	 *
	 * Includes Sizzle.js
	 * https://sizzlejs.com/
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license
	 * https://jquery.org/license
	 *
	 * Date: 2016-09-22T22:30Z
	 */
	( function( global, factory ) {
	
		"use strict";
	
		if ( typeof module === "object" && typeof module.exports === "object" ) {
	
			// For CommonJS and CommonJS-like environments where a proper `window`
			// is present, execute the factory and get jQuery.
			// For environments that do not have a `window` with a `document`
			// (such as Node.js), expose a factory as module.exports.
			// This accentuates the need for the creation of a real `window`.
			// e.g. var jQuery = require("jquery")(window);
			// See ticket #14549 for more info.
			module.exports = global.document ?
				factory( global, true ) :
				function( w ) {
					if ( !w.document ) {
						throw new Error( "jQuery requires a window with a document" );
					}
					return factory( w );
				};
		} else {
			factory( global );
		}
	
	// Pass this if window is not defined yet
	} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {
	
	// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
	// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
	// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
	// enough that all such attempts are guarded in a try block.
	"use strict";
	
	var arr = [];
	
	var document = window.document;
	
	var getProto = Object.getPrototypeOf;
	
	var slice = arr.slice;
	
	var concat = arr.concat;
	
	var push = arr.push;
	
	var indexOf = arr.indexOf;
	
	var class2type = {};
	
	var toString = class2type.toString;
	
	var hasOwn = class2type.hasOwnProperty;
	
	var fnToString = hasOwn.toString;
	
	var ObjectFunctionString = fnToString.call( Object );
	
	var support = {};
	
	
	
		function DOMEval( code, doc ) {
			doc = doc || document;
	
			var script = doc.createElement( "script" );
	
			script.text = code;
			doc.head.appendChild( script ).parentNode.removeChild( script );
		}
	/* global Symbol */
	// Defining this global in .eslintrc.json would create a danger of using the global
	// unguarded in another place, it seems safer to define global only for this module
	
	
	
	var
		version = "3.1.1",
	
		// Define a local copy of jQuery
		jQuery = function( selector, context ) {
	
			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init( selector, context );
		},
	
		// Support: Android <=4.0 only
		// Make sure we trim BOM and NBSP
		rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
	
		// Matches dashed string for camelizing
		rmsPrefix = /^-ms-/,
		rdashAlpha = /-([a-z])/g,
	
		// Used by jQuery.camelCase as callback to replace()
		fcamelCase = function( all, letter ) {
			return letter.toUpperCase();
		};
	
	jQuery.fn = jQuery.prototype = {
	
		// The current version of jQuery being used
		jquery: version,
	
		constructor: jQuery,
	
		// The default length of a jQuery object is 0
		length: 0,
	
		toArray: function() {
			return slice.call( this );
		},
	
		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function( num ) {
	
			// Return all the elements in a clean array
			if ( num == null ) {
				return slice.call( this );
			}
	
			// Return just the one element from the set
			return num < 0 ? this[ num + this.length ] : this[ num ];
		},
	
		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function( elems ) {
	
			// Build a new jQuery matched element set
			var ret = jQuery.merge( this.constructor(), elems );
	
			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;
	
			// Return the newly-formed element set
			return ret;
		},
	
		// Execute a callback for every element in the matched set.
		each: function( callback ) {
			return jQuery.each( this, callback );
		},
	
		map: function( callback ) {
			return this.pushStack( jQuery.map( this, function( elem, i ) {
				return callback.call( elem, i, elem );
			} ) );
		},
	
		slice: function() {
			return this.pushStack( slice.apply( this, arguments ) );
		},
	
		first: function() {
			return this.eq( 0 );
		},
	
		last: function() {
			return this.eq( -1 );
		},
	
		eq: function( i ) {
			var len = this.length,
				j = +i + ( i < 0 ? len : 0 );
			return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
		},
	
		end: function() {
			return this.prevObject || this.constructor();
		},
	
		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: arr.sort,
		splice: arr.splice
	};
	
	jQuery.extend = jQuery.fn.extend = function() {
		var options, name, src, copy, copyIsArray, clone,
			target = arguments[ 0 ] || {},
			i = 1,
			length = arguments.length,
			deep = false;
	
		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;
	
			// Skip the boolean and the target
			target = arguments[ i ] || {};
			i++;
		}
	
		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && !jQuery.isFunction( target ) ) {
			target = {};
		}
	
		// Extend jQuery itself if only one argument is passed
		if ( i === length ) {
			target = this;
			i--;
		}
	
		for ( ; i < length; i++ ) {
	
			// Only deal with non-null/undefined values
			if ( ( options = arguments[ i ] ) != null ) {
	
				// Extend the base object
				for ( name in options ) {
					src = target[ name ];
					copy = options[ name ];
	
					// Prevent never-ending loop
					if ( target === copy ) {
						continue;
					}
	
					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
						( copyIsArray = jQuery.isArray( copy ) ) ) ) {
	
						if ( copyIsArray ) {
							copyIsArray = false;
							clone = src && jQuery.isArray( src ) ? src : [];
	
						} else {
							clone = src && jQuery.isPlainObject( src ) ? src : {};
						}
	
						// Never move original objects, clone them
						target[ name ] = jQuery.extend( deep, clone, copy );
	
					// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	jQuery.extend( {
	
		// Unique for each copy of jQuery on the page
		expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),
	
		// Assume jQuery is ready without the ready module
		isReady: true,
	
		error: function( msg ) {
			throw new Error( msg );
		},
	
		noop: function() {},
	
		isFunction: function( obj ) {
			return jQuery.type( obj ) === "function";
		},
	
		isArray: Array.isArray,
	
		isWindow: function( obj ) {
			return obj != null && obj === obj.window;
		},
	
		isNumeric: function( obj ) {
	
			// As of jQuery 3.0, isNumeric is limited to
			// strings and numbers (primitives or objects)
			// that can be coerced to finite numbers (gh-2662)
			var type = jQuery.type( obj );
			return ( type === "number" || type === "string" ) &&
	
				// parseFloat NaNs numeric-cast false positives ("")
				// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
				// subtraction forces infinities to NaN
				!isNaN( obj - parseFloat( obj ) );
		},
	
		isPlainObject: function( obj ) {
			var proto, Ctor;
	
			// Detect obvious negatives
			// Use toString instead of jQuery.type to catch host objects
			if ( !obj || toString.call( obj ) !== "[object Object]" ) {
				return false;
			}
	
			proto = getProto( obj );
	
			// Objects with no prototype (e.g., `Object.create( null )`) are plain
			if ( !proto ) {
				return true;
			}
	
			// Objects with prototype are plain iff they were constructed by a global Object function
			Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
			return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
		},
	
		isEmptyObject: function( obj ) {
	
			/* eslint-disable no-unused-vars */
			// See https://github.com/eslint/eslint/issues/6125
			var name;
	
			for ( name in obj ) {
				return false;
			}
			return true;
		},
	
		type: function( obj ) {
			if ( obj == null ) {
				return obj + "";
			}
	
			// Support: Android <=2.3 only (functionish RegExp)
			return typeof obj === "object" || typeof obj === "function" ?
				class2type[ toString.call( obj ) ] || "object" :
				typeof obj;
		},
	
		// Evaluates a script in a global context
		globalEval: function( code ) {
			DOMEval( code );
		},
	
		// Convert dashed to camelCase; used by the css and data modules
		// Support: IE <=9 - 11, Edge 12 - 13
		// Microsoft forgot to hump their vendor prefix (#9572)
		camelCase: function( string ) {
			return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
		},
	
		nodeName: function( elem, name ) {
			return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
		},
	
		each: function( obj, callback ) {
			var length, i = 0;
	
			if ( isArrayLike( obj ) ) {
				length = obj.length;
				for ( ; i < length; i++ ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			}
	
			return obj;
		},
	
		// Support: Android <=4.0 only
		trim: function( text ) {
			return text == null ?
				"" :
				( text + "" ).replace( rtrim, "" );
		},
	
		// results is for internal usage only
		makeArray: function( arr, results ) {
			var ret = results || [];
	
			if ( arr != null ) {
				if ( isArrayLike( Object( arr ) ) ) {
					jQuery.merge( ret,
						typeof arr === "string" ?
						[ arr ] : arr
					);
				} else {
					push.call( ret, arr );
				}
			}
	
			return ret;
		},
	
		inArray: function( elem, arr, i ) {
			return arr == null ? -1 : indexOf.call( arr, elem, i );
		},
	
		// Support: Android <=4.0 only, PhantomJS 1 only
		// push.apply(_, arraylike) throws on ancient WebKit
		merge: function( first, second ) {
			var len = +second.length,
				j = 0,
				i = first.length;
	
			for ( ; j < len; j++ ) {
				first[ i++ ] = second[ j ];
			}
	
			first.length = i;
	
			return first;
		},
	
		grep: function( elems, callback, invert ) {
			var callbackInverse,
				matches = [],
				i = 0,
				length = elems.length,
				callbackExpect = !invert;
	
			// Go through the array, only saving the items
			// that pass the validator function
			for ( ; i < length; i++ ) {
				callbackInverse = !callback( elems[ i ], i );
				if ( callbackInverse !== callbackExpect ) {
					matches.push( elems[ i ] );
				}
			}
	
			return matches;
		},
	
		// arg is for internal usage only
		map: function( elems, callback, arg ) {
			var length, value,
				i = 0,
				ret = [];
	
			// Go through the array, translating each of the items to their new values
			if ( isArrayLike( elems ) ) {
				length = elems.length;
				for ( ; i < length; i++ ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
	
			// Go through every key on the object,
			} else {
				for ( i in elems ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
			}
	
			// Flatten any nested arrays
			return concat.apply( [], ret );
		},
	
		// A global GUID counter for objects
		guid: 1,
	
		// Bind a function to a context, optionally partially applying any
		// arguments.
		proxy: function( fn, context ) {
			var tmp, args, proxy;
	
			if ( typeof context === "string" ) {
				tmp = fn[ context ];
				context = fn;
				fn = tmp;
			}
	
			// Quick check to determine if target is callable, in the spec
			// this throws a TypeError, but we will just return undefined.
			if ( !jQuery.isFunction( fn ) ) {
				return undefined;
			}
	
			// Simulated bind
			args = slice.call( arguments, 2 );
			proxy = function() {
				return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
			};
	
			// Set the guid of unique handler to the same of original handler, so it can be removed
			proxy.guid = fn.guid = fn.guid || jQuery.guid++;
	
			return proxy;
		},
	
		now: Date.now,
	
		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	} );
	
	if ( typeof Symbol === "function" ) {
		jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
	}
	
	// Populate the class2type map
	jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );
	
	function isArrayLike( obj ) {
	
		// Support: real iOS 8.2 only (not reproducible in simulator)
		// `in` check used to prevent JIT error (gh-2145)
		// hasOwn isn't used here due to false negatives
		// regarding Nodelist length in IE
		var length = !!obj && "length" in obj && obj.length,
			type = jQuery.type( obj );
	
		if ( type === "function" || jQuery.isWindow( obj ) ) {
			return false;
		}
	
		return type === "array" || length === 0 ||
			typeof length === "number" && length > 0 && ( length - 1 ) in obj;
	}
	var Sizzle =
	/*!
	 * Sizzle CSS Selector Engine v2.3.3
	 * https://sizzlejs.com/
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2016-08-08
	 */
	(function( window ) {
	
	var i,
		support,
		Expr,
		getText,
		isXML,
		tokenize,
		compile,
		select,
		outermostContext,
		sortInput,
		hasDuplicate,
	
		// Local document vars
		setDocument,
		document,
		docElem,
		documentIsHTML,
		rbuggyQSA,
		rbuggyMatches,
		matches,
		contains,
	
		// Instance-specific data
		expando = "sizzle" + 1 * new Date(),
		preferredDoc = window.document,
		dirruns = 0,
		done = 0,
		classCache = createCache(),
		tokenCache = createCache(),
		compilerCache = createCache(),
		sortOrder = function( a, b ) {
			if ( a === b ) {
				hasDuplicate = true;
			}
			return 0;
		},
	
		// Instance methods
		hasOwn = ({}).hasOwnProperty,
		arr = [],
		pop = arr.pop,
		push_native = arr.push,
		push = arr.push,
		slice = arr.slice,
		// Use a stripped-down indexOf as it's faster than native
		// https://jsperf.com/thor-indexof-vs-for/5
		indexOf = function( list, elem ) {
			var i = 0,
				len = list.length;
			for ( ; i < len; i++ ) {
				if ( list[i] === elem ) {
					return i;
				}
			}
			return -1;
		},
	
		booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
	
		// Regular expressions
	
		// http://www.w3.org/TR/css3-selectors/#whitespace
		whitespace = "[\\x20\\t\\r\\n\\f]",
	
		// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
		identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",
	
		// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +
			// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
			"*\\]",
	
		pseudos = ":(" + identifier + ")(?:\\((" +
			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
			// 3. anything else (capture 2)
			".*" +
			")\\)|)",
	
		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rwhitespace = new RegExp( whitespace + "+", "g" ),
		rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),
	
		rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
		rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),
	
		rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),
	
		rpseudo = new RegExp( pseudos ),
		ridentifier = new RegExp( "^" + identifier + "$" ),
	
		matchExpr = {
			"ID": new RegExp( "^#(" + identifier + ")" ),
			"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
			"TAG": new RegExp( "^(" + identifier + "|[*])" ),
			"ATTR": new RegExp( "^" + attributes ),
			"PSEUDO": new RegExp( "^" + pseudos ),
			"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
				"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
				"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
			"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
				whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
		},
	
		rinputs = /^(?:input|select|textarea|button)$/i,
		rheader = /^h\d$/i,
	
		rnative = /^[^{]+\{\s*\[native \w/,
	
		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
	
		rsibling = /[+~]/,
	
		// CSS escapes
		// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
		funescape = function( _, escaped, escapedWhitespace ) {
			var high = "0x" + escaped - 0x10000;
			// NaN means non-codepoint
			// Support: Firefox<24
			// Workaround erroneous numeric interpretation of +"0x"
			return high !== high || escapedWhitespace ?
				escaped :
				high < 0 ?
					// BMP codepoint
					String.fromCharCode( high + 0x10000 ) :
					// Supplemental Plane codepoint (surrogate pair)
					String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
		},
	
		// CSS string/identifier serialization
		// https://drafts.csswg.org/cssom/#common-serializing-idioms
		rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
		fcssescape = function( ch, asCodePoint ) {
			if ( asCodePoint ) {
	
				// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
				if ( ch === "\0" ) {
					return "\uFFFD";
				}
	
				// Control characters and (dependent upon position) numbers get escaped as code points
				return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
			}
	
			// Other potentially-special ASCII characters get backslash-escaped
			return "\\" + ch;
		},
	
		// Used for iframes
		// See setDocument()
		// Removing the function wrapper causes a "Permission Denied"
		// error in IE
		unloadHandler = function() {
			setDocument();
		},
	
		disabledAncestor = addCombinator(
			function( elem ) {
				return elem.disabled === true && ("form" in elem || "label" in elem);
			},
			{ dir: "parentNode", next: "legend" }
		);
	
	// Optimize for push.apply( _, NodeList )
	try {
		push.apply(
			(arr = slice.call( preferredDoc.childNodes )),
			preferredDoc.childNodes
		);
		// Support: Android<4.0
		// Detect silently failing push.apply
		arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
		push = { apply: arr.length ?
	
			// Leverage slice if possible
			function( target, els ) {
				push_native.apply( target, slice.call(els) );
			} :
	
			// Support: IE<9
			// Otherwise append directly
			function( target, els ) {
				var j = target.length,
					i = 0;
				// Can't trust NodeList.length
				while ( (target[j++] = els[i++]) ) {}
				target.length = j - 1;
			}
		};
	}
	
	function Sizzle( selector, context, results, seed ) {
		var m, i, elem, nid, match, groups, newSelector,
			newContext = context && context.ownerDocument,
	
			// nodeType defaults to 9, since context defaults to document
			nodeType = context ? context.nodeType : 9;
	
		results = results || [];
	
		// Return early from calls with invalid selector or context
		if ( typeof selector !== "string" || !selector ||
			nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {
	
			return results;
		}
	
		// Try to shortcut find operations (as opposed to filters) in HTML documents
		if ( !seed ) {
	
			if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
				setDocument( context );
			}
			context = context || document;
	
			if ( documentIsHTML ) {
	
				// If the selector is sufficiently simple, try using a "get*By*" DOM method
				// (excepting DocumentFragment context, where the methods don't exist)
				if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {
	
					// ID selector
					if ( (m = match[1]) ) {
	
						// Document context
						if ( nodeType === 9 ) {
							if ( (elem = context.getElementById( m )) ) {
	
								// Support: IE, Opera, Webkit
								// TODO: identify versions
								// getElementById can match elements by name instead of ID
								if ( elem.id === m ) {
									results.push( elem );
									return results;
								}
							} else {
								return results;
							}
	
						// Element context
						} else {
	
							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( newContext && (elem = newContext.getElementById( m )) &&
								contains( context, elem ) &&
								elem.id === m ) {
	
								results.push( elem );
								return results;
							}
						}
	
					// Type selector
					} else if ( match[2] ) {
						push.apply( results, context.getElementsByTagName( selector ) );
						return results;
	
					// Class selector
					} else if ( (m = match[3]) && support.getElementsByClassName &&
						context.getElementsByClassName ) {
	
						push.apply( results, context.getElementsByClassName( m ) );
						return results;
					}
				}
	
				// Take advantage of querySelectorAll
				if ( support.qsa &&
					!compilerCache[ selector + " " ] &&
					(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {
	
					if ( nodeType !== 1 ) {
						newContext = context;
						newSelector = selector;
	
					// qSA looks outside Element context, which is not what we want
					// Thanks to Andrew Dupont for this workaround technique
					// Support: IE <=8
					// Exclude object elements
					} else if ( context.nodeName.toLowerCase() !== "object" ) {
	
						// Capture the context ID, setting it first if necessary
						if ( (nid = context.getAttribute( "id" )) ) {
							nid = nid.replace( rcssescape, fcssescape );
						} else {
							context.setAttribute( "id", (nid = expando) );
						}
	
						// Prefix every selector in the list
						groups = tokenize( selector );
						i = groups.length;
						while ( i-- ) {
							groups[i] = "#" + nid + " " + toSelector( groups[i] );
						}
						newSelector = groups.join( "," );
	
						// Expand context for sibling selectors
						newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
							context;
					}
	
					if ( newSelector ) {
						try {
							push.apply( results,
								newContext.querySelectorAll( newSelector )
							);
							return results;
						} catch ( qsaError ) {
						} finally {
							if ( nid === expando ) {
								context.removeAttribute( "id" );
							}
						}
					}
				}
			}
		}
	
		// All others
		return select( selector.replace( rtrim, "$1" ), context, results, seed );
	}
	
	/**
	 * Create key-value caches of limited size
	 * @returns {function(string, object)} Returns the Object data after storing it on itself with
	 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *	deleting the oldest entry
	 */
	function createCache() {
		var keys = [];
	
		function cache( key, value ) {
			// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
			if ( keys.push( key + " " ) > Expr.cacheLength ) {
				// Only keep the most recent entries
				delete cache[ keys.shift() ];
			}
			return (cache[ key + " " ] = value);
		}
		return cache;
	}
	
	/**
	 * Mark a function for special use by Sizzle
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
		fn[ expando ] = true;
		return fn;
	}
	
	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created element and returns a boolean result
	 */
	function assert( fn ) {
		var el = document.createElement("fieldset");
	
		try {
			return !!fn( el );
		} catch (e) {
			return false;
		} finally {
			// Remove from its parent by default
			if ( el.parentNode ) {
				el.parentNode.removeChild( el );
			}
			// release memory in IE
			el = null;
		}
	}
	
	/**
	 * Adds the same handler for all of the specified attrs
	 * @param {String} attrs Pipe-separated list of attributes
	 * @param {Function} handler The method that will be applied
	 */
	function addHandle( attrs, handler ) {
		var arr = attrs.split("|"),
			i = arr.length;
	
		while ( i-- ) {
			Expr.attrHandle[ arr[i] ] = handler;
		}
	}
	
	/**
	 * Checks document order of two siblings
	 * @param {Element} a
	 * @param {Element} b
	 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
	 */
	function siblingCheck( a, b ) {
		var cur = b && a,
			diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
				a.sourceIndex - b.sourceIndex;
	
		// Use IE sourceIndex if available on both nodes
		if ( diff ) {
			return diff;
		}
	
		// Check if b follows a
		if ( cur ) {
			while ( (cur = cur.nextSibling) ) {
				if ( cur === b ) {
					return -1;
				}
			}
		}
	
		return a ? 1 : -1;
	}
	
	/**
	 * Returns a function to use in pseudos for input types
	 * @param {String} type
	 */
	function createInputPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for buttons
	 * @param {String} type
	 */
	function createButtonPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return (name === "input" || name === "button") && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for :enabled/:disabled
	 * @param {Boolean} disabled true for :disabled; false for :enabled
	 */
	function createDisabledPseudo( disabled ) {
	
		// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
		return function( elem ) {
	
			// Only certain elements can match :enabled or :disabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
			if ( "form" in elem ) {
	
				// Check for inherited disabledness on relevant non-disabled elements:
				// * listed form-associated elements in a disabled fieldset
				//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
				// * option elements in a disabled optgroup
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
				// All such elements have a "form" property.
				if ( elem.parentNode && elem.disabled === false ) {
	
					// Option elements defer to a parent optgroup if present
					if ( "label" in elem ) {
						if ( "label" in elem.parentNode ) {
							return elem.parentNode.disabled === disabled;
						} else {
							return elem.disabled === disabled;
						}
					}
	
					// Support: IE 6 - 11
					// Use the isDisabled shortcut property to check for disabled fieldset ancestors
					return elem.isDisabled === disabled ||
	
						// Where there is no isDisabled, check manually
						/* jshint -W018 */
						elem.isDisabled !== !disabled &&
							disabledAncestor( elem ) === disabled;
				}
	
				return elem.disabled === disabled;
	
			// Try to winnow out elements that can't be disabled before trusting the disabled property.
			// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
			// even exist on them, let alone have a boolean value.
			} else if ( "label" in elem ) {
				return elem.disabled === disabled;
			}
	
			// Remaining elements are neither :enabled nor :disabled
			return false;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for positionals
	 * @param {Function} fn
	 */
	function createPositionalPseudo( fn ) {
		return markFunction(function( argument ) {
			argument = +argument;
			return markFunction(function( seed, matches ) {
				var j,
					matchIndexes = fn( [], seed.length, argument ),
					i = matchIndexes.length;
	
				// Match elements found at the specified indexes
				while ( i-- ) {
					if ( seed[ (j = matchIndexes[i]) ] ) {
						seed[j] = !(matches[j] = seed[j]);
					}
				}
			});
		});
	}
	
	/**
	 * Checks a node for validity as a Sizzle context
	 * @param {Element|Object=} context
	 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	 */
	function testContext( context ) {
		return context && typeof context.getElementsByTagName !== "undefined" && context;
	}
	
	// Expose support vars for convenience
	support = Sizzle.support = {};
	
	/**
	 * Detects XML nodes
	 * @param {Element|Object} elem An element or a document
	 * @returns {Boolean} True iff elem is a non-HTML XML node
	 */
	isXML = Sizzle.isXML = function( elem ) {
		// documentElement is verified for cases where it doesn't yet exist
		// (such as loading iframes in IE - #4833)
		var documentElement = elem && (elem.ownerDocument || elem).documentElement;
		return documentElement ? documentElement.nodeName !== "HTML" : false;
	};
	
	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [doc] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	setDocument = Sizzle.setDocument = function( node ) {
		var hasCompare, subWindow,
			doc = node ? node.ownerDocument || node : preferredDoc;
	
		// Return early if doc is invalid or already selected
		if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
			return document;
		}
	
		// Update global variables
		document = doc;
		docElem = document.documentElement;
		documentIsHTML = !isXML( document );
	
		// Support: IE 9-11, Edge
		// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
		if ( preferredDoc !== document &&
			(subWindow = document.defaultView) && subWindow.top !== subWindow ) {
	
			// Support: IE 11, Edge
			if ( subWindow.addEventListener ) {
				subWindow.addEventListener( "unload", unloadHandler, false );
	
			// Support: IE 9 - 10 only
			} else if ( subWindow.attachEvent ) {
				subWindow.attachEvent( "onunload", unloadHandler );
			}
		}
	
		/* Attributes
		---------------------------------------------------------------------- */
	
		// Support: IE<8
		// Verify that getAttribute really returns attributes and not properties
		// (excepting IE8 booleans)
		support.attributes = assert(function( el ) {
			el.className = "i";
			return !el.getAttribute("className");
		});
	
		/* getElement(s)By*
		---------------------------------------------------------------------- */
	
		// Check if getElementsByTagName("*") returns only elements
		support.getElementsByTagName = assert(function( el ) {
			el.appendChild( document.createComment("") );
			return !el.getElementsByTagName("*").length;
		});
	
		// Support: IE<9
		support.getElementsByClassName = rnative.test( document.getElementsByClassName );
	
		// Support: IE<10
		// Check if getElementById returns elements by name
		// The broken getElementById methods don't pick up programmatically-set names,
		// so use a roundabout getElementsByName test
		support.getById = assert(function( el ) {
			docElem.appendChild( el ).id = expando;
			return !document.getElementsByName || !document.getElementsByName( expando ).length;
		});
	
		// ID filter and find
		if ( support.getById ) {
			Expr.filter["ID"] = function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					return elem.getAttribute("id") === attrId;
				};
			};
			Expr.find["ID"] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var elem = context.getElementById( id );
					return elem ? [ elem ] : [];
				}
			};
		} else {
			Expr.filter["ID"] =  function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					var node = typeof elem.getAttributeNode !== "undefined" &&
						elem.getAttributeNode("id");
					return node && node.value === attrId;
				};
			};
	
			// Support: IE 6 - 7 only
			// getElementById is not reliable as a find shortcut
			Expr.find["ID"] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var node, i, elems,
						elem = context.getElementById( id );
	
					if ( elem ) {
	
						// Verify the id attribute
						node = elem.getAttributeNode("id");
						if ( node && node.value === id ) {
							return [ elem ];
						}
	
						// Fall back on getElementsByName
						elems = context.getElementsByName( id );
						i = 0;
						while ( (elem = elems[i++]) ) {
							node = elem.getAttributeNode("id");
							if ( node && node.value === id ) {
								return [ elem ];
							}
						}
					}
	
					return [];
				}
			};
		}
	
		// Tag
		Expr.find["TAG"] = support.getElementsByTagName ?
			function( tag, context ) {
				if ( typeof context.getElementsByTagName !== "undefined" ) {
					return context.getElementsByTagName( tag );
	
				// DocumentFragment nodes don't have gEBTN
				} else if ( support.qsa ) {
					return context.querySelectorAll( tag );
				}
			} :
	
			function( tag, context ) {
				var elem,
					tmp = [],
					i = 0,
					// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
					results = context.getElementsByTagName( tag );
	
				// Filter out possible comments
				if ( tag === "*" ) {
					while ( (elem = results[i++]) ) {
						if ( elem.nodeType === 1 ) {
							tmp.push( elem );
						}
					}
	
					return tmp;
				}
				return results;
			};
	
		// Class
		Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
			if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
				return context.getElementsByClassName( className );
			}
		};
	
		/* QSA/matchesSelector
		---------------------------------------------------------------------- */
	
		// QSA and matchesSelector support
	
		// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
		rbuggyMatches = [];
	
		// qSa(:focus) reports false when true (Chrome 21)
		// We allow this because of a bug in IE8/9 that throws an error
		// whenever `document.activeElement` is accessed on an iframe
		// So, we allow :focus to pass through QSA all the time to avoid the IE error
		// See https://bugs.jquery.com/ticket/13378
		rbuggyQSA = [];
	
		if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
			// Build QSA regex
			// Regex strategy adopted from Diego Perini
			assert(function( el ) {
				// Select is set to empty string on purpose
				// This is to test IE's treatment of not explicitly
				// setting a boolean content attribute,
				// since its presence should be enough
				// https://bugs.jquery.com/ticket/12359
				docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
					"<select id='" + expando + "-\r\\' msallowcapture=''>" +
					"<option selected=''></option></select>";
	
				// Support: IE8, Opera 11-12.16
				// Nothing should be selected when empty strings follow ^= or $= or *=
				// The test attribute must be unknown in Opera but "safe" for WinRT
				// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
				if ( el.querySelectorAll("[msallowcapture^='']").length ) {
					rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
				}
	
				// Support: IE8
				// Boolean attributes and "value" are not treated correctly
				if ( !el.querySelectorAll("[selected]").length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
				}
	
				// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
				if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
					rbuggyQSA.push("~=");
				}
	
				// Webkit/Opera - :checked should return selected option elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				// IE8 throws error here and will not see later tests
				if ( !el.querySelectorAll(":checked").length ) {
					rbuggyQSA.push(":checked");
				}
	
				// Support: Safari 8+, iOS 8+
				// https://bugs.webkit.org/show_bug.cgi?id=136851
				// In-page `selector#id sibling-combinator selector` fails
				if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
					rbuggyQSA.push(".#.+[+~]");
				}
			});
	
			assert(function( el ) {
				el.innerHTML = "<a href='' disabled='disabled'></a>" +
					"<select disabled='disabled'><option/></select>";
	
				// Support: Windows 8 Native Apps
				// The type and name attributes are restricted during .innerHTML assignment
				var input = document.createElement("input");
				input.setAttribute( "type", "hidden" );
				el.appendChild( input ).setAttribute( "name", "D" );
	
				// Support: IE8
				// Enforce case-sensitivity of name attribute
				if ( el.querySelectorAll("[name=d]").length ) {
					rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
				}
	
				// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
				// IE8 throws error here and will not see later tests
				if ( el.querySelectorAll(":enabled").length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Support: IE9-11+
				// IE's :disabled selector does not pick up the children of disabled fieldsets
				docElem.appendChild( el ).disabled = true;
				if ( el.querySelectorAll(":disabled").length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Opera 10-11 does not throw on post-comma invalid pseudos
				el.querySelectorAll("*,:x");
				rbuggyQSA.push(",.*:");
			});
		}
	
		if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
			docElem.webkitMatchesSelector ||
			docElem.mozMatchesSelector ||
			docElem.oMatchesSelector ||
			docElem.msMatchesSelector) )) ) {
	
			assert(function( el ) {
				// Check to see if it's possible to do matchesSelector
				// on a disconnected node (IE 9)
				support.disconnectedMatch = matches.call( el, "*" );
	
				// This should fail with an exception
				// Gecko does not error, returns false instead
				matches.call( el, "[s!='']:x" );
				rbuggyMatches.push( "!=", pseudos );
			});
		}
	
		rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
		rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );
	
		/* Contains
		---------------------------------------------------------------------- */
		hasCompare = rnative.test( docElem.compareDocumentPosition );
	
		// Element contains another
		// Purposefully self-exclusive
		// As in, an element does not contain itself
		contains = hasCompare || rnative.test( docElem.contains ) ?
			function( a, b ) {
				var adown = a.nodeType === 9 ? a.documentElement : a,
					bup = b && b.parentNode;
				return a === bup || !!( bup && bup.nodeType === 1 && (
					adown.contains ?
						adown.contains( bup ) :
						a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
				));
			} :
			function( a, b ) {
				if ( b ) {
					while ( (b = b.parentNode) ) {
						if ( b === a ) {
							return true;
						}
					}
				}
				return false;
			};
	
		/* Sorting
		---------------------------------------------------------------------- */
	
		// Document order sorting
		sortOrder = hasCompare ?
		function( a, b ) {
	
			// Flag for duplicate removal
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			// Sort on method existence if only one input has compareDocumentPosition
			var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
			if ( compare ) {
				return compare;
			}
	
			// Calculate position if both inputs belong to the same document
			compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
				a.compareDocumentPosition( b ) :
	
				// Otherwise we know they are disconnected
				1;
	
			// Disconnected nodes
			if ( compare & 1 ||
				(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {
	
				// Choose the first element that is related to our preferred document
				if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
					return -1;
				}
				if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
					return 1;
				}
	
				// Maintain original order
				return sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
			}
	
			return compare & 4 ? -1 : 1;
		} :
		function( a, b ) {
			// Exit early if the nodes are identical
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			var cur,
				i = 0,
				aup = a.parentNode,
				bup = b.parentNode,
				ap = [ a ],
				bp = [ b ];
	
			// Parentless nodes are either documents or disconnected
			if ( !aup || !bup ) {
				return a === document ? -1 :
					b === document ? 1 :
					aup ? -1 :
					bup ? 1 :
					sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
	
			// If the nodes are siblings, we can do a quick check
			} else if ( aup === bup ) {
				return siblingCheck( a, b );
			}
	
			// Otherwise we need full lists of their ancestors for comparison
			cur = a;
			while ( (cur = cur.parentNode) ) {
				ap.unshift( cur );
			}
			cur = b;
			while ( (cur = cur.parentNode) ) {
				bp.unshift( cur );
			}
	
			// Walk down the tree looking for a discrepancy
			while ( ap[i] === bp[i] ) {
				i++;
			}
	
			return i ?
				// Do a sibling check if the nodes have a common ancestor
				siblingCheck( ap[i], bp[i] ) :
	
				// Otherwise nodes in our document sort first
				ap[i] === preferredDoc ? -1 :
				bp[i] === preferredDoc ? 1 :
				0;
		};
	
		return document;
	};
	
	Sizzle.matches = function( expr, elements ) {
		return Sizzle( expr, null, null, elements );
	};
	
	Sizzle.matchesSelector = function( elem, expr ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		// Make sure that attribute selectors are quoted
		expr = expr.replace( rattributeQuotes, "='$1']" );
	
		if ( support.matchesSelector && documentIsHTML &&
			!compilerCache[ expr + " " ] &&
			( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
			( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {
	
			try {
				var ret = matches.call( elem, expr );
	
				// IE 9's matchesSelector returns false on disconnected nodes
				if ( ret || support.disconnectedMatch ||
						// As well, disconnected nodes are said to be in a document
						// fragment in IE 9
						elem.document && elem.document.nodeType !== 11 ) {
					return ret;
				}
			} catch (e) {}
		}
	
		return Sizzle( expr, document, null, [ elem ] ).length > 0;
	};
	
	Sizzle.contains = function( context, elem ) {
		// Set document vars if needed
		if ( ( context.ownerDocument || context ) !== document ) {
			setDocument( context );
		}
		return contains( context, elem );
	};
	
	Sizzle.attr = function( elem, name ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		var fn = Expr.attrHandle[ name.toLowerCase() ],
			// Don't get fooled by Object.prototype properties (jQuery #13807)
			val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
				fn( elem, name, !documentIsHTML ) :
				undefined;
	
		return val !== undefined ?
			val :
			support.attributes || !documentIsHTML ?
				elem.getAttribute( name ) :
				(val = elem.getAttributeNode(name)) && val.specified ?
					val.value :
					null;
	};
	
	Sizzle.escape = function( sel ) {
		return (sel + "").replace( rcssescape, fcssescape );
	};
	
	Sizzle.error = function( msg ) {
		throw new Error( "Syntax error, unrecognized expression: " + msg );
	};
	
	/**
	 * Document sorting and removing duplicates
	 * @param {ArrayLike} results
	 */
	Sizzle.uniqueSort = function( results ) {
		var elem,
			duplicates = [],
			j = 0,
			i = 0;
	
		// Unless we *know* we can detect duplicates, assume their presence
		hasDuplicate = !support.detectDuplicates;
		sortInput = !support.sortStable && results.slice( 0 );
		results.sort( sortOrder );
	
		if ( hasDuplicate ) {
			while ( (elem = results[i++]) ) {
				if ( elem === results[ i ] ) {
					j = duplicates.push( i );
				}
			}
			while ( j-- ) {
				results.splice( duplicates[ j ], 1 );
			}
		}
	
		// Clear input after sorting to release objects
		// See https://github.com/jquery/sizzle/pull/225
		sortInput = null;
	
		return results;
	};
	
	/**
	 * Utility function for retrieving the text value of an array of DOM nodes
	 * @param {Array|Element} elem
	 */
	getText = Sizzle.getText = function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;
	
		if ( !nodeType ) {
			// If no nodeType, this is expected to be an array
			while ( (node = elem[i++]) ) {
				// Do not traverse comment nodes
				ret += getText( node );
			}
		} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
			// Use textContent for elements
			// innerText usage removed for consistency of new lines (jQuery #11153)
			if ( typeof elem.textContent === "string" ) {
				return elem.textContent;
			} else {
				// Traverse its children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					ret += getText( elem );
				}
			}
		} else if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}
		// Do not include comment or processing instruction nodes
	
		return ret;
	};
	
	Expr = Sizzle.selectors = {
	
		// Can be adjusted by the user
		cacheLength: 50,
	
		createPseudo: markFunction,
	
		match: matchExpr,
	
		attrHandle: {},
	
		find: {},
	
		relative: {
			">": { dir: "parentNode", first: true },
			" ": { dir: "parentNode" },
			"+": { dir: "previousSibling", first: true },
			"~": { dir: "previousSibling" }
		},
	
		preFilter: {
			"ATTR": function( match ) {
				match[1] = match[1].replace( runescape, funescape );
	
				// Move the given value to match[3] whether quoted or unquoted
				match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );
	
				if ( match[2] === "~=" ) {
					match[3] = " " + match[3] + " ";
				}
	
				return match.slice( 0, 4 );
			},
	
			"CHILD": function( match ) {
				/* matches from matchExpr["CHILD"]
					1 type (only|nth|...)
					2 what (child|of-type)
					3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
					4 xn-component of xn+y argument ([+-]?\d*n|)
					5 sign of xn-component
					6 x of xn-component
					7 sign of y-component
					8 y of y-component
				*/
				match[1] = match[1].toLowerCase();
	
				if ( match[1].slice( 0, 3 ) === "nth" ) {
					// nth-* requires argument
					if ( !match[3] ) {
						Sizzle.error( match[0] );
					}
	
					// numeric x and y parameters for Expr.filter.CHILD
					// remember that false/true cast respectively to 0/1
					match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
					match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );
	
				// other types prohibit arguments
				} else if ( match[3] ) {
					Sizzle.error( match[0] );
				}
	
				return match;
			},
	
			"PSEUDO": function( match ) {
				var excess,
					unquoted = !match[6] && match[2];
	
				if ( matchExpr["CHILD"].test( match[0] ) ) {
					return null;
				}
	
				// Accept quoted arguments as-is
				if ( match[3] ) {
					match[2] = match[4] || match[5] || "";
	
				// Strip excess characters from unquoted arguments
				} else if ( unquoted && rpseudo.test( unquoted ) &&
					// Get excess from tokenize (recursively)
					(excess = tokenize( unquoted, true )) &&
					// advance to the next closing parenthesis
					(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {
	
					// excess is a negative index
					match[0] = match[0].slice( 0, excess );
					match[2] = unquoted.slice( 0, excess );
				}
	
				// Return only captures needed by the pseudo filter method (type and argument)
				return match.slice( 0, 3 );
			}
		},
	
		filter: {
	
			"TAG": function( nodeNameSelector ) {
				var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
				return nodeNameSelector === "*" ?
					function() { return true; } :
					function( elem ) {
						return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
					};
			},
	
			"CLASS": function( className ) {
				var pattern = classCache[ className + " " ];
	
				return pattern ||
					(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
					classCache( className, function( elem ) {
						return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
					});
			},
	
			"ATTR": function( name, operator, check ) {
				return function( elem ) {
					var result = Sizzle.attr( elem, name );
	
					if ( result == null ) {
						return operator === "!=";
					}
					if ( !operator ) {
						return true;
					}
	
					result += "";
	
					return operator === "=" ? result === check :
						operator === "!=" ? result !== check :
						operator === "^=" ? check && result.indexOf( check ) === 0 :
						operator === "*=" ? check && result.indexOf( check ) > -1 :
						operator === "$=" ? check && result.slice( -check.length ) === check :
						operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
						operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
						false;
				};
			},
	
			"CHILD": function( type, what, argument, first, last ) {
				var simple = type.slice( 0, 3 ) !== "nth",
					forward = type.slice( -4 ) !== "last",
					ofType = what === "of-type";
	
				return first === 1 && last === 0 ?
	
					// Shortcut for :nth-*(n)
					function( elem ) {
						return !!elem.parentNode;
					} :
	
					function( elem, context, xml ) {
						var cache, uniqueCache, outerCache, node, nodeIndex, start,
							dir = simple !== forward ? "nextSibling" : "previousSibling",
							parent = elem.parentNode,
							name = ofType && elem.nodeName.toLowerCase(),
							useCache = !xml && !ofType,
							diff = false;
	
						if ( parent ) {
	
							// :(first|last|only)-(child|of-type)
							if ( simple ) {
								while ( dir ) {
									node = elem;
									while ( (node = node[ dir ]) ) {
										if ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) {
	
											return false;
										}
									}
									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}
	
							start = [ forward ? parent.firstChild : parent.lastChild ];
	
							// non-xml :nth-child(...) stores cache data on `parent`
							if ( forward && useCache ) {
	
								// Seek `elem` from a previously-cached index
	
								// ...in a gzip-friendly way
								node = parent;
								outerCache = node[ expando ] || (node[ expando ] = {});
	
								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});
	
								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex && cache[ 2 ];
								node = nodeIndex && parent.childNodes[ nodeIndex ];
	
								while ( (node = ++nodeIndex && node && node[ dir ] ||
	
									// Fallback to seeking `elem` from the start
									(diff = nodeIndex = 0) || start.pop()) ) {
	
									// When found, cache indexes on `parent` and break
									if ( node.nodeType === 1 && ++diff && node === elem ) {
										uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
										break;
									}
								}
	
							} else {
								// Use previously-cached element index if available
								if ( useCache ) {
									// ...in a gzip-friendly way
									node = elem;
									outerCache = node[ expando ] || (node[ expando ] = {});
	
									// Support: IE <9 only
									// Defend against cloned attroperties (jQuery gh-1709)
									uniqueCache = outerCache[ node.uniqueID ] ||
										(outerCache[ node.uniqueID ] = {});
	
									cache = uniqueCache[ type ] || [];
									nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
									diff = nodeIndex;
								}
	
								// xml :nth-child(...)
								// or :nth-last-child(...) or :nth(-last)?-of-type(...)
								if ( diff === false ) {
									// Use the same loop as above to seek `elem` from the start
									while ( (node = ++nodeIndex && node && node[ dir ] ||
										(diff = nodeIndex = 0) || start.pop()) ) {
	
										if ( ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) &&
											++diff ) {
	
											// Cache the index of each encountered element
											if ( useCache ) {
												outerCache = node[ expando ] || (node[ expando ] = {});
	
												// Support: IE <9 only
												// Defend against cloned attroperties (jQuery gh-1709)
												uniqueCache = outerCache[ node.uniqueID ] ||
													(outerCache[ node.uniqueID ] = {});
	
												uniqueCache[ type ] = [ dirruns, diff ];
											}
	
											if ( node === elem ) {
												break;
											}
										}
									}
								}
							}
	
							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || ( diff % first === 0 && diff / first >= 0 );
						}
					};
			},
	
			"PSEUDO": function( pseudo, argument ) {
				// pseudo-class names are case-insensitive
				// http://www.w3.org/TR/selectors/#pseudo-classes
				// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
				// Remember that setFilters inherits from pseudos
				var args,
					fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
						Sizzle.error( "unsupported pseudo: " + pseudo );
	
				// The user may use createPseudo to indicate that
				// arguments are needed to create the filter function
				// just as Sizzle does
				if ( fn[ expando ] ) {
					return fn( argument );
				}
	
				// But maintain support for old signatures
				if ( fn.length > 1 ) {
					args = [ pseudo, pseudo, "", argument ];
					return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
						markFunction(function( seed, matches ) {
							var idx,
								matched = fn( seed, argument ),
								i = matched.length;
							while ( i-- ) {
								idx = indexOf( seed, matched[i] );
								seed[ idx ] = !( matches[ idx ] = matched[i] );
							}
						}) :
						function( elem ) {
							return fn( elem, 0, args );
						};
				}
	
				return fn;
			}
		},
	
		pseudos: {
			// Potentially complex pseudos
			"not": markFunction(function( selector ) {
				// Trim the selector passed to compile
				// to avoid treating leading and trailing
				// spaces as combinators
				var input = [],
					results = [],
					matcher = compile( selector.replace( rtrim, "$1" ) );
	
				return matcher[ expando ] ?
					markFunction(function( seed, matches, context, xml ) {
						var elem,
							unmatched = matcher( seed, null, xml, [] ),
							i = seed.length;
	
						// Match elements unmatched by `matcher`
						while ( i-- ) {
							if ( (elem = unmatched[i]) ) {
								seed[i] = !(matches[i] = elem);
							}
						}
					}) :
					function( elem, context, xml ) {
						input[0] = elem;
						matcher( input, null, xml, results );
						// Don't keep the element (issue #299)
						input[0] = null;
						return !results.pop();
					};
			}),
	
			"has": markFunction(function( selector ) {
				return function( elem ) {
					return Sizzle( selector, elem ).length > 0;
				};
			}),
	
			"contains": markFunction(function( text ) {
				text = text.replace( runescape, funescape );
				return function( elem ) {
					return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
				};
			}),
	
			// "Whether an element is represented by a :lang() selector
			// is based solely on the element's language value
			// being equal to the identifier C,
			// or beginning with the identifier C immediately followed by "-".
			// The matching of C against the element's language value is performed case-insensitively.
			// The identifier C does not have to be a valid language name."
			// http://www.w3.org/TR/selectors/#lang-pseudo
			"lang": markFunction( function( lang ) {
				// lang value must be a valid identifier
				if ( !ridentifier.test(lang || "") ) {
					Sizzle.error( "unsupported lang: " + lang );
				}
				lang = lang.replace( runescape, funescape ).toLowerCase();
				return function( elem ) {
					var elemLang;
					do {
						if ( (elemLang = documentIsHTML ?
							elem.lang :
							elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {
	
							elemLang = elemLang.toLowerCase();
							return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
						}
					} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
					return false;
				};
			}),
	
			// Miscellaneous
			"target": function( elem ) {
				var hash = window.location && window.location.hash;
				return hash && hash.slice( 1 ) === elem.id;
			},
	
			"root": function( elem ) {
				return elem === docElem;
			},
	
			"focus": function( elem ) {
				return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
			},
	
			// Boolean properties
			"enabled": createDisabledPseudo( false ),
			"disabled": createDisabledPseudo( true ),
	
			"checked": function( elem ) {
				// In CSS3, :checked should return both checked and selected elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				var nodeName = elem.nodeName.toLowerCase();
				return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
			},
	
			"selected": function( elem ) {
				// Accessing this property makes selected-by-default
				// options in Safari work properly
				if ( elem.parentNode ) {
					elem.parentNode.selectedIndex;
				}
	
				return elem.selected === true;
			},
	
			// Contents
			"empty": function( elem ) {
				// http://www.w3.org/TR/selectors/#empty-pseudo
				// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
				//   but not by others (comment: 8; processing instruction: 7; etc.)
				// nodeType < 6 works because attributes (2) do not appear as children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					if ( elem.nodeType < 6 ) {
						return false;
					}
				}
				return true;
			},
	
			"parent": function( elem ) {
				return !Expr.pseudos["empty"]( elem );
			},
	
			// Element/input types
			"header": function( elem ) {
				return rheader.test( elem.nodeName );
			},
	
			"input": function( elem ) {
				return rinputs.test( elem.nodeName );
			},
	
			"button": function( elem ) {
				var name = elem.nodeName.toLowerCase();
				return name === "input" && elem.type === "button" || name === "button";
			},
	
			"text": function( elem ) {
				var attr;
				return elem.nodeName.toLowerCase() === "input" &&
					elem.type === "text" &&
	
					// Support: IE<8
					// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
					( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
			},
	
			// Position-in-collection
			"first": createPositionalPseudo(function() {
				return [ 0 ];
			}),
	
			"last": createPositionalPseudo(function( matchIndexes, length ) {
				return [ length - 1 ];
			}),
	
			"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
				return [ argument < 0 ? argument + length : argument ];
			}),
	
			"even": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 0;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"odd": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 1;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; --i >= 0; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; ++i < length; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			})
		}
	};
	
	Expr.pseudos["nth"] = Expr.pseudos["eq"];
	
	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
		Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
		Expr.pseudos[ i ] = createButtonPseudo( i );
	}
	
	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();
	
	tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
		var matched, match, tokens, type,
			soFar, groups, preFilters,
			cached = tokenCache[ selector + " " ];
	
		if ( cached ) {
			return parseOnly ? 0 : cached.slice( 0 );
		}
	
		soFar = selector;
		groups = [];
		preFilters = Expr.preFilter;
	
		while ( soFar ) {
	
			// Comma and first run
			if ( !matched || (match = rcomma.exec( soFar )) ) {
				if ( match ) {
					// Don't consume trailing commas as valid
					soFar = soFar.slice( match[0].length ) || soFar;
				}
				groups.push( (tokens = []) );
			}
	
			matched = false;
	
			// Combinators
			if ( (match = rcombinators.exec( soFar )) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					// Cast descendant combinators to space
					type: match[0].replace( rtrim, " " )
				});
				soFar = soFar.slice( matched.length );
			}
	
			// Filters
			for ( type in Expr.filter ) {
				if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
					(match = preFilters[ type ]( match ))) ) {
					matched = match.shift();
					tokens.push({
						value: matched,
						type: type,
						matches: match
					});
					soFar = soFar.slice( matched.length );
				}
			}
	
			if ( !matched ) {
				break;
			}
		}
	
		// Return the length of the invalid excess
		// if we're just parsing
		// Otherwise, throw an error or return tokens
		return parseOnly ?
			soFar.length :
			soFar ?
				Sizzle.error( selector ) :
				// Cache the tokens
				tokenCache( selector, groups ).slice( 0 );
	};
	
	function toSelector( tokens ) {
		var i = 0,
			len = tokens.length,
			selector = "";
		for ( ; i < len; i++ ) {
			selector += tokens[i].value;
		}
		return selector;
	}
	
	function addCombinator( matcher, combinator, base ) {
		var dir = combinator.dir,
			skip = combinator.next,
			key = skip || dir,
			checkNonElements = base && key === "parentNode",
			doneName = done++;
	
		return combinator.first ?
			// Check against closest ancestor/preceding element
			function( elem, context, xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						return matcher( elem, context, xml );
					}
				}
				return false;
			} :
	
			// Check against all ancestor/preceding elements
			function( elem, context, xml ) {
				var oldCache, uniqueCache, outerCache,
					newCache = [ dirruns, doneName ];
	
				// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
				if ( xml ) {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							if ( matcher( elem, context, xml ) ) {
								return true;
							}
						}
					}
				} else {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							outerCache = elem[ expando ] || (elem[ expando ] = {});
	
							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});
	
							if ( skip && skip === elem.nodeName.toLowerCase() ) {
								elem = elem[ dir ] || elem;
							} else if ( (oldCache = uniqueCache[ key ]) &&
								oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {
	
								// Assign to newCache so results back-propagate to previous elements
								return (newCache[ 2 ] = oldCache[ 2 ]);
							} else {
								// Reuse newcache so results back-propagate to previous elements
								uniqueCache[ key ] = newCache;
	
								// A match means we're done; a fail means we have to keep checking
								if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
									return true;
								}
							}
						}
					}
				}
				return false;
			};
	}
	
	function elementMatcher( matchers ) {
		return matchers.length > 1 ?
			function( elem, context, xml ) {
				var i = matchers.length;
				while ( i-- ) {
					if ( !matchers[i]( elem, context, xml ) ) {
						return false;
					}
				}
				return true;
			} :
			matchers[0];
	}
	
	function multipleContexts( selector, contexts, results ) {
		var i = 0,
			len = contexts.length;
		for ( ; i < len; i++ ) {
			Sizzle( selector, contexts[i], results );
		}
		return results;
	}
	
	function condense( unmatched, map, filter, context, xml ) {
		var elem,
			newUnmatched = [],
			i = 0,
			len = unmatched.length,
			mapped = map != null;
	
		for ( ; i < len; i++ ) {
			if ( (elem = unmatched[i]) ) {
				if ( !filter || filter( elem, context, xml ) ) {
					newUnmatched.push( elem );
					if ( mapped ) {
						map.push( i );
					}
				}
			}
		}
	
		return newUnmatched;
	}
	
	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
		if ( postFilter && !postFilter[ expando ] ) {
			postFilter = setMatcher( postFilter );
		}
		if ( postFinder && !postFinder[ expando ] ) {
			postFinder = setMatcher( postFinder, postSelector );
		}
		return markFunction(function( seed, results, context, xml ) {
			var temp, i, elem,
				preMap = [],
				postMap = [],
				preexisting = results.length,
	
				// Get initial elements from seed or context
				elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),
	
				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && ( seed || !selector ) ?
					condense( elems, preMap, preFilter, context, xml ) :
					elems,
	
				matcherOut = matcher ?
					// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
					postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
	
						// ...intermediate processing is necessary
						[] :
	
						// ...otherwise use results directly
						results :
					matcherIn;
	
			// Find primary matches
			if ( matcher ) {
				matcher( matcherIn, matcherOut, context, xml );
			}
	
			// Apply postFilter
			if ( postFilter ) {
				temp = condense( matcherOut, postMap );
				postFilter( temp, [], context, xml );
	
				// Un-match failing elements by moving them back to matcherIn
				i = temp.length;
				while ( i-- ) {
					if ( (elem = temp[i]) ) {
						matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
					}
				}
			}
	
			if ( seed ) {
				if ( postFinder || preFilter ) {
					if ( postFinder ) {
						// Get the final matcherOut by condensing this intermediate into postFinder contexts
						temp = [];
						i = matcherOut.length;
						while ( i-- ) {
							if ( (elem = matcherOut[i]) ) {
								// Restore matcherIn since elem is not yet a final match
								temp.push( (matcherIn[i] = elem) );
							}
						}
						postFinder( null, (matcherOut = []), temp, xml );
					}
	
					// Move matched elements from seed to results to keep them synchronized
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) &&
							(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {
	
							seed[temp] = !(results[temp] = elem);
						}
					}
				}
	
			// Add elements to results, through postFinder if defined
			} else {
				matcherOut = condense(
					matcherOut === results ?
						matcherOut.splice( preexisting, matcherOut.length ) :
						matcherOut
				);
				if ( postFinder ) {
					postFinder( null, results, matcherOut, xml );
				} else {
					push.apply( results, matcherOut );
				}
			}
		});
	}
	
	function matcherFromTokens( tokens ) {
		var checkContext, matcher, j,
			len = tokens.length,
			leadingRelative = Expr.relative[ tokens[0].type ],
			implicitRelative = leadingRelative || Expr.relative[" "],
			i = leadingRelative ? 1 : 0,
	
			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator( function( elem ) {
				return elem === checkContext;
			}, implicitRelative, true ),
			matchAnyContext = addCombinator( function( elem ) {
				return indexOf( checkContext, elem ) > -1;
			}, implicitRelative, true ),
			matchers = [ function( elem, context, xml ) {
				var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
					(checkContext = context).nodeType ?
						matchContext( elem, context, xml ) :
						matchAnyContext( elem, context, xml ) );
				// Avoid hanging onto element (issue #299)
				checkContext = null;
				return ret;
			} ];
	
		for ( ; i < len; i++ ) {
			if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
				matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
			} else {
				matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );
	
				// Return special upon seeing a positional matcher
				if ( matcher[ expando ] ) {
					// Find the next relative operator (if any) for proper handling
					j = ++i;
					for ( ; j < len; j++ ) {
						if ( Expr.relative[ tokens[j].type ] ) {
							break;
						}
					}
					return setMatcher(
						i > 1 && elementMatcher( matchers ),
						i > 1 && toSelector(
							// If the preceding token was a descendant combinator, insert an implicit any-element `*`
							tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
						).replace( rtrim, "$1" ),
						matcher,
						i < j && matcherFromTokens( tokens.slice( i, j ) ),
						j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
						j < len && toSelector( tokens )
					);
				}
				matchers.push( matcher );
			}
		}
	
		return elementMatcher( matchers );
	}
	
	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
		var bySet = setMatchers.length > 0,
			byElement = elementMatchers.length > 0,
			superMatcher = function( seed, context, xml, results, outermost ) {
				var elem, j, matcher,
					matchedCount = 0,
					i = "0",
					unmatched = seed && [],
					setMatched = [],
					contextBackup = outermostContext,
					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
					len = elems.length;
	
				if ( outermost ) {
					outermostContext = context === document || context || outermost;
				}
	
				// Add elements passing elementMatchers directly to results
				// Support: IE<9, Safari
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
				for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
					if ( byElement && elem ) {
						j = 0;
						if ( !context && elem.ownerDocument !== document ) {
							setDocument( elem );
							xml = !documentIsHTML;
						}
						while ( (matcher = elementMatchers[j++]) ) {
							if ( matcher( elem, context || document, xml) ) {
								results.push( elem );
								break;
							}
						}
						if ( outermost ) {
							dirruns = dirrunsUnique;
						}
					}
	
					// Track unmatched elements for set filters
					if ( bySet ) {
						// They will have gone through all possible matchers
						if ( (elem = !matcher && elem) ) {
							matchedCount--;
						}
	
						// Lengthen the array for every element, matched or not
						if ( seed ) {
							unmatched.push( elem );
						}
					}
				}
	
				// `i` is now the count of elements visited above, and adding it to `matchedCount`
				// makes the latter nonnegative.
				matchedCount += i;
	
				// Apply set filters to unmatched elements
				// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
				// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
				// no element matchers and no seed.
				// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
				// case, which will result in a "00" `matchedCount` that differs from `i` but is also
				// numerically zero.
				if ( bySet && i !== matchedCount ) {
					j = 0;
					while ( (matcher = setMatchers[j++]) ) {
						matcher( unmatched, setMatched, context, xml );
					}
	
					if ( seed ) {
						// Reintegrate element matches to eliminate the need for sorting
						if ( matchedCount > 0 ) {
							while ( i-- ) {
								if ( !(unmatched[i] || setMatched[i]) ) {
									setMatched[i] = pop.call( results );
								}
							}
						}
	
						// Discard index placeholder values to get only actual matches
						setMatched = condense( setMatched );
					}
	
					// Add matches to results
					push.apply( results, setMatched );
	
					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if ( outermost && !seed && setMatched.length > 0 &&
						( matchedCount + setMatchers.length ) > 1 ) {
	
						Sizzle.uniqueSort( results );
					}
				}
	
				// Override manipulation of globals by nested matchers
				if ( outermost ) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}
	
				return unmatched;
			};
	
		return bySet ?
			markFunction( superMatcher ) :
			superMatcher;
	}
	
	compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
		var i,
			setMatchers = [],
			elementMatchers = [],
			cached = compilerCache[ selector + " " ];
	
		if ( !cached ) {
			// Generate a function of recursive functions that can be used to check each element
			if ( !match ) {
				match = tokenize( selector );
			}
			i = match.length;
			while ( i-- ) {
				cached = matcherFromTokens( match[i] );
				if ( cached[ expando ] ) {
					setMatchers.push( cached );
				} else {
					elementMatchers.push( cached );
				}
			}
	
			// Cache the compiled function
			cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );
	
			// Save selector and tokenization
			cached.selector = selector;
		}
		return cached;
	};
	
	/**
	 * A low-level selection function that works with Sizzle's compiled
	 *  selector functions
	 * @param {String|Function} selector A selector or a pre-compiled
	 *  selector function built with Sizzle.compile
	 * @param {Element} context
	 * @param {Array} [results]
	 * @param {Array} [seed] A set of elements to match against
	 */
	select = Sizzle.select = function( selector, context, results, seed ) {
		var i, tokens, token, type, find,
			compiled = typeof selector === "function" && selector,
			match = !seed && tokenize( (selector = compiled.selector || selector) );
	
		results = results || [];
	
		// Try to minimize operations if there is only one selector in the list and no seed
		// (the latter of which guarantees us context)
		if ( match.length === 1 ) {
	
			// Reduce context if the leading compound selector is an ID
			tokens = match[0] = match[0].slice( 0 );
			if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
					context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {
	
				context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
				if ( !context ) {
					return results;
	
				// Precompiled matchers will still verify ancestry, so step up a level
				} else if ( compiled ) {
					context = context.parentNode;
				}
	
				selector = selector.slice( tokens.shift().value.length );
			}
	
			// Fetch a seed set for right-to-left matching
			i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
			while ( i-- ) {
				token = tokens[i];
	
				// Abort if we hit a combinator
				if ( Expr.relative[ (type = token.type) ] ) {
					break;
				}
				if ( (find = Expr.find[ type ]) ) {
					// Search, expanding context for leading sibling combinators
					if ( (seed = find(
						token.matches[0].replace( runescape, funescape ),
						rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
					)) ) {
	
						// If seed is empty or no tokens remain, we can return early
						tokens.splice( i, 1 );
						selector = seed.length && toSelector( tokens );
						if ( !selector ) {
							push.apply( results, seed );
							return results;
						}
	
						break;
					}
				}
			}
		}
	
		// Compile and execute a filtering function if one is not provided
		// Provide `match` to avoid retokenization if we modified the selector above
		( compiled || compile( selector, match ) )(
			seed,
			context,
			!documentIsHTML,
			results,
			!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
		);
		return results;
	};
	
	// One-time assignments
	
	// Sort stability
	support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;
	
	// Support: Chrome 14-35+
	// Always assume duplicates if they aren't passed to the comparison function
	support.detectDuplicates = !!hasDuplicate;
	
	// Initialize against the default document
	setDocument();
	
	// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
	// Detached nodes confoundingly follow *each other*
	support.sortDetached = assert(function( el ) {
		// Should return 1, but returns 4 (following)
		return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
	});
	
	// Support: IE<8
	// Prevent attribute/property "interpolation"
	// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
	if ( !assert(function( el ) {
		el.innerHTML = "<a href='#'></a>";
		return el.firstChild.getAttribute("href") === "#" ;
	}) ) {
		addHandle( "type|href|height|width", function( elem, name, isXML ) {
			if ( !isXML ) {
				return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
			}
		});
	}
	
	// Support: IE<9
	// Use defaultValue in place of getAttribute("value")
	if ( !support.attributes || !assert(function( el ) {
		el.innerHTML = "<input/>";
		el.firstChild.setAttribute( "value", "" );
		return el.firstChild.getAttribute( "value" ) === "";
	}) ) {
		addHandle( "value", function( elem, name, isXML ) {
			if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
				return elem.defaultValue;
			}
		});
	}
	
	// Support: IE<9
	// Use getAttributeNode to fetch booleans when getAttribute lies
	if ( !assert(function( el ) {
		return el.getAttribute("disabled") == null;
	}) ) {
		addHandle( booleans, function( elem, name, isXML ) {
			var val;
			if ( !isXML ) {
				return elem[ name ] === true ? name.toLowerCase() :
						(val = elem.getAttributeNode( name )) && val.specified ?
						val.value :
					null;
			}
		});
	}
	
	return Sizzle;
	
	})( window );
	
	
	
	jQuery.find = Sizzle;
	jQuery.expr = Sizzle.selectors;
	
	// Deprecated
	jQuery.expr[ ":" ] = jQuery.expr.pseudos;
	jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
	jQuery.text = Sizzle.getText;
	jQuery.isXMLDoc = Sizzle.isXML;
	jQuery.contains = Sizzle.contains;
	jQuery.escapeSelector = Sizzle.escape;
	
	
	
	
	var dir = function( elem, dir, until ) {
		var matched = [],
			truncate = until !== undefined;
	
		while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
			if ( elem.nodeType === 1 ) {
				if ( truncate && jQuery( elem ).is( until ) ) {
					break;
				}
				matched.push( elem );
			}
		}
		return matched;
	};
	
	
	var siblings = function( n, elem ) {
		var matched = [];
	
		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				matched.push( n );
			}
		}
	
		return matched;
	};
	
	
	var rneedsContext = jQuery.expr.match.needsContext;
	
	var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );
	
	
	
	var risSimple = /^.[^:#\[\.,]*$/;
	
	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
		if ( jQuery.isFunction( qualifier ) ) {
			return jQuery.grep( elements, function( elem, i ) {
				return !!qualifier.call( elem, i, elem ) !== not;
			} );
		}
	
		// Single element
		if ( qualifier.nodeType ) {
			return jQuery.grep( elements, function( elem ) {
				return ( elem === qualifier ) !== not;
			} );
		}
	
		// Arraylike of elements (jQuery, arguments, Array)
		if ( typeof qualifier !== "string" ) {
			return jQuery.grep( elements, function( elem ) {
				return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
			} );
		}
	
		// Simple selector that can be filtered directly, removing non-Elements
		if ( risSimple.test( qualifier ) ) {
			return jQuery.filter( qualifier, elements, not );
		}
	
		// Complex selector, compare the two sets, removing non-Elements
		qualifier = jQuery.filter( qualifier, elements );
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not && elem.nodeType === 1;
		} );
	}
	
	jQuery.filter = function( expr, elems, not ) {
		var elem = elems[ 0 ];
	
		if ( not ) {
			expr = ":not(" + expr + ")";
		}
	
		if ( elems.length === 1 && elem.nodeType === 1 ) {
			return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
		}
	
		return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
			return elem.nodeType === 1;
		} ) );
	};
	
	jQuery.fn.extend( {
		find: function( selector ) {
			var i, ret,
				len = this.length,
				self = this;
	
			if ( typeof selector !== "string" ) {
				return this.pushStack( jQuery( selector ).filter( function() {
					for ( i = 0; i < len; i++ ) {
						if ( jQuery.contains( self[ i ], this ) ) {
							return true;
						}
					}
				} ) );
			}
	
			ret = this.pushStack( [] );
	
			for ( i = 0; i < len; i++ ) {
				jQuery.find( selector, self[ i ], ret );
			}
	
			return len > 1 ? jQuery.uniqueSort( ret ) : ret;
		},
		filter: function( selector ) {
			return this.pushStack( winnow( this, selector || [], false ) );
		},
		not: function( selector ) {
			return this.pushStack( winnow( this, selector || [], true ) );
		},
		is: function( selector ) {
			return !!winnow(
				this,
	
				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test( selector ) ?
					jQuery( selector ) :
					selector || [],
				false
			).length;
		}
	} );
	
	
	// Initialize a jQuery object
	
	
	// A central reference to the root jQuery(document)
	var rootjQuery,
	
		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
		// Strict HTML recognition (#11290: must start with <)
		// Shortcut simple #id case for speed
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
	
		init = jQuery.fn.init = function( selector, context, root ) {
			var match, elem;
	
			// HANDLE: $(""), $(null), $(undefined), $(false)
			if ( !selector ) {
				return this;
			}
	
			// Method init() accepts an alternate rootjQuery
			// so migrate can support jQuery.sub (gh-2101)
			root = root || rootjQuery;
	
			// Handle HTML strings
			if ( typeof selector === "string" ) {
				if ( selector[ 0 ] === "<" &&
					selector[ selector.length - 1 ] === ">" &&
					selector.length >= 3 ) {
	
					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [ null, selector, null ];
	
				} else {
					match = rquickExpr.exec( selector );
				}
	
				// Match html or make sure no context is specified for #id
				if ( match && ( match[ 1 ] || !context ) ) {
	
					// HANDLE: $(html) -> $(array)
					if ( match[ 1 ] ) {
						context = context instanceof jQuery ? context[ 0 ] : context;
	
						// Option to run scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge( this, jQuery.parseHTML(
							match[ 1 ],
							context && context.nodeType ? context.ownerDocument || context : document,
							true
						) );
	
						// HANDLE: $(html, props)
						if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
							for ( match in context ) {
	
								// Properties of context are called as methods if possible
								if ( jQuery.isFunction( this[ match ] ) ) {
									this[ match ]( context[ match ] );
	
								// ...and otherwise set as attributes
								} else {
									this.attr( match, context[ match ] );
								}
							}
						}
	
						return this;
	
					// HANDLE: $(#id)
					} else {
						elem = document.getElementById( match[ 2 ] );
	
						if ( elem ) {
	
							// Inject the element directly into the jQuery object
							this[ 0 ] = elem;
							this.length = 1;
						}
						return this;
					}
	
				// HANDLE: $(expr, $(...))
				} else if ( !context || context.jquery ) {
					return ( context || root ).find( selector );
	
				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor( context ).find( selector );
				}
	
			// HANDLE: $(DOMElement)
			} else if ( selector.nodeType ) {
				this[ 0 ] = selector;
				this.length = 1;
				return this;
	
			// HANDLE: $(function)
			// Shortcut for document ready
			} else if ( jQuery.isFunction( selector ) ) {
				return root.ready !== undefined ?
					root.ready( selector ) :
	
					// Execute immediately if ready is not present
					selector( jQuery );
			}
	
			return jQuery.makeArray( selector, this );
		};
	
	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;
	
	// Initialize central reference
	rootjQuery = jQuery( document );
	
	
	var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	
		// Methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};
	
	jQuery.fn.extend( {
		has: function( target ) {
			var targets = jQuery( target, this ),
				l = targets.length;
	
			return this.filter( function() {
				var i = 0;
				for ( ; i < l; i++ ) {
					if ( jQuery.contains( this, targets[ i ] ) ) {
						return true;
					}
				}
			} );
		},
	
		closest: function( selectors, context ) {
			var cur,
				i = 0,
				l = this.length,
				matched = [],
				targets = typeof selectors !== "string" && jQuery( selectors );
	
			// Positional selectors never match, since there's no _selection_ context
			if ( !rneedsContext.test( selectors ) ) {
				for ( ; i < l; i++ ) {
					for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {
	
						// Always skip document fragments
						if ( cur.nodeType < 11 && ( targets ?
							targets.index( cur ) > -1 :
	
							// Don't pass non-elements to Sizzle
							cur.nodeType === 1 &&
								jQuery.find.matchesSelector( cur, selectors ) ) ) {
	
							matched.push( cur );
							break;
						}
					}
				}
			}
	
			return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
		},
	
		// Determine the position of an element within the set
		index: function( elem ) {
	
			// No argument, return index in parent
			if ( !elem ) {
				return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
			}
	
			// Index in selector
			if ( typeof elem === "string" ) {
				return indexOf.call( jQuery( elem ), this[ 0 ] );
			}
	
			// Locate the position of the desired element
			return indexOf.call( this,
	
				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[ 0 ] : elem
			);
		},
	
		add: function( selector, context ) {
			return this.pushStack(
				jQuery.uniqueSort(
					jQuery.merge( this.get(), jQuery( selector, context ) )
				)
			);
		},
	
		addBack: function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter( selector )
			);
		}
	} );
	
	function sibling( cur, dir ) {
		while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
		return cur;
	}
	
	jQuery.each( {
		parent: function( elem ) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function( elem ) {
			return dir( elem, "parentNode" );
		},
		parentsUntil: function( elem, i, until ) {
			return dir( elem, "parentNode", until );
		},
		next: function( elem ) {
			return sibling( elem, "nextSibling" );
		},
		prev: function( elem ) {
			return sibling( elem, "previousSibling" );
		},
		nextAll: function( elem ) {
			return dir( elem, "nextSibling" );
		},
		prevAll: function( elem ) {
			return dir( elem, "previousSibling" );
		},
		nextUntil: function( elem, i, until ) {
			return dir( elem, "nextSibling", until );
		},
		prevUntil: function( elem, i, until ) {
			return dir( elem, "previousSibling", until );
		},
		siblings: function( elem ) {
			return siblings( ( elem.parentNode || {} ).firstChild, elem );
		},
		children: function( elem ) {
			return siblings( elem.firstChild );
		},
		contents: function( elem ) {
			return elem.contentDocument || jQuery.merge( [], elem.childNodes );
		}
	}, function( name, fn ) {
		jQuery.fn[ name ] = function( until, selector ) {
			var matched = jQuery.map( this, fn, until );
	
			if ( name.slice( -5 ) !== "Until" ) {
				selector = until;
			}
	
			if ( selector && typeof selector === "string" ) {
				matched = jQuery.filter( selector, matched );
			}
	
			if ( this.length > 1 ) {
	
				// Remove duplicates
				if ( !guaranteedUnique[ name ] ) {
					jQuery.uniqueSort( matched );
				}
	
				// Reverse order for parents* and prev-derivatives
				if ( rparentsprev.test( name ) ) {
					matched.reverse();
				}
			}
	
			return this.pushStack( matched );
		};
	} );
	var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );
	
	
	
	// Convert String-formatted options into Object-formatted ones
	function createOptions( options ) {
		var object = {};
		jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
			object[ flag ] = true;
		} );
		return object;
	}
	
	/*
	 * Create a callback list using the following parameters:
	 *
	 *	options: an optional list of space-separated options that will change how
	 *			the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *	once:			will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *	memory:			will keep track of previous values and will call any callback added
	 *					after the list has been fired right away with the latest "memorized"
	 *					values (like a Deferred)
	 *
	 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *	stopOnFalse:	interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {
	
		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ?
			createOptions( options ) :
			jQuery.extend( {}, options );
	
		var // Flag to know if list is currently firing
			firing,
	
			// Last fire value for non-forgettable lists
			memory,
	
			// Flag to know if list was already fired
			fired,
	
			// Flag to prevent firing
			locked,
	
			// Actual callback list
			list = [],
	
			// Queue of execution data for repeatable lists
			queue = [],
	
			// Index of currently firing callback (modified by add/remove as needed)
			firingIndex = -1,
	
			// Fire callbacks
			fire = function() {
	
				// Enforce single-firing
				locked = options.once;
	
				// Execute callbacks for all pending executions,
				// respecting firingIndex overrides and runtime changes
				fired = firing = true;
				for ( ; queue.length; firingIndex = -1 ) {
					memory = queue.shift();
					while ( ++firingIndex < list.length ) {
	
						// Run callback and check for early termination
						if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
							options.stopOnFalse ) {
	
							// Jump to end and forget the data so .add doesn't re-fire
							firingIndex = list.length;
							memory = false;
						}
					}
				}
	
				// Forget the data if we're done with it
				if ( !options.memory ) {
					memory = false;
				}
	
				firing = false;
	
				// Clean up if we're done firing for good
				if ( locked ) {
	
					// Keep an empty list if we have data for future add calls
					if ( memory ) {
						list = [];
	
					// Otherwise, this object is spent
					} else {
						list = "";
					}
				}
			},
	
			// Actual Callbacks object
			self = {
	
				// Add a callback or a collection of callbacks to the list
				add: function() {
					if ( list ) {
	
						// If we have memory from a past run, we should fire after adding
						if ( memory && !firing ) {
							firingIndex = list.length - 1;
							queue.push( memory );
						}
	
						( function add( args ) {
							jQuery.each( args, function( _, arg ) {
								if ( jQuery.isFunction( arg ) ) {
									if ( !options.unique || !self.has( arg ) ) {
										list.push( arg );
									}
								} else if ( arg && arg.length && jQuery.type( arg ) !== "string" ) {
	
									// Inspect recursively
									add( arg );
								}
							} );
						} )( arguments );
	
						if ( memory && !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Remove a callback from the list
				remove: function() {
					jQuery.each( arguments, function( _, arg ) {
						var index;
						while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
							list.splice( index, 1 );
	
							// Handle firing indexes
							if ( index <= firingIndex ) {
								firingIndex--;
							}
						}
					} );
					return this;
				},
	
				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function( fn ) {
					return fn ?
						jQuery.inArray( fn, list ) > -1 :
						list.length > 0;
				},
	
				// Remove all callbacks from the list
				empty: function() {
					if ( list ) {
						list = [];
					}
					return this;
				},
	
				// Disable .fire and .add
				// Abort any current/pending executions
				// Clear all callbacks and values
				disable: function() {
					locked = queue = [];
					list = memory = "";
					return this;
				},
				disabled: function() {
					return !list;
				},
	
				// Disable .fire
				// Also disable .add unless we have memory (since it would have no effect)
				// Abort any pending executions
				lock: function() {
					locked = queue = [];
					if ( !memory && !firing ) {
						list = memory = "";
					}
					return this;
				},
				locked: function() {
					return !!locked;
				},
	
				// Call all callbacks with the given context and arguments
				fireWith: function( context, args ) {
					if ( !locked ) {
						args = args || [];
						args = [ context, args.slice ? args.slice() : args ];
						queue.push( args );
						if ( !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Call all the callbacks with the given arguments
				fire: function() {
					self.fireWith( this, arguments );
					return this;
				},
	
				// To know if the callbacks have already been called at least once
				fired: function() {
					return !!fired;
				}
			};
	
		return self;
	};
	
	
	function Identity( v ) {
		return v;
	}
	function Thrower( ex ) {
		throw ex;
	}
	
	function adoptValue( value, resolve, reject ) {
		var method;
	
		try {
	
			// Check for promise aspect first to privilege synchronous behavior
			if ( value && jQuery.isFunction( ( method = value.promise ) ) ) {
				method.call( value ).done( resolve ).fail( reject );
	
			// Other thenables
			} else if ( value && jQuery.isFunction( ( method = value.then ) ) ) {
				method.call( value, resolve, reject );
	
			// Other non-thenables
			} else {
	
				// Support: Android 4.0 only
				// Strict mode functions invoked without .call/.apply get global-object context
				resolve.call( undefined, value );
			}
	
		// For Promises/A+, convert exceptions into rejections
		// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
		// Deferred#then to conditionally suppress rejection.
		} catch ( value ) {
	
			// Support: Android 4.0 only
			// Strict mode functions invoked without .call/.apply get global-object context
			reject.call( undefined, value );
		}
	}
	
	jQuery.extend( {
	
		Deferred: function( func ) {
			var tuples = [
	
					// action, add listener, callbacks,
					// ... .then handlers, argument index, [final state]
					[ "notify", "progress", jQuery.Callbacks( "memory" ),
						jQuery.Callbacks( "memory" ), 2 ],
					[ "resolve", "done", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 0, "resolved" ],
					[ "reject", "fail", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 1, "rejected" ]
				],
				state = "pending",
				promise = {
					state: function() {
						return state;
					},
					always: function() {
						deferred.done( arguments ).fail( arguments );
						return this;
					},
					"catch": function( fn ) {
						return promise.then( null, fn );
					},
	
					// Keep pipe for back-compat
					pipe: function( /* fnDone, fnFail, fnProgress */ ) {
						var fns = arguments;
	
						return jQuery.Deferred( function( newDefer ) {
							jQuery.each( tuples, function( i, tuple ) {
	
								// Map tuples (progress, done, fail) to arguments (done, fail, progress)
								var fn = jQuery.isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];
	
								// deferred.progress(function() { bind to newDefer or newDefer.notify })
								// deferred.done(function() { bind to newDefer or newDefer.resolve })
								// deferred.fail(function() { bind to newDefer or newDefer.reject })
								deferred[ tuple[ 1 ] ]( function() {
									var returned = fn && fn.apply( this, arguments );
									if ( returned && jQuery.isFunction( returned.promise ) ) {
										returned.promise()
											.progress( newDefer.notify )
											.done( newDefer.resolve )
											.fail( newDefer.reject );
									} else {
										newDefer[ tuple[ 0 ] + "With" ](
											this,
											fn ? [ returned ] : arguments
										);
									}
								} );
							} );
							fns = null;
						} ).promise();
					},
					then: function( onFulfilled, onRejected, onProgress ) {
						var maxDepth = 0;
						function resolve( depth, deferred, handler, special ) {
							return function() {
								var that = this,
									args = arguments,
									mightThrow = function() {
										var returned, then;
	
										// Support: Promises/A+ section 2.3.3.3.3
										// https://promisesaplus.com/#point-59
										// Ignore double-resolution attempts
										if ( depth < maxDepth ) {
											return;
										}
	
										returned = handler.apply( that, args );
	
										// Support: Promises/A+ section 2.3.1
										// https://promisesaplus.com/#point-48
										if ( returned === deferred.promise() ) {
											throw new TypeError( "Thenable self-resolution" );
										}
	
										// Support: Promises/A+ sections 2.3.3.1, 3.5
										// https://promisesaplus.com/#point-54
										// https://promisesaplus.com/#point-75
										// Retrieve `then` only once
										then = returned &&
	
											// Support: Promises/A+ section 2.3.4
											// https://promisesaplus.com/#point-64
											// Only check objects and functions for thenability
											( typeof returned === "object" ||
												typeof returned === "function" ) &&
											returned.then;
	
										// Handle a returned thenable
										if ( jQuery.isFunction( then ) ) {
	
											// Special processors (notify) just wait for resolution
											if ( special ) {
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special )
												);
	
											// Normal processors (resolve) also hook into progress
											} else {
	
												// ...and disregard older resolution values
												maxDepth++;
	
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special ),
													resolve( maxDepth, deferred, Identity,
														deferred.notifyWith )
												);
											}
	
										// Handle all other returned values
										} else {
	
											// Only substitute handlers pass on context
											// and multiple values (non-spec behavior)
											if ( handler !== Identity ) {
												that = undefined;
												args = [ returned ];
											}
	
											// Process the value(s)
											// Default process is resolve
											( special || deferred.resolveWith )( that, args );
										}
									},
	
									// Only normal processors (resolve) catch and reject exceptions
									process = special ?
										mightThrow :
										function() {
											try {
												mightThrow();
											} catch ( e ) {
	
												if ( jQuery.Deferred.exceptionHook ) {
													jQuery.Deferred.exceptionHook( e,
														process.stackTrace );
												}
	
												// Support: Promises/A+ section 2.3.3.3.4.1
												// https://promisesaplus.com/#point-61
												// Ignore post-resolution exceptions
												if ( depth + 1 >= maxDepth ) {
	
													// Only substitute handlers pass on context
													// and multiple values (non-spec behavior)
													if ( handler !== Thrower ) {
														that = undefined;
														args = [ e ];
													}
	
													deferred.rejectWith( that, args );
												}
											}
										};
	
								// Support: Promises/A+ section 2.3.3.3.1
								// https://promisesaplus.com/#point-57
								// Re-resolve promises immediately to dodge false rejection from
								// subsequent errors
								if ( depth ) {
									process();
								} else {
	
									// Call an optional hook to record the stack, in case of exception
									// since it's otherwise lost when execution goes async
									if ( jQuery.Deferred.getStackHook ) {
										process.stackTrace = jQuery.Deferred.getStackHook();
									}
									window.setTimeout( process );
								}
							};
						}
	
						return jQuery.Deferred( function( newDefer ) {
	
							// progress_handlers.add( ... )
							tuples[ 0 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									jQuery.isFunction( onProgress ) ?
										onProgress :
										Identity,
									newDefer.notifyWith
								)
							);
	
							// fulfilled_handlers.add( ... )
							tuples[ 1 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									jQuery.isFunction( onFulfilled ) ?
										onFulfilled :
										Identity
								)
							);
	
							// rejected_handlers.add( ... )
							tuples[ 2 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									jQuery.isFunction( onRejected ) ?
										onRejected :
										Thrower
								)
							);
						} ).promise();
					},
	
					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function( obj ) {
						return obj != null ? jQuery.extend( obj, promise ) : promise;
					}
				},
				deferred = {};
	
			// Add list-specific methods
			jQuery.each( tuples, function( i, tuple ) {
				var list = tuple[ 2 ],
					stateString = tuple[ 5 ];
	
				// promise.progress = list.add
				// promise.done = list.add
				// promise.fail = list.add
				promise[ tuple[ 1 ] ] = list.add;
	
				// Handle state
				if ( stateString ) {
					list.add(
						function() {
	
							// state = "resolved" (i.e., fulfilled)
							// state = "rejected"
							state = stateString;
						},
	
						// rejected_callbacks.disable
						// fulfilled_callbacks.disable
						tuples[ 3 - i ][ 2 ].disable,
	
						// progress_callbacks.lock
						tuples[ 0 ][ 2 ].lock
					);
				}
	
				// progress_handlers.fire
				// fulfilled_handlers.fire
				// rejected_handlers.fire
				list.add( tuple[ 3 ].fire );
	
				// deferred.notify = function() { deferred.notifyWith(...) }
				// deferred.resolve = function() { deferred.resolveWith(...) }
				// deferred.reject = function() { deferred.rejectWith(...) }
				deferred[ tuple[ 0 ] ] = function() {
					deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
					return this;
				};
	
				// deferred.notifyWith = list.fireWith
				// deferred.resolveWith = list.fireWith
				// deferred.rejectWith = list.fireWith
				deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
			} );
	
			// Make the deferred a promise
			promise.promise( deferred );
	
			// Call given func if any
			if ( func ) {
				func.call( deferred, deferred );
			}
	
			// All done!
			return deferred;
		},
	
		// Deferred helper
		when: function( singleValue ) {
			var
	
				// count of uncompleted subordinates
				remaining = arguments.length,
	
				// count of unprocessed arguments
				i = remaining,
	
				// subordinate fulfillment data
				resolveContexts = Array( i ),
				resolveValues = slice.call( arguments ),
	
				// the master Deferred
				master = jQuery.Deferred(),
	
				// subordinate callback factory
				updateFunc = function( i ) {
					return function( value ) {
						resolveContexts[ i ] = this;
						resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
						if ( !( --remaining ) ) {
							master.resolveWith( resolveContexts, resolveValues );
						}
					};
				};
	
			// Single- and empty arguments are adopted like Promise.resolve
			if ( remaining <= 1 ) {
				adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject );
	
				// Use .then() to unwrap secondary thenables (cf. gh-3000)
				if ( master.state() === "pending" ||
					jQuery.isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {
	
					return master.then();
				}
			}
	
			// Multiple arguments are aggregated like Promise.all array elements
			while ( i-- ) {
				adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
			}
	
			return master.promise();
		}
	} );
	
	
	// These usually indicate a programmer mistake during development,
	// warn about them ASAP rather than swallowing them by default.
	var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
	
	jQuery.Deferred.exceptionHook = function( error, stack ) {
	
		// Support: IE 8 - 9 only
		// Console exists when dev tools are open, which can happen at any time
		if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
			window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
		}
	};
	
	
	
	
	jQuery.readyException = function( error ) {
		window.setTimeout( function() {
			throw error;
		} );
	};
	
	
	
	
	// The deferred used on DOM ready
	var readyList = jQuery.Deferred();
	
	jQuery.fn.ready = function( fn ) {
	
		readyList
			.then( fn )
	
			// Wrap jQuery.readyException in a function so that the lookup
			// happens at the time of error handling instead of callback
			// registration.
			.catch( function( error ) {
				jQuery.readyException( error );
			} );
	
		return this;
	};
	
	jQuery.extend( {
	
		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,
	
		// A counter to track how many items to wait for before
		// the ready event fires. See #6781
		readyWait: 1,
	
		// Hold (or release) the ready event
		holdReady: function( hold ) {
			if ( hold ) {
				jQuery.readyWait++;
			} else {
				jQuery.ready( true );
			}
		},
	
		// Handle when the DOM is ready
		ready: function( wait ) {
	
			// Abort if there are pending holds or we're already ready
			if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
				return;
			}
	
			// Remember that the DOM is ready
			jQuery.isReady = true;
	
			// If a normal DOM Ready event fired, decrement, and wait if need be
			if ( wait !== true && --jQuery.readyWait > 0 ) {
				return;
			}
	
			// If there are functions bound, to execute
			readyList.resolveWith( document, [ jQuery ] );
		}
	} );
	
	jQuery.ready.then = readyList.then;
	
	// The ready event handler and self cleanup method
	function completed() {
		document.removeEventListener( "DOMContentLoaded", completed );
		window.removeEventListener( "load", completed );
		jQuery.ready();
	}
	
	// Catch cases where $(document).ready() is called
	// after the browser event has already occurred.
	// Support: IE <=9 - 10 only
	// Older IE sometimes signals "interactive" too soon
	if ( document.readyState === "complete" ||
		( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {
	
		// Handle it asynchronously to allow scripts the opportunity to delay ready
		window.setTimeout( jQuery.ready );
	
	} else {
	
		// Use the handy event callback
		document.addEventListener( "DOMContentLoaded", completed );
	
		// A fallback to window.onload, that will always work
		window.addEventListener( "load", completed );
	}
	
	
	
	
	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
		var i = 0,
			len = elems.length,
			bulk = key == null;
	
		// Sets many values
		if ( jQuery.type( key ) === "object" ) {
			chainable = true;
			for ( i in key ) {
				access( elems, fn, i, key[ i ], true, emptyGet, raw );
			}
	
		// Sets one value
		} else if ( value !== undefined ) {
			chainable = true;
	
			if ( !jQuery.isFunction( value ) ) {
				raw = true;
			}
	
			if ( bulk ) {
	
				// Bulk operations run against the entire set
				if ( raw ) {
					fn.call( elems, value );
					fn = null;
	
				// ...except when executing function values
				} else {
					bulk = fn;
					fn = function( elem, key, value ) {
						return bulk.call( jQuery( elem ), value );
					};
				}
			}
	
			if ( fn ) {
				for ( ; i < len; i++ ) {
					fn(
						elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
					);
				}
			}
		}
	
		if ( chainable ) {
			return elems;
		}
	
		// Gets
		if ( bulk ) {
			return fn.call( elems );
		}
	
		return len ? fn( elems[ 0 ], key ) : emptyGet;
	};
	var acceptData = function( owner ) {
	
		// Accepts only:
		//  - Node
		//    - Node.ELEMENT_NODE
		//    - Node.DOCUMENT_NODE
		//  - Object
		//    - Any
		return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
	};
	
	
	
	
	function Data() {
		this.expando = jQuery.expando + Data.uid++;
	}
	
	Data.uid = 1;
	
	Data.prototype = {
	
		cache: function( owner ) {
	
			// Check if the owner object already has a cache
			var value = owner[ this.expando ];
	
			// If not, create one
			if ( !value ) {
				value = {};
	
				// We can accept data for non-element nodes in modern browsers,
				// but we should not, see #8335.
				// Always return an empty object.
				if ( acceptData( owner ) ) {
	
					// If it is a node unlikely to be stringify-ed or looped over
					// use plain assignment
					if ( owner.nodeType ) {
						owner[ this.expando ] = value;
	
					// Otherwise secure it in a non-enumerable property
					// configurable must be true to allow the property to be
					// deleted when data is removed
					} else {
						Object.defineProperty( owner, this.expando, {
							value: value,
							configurable: true
						} );
					}
				}
			}
	
			return value;
		},
		set: function( owner, data, value ) {
			var prop,
				cache = this.cache( owner );
	
			// Handle: [ owner, key, value ] args
			// Always use camelCase key (gh-2257)
			if ( typeof data === "string" ) {
				cache[ jQuery.camelCase( data ) ] = value;
	
			// Handle: [ owner, { properties } ] args
			} else {
	
				// Copy the properties one-by-one to the cache object
				for ( prop in data ) {
					cache[ jQuery.camelCase( prop ) ] = data[ prop ];
				}
			}
			return cache;
		},
		get: function( owner, key ) {
			return key === undefined ?
				this.cache( owner ) :
	
				// Always use camelCase key (gh-2257)
				owner[ this.expando ] && owner[ this.expando ][ jQuery.camelCase( key ) ];
		},
		access: function( owner, key, value ) {
	
			// In cases where either:
			//
			//   1. No key was specified
			//   2. A string key was specified, but no value provided
			//
			// Take the "read" path and allow the get method to determine
			// which value to return, respectively either:
			//
			//   1. The entire cache object
			//   2. The data stored at the key
			//
			if ( key === undefined ||
					( ( key && typeof key === "string" ) && value === undefined ) ) {
	
				return this.get( owner, key );
			}
	
			// When the key is not a string, or both a key and value
			// are specified, set or extend (existing objects) with either:
			//
			//   1. An object of properties
			//   2. A key and value
			//
			this.set( owner, key, value );
	
			// Since the "set" path can have two possible entry points
			// return the expected data based on which path was taken[*]
			return value !== undefined ? value : key;
		},
		remove: function( owner, key ) {
			var i,
				cache = owner[ this.expando ];
	
			if ( cache === undefined ) {
				return;
			}
	
			if ( key !== undefined ) {
	
				// Support array or space separated string of keys
				if ( jQuery.isArray( key ) ) {
	
					// If key is an array of keys...
					// We always set camelCase keys, so remove that.
					key = key.map( jQuery.camelCase );
				} else {
					key = jQuery.camelCase( key );
	
					// If a key with the spaces exists, use it.
					// Otherwise, create an array by matching non-whitespace
					key = key in cache ?
						[ key ] :
						( key.match( rnothtmlwhite ) || [] );
				}
	
				i = key.length;
	
				while ( i-- ) {
					delete cache[ key[ i ] ];
				}
			}
	
			// Remove the expando if there's no more data
			if ( key === undefined || jQuery.isEmptyObject( cache ) ) {
	
				// Support: Chrome <=35 - 45
				// Webkit & Blink performance suffers when deleting properties
				// from DOM nodes, so set to undefined instead
				// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
				if ( owner.nodeType ) {
					owner[ this.expando ] = undefined;
				} else {
					delete owner[ this.expando ];
				}
			}
		},
		hasData: function( owner ) {
			var cache = owner[ this.expando ];
			return cache !== undefined && !jQuery.isEmptyObject( cache );
		}
	};
	var dataPriv = new Data();
	
	var dataUser = new Data();
	
	
	
	//	Implementation Summary
	//
	//	1. Enforce API surface and semantic compatibility with 1.9.x branch
	//	2. Improve the module's maintainability by reducing the storage
	//		paths to a single mechanism.
	//	3. Use the same single mechanism to support "private" and "user" data.
	//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
	//	5. Avoid exposing implementation details on user objects (eg. expando properties)
	//	6. Provide a clear path for implementation upgrade to WeakMap in 2014
	
	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		rmultiDash = /[A-Z]/g;
	
	function getData( data ) {
		if ( data === "true" ) {
			return true;
		}
	
		if ( data === "false" ) {
			return false;
		}
	
		if ( data === "null" ) {
			return null;
		}
	
		// Only convert to a number if it doesn't change the string
		if ( data === +data + "" ) {
			return +data;
		}
	
		if ( rbrace.test( data ) ) {
			return JSON.parse( data );
		}
	
		return data;
	}
	
	function dataAttr( elem, key, data ) {
		var name;
	
		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if ( data === undefined && elem.nodeType === 1 ) {
			name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
			data = elem.getAttribute( name );
	
			if ( typeof data === "string" ) {
				try {
					data = getData( data );
				} catch ( e ) {}
	
				// Make sure we set the data so it isn't changed later
				dataUser.set( elem, key, data );
			} else {
				data = undefined;
			}
		}
		return data;
	}
	
	jQuery.extend( {
		hasData: function( elem ) {
			return dataUser.hasData( elem ) || dataPriv.hasData( elem );
		},
	
		data: function( elem, name, data ) {
			return dataUser.access( elem, name, data );
		},
	
		removeData: function( elem, name ) {
			dataUser.remove( elem, name );
		},
	
		// TODO: Now that all calls to _data and _removeData have been replaced
		// with direct calls to dataPriv methods, these can be deprecated.
		_data: function( elem, name, data ) {
			return dataPriv.access( elem, name, data );
		},
	
		_removeData: function( elem, name ) {
			dataPriv.remove( elem, name );
		}
	} );
	
	jQuery.fn.extend( {
		data: function( key, value ) {
			var i, name, data,
				elem = this[ 0 ],
				attrs = elem && elem.attributes;
	
			// Gets all values
			if ( key === undefined ) {
				if ( this.length ) {
					data = dataUser.get( elem );
	
					if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
						i = attrs.length;
						while ( i-- ) {
	
							// Support: IE 11 only
							// The attrs elements can be null (#14894)
							if ( attrs[ i ] ) {
								name = attrs[ i ].name;
								if ( name.indexOf( "data-" ) === 0 ) {
									name = jQuery.camelCase( name.slice( 5 ) );
									dataAttr( elem, name, data[ name ] );
								}
							}
						}
						dataPriv.set( elem, "hasDataAttrs", true );
					}
				}
	
				return data;
			}
	
			// Sets multiple values
			if ( typeof key === "object" ) {
				return this.each( function() {
					dataUser.set( this, key );
				} );
			}
	
			return access( this, function( value ) {
				var data;
	
				// The calling jQuery object (element matches) is not empty
				// (and therefore has an element appears at this[ 0 ]) and the
				// `value` parameter was not undefined. An empty jQuery object
				// will result in `undefined` for elem = this[ 0 ] which will
				// throw an exception if an attempt to read a data cache is made.
				if ( elem && value === undefined ) {
	
					// Attempt to get data from the cache
					// The key will always be camelCased in Data
					data = dataUser.get( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// Attempt to "discover" the data in
					// HTML5 custom data-* attrs
					data = dataAttr( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// We tried really hard, but the data doesn't exist.
					return;
				}
	
				// Set the data...
				this.each( function() {
	
					// We always store the camelCased key
					dataUser.set( this, key, value );
				} );
			}, null, value, arguments.length > 1, null, true );
		},
	
		removeData: function( key ) {
			return this.each( function() {
				dataUser.remove( this, key );
			} );
		}
	} );
	
	
	jQuery.extend( {
		queue: function( elem, type, data ) {
			var queue;
	
			if ( elem ) {
				type = ( type || "fx" ) + "queue";
				queue = dataPriv.get( elem, type );
	
				// Speed up dequeue by getting out quickly if this is just a lookup
				if ( data ) {
					if ( !queue || jQuery.isArray( data ) ) {
						queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
					} else {
						queue.push( data );
					}
				}
				return queue || [];
			}
		},
	
		dequeue: function( elem, type ) {
			type = type || "fx";
	
			var queue = jQuery.queue( elem, type ),
				startLength = queue.length,
				fn = queue.shift(),
				hooks = jQuery._queueHooks( elem, type ),
				next = function() {
					jQuery.dequeue( elem, type );
				};
	
			// If the fx queue is dequeued, always remove the progress sentinel
			if ( fn === "inprogress" ) {
				fn = queue.shift();
				startLength--;
			}
	
			if ( fn ) {
	
				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if ( type === "fx" ) {
					queue.unshift( "inprogress" );
				}
	
				// Clear up the last queue stop function
				delete hooks.stop;
				fn.call( elem, next, hooks );
			}
	
			if ( !startLength && hooks ) {
				hooks.empty.fire();
			}
		},
	
		// Not public - generate a queueHooks object, or return the current one
		_queueHooks: function( elem, type ) {
			var key = type + "queueHooks";
			return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
				empty: jQuery.Callbacks( "once memory" ).add( function() {
					dataPriv.remove( elem, [ type + "queue", key ] );
				} )
			} );
		}
	} );
	
	jQuery.fn.extend( {
		queue: function( type, data ) {
			var setter = 2;
	
			if ( typeof type !== "string" ) {
				data = type;
				type = "fx";
				setter--;
			}
	
			if ( arguments.length < setter ) {
				return jQuery.queue( this[ 0 ], type );
			}
	
			return data === undefined ?
				this :
				this.each( function() {
					var queue = jQuery.queue( this, type, data );
	
					// Ensure a hooks for this queue
					jQuery._queueHooks( this, type );
	
					if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
						jQuery.dequeue( this, type );
					}
				} );
		},
		dequeue: function( type ) {
			return this.each( function() {
				jQuery.dequeue( this, type );
			} );
		},
		clearQueue: function( type ) {
			return this.queue( type || "fx", [] );
		},
	
		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function( type, obj ) {
			var tmp,
				count = 1,
				defer = jQuery.Deferred(),
				elements = this,
				i = this.length,
				resolve = function() {
					if ( !( --count ) ) {
						defer.resolveWith( elements, [ elements ] );
					}
				};
	
			if ( typeof type !== "string" ) {
				obj = type;
				type = undefined;
			}
			type = type || "fx";
	
			while ( i-- ) {
				tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
				if ( tmp && tmp.empty ) {
					count++;
					tmp.empty.add( resolve );
				}
			}
			resolve();
			return defer.promise( obj );
		}
	} );
	var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;
	
	var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );
	
	
	var cssExpand = [ "Top", "Right", "Bottom", "Left" ];
	
	var isHiddenWithinTree = function( elem, el ) {
	
			// isHiddenWithinTree might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;
	
			// Inline style trumps all
			return elem.style.display === "none" ||
				elem.style.display === "" &&
	
				// Otherwise, check computed style
				// Support: Firefox <=43 - 45
				// Disconnected elements can have computed display: none, so first confirm that elem is
				// in the document.
				jQuery.contains( elem.ownerDocument, elem ) &&
	
				jQuery.css( elem, "display" ) === "none";
		};
	
	var swap = function( elem, options, callback, args ) {
		var ret, name,
			old = {};
	
		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}
	
		ret = callback.apply( elem, args || [] );
	
		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}
	
		return ret;
	};
	
	
	
	
	function adjustCSS( elem, prop, valueParts, tween ) {
		var adjusted,
			scale = 1,
			maxIterations = 20,
			currentValue = tween ?
				function() {
					return tween.cur();
				} :
				function() {
					return jQuery.css( elem, prop, "" );
				},
			initial = currentValue(),
			unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),
	
			// Starting value computation is required for potential unit mismatches
			initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
				rcssNum.exec( jQuery.css( elem, prop ) );
	
		if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {
	
			// Trust units reported by jQuery.css
			unit = unit || initialInUnit[ 3 ];
	
			// Make sure we update the tween properties later on
			valueParts = valueParts || [];
	
			// Iteratively approximate from a nonzero starting point
			initialInUnit = +initial || 1;
	
			do {
	
				// If previous iteration zeroed out, double until we get *something*.
				// Use string for doubling so we don't accidentally see scale as unchanged below
				scale = scale || ".5";
	
				// Adjust and apply
				initialInUnit = initialInUnit / scale;
				jQuery.style( elem, prop, initialInUnit + unit );
	
			// Update scale, tolerating zero or NaN from tween.cur()
			// Break the loop if scale is unchanged or perfect, or if we've just had enough.
			} while (
				scale !== ( scale = currentValue() / initial ) && scale !== 1 && --maxIterations
			);
		}
	
		if ( valueParts ) {
			initialInUnit = +initialInUnit || +initial || 0;
	
			// Apply relative offset (+=/-=) if specified
			adjusted = valueParts[ 1 ] ?
				initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
				+valueParts[ 2 ];
			if ( tween ) {
				tween.unit = unit;
				tween.start = initialInUnit;
				tween.end = adjusted;
			}
		}
		return adjusted;
	}
	
	
	var defaultDisplayMap = {};
	
	function getDefaultDisplay( elem ) {
		var temp,
			doc = elem.ownerDocument,
			nodeName = elem.nodeName,
			display = defaultDisplayMap[ nodeName ];
	
		if ( display ) {
			return display;
		}
	
		temp = doc.body.appendChild( doc.createElement( nodeName ) );
		display = jQuery.css( temp, "display" );
	
		temp.parentNode.removeChild( temp );
	
		if ( display === "none" ) {
			display = "block";
		}
		defaultDisplayMap[ nodeName ] = display;
	
		return display;
	}
	
	function showHide( elements, show ) {
		var display, elem,
			values = [],
			index = 0,
			length = elements.length;
	
		// Determine new display value for elements that need to change
		for ( ; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
	
			display = elem.style.display;
			if ( show ) {
	
				// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
				// check is required in this first loop unless we have a nonempty display value (either
				// inline or about-to-be-restored)
				if ( display === "none" ) {
					values[ index ] = dataPriv.get( elem, "display" ) || null;
					if ( !values[ index ] ) {
						elem.style.display = "";
					}
				}
				if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
					values[ index ] = getDefaultDisplay( elem );
				}
			} else {
				if ( display !== "none" ) {
					values[ index ] = "none";
	
					// Remember what we're overwriting
					dataPriv.set( elem, "display", display );
				}
			}
		}
	
		// Set the display of the elements in a second loop to avoid constant reflow
		for ( index = 0; index < length; index++ ) {
			if ( values[ index ] != null ) {
				elements[ index ].style.display = values[ index ];
			}
		}
	
		return elements;
	}
	
	jQuery.fn.extend( {
		show: function() {
			return showHide( this, true );
		},
		hide: function() {
			return showHide( this );
		},
		toggle: function( state ) {
			if ( typeof state === "boolean" ) {
				return state ? this.show() : this.hide();
			}
	
			return this.each( function() {
				if ( isHiddenWithinTree( this ) ) {
					jQuery( this ).show();
				} else {
					jQuery( this ).hide();
				}
			} );
		}
	} );
	var rcheckableType = ( /^(?:checkbox|radio)$/i );
	
	var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]+)/i );
	
	var rscriptType = ( /^$|\/(?:java|ecma)script/i );
	
	
	
	// We have to close these tags to support XHTML (#13200)
	var wrapMap = {
	
		// Support: IE <=9 only
		option: [ 1, "<select multiple='multiple'>", "</select>" ],
	
		// XHTML parsers do not magically insert elements in the
		// same way that tag soup parsers do. So we cannot shorten
		// this by omitting <tbody> or other required elements.
		thead: [ 1, "<table>", "</table>" ],
		col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
	
		_default: [ 0, "", "" ]
	};
	
	// Support: IE <=9 only
	wrapMap.optgroup = wrapMap.option;
	
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	
	function getAll( context, tag ) {
	
		// Support: IE <=9 - 11 only
		// Use typeof to avoid zero-argument method invocation on host objects (#15151)
		var ret;
	
		if ( typeof context.getElementsByTagName !== "undefined" ) {
			ret = context.getElementsByTagName( tag || "*" );
	
		} else if ( typeof context.querySelectorAll !== "undefined" ) {
			ret = context.querySelectorAll( tag || "*" );
	
		} else {
			ret = [];
		}
	
		if ( tag === undefined || tag && jQuery.nodeName( context, tag ) ) {
			return jQuery.merge( [ context ], ret );
		}
	
		return ret;
	}
	
	
	// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
		var i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			dataPriv.set(
				elems[ i ],
				"globalEval",
				!refElements || dataPriv.get( refElements[ i ], "globalEval" )
			);
		}
	}
	
	
	var rhtml = /<|&#?\w+;/;
	
	function buildFragment( elems, context, scripts, selection, ignored ) {
		var elem, tmp, tag, wrap, contains, j,
			fragment = context.createDocumentFragment(),
			nodes = [],
			i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			elem = elems[ i ];
	
			if ( elem || elem === 0 ) {
	
				// Add nodes directly
				if ( jQuery.type( elem ) === "object" ) {
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );
	
				// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );
	
				// Convert html into DOM nodes
				} else {
					tmp = tmp || fragment.appendChild( context.createElement( "div" ) );
	
					// Deserialize a standard representation
					tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;
					tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];
	
					// Descend through wrappers to the right content
					j = wrap[ 0 ];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, tmp.childNodes );
	
					// Remember the top-level container
					tmp = fragment.firstChild;
	
					// Ensure the created nodes are orphaned (#12392)
					tmp.textContent = "";
				}
			}
		}
	
		// Remove wrapper from fragment
		fragment.textContent = "";
	
		i = 0;
		while ( ( elem = nodes[ i++ ] ) ) {
	
			// Skip elements already in the context collection (trac-4087)
			if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
				if ( ignored ) {
					ignored.push( elem );
				}
				continue;
			}
	
			contains = jQuery.contains( elem.ownerDocument, elem );
	
			// Append to fragment
			tmp = getAll( fragment.appendChild( elem ), "script" );
	
			// Preserve script evaluation history
			if ( contains ) {
				setGlobalEval( tmp );
			}
	
			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( ( elem = tmp[ j++ ] ) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}
	
		return fragment;
	}
	
	
	( function() {
		var fragment = document.createDocumentFragment(),
			div = fragment.appendChild( document.createElement( "div" ) ),
			input = document.createElement( "input" );
	
		// Support: Android 4.0 - 4.3 only
		// Check state lost if the name is set (#11217)
		// Support: Windows Web Apps (WWA)
		// `name` and `type` must use .setAttribute for WWA (#14901)
		input.setAttribute( "type", "radio" );
		input.setAttribute( "checked", "checked" );
		input.setAttribute( "name", "t" );
	
		div.appendChild( input );
	
		// Support: Android <=4.1 only
		// Older WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;
	
		// Support: IE <=11 only
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
	} )();
	var documentElement = document.documentElement;
	
	
	
	var
		rkeyEvent = /^key/,
		rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
		rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
	
	function returnTrue() {
		return true;
	}
	
	function returnFalse() {
		return false;
	}
	
	// Support: IE <=9 only
	// See #13393 for more info
	function safeActiveElement() {
		try {
			return document.activeElement;
		} catch ( err ) { }
	}
	
	function on( elem, types, selector, data, fn, one ) {
		var origFn, type;
	
		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {
	
			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {
	
				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				on( elem, type, selector, data, types[ type ], one );
			}
			return elem;
		}
	
		if ( data == null && fn == null ) {
	
			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {
	
				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {
	
				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return elem;
		}
	
		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {
	
				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};
	
			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return elem.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		} );
	}
	
	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {
	
		global: {},
	
		add: function( elem, types, handler, data, selector ) {
	
			var handleObjIn, eventHandle, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.get( elem );
	
			// Don't attach events to noData or text/comment nodes (but allow plain objects)
			if ( !elemData ) {
				return;
			}
	
			// Caller can pass in an object of custom data in lieu of the handler
			if ( handler.handler ) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}
	
			// Ensure that invalid selectors throw exceptions at attach time
			// Evaluate against documentElement in case elem is a non-element node (e.g., document)
			if ( selector ) {
				jQuery.find.matchesSelector( documentElement, selector );
			}
	
			// Make sure that the handler has a unique ID, used to find/remove it later
			if ( !handler.guid ) {
				handler.guid = jQuery.guid++;
			}
	
			// Init the element's event structure and main handler, if this is the first
			if ( !( events = elemData.events ) ) {
				events = elemData.events = {};
			}
			if ( !( eventHandle = elemData.handle ) ) {
				eventHandle = elemData.handle = function( e ) {
	
					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
						jQuery.event.dispatch.apply( elem, arguments ) : undefined;
				};
			}
	
			// Handle multiple events separated by a space
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// There *must* be a type, no attaching namespace-only handlers
				if ( !type ) {
					continue;
				}
	
				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[ type ] || {};
	
				// If selector defined, determine special event api type, otherwise given type
				type = ( selector ? special.delegateType : special.bindType ) || type;
	
				// Update special based on newly reset type
				special = jQuery.event.special[ type ] || {};
	
				// handleObj is passed to all event handlers
				handleObj = jQuery.extend( {
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
					namespace: namespaces.join( "." )
				}, handleObjIn );
	
				// Init the event handler queue if we're the first
				if ( !( handlers = events[ type ] ) ) {
					handlers = events[ type ] = [];
					handlers.delegateCount = 0;
	
					// Only use addEventListener if the special events handler returns false
					if ( !special.setup ||
						special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
	
						if ( elem.addEventListener ) {
							elem.addEventListener( type, eventHandle );
						}
					}
				}
	
				if ( special.add ) {
					special.add.call( elem, handleObj );
	
					if ( !handleObj.handler.guid ) {
						handleObj.handler.guid = handler.guid;
					}
				}
	
				// Add to the element's handler list, delegates in front
				if ( selector ) {
					handlers.splice( handlers.delegateCount++, 0, handleObj );
				} else {
					handlers.push( handleObj );
				}
	
				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[ type ] = true;
			}
	
		},
	
		// Detach an event or set of events from an element
		remove: function( elem, types, handler, selector, mappedTypes ) {
	
			var j, origCount, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );
	
			if ( !elemData || !( events = elemData.events ) ) {
				return;
			}
	
			// Once for each type.namespace in types; type may be omitted
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// Unbind all events (on this namespace, if provided) for the element
				if ( !type ) {
					for ( type in events ) {
						jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
					}
					continue;
				}
	
				special = jQuery.event.special[ type ] || {};
				type = ( selector ? special.delegateType : special.bindType ) || type;
				handlers = events[ type ] || [];
				tmp = tmp[ 2 ] &&
					new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );
	
				// Remove matching events
				origCount = j = handlers.length;
				while ( j-- ) {
					handleObj = handlers[ j ];
	
					if ( ( mappedTypes || origType === handleObj.origType ) &&
						( !handler || handler.guid === handleObj.guid ) &&
						( !tmp || tmp.test( handleObj.namespace ) ) &&
						( !selector || selector === handleObj.selector ||
							selector === "**" && handleObj.selector ) ) {
						handlers.splice( j, 1 );
	
						if ( handleObj.selector ) {
							handlers.delegateCount--;
						}
						if ( special.remove ) {
							special.remove.call( elem, handleObj );
						}
					}
				}
	
				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if ( origCount && !handlers.length ) {
					if ( !special.teardown ||
						special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
	
						jQuery.removeEvent( elem, type, elemData.handle );
					}
	
					delete events[ type ];
				}
			}
	
			// Remove data and the expando if it's no longer used
			if ( jQuery.isEmptyObject( events ) ) {
				dataPriv.remove( elem, "handle events" );
			}
		},
	
		dispatch: function( nativeEvent ) {
	
			// Make a writable jQuery.Event from the native event object
			var event = jQuery.event.fix( nativeEvent );
	
			var i, j, ret, matched, handleObj, handlerQueue,
				args = new Array( arguments.length ),
				handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
				special = jQuery.event.special[ event.type ] || {};
	
			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[ 0 ] = event;
	
			for ( i = 1; i < arguments.length; i++ ) {
				args[ i ] = arguments[ i ];
			}
	
			event.delegateTarget = this;
	
			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
				return;
			}
	
			// Determine handlers
			handlerQueue = jQuery.event.handlers.call( this, event, handlers );
	
			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
				event.currentTarget = matched.elem;
	
				j = 0;
				while ( ( handleObj = matched.handlers[ j++ ] ) &&
					!event.isImmediatePropagationStopped() ) {
	
					// Triggered event must either 1) have no namespace, or 2) have namespace(s)
					// a subset or equal to those in the bound event (both can have no namespace).
					if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {
	
						event.handleObj = handleObj;
						event.data = handleObj.data;
	
						ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
							handleObj.handler ).apply( matched.elem, args );
	
						if ( ret !== undefined ) {
							if ( ( event.result = ret ) === false ) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}
	
			// Call the postDispatch hook for the mapped type
			if ( special.postDispatch ) {
				special.postDispatch.call( this, event );
			}
	
			return event.result;
		},
	
		handlers: function( event, handlers ) {
			var i, handleObj, sel, matchedHandlers, matchedSelectors,
				handlerQueue = [],
				delegateCount = handlers.delegateCount,
				cur = event.target;
	
			// Find delegate handlers
			if ( delegateCount &&
	
				// Support: IE <=9
				// Black-hole SVG <use> instance trees (trac-13180)
				cur.nodeType &&
	
				// Support: Firefox <=42
				// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
				// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
				// Support: IE 11 only
				// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
				!( event.type === "click" && event.button >= 1 ) ) {
	
				for ( ; cur !== this; cur = cur.parentNode || this ) {
	
					// Don't check non-elements (#13208)
					// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
					if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
						matchedHandlers = [];
						matchedSelectors = {};
						for ( i = 0; i < delegateCount; i++ ) {
							handleObj = handlers[ i ];
	
							// Don't conflict with Object.prototype properties (#13203)
							sel = handleObj.selector + " ";
	
							if ( matchedSelectors[ sel ] === undefined ) {
								matchedSelectors[ sel ] = handleObj.needsContext ?
									jQuery( sel, this ).index( cur ) > -1 :
									jQuery.find( sel, this, null, [ cur ] ).length;
							}
							if ( matchedSelectors[ sel ] ) {
								matchedHandlers.push( handleObj );
							}
						}
						if ( matchedHandlers.length ) {
							handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
						}
					}
				}
			}
	
			// Add the remaining (directly-bound) handlers
			cur = this;
			if ( delegateCount < handlers.length ) {
				handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
			}
	
			return handlerQueue;
		},
	
		addProp: function( name, hook ) {
			Object.defineProperty( jQuery.Event.prototype, name, {
				enumerable: true,
				configurable: true,
	
				get: jQuery.isFunction( hook ) ?
					function() {
						if ( this.originalEvent ) {
								return hook( this.originalEvent );
						}
					} :
					function() {
						if ( this.originalEvent ) {
								return this.originalEvent[ name ];
						}
					},
	
				set: function( value ) {
					Object.defineProperty( this, name, {
						enumerable: true,
						configurable: true,
						writable: true,
						value: value
					} );
				}
			} );
		},
	
		fix: function( originalEvent ) {
			return originalEvent[ jQuery.expando ] ?
				originalEvent :
				new jQuery.Event( originalEvent );
		},
	
		special: {
			load: {
	
				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			focus: {
	
				// Fire native event if possible so blur/focus sequence is correct
				trigger: function() {
					if ( this !== safeActiveElement() && this.focus ) {
						this.focus();
						return false;
					}
				},
				delegateType: "focusin"
			},
			blur: {
				trigger: function() {
					if ( this === safeActiveElement() && this.blur ) {
						this.blur();
						return false;
					}
				},
				delegateType: "focusout"
			},
			click: {
	
				// For checkbox, fire native event so checked state will be right
				trigger: function() {
					if ( this.type === "checkbox" && this.click && jQuery.nodeName( this, "input" ) ) {
						this.click();
						return false;
					}
				},
	
				// For cross-browser consistency, don't fire native .click() on links
				_default: function( event ) {
					return jQuery.nodeName( event.target, "a" );
				}
			},
	
			beforeunload: {
				postDispatch: function( event ) {
	
					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if ( event.result !== undefined && event.originalEvent ) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		}
	};
	
	jQuery.removeEvent = function( elem, type, handle ) {
	
		// This "if" is needed for plain objects
		if ( elem.removeEventListener ) {
			elem.removeEventListener( type, handle );
		}
	};
	
	jQuery.Event = function( src, props ) {
	
		// Allow instantiation without the 'new' keyword
		if ( !( this instanceof jQuery.Event ) ) {
			return new jQuery.Event( src, props );
		}
	
		// Event object
		if ( src && src.type ) {
			this.originalEvent = src;
			this.type = src.type;
	
			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented ||
					src.defaultPrevented === undefined &&
	
					// Support: Android <=2.3 only
					src.returnValue === false ?
				returnTrue :
				returnFalse;
	
			// Create target properties
			// Support: Safari <=6 - 7 only
			// Target should not be a text node (#504, #13143)
			this.target = ( src.target && src.target.nodeType === 3 ) ?
				src.target.parentNode :
				src.target;
	
			this.currentTarget = src.currentTarget;
			this.relatedTarget = src.relatedTarget;
	
		// Event type
		} else {
			this.type = src;
		}
	
		// Put explicitly provided properties onto the event object
		if ( props ) {
			jQuery.extend( this, props );
		}
	
		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || jQuery.now();
	
		// Mark it as fixed
		this[ jQuery.expando ] = true;
	};
	
	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		constructor: jQuery.Event,
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
		isSimulated: false,
	
		preventDefault: function() {
			var e = this.originalEvent;
	
			this.isDefaultPrevented = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.preventDefault();
			}
		},
		stopPropagation: function() {
			var e = this.originalEvent;
	
			this.isPropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopPropagation();
			}
		},
		stopImmediatePropagation: function() {
			var e = this.originalEvent;
	
			this.isImmediatePropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopImmediatePropagation();
			}
	
			this.stopPropagation();
		}
	};
	
	// Includes all common event props including KeyEvent and MouseEvent specific props
	jQuery.each( {
		altKey: true,
		bubbles: true,
		cancelable: true,
		changedTouches: true,
		ctrlKey: true,
		detail: true,
		eventPhase: true,
		metaKey: true,
		pageX: true,
		pageY: true,
		shiftKey: true,
		view: true,
		"char": true,
		charCode: true,
		key: true,
		keyCode: true,
		button: true,
		buttons: true,
		clientX: true,
		clientY: true,
		offsetX: true,
		offsetY: true,
		pointerId: true,
		pointerType: true,
		screenX: true,
		screenY: true,
		targetTouches: true,
		toElement: true,
		touches: true,
	
		which: function( event ) {
			var button = event.button;
	
			// Add which for key events
			if ( event.which == null && rkeyEvent.test( event.type ) ) {
				return event.charCode != null ? event.charCode : event.keyCode;
			}
	
			// Add which for click: 1 === left; 2 === middle; 3 === right
			if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
				if ( button & 1 ) {
					return 1;
				}
	
				if ( button & 2 ) {
					return 3;
				}
	
				if ( button & 4 ) {
					return 2;
				}
	
				return 0;
			}
	
			return event.which;
		}
	}, jQuery.event.addProp );
	
	// Create mouseenter/leave events using mouseover/out and event-time checks
	// so that event delegation works in jQuery.
	// Do the same for pointerenter/pointerleave and pointerover/pointerout
	//
	// Support: Safari 7 only
	// Safari sends mouseenter too often; see:
	// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
	// for the description of the bug (it existed in older Chrome versions as well).
	jQuery.each( {
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function( orig, fix ) {
		jQuery.event.special[ orig ] = {
			delegateType: fix,
			bindType: fix,
	
			handle: function( event ) {
				var ret,
					target = this,
					related = event.relatedTarget,
					handleObj = event.handleObj;
	
				// For mouseenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply( this, arguments );
					event.type = fix;
				}
				return ret;
			}
		};
	} );
	
	jQuery.fn.extend( {
	
		on: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn );
		},
		one: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn, 1 );
		},
		off: function( types, selector, fn ) {
			var handleObj, type;
			if ( types && types.preventDefault && types.handleObj ) {
	
				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery( types.delegateTarget ).off(
					handleObj.namespace ?
						handleObj.origType + "." + handleObj.namespace :
						handleObj.origType,
					handleObj.selector,
					handleObj.handler
				);
				return this;
			}
			if ( typeof types === "object" ) {
	
				// ( types-object [, selector] )
				for ( type in types ) {
					this.off( type, selector, types[ type ] );
				}
				return this;
			}
			if ( selector === false || typeof selector === "function" ) {
	
				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if ( fn === false ) {
				fn = returnFalse;
			}
			return this.each( function() {
				jQuery.event.remove( this, types, fn, selector );
			} );
		}
	} );
	
	
	var
	
		/* eslint-disable max-len */
	
		// See https://github.com/eslint/eslint/issues/3229
		rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,
	
		/* eslint-enable */
	
		// Support: IE <=10 - 11, Edge 12 - 13
		// In IE/Edge using regex groups here causes severe slowdowns.
		// See https://connect.microsoft.com/IE/feedback/details/1736512/
		rnoInnerhtml = /<script|<style|<link/i,
	
		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
		rscriptTypeMasked = /^true\/(.*)/,
		rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
	
	function manipulationTarget( elem, content ) {
		if ( jQuery.nodeName( elem, "table" ) &&
			jQuery.nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {
	
			return elem.getElementsByTagName( "tbody" )[ 0 ] || elem;
		}
	
		return elem;
	}
	
	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
		elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
		return elem;
	}
	function restoreScript( elem ) {
		var match = rscriptTypeMasked.exec( elem.type );
	
		if ( match ) {
			elem.type = match[ 1 ];
		} else {
			elem.removeAttribute( "type" );
		}
	
		return elem;
	}
	
	function cloneCopyEvent( src, dest ) {
		var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;
	
		if ( dest.nodeType !== 1 ) {
			return;
		}
	
		// 1. Copy private data: events, handlers, etc.
		if ( dataPriv.hasData( src ) ) {
			pdataOld = dataPriv.access( src );
			pdataCur = dataPriv.set( dest, pdataOld );
			events = pdataOld.events;
	
			if ( events ) {
				delete pdataCur.handle;
				pdataCur.events = {};
	
				for ( type in events ) {
					for ( i = 0, l = events[ type ].length; i < l; i++ ) {
						jQuery.event.add( dest, type, events[ type ][ i ] );
					}
				}
			}
		}
	
		// 2. Copy user data
		if ( dataUser.hasData( src ) ) {
			udataOld = dataUser.access( src );
			udataCur = jQuery.extend( {}, udataOld );
	
			dataUser.set( dest, udataCur );
		}
	}
	
	// Fix IE bugs, see support tests
	function fixInput( src, dest ) {
		var nodeName = dest.nodeName.toLowerCase();
	
		// Fails to persist the checked state of a cloned checkbox or radio button.
		if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
			dest.checked = src.checked;
	
		// Fails to return the selected option to the default selected state when cloning options
		} else if ( nodeName === "input" || nodeName === "textarea" ) {
			dest.defaultValue = src.defaultValue;
		}
	}
	
	function domManip( collection, args, callback, ignored ) {
	
		// Flatten any nested arrays
		args = concat.apply( [], args );
	
		var fragment, first, scripts, hasScripts, node, doc,
			i = 0,
			l = collection.length,
			iNoClone = l - 1,
			value = args[ 0 ],
			isFunction = jQuery.isFunction( value );
	
		// We can't cloneNode fragments that contain checked, in WebKit
		if ( isFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
			return collection.each( function( index ) {
				var self = collection.eq( index );
				if ( isFunction ) {
					args[ 0 ] = value.call( this, index, self.html() );
				}
				domManip( self, args, callback, ignored );
			} );
		}
	
		if ( l ) {
			fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
			first = fragment.firstChild;
	
			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}
	
			// Require either new content or an interest in ignored elements to invoke the callback
			if ( first || ignored ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;
	
				// Use the original fragment for the last item
				// instead of the first because it can end up
				// being emptied incorrectly in certain situations (#8070).
				for ( ; i < l; i++ ) {
					node = fragment;
	
					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );
	
						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {
	
							// Support: Android <=4.0 only, PhantomJS 1 only
							// push.apply(_, arraylike) throws on ancient WebKit
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}
	
					callback.call( collection[ i ], node, i );
				}
	
				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;
	
					// Reenable scripts
					jQuery.map( scripts, restoreScript );
	
					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
							!dataPriv.access( node, "globalEval" ) &&
							jQuery.contains( doc, node ) ) {
	
							if ( node.src ) {
	
								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl ) {
									jQuery._evalUrl( node.src );
								}
							} else {
								DOMEval( node.textContent.replace( rcleanScript, "" ), doc );
							}
						}
					}
				}
			}
		}
	
		return collection;
	}
	
	function remove( elem, selector, keepData ) {
		var node,
			nodes = selector ? jQuery.filter( selector, elem ) : elem,
			i = 0;
	
		for ( ; ( node = nodes[ i ] ) != null; i++ ) {
			if ( !keepData && node.nodeType === 1 ) {
				jQuery.cleanData( getAll( node ) );
			}
	
			if ( node.parentNode ) {
				if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
					setGlobalEval( getAll( node, "script" ) );
				}
				node.parentNode.removeChild( node );
			}
		}
	
		return elem;
	}
	
	jQuery.extend( {
		htmlPrefilter: function( html ) {
			return html.replace( rxhtmlTag, "<$1></$2>" );
		},
	
		clone: function( elem, dataAndEvents, deepDataAndEvents ) {
			var i, l, srcElements, destElements,
				clone = elem.cloneNode( true ),
				inPage = jQuery.contains( elem.ownerDocument, elem );
	
			// Fix IE cloning issues
			if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
					!jQuery.isXMLDoc( elem ) ) {
	
				// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
				destElements = getAll( clone );
				srcElements = getAll( elem );
	
				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					fixInput( srcElements[ i ], destElements[ i ] );
				}
			}
	
			// Copy the events from the original to the clone
			if ( dataAndEvents ) {
				if ( deepDataAndEvents ) {
					srcElements = srcElements || getAll( elem );
					destElements = destElements || getAll( clone );
	
					for ( i = 0, l = srcElements.length; i < l; i++ ) {
						cloneCopyEvent( srcElements[ i ], destElements[ i ] );
					}
				} else {
					cloneCopyEvent( elem, clone );
				}
			}
	
			// Preserve script evaluation history
			destElements = getAll( clone, "script" );
			if ( destElements.length > 0 ) {
				setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
			}
	
			// Return the cloned set
			return clone;
		},
	
		cleanData: function( elems ) {
			var data, elem, type,
				special = jQuery.event.special,
				i = 0;
	
			for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
				if ( acceptData( elem ) ) {
					if ( ( data = elem[ dataPriv.expando ] ) ) {
						if ( data.events ) {
							for ( type in data.events ) {
								if ( special[ type ] ) {
									jQuery.event.remove( elem, type );
	
								// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent( elem, type, data.handle );
								}
							}
						}
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataPriv.expando ] = undefined;
					}
					if ( elem[ dataUser.expando ] ) {
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataUser.expando ] = undefined;
					}
				}
			}
		}
	} );
	
	jQuery.fn.extend( {
		detach: function( selector ) {
			return remove( this, selector, true );
		},
	
		remove: function( selector ) {
			return remove( this, selector );
		},
	
		text: function( value ) {
			return access( this, function( value ) {
				return value === undefined ?
					jQuery.text( this ) :
					this.empty().each( function() {
						if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
							this.textContent = value;
						}
					} );
			}, null, value, arguments.length );
		},
	
		append: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.appendChild( elem );
				}
			} );
		},
	
		prepend: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.insertBefore( elem, target.firstChild );
				}
			} );
		},
	
		before: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this );
				}
			} );
		},
	
		after: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this.nextSibling );
				}
			} );
		},
	
		empty: function() {
			var elem,
				i = 0;
	
			for ( ; ( elem = this[ i ] ) != null; i++ ) {
				if ( elem.nodeType === 1 ) {
	
					// Prevent memory leaks
					jQuery.cleanData( getAll( elem, false ) );
	
					// Remove any remaining nodes
					elem.textContent = "";
				}
			}
	
			return this;
		},
	
		clone: function( dataAndEvents, deepDataAndEvents ) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
	
			return this.map( function() {
				return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
			} );
		},
	
		html: function( value ) {
			return access( this, function( value ) {
				var elem = this[ 0 ] || {},
					i = 0,
					l = this.length;
	
				if ( value === undefined && elem.nodeType === 1 ) {
					return elem.innerHTML;
				}
	
				// See if we can take a shortcut and just use innerHTML
				if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
					!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {
	
					value = jQuery.htmlPrefilter( value );
	
					try {
						for ( ; i < l; i++ ) {
							elem = this[ i ] || {};
	
							// Remove element nodes and prevent memory leaks
							if ( elem.nodeType === 1 ) {
								jQuery.cleanData( getAll( elem, false ) );
								elem.innerHTML = value;
							}
						}
	
						elem = 0;
	
					// If using innerHTML throws an exception, use the fallback method
					} catch ( e ) {}
				}
	
				if ( elem ) {
					this.empty().append( value );
				}
			}, null, value, arguments.length );
		},
	
		replaceWith: function() {
			var ignored = [];
	
			// Make the changes, replacing each non-ignored context element with the new content
			return domManip( this, arguments, function( elem ) {
				var parent = this.parentNode;
	
				if ( jQuery.inArray( this, ignored ) < 0 ) {
					jQuery.cleanData( getAll( this ) );
					if ( parent ) {
						parent.replaceChild( elem, this );
					}
				}
	
			// Force callback invocation
			}, ignored );
		}
	} );
	
	jQuery.each( {
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function( name, original ) {
		jQuery.fn[ name ] = function( selector ) {
			var elems,
				ret = [],
				insert = jQuery( selector ),
				last = insert.length - 1,
				i = 0;
	
			for ( ; i <= last; i++ ) {
				elems = i === last ? this : this.clone( true );
				jQuery( insert[ i ] )[ original ]( elems );
	
				// Support: Android <=4.0 only, PhantomJS 1 only
				// .get() because push.apply(_, arraylike) throws on ancient WebKit
				push.apply( ret, elems.get() );
			}
	
			return this.pushStack( ret );
		};
	} );
	var rmargin = ( /^margin/ );
	
	var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
	
	var getStyles = function( elem ) {
	
			// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
			// IE throws on elements created in popups
			// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
			var view = elem.ownerDocument.defaultView;
	
			if ( !view || !view.opener ) {
				view = window;
			}
	
			return view.getComputedStyle( elem );
		};
	
	
	
	( function() {
	
		// Executing both pixelPosition & boxSizingReliable tests require only one layout
		// so they're executed at the same time to save the second computation.
		function computeStyleTests() {
	
			// This is a singleton, we need to execute it only once
			if ( !div ) {
				return;
			}
	
			div.style.cssText =
				"box-sizing:border-box;" +
				"position:relative;display:block;" +
				"margin:auto;border:1px;padding:1px;" +
				"top:1%;width:50%";
			div.innerHTML = "";
			documentElement.appendChild( container );
	
			var divStyle = window.getComputedStyle( div );
			pixelPositionVal = divStyle.top !== "1%";
	
			// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
			reliableMarginLeftVal = divStyle.marginLeft === "2px";
			boxSizingReliableVal = divStyle.width === "4px";
	
			// Support: Android 4.0 - 4.3 only
			// Some styles come back with percentage values, even though they shouldn't
			div.style.marginRight = "50%";
			pixelMarginRightVal = divStyle.marginRight === "4px";
	
			documentElement.removeChild( container );
	
			// Nullify the div so it wouldn't be stored in the memory and
			// it will also be a sign that checks already performed
			div = null;
		}
	
		var pixelPositionVal, boxSizingReliableVal, pixelMarginRightVal, reliableMarginLeftVal,
			container = document.createElement( "div" ),
			div = document.createElement( "div" );
	
		// Finish early in limited (non-browser) environments
		if ( !div.style ) {
			return;
		}
	
		// Support: IE <=9 - 11 only
		// Style of cloned element affects source element cloned (#8908)
		div.style.backgroundClip = "content-box";
		div.cloneNode( true ).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";
	
		container.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;" +
			"padding:0;margin-top:1px;position:absolute";
		container.appendChild( div );
	
		jQuery.extend( support, {
			pixelPosition: function() {
				computeStyleTests();
				return pixelPositionVal;
			},
			boxSizingReliable: function() {
				computeStyleTests();
				return boxSizingReliableVal;
			},
			pixelMarginRight: function() {
				computeStyleTests();
				return pixelMarginRightVal;
			},
			reliableMarginLeft: function() {
				computeStyleTests();
				return reliableMarginLeftVal;
			}
		} );
	} )();
	
	
	function curCSS( elem, name, computed ) {
		var width, minWidth, maxWidth, ret,
			style = elem.style;
	
		computed = computed || getStyles( elem );
	
		// Support: IE <=9 only
		// getPropertyValue is only needed for .css('filter') (#12537)
		if ( computed ) {
			ret = computed.getPropertyValue( name ) || computed[ name ];
	
			if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
				ret = jQuery.style( elem, name );
			}
	
			// A tribute to the "awesome hack by Dean Edwards"
			// Android Browser returns percentage for some values,
			// but width seems to be reliably pixels.
			// This is against the CSSOM draft spec:
			// https://drafts.csswg.org/cssom/#resolved-values
			if ( !support.pixelMarginRight() && rnumnonpx.test( ret ) && rmargin.test( name ) ) {
	
				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;
	
				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;
	
				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}
	
		return ret !== undefined ?
	
			// Support: IE <=9 - 11 only
			// IE returns zIndex value as an integer.
			ret + "" :
			ret;
	}
	
	
	function addGetHookIf( conditionFn, hookFn ) {
	
		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function() {
				if ( conditionFn() ) {
	
					// Hook not needed (or it's not possible to use it due
					// to missing dependency), remove it.
					delete this.get;
					return;
				}
	
				// Hook needed; redefine it so that the support test is not executed again.
				return ( this.get = hookFn ).apply( this, arguments );
			}
		};
	}
	
	
	var
	
		// Swappable if display is none or starts with table
		// except "table", "table-cell", or "table-caption"
		// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
		cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		},
	
		cssPrefixes = [ "Webkit", "Moz", "ms" ],
		emptyStyle = document.createElement( "div" ).style;
	
	// Return a css property mapped to a potentially vendor prefixed property
	function vendorPropName( name ) {
	
		// Shortcut for names that are not vendor prefixed
		if ( name in emptyStyle ) {
			return name;
		}
	
		// Check for vendor prefixed names
		var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
			i = cssPrefixes.length;
	
		while ( i-- ) {
			name = cssPrefixes[ i ] + capName;
			if ( name in emptyStyle ) {
				return name;
			}
		}
	}
	
	function setPositiveNumber( elem, value, subtract ) {
	
		// Any relative (+/-) values have already been
		// normalized at this point
		var matches = rcssNum.exec( value );
		return matches ?
	
			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
			value;
	}
	
	function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
		var i,
			val = 0;
	
		// If we already have the right measurement, avoid augmentation
		if ( extra === ( isBorderBox ? "border" : "content" ) ) {
			i = 4;
	
		// Otherwise initialize for horizontal or vertical properties
		} else {
			i = name === "width" ? 1 : 0;
		}
	
		for ( ; i < 4; i += 2 ) {
	
			// Both box models exclude margin, so add it if we want it
			if ( extra === "margin" ) {
				val += jQuery.css( elem, extra + cssExpand[ i ], true, styles );
			}
	
			if ( isBorderBox ) {
	
				// border-box includes padding, so remove it if we want content
				if ( extra === "content" ) {
					val -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
				}
	
				// At this point, extra isn't border nor margin, so remove border
				if ( extra !== "margin" ) {
					val -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			} else {
	
				// At this point, extra isn't content, so add padding
				val += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
	
				// At this point, extra isn't content nor padding, so add border
				if ( extra !== "padding" ) {
					val += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			}
		}
	
		return val;
	}
	
	function getWidthOrHeight( elem, name, extra ) {
	
		// Start with offset property, which is equivalent to the border-box value
		var val,
			valueIsBorderBox = true,
			styles = getStyles( elem ),
			isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";
	
		// Support: IE <=11 only
		// Running getBoundingClientRect on a disconnected node
		// in IE throws an error.
		if ( elem.getClientRects().length ) {
			val = elem.getBoundingClientRect()[ name ];
		}
	
		// Some non-html elements return undefined for offsetWidth, so check for null/undefined
		// svg - https://bugzilla.mozilla.org/show_bug.cgi?id=649285
		// MathML - https://bugzilla.mozilla.org/show_bug.cgi?id=491668
		if ( val <= 0 || val == null ) {
	
			// Fall back to computed then uncomputed css if necessary
			val = curCSS( elem, name, styles );
			if ( val < 0 || val == null ) {
				val = elem.style[ name ];
			}
	
			// Computed unit is not pixels. Stop here and return.
			if ( rnumnonpx.test( val ) ) {
				return val;
			}
	
			// Check for style in case a browser which returns unreliable values
			// for getComputedStyle silently falls back to the reliable elem.style
			valueIsBorderBox = isBorderBox &&
				( support.boxSizingReliable() || val === elem.style[ name ] );
	
			// Normalize "", auto, and prepare for extra
			val = parseFloat( val ) || 0;
		}
	
		// Use the active box-sizing model to add/subtract irrelevant styles
		return ( val +
			augmentWidthOrHeight(
				elem,
				name,
				extra || ( isBorderBox ? "border" : "content" ),
				valueIsBorderBox,
				styles
			)
		) + "px";
	}
	
	jQuery.extend( {
	
		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function( elem, computed ) {
					if ( computed ) {
	
						// We should always get a number back from opacity
						var ret = curCSS( elem, "opacity" );
						return ret === "" ? "1" : ret;
					}
				}
			}
		},
	
		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			"animationIterationCount": true,
			"columnCount": true,
			"fillOpacity": true,
			"flexGrow": true,
			"flexShrink": true,
			"fontWeight": true,
			"lineHeight": true,
			"opacity": true,
			"order": true,
			"orphans": true,
			"widows": true,
			"zIndex": true,
			"zoom": true
		},
	
		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {
			"float": "cssFloat"
		},
	
		// Get and set the style property on a DOM Node
		style: function( elem, name, value, extra ) {
	
			// Don't set styles on text and comment nodes
			if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
				return;
			}
	
			// Make sure that we're working with the right name
			var ret, type, hooks,
				origName = jQuery.camelCase( name ),
				style = elem.style;
	
			name = jQuery.cssProps[ origName ] ||
				( jQuery.cssProps[ origName ] = vendorPropName( origName ) || origName );
	
			// Gets hook for the prefixed version, then unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// Check if we're setting a value
			if ( value !== undefined ) {
				type = typeof value;
	
				// Convert "+=" or "-=" to relative numbers (#7345)
				if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
					value = adjustCSS( elem, name, ret );
	
					// Fixes bug #9237
					type = "number";
				}
	
				// Make sure that null and NaN values aren't set (#7116)
				if ( value == null || value !== value ) {
					return;
				}
	
				// If a number was passed in, add the unit (except for certain CSS properties)
				if ( type === "number" ) {
					value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
				}
	
				// background-* props affect original clone's values
				if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
					style[ name ] = "inherit";
				}
	
				// If a hook was provided, use that value, otherwise just set the specified value
				if ( !hooks || !( "set" in hooks ) ||
					( value = hooks.set( elem, value, extra ) ) !== undefined ) {
	
					style[ name ] = value;
				}
	
			} else {
	
				// If a hook was provided get the non-computed value from there
				if ( hooks && "get" in hooks &&
					( ret = hooks.get( elem, false, extra ) ) !== undefined ) {
	
					return ret;
				}
	
				// Otherwise just get the value from the style object
				return style[ name ];
			}
		},
	
		css: function( elem, name, extra, styles ) {
			var val, num, hooks,
				origName = jQuery.camelCase( name );
	
			// Make sure that we're working with the right name
			name = jQuery.cssProps[ origName ] ||
				( jQuery.cssProps[ origName ] = vendorPropName( origName ) || origName );
	
			// Try prefixed name followed by the unprefixed name
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// If a hook was provided get the computed value from there
			if ( hooks && "get" in hooks ) {
				val = hooks.get( elem, true, extra );
			}
	
			// Otherwise, if a way to get the computed value exists, use that
			if ( val === undefined ) {
				val = curCSS( elem, name, styles );
			}
	
			// Convert "normal" to computed value
			if ( val === "normal" && name in cssNormalTransform ) {
				val = cssNormalTransform[ name ];
			}
	
			// Make numeric if forced or a qualifier was provided and val looks numeric
			if ( extra === "" || extra ) {
				num = parseFloat( val );
				return extra === true || isFinite( num ) ? num || 0 : val;
			}
			return val;
		}
	} );
	
	jQuery.each( [ "height", "width" ], function( i, name ) {
		jQuery.cssHooks[ name ] = {
			get: function( elem, computed, extra ) {
				if ( computed ) {
	
					// Certain elements can have dimension info if we invisibly show them
					// but it must have a current display style that would benefit
					return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
	
						// Support: Safari 8+
						// Table columns in Safari have non-zero offsetWidth & zero
						// getBoundingClientRect().width unless display is changed.
						// Support: IE <=11 only
						// Running getBoundingClientRect on a disconnected node
						// in IE throws an error.
						( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
							swap( elem, cssShow, function() {
								return getWidthOrHeight( elem, name, extra );
							} ) :
							getWidthOrHeight( elem, name, extra );
				}
			},
	
			set: function( elem, value, extra ) {
				var matches,
					styles = extra && getStyles( elem ),
					subtract = extra && augmentWidthOrHeight(
						elem,
						name,
						extra,
						jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
						styles
					);
	
				// Convert to pixels if value adjustment is needed
				if ( subtract && ( matches = rcssNum.exec( value ) ) &&
					( matches[ 3 ] || "px" ) !== "px" ) {
	
					elem.style[ name ] = value;
					value = jQuery.css( elem, name );
				}
	
				return setPositiveNumber( elem, value, subtract );
			}
		};
	} );
	
	jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
		function( elem, computed ) {
			if ( computed ) {
				return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
					elem.getBoundingClientRect().left -
						swap( elem, { marginLeft: 0 }, function() {
							return elem.getBoundingClientRect().left;
						} )
					) + "px";
			}
		}
	);
	
	// These hooks are used by animate to expand properties
	jQuery.each( {
		margin: "",
		padding: "",
		border: "Width"
	}, function( prefix, suffix ) {
		jQuery.cssHooks[ prefix + suffix ] = {
			expand: function( value ) {
				var i = 0,
					expanded = {},
	
					// Assumes a single number if not a string
					parts = typeof value === "string" ? value.split( " " ) : [ value ];
	
				for ( ; i < 4; i++ ) {
					expanded[ prefix + cssExpand[ i ] + suffix ] =
						parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
				}
	
				return expanded;
			}
		};
	
		if ( !rmargin.test( prefix ) ) {
			jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
		}
	} );
	
	jQuery.fn.extend( {
		css: function( name, value ) {
			return access( this, function( elem, name, value ) {
				var styles, len,
					map = {},
					i = 0;
	
				if ( jQuery.isArray( name ) ) {
					styles = getStyles( elem );
					len = name.length;
	
					for ( ; i < len; i++ ) {
						map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
					}
	
					return map;
				}
	
				return value !== undefined ?
					jQuery.style( elem, name, value ) :
					jQuery.css( elem, name );
			}, name, value, arguments.length > 1 );
		}
	} );
	
	
	function Tween( elem, options, prop, end, easing ) {
		return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;
	
	Tween.prototype = {
		constructor: Tween,
		init: function( elem, options, prop, end, easing, unit ) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || jQuery.easing._default;
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
		},
		cur: function() {
			var hooks = Tween.propHooks[ this.prop ];
	
			return hooks && hooks.get ?
				hooks.get( this ) :
				Tween.propHooks._default.get( this );
		},
		run: function( percent ) {
			var eased,
				hooks = Tween.propHooks[ this.prop ];
	
			if ( this.options.duration ) {
				this.pos = eased = jQuery.easing[ this.easing ](
					percent, this.options.duration * percent, 0, 1, this.options.duration
				);
			} else {
				this.pos = eased = percent;
			}
			this.now = ( this.end - this.start ) * eased + this.start;
	
			if ( this.options.step ) {
				this.options.step.call( this.elem, this.now, this );
			}
	
			if ( hooks && hooks.set ) {
				hooks.set( this );
			} else {
				Tween.propHooks._default.set( this );
			}
			return this;
		}
	};
	
	Tween.prototype.init.prototype = Tween.prototype;
	
	Tween.propHooks = {
		_default: {
			get: function( tween ) {
				var result;
	
				// Use a property on the element directly when it is not a DOM element,
				// or when there is no matching style property that exists.
				if ( tween.elem.nodeType !== 1 ||
					tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
					return tween.elem[ tween.prop ];
				}
	
				// Passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails.
				// Simple values such as "10px" are parsed to Float;
				// complex values such as "rotate(1rad)" are returned as-is.
				result = jQuery.css( tween.elem, tween.prop, "" );
	
				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function( tween ) {
	
				// Use step hook for back compat.
				// Use cssHook if its there.
				// Use .style if available and use plain properties where available.
				if ( jQuery.fx.step[ tween.prop ] ) {
					jQuery.fx.step[ tween.prop ]( tween );
				} else if ( tween.elem.nodeType === 1 &&
					( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
						jQuery.cssHooks[ tween.prop ] ) ) {
					jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
				} else {
					tween.elem[ tween.prop ] = tween.now;
				}
			}
		}
	};
	
	// Support: IE <=9 only
	// Panic based approach to setting things on disconnected nodes
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function( tween ) {
			if ( tween.elem.nodeType && tween.elem.parentNode ) {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	};
	
	jQuery.easing = {
		linear: function( p ) {
			return p;
		},
		swing: function( p ) {
			return 0.5 - Math.cos( p * Math.PI ) / 2;
		},
		_default: "swing"
	};
	
	jQuery.fx = Tween.prototype.init;
	
	// Back compat <1.8 extension point
	jQuery.fx.step = {};
	
	
	
	
	var
		fxNow, timerId,
		rfxtypes = /^(?:toggle|show|hide)$/,
		rrun = /queueHooks$/;
	
	function raf() {
		if ( timerId ) {
			window.requestAnimationFrame( raf );
			jQuery.fx.tick();
		}
	}
	
	// Animations created synchronously will run synchronously
	function createFxNow() {
		window.setTimeout( function() {
			fxNow = undefined;
		} );
		return ( fxNow = jQuery.now() );
	}
	
	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
		var which,
			i = 0,
			attrs = { height: type };
	
		// If we include width, step value is 1 to do all cssExpand values,
		// otherwise step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for ( ; i < 4; i += 2 - includeWidth ) {
			which = cssExpand[ i ];
			attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
		}
	
		if ( includeWidth ) {
			attrs.opacity = attrs.width = type;
		}
	
		return attrs;
	}
	
	function createTween( value, prop, animation ) {
		var tween,
			collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
			index = 0,
			length = collection.length;
		for ( ; index < length; index++ ) {
			if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {
	
				// We're done with this property
				return tween;
			}
		}
	}
	
	function defaultPrefilter( elem, props, opts ) {
		var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
			isBox = "width" in props || "height" in props,
			anim = this,
			orig = {},
			style = elem.style,
			hidden = elem.nodeType && isHiddenWithinTree( elem ),
			dataShow = dataPriv.get( elem, "fxshow" );
	
		// Queue-skipping animations hijack the fx hooks
		if ( !opts.queue ) {
			hooks = jQuery._queueHooks( elem, "fx" );
			if ( hooks.unqueued == null ) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function() {
					if ( !hooks.unqueued ) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;
	
			anim.always( function() {
	
				// Ensure the complete handler is called before this completes
				anim.always( function() {
					hooks.unqueued--;
					if ( !jQuery.queue( elem, "fx" ).length ) {
						hooks.empty.fire();
					}
				} );
			} );
		}
	
		// Detect show/hide animations
		for ( prop in props ) {
			value = props[ prop ];
			if ( rfxtypes.test( value ) ) {
				delete props[ prop ];
				toggle = toggle || value === "toggle";
				if ( value === ( hidden ? "hide" : "show" ) ) {
	
					// Pretend to be hidden if this is a "show" and
					// there is still data from a stopped show/hide
					if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
						hidden = true;
	
					// Ignore all other no-op show/hide data
					} else {
						continue;
					}
				}
				orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
			}
		}
	
		// Bail out if this is a no-op like .hide().hide()
		propTween = !jQuery.isEmptyObject( props );
		if ( !propTween && jQuery.isEmptyObject( orig ) ) {
			return;
		}
	
		// Restrict "overflow" and "display" styles during box animations
		if ( isBox && elem.nodeType === 1 ) {
	
			// Support: IE <=9 - 11, Edge 12 - 13
			// Record all 3 overflow attributes because IE does not infer the shorthand
			// from identically-valued overflowX and overflowY
			opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];
	
			// Identify a display type, preferring old show/hide data over the CSS cascade
			restoreDisplay = dataShow && dataShow.display;
			if ( restoreDisplay == null ) {
				restoreDisplay = dataPriv.get( elem, "display" );
			}
			display = jQuery.css( elem, "display" );
			if ( display === "none" ) {
				if ( restoreDisplay ) {
					display = restoreDisplay;
				} else {
	
					// Get nonempty value(s) by temporarily forcing visibility
					showHide( [ elem ], true );
					restoreDisplay = elem.style.display || restoreDisplay;
					display = jQuery.css( elem, "display" );
					showHide( [ elem ] );
				}
			}
	
			// Animate inline elements as inline-block
			if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
				if ( jQuery.css( elem, "float" ) === "none" ) {
	
					// Restore the original display value at the end of pure show/hide animations
					if ( !propTween ) {
						anim.done( function() {
							style.display = restoreDisplay;
						} );
						if ( restoreDisplay == null ) {
							display = style.display;
							restoreDisplay = display === "none" ? "" : display;
						}
					}
					style.display = "inline-block";
				}
			}
		}
	
		if ( opts.overflow ) {
			style.overflow = "hidden";
			anim.always( function() {
				style.overflow = opts.overflow[ 0 ];
				style.overflowX = opts.overflow[ 1 ];
				style.overflowY = opts.overflow[ 2 ];
			} );
		}
	
		// Implement show/hide animations
		propTween = false;
		for ( prop in orig ) {
	
			// General show/hide setup for this element animation
			if ( !propTween ) {
				if ( dataShow ) {
					if ( "hidden" in dataShow ) {
						hidden = dataShow.hidden;
					}
				} else {
					dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
				}
	
				// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
				if ( toggle ) {
					dataShow.hidden = !hidden;
				}
	
				// Show elements before animating them
				if ( hidden ) {
					showHide( [ elem ], true );
				}
	
				/* eslint-disable no-loop-func */
	
				anim.done( function() {
	
				/* eslint-enable no-loop-func */
	
					// The final step of a "hide" animation is actually hiding the element
					if ( !hidden ) {
						showHide( [ elem ] );
					}
					dataPriv.remove( elem, "fxshow" );
					for ( prop in orig ) {
						jQuery.style( elem, prop, orig[ prop ] );
					}
				} );
			}
	
			// Per-property setup
			propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
			if ( !( prop in dataShow ) ) {
				dataShow[ prop ] = propTween.start;
				if ( hidden ) {
					propTween.end = propTween.start;
					propTween.start = 0;
				}
			}
		}
	}
	
	function propFilter( props, specialEasing ) {
		var index, name, easing, value, hooks;
	
		// camelCase, specialEasing and expand cssHook pass
		for ( index in props ) {
			name = jQuery.camelCase( index );
			easing = specialEasing[ name ];
			value = props[ index ];
			if ( jQuery.isArray( value ) ) {
				easing = value[ 1 ];
				value = props[ index ] = value[ 0 ];
			}
	
			if ( index !== name ) {
				props[ name ] = value;
				delete props[ index ];
			}
	
			hooks = jQuery.cssHooks[ name ];
			if ( hooks && "expand" in hooks ) {
				value = hooks.expand( value );
				delete props[ name ];
	
				// Not quite $.extend, this won't overwrite existing keys.
				// Reusing 'index' because we have the correct "name"
				for ( index in value ) {
					if ( !( index in props ) ) {
						props[ index ] = value[ index ];
						specialEasing[ index ] = easing;
					}
				}
			} else {
				specialEasing[ name ] = easing;
			}
		}
	}
	
	function Animation( elem, properties, options ) {
		var result,
			stopped,
			index = 0,
			length = Animation.prefilters.length,
			deferred = jQuery.Deferred().always( function() {
	
				// Don't match elem in the :animated selector
				delete tick.elem;
			} ),
			tick = function() {
				if ( stopped ) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
					remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
	
					// Support: Android 2.3 only
					// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
					temp = remaining / animation.duration || 0,
					percent = 1 - temp,
					index = 0,
					length = animation.tweens.length;
	
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( percent );
				}
	
				deferred.notifyWith( elem, [ animation, percent, remaining ] );
	
				if ( percent < 1 && length ) {
					return remaining;
				} else {
					deferred.resolveWith( elem, [ animation ] );
					return false;
				}
			},
			animation = deferred.promise( {
				elem: elem,
				props: jQuery.extend( {}, properties ),
				opts: jQuery.extend( true, {
					specialEasing: {},
					easing: jQuery.easing._default
				}, options ),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function( prop, end ) {
					var tween = jQuery.Tween( elem, animation.opts, prop, end,
							animation.opts.specialEasing[ prop ] || animation.opts.easing );
					animation.tweens.push( tween );
					return tween;
				},
				stop: function( gotoEnd ) {
					var index = 0,
	
						// If we are going to the end, we want to run all the tweens
						// otherwise we skip this part
						length = gotoEnd ? animation.tweens.length : 0;
					if ( stopped ) {
						return this;
					}
					stopped = true;
					for ( ; index < length; index++ ) {
						animation.tweens[ index ].run( 1 );
					}
	
					// Resolve when we played the last frame; otherwise, reject
					if ( gotoEnd ) {
						deferred.notifyWith( elem, [ animation, 1, 0 ] );
						deferred.resolveWith( elem, [ animation, gotoEnd ] );
					} else {
						deferred.rejectWith( elem, [ animation, gotoEnd ] );
					}
					return this;
				}
			} ),
			props = animation.props;
	
		propFilter( props, animation.opts.specialEasing );
	
		for ( ; index < length; index++ ) {
			result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
			if ( result ) {
				if ( jQuery.isFunction( result.stop ) ) {
					jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
						jQuery.proxy( result.stop, result );
				}
				return result;
			}
		}
	
		jQuery.map( props, createTween, animation );
	
		if ( jQuery.isFunction( animation.opts.start ) ) {
			animation.opts.start.call( elem, animation );
		}
	
		jQuery.fx.timer(
			jQuery.extend( tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			} )
		);
	
		// attach callbacks from options
		return animation.progress( animation.opts.progress )
			.done( animation.opts.done, animation.opts.complete )
			.fail( animation.opts.fail )
			.always( animation.opts.always );
	}
	
	jQuery.Animation = jQuery.extend( Animation, {
	
		tweeners: {
			"*": [ function( prop, value ) {
				var tween = this.createTween( prop, value );
				adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
				return tween;
			} ]
		},
	
		tweener: function( props, callback ) {
			if ( jQuery.isFunction( props ) ) {
				callback = props;
				props = [ "*" ];
			} else {
				props = props.match( rnothtmlwhite );
			}
	
			var prop,
				index = 0,
				length = props.length;
	
			for ( ; index < length; index++ ) {
				prop = props[ index ];
				Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
				Animation.tweeners[ prop ].unshift( callback );
			}
		},
	
		prefilters: [ defaultPrefilter ],
	
		prefilter: function( callback, prepend ) {
			if ( prepend ) {
				Animation.prefilters.unshift( callback );
			} else {
				Animation.prefilters.push( callback );
			}
		}
	} );
	
	jQuery.speed = function( speed, easing, fn ) {
		var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
			complete: fn || !fn && easing ||
				jQuery.isFunction( speed ) && speed,
			duration: speed,
			easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
		};
	
		// Go to the end state if fx are off or if document is hidden
		if ( jQuery.fx.off || document.hidden ) {
			opt.duration = 0;
	
		} else {
			if ( typeof opt.duration !== "number" ) {
				if ( opt.duration in jQuery.fx.speeds ) {
					opt.duration = jQuery.fx.speeds[ opt.duration ];
	
				} else {
					opt.duration = jQuery.fx.speeds._default;
				}
			}
		}
	
		// Normalize opt.queue - true/undefined/null -> "fx"
		if ( opt.queue == null || opt.queue === true ) {
			opt.queue = "fx";
		}
	
		// Queueing
		opt.old = opt.complete;
	
		opt.complete = function() {
			if ( jQuery.isFunction( opt.old ) ) {
				opt.old.call( this );
			}
	
			if ( opt.queue ) {
				jQuery.dequeue( this, opt.queue );
			}
		};
	
		return opt;
	};
	
	jQuery.fn.extend( {
		fadeTo: function( speed, to, easing, callback ) {
	
			// Show any hidden elements after setting opacity to 0
			return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()
	
				// Animate to the value specified
				.end().animate( { opacity: to }, speed, easing, callback );
		},
		animate: function( prop, speed, easing, callback ) {
			var empty = jQuery.isEmptyObject( prop ),
				optall = jQuery.speed( speed, easing, callback ),
				doAnimation = function() {
	
					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation( this, jQuery.extend( {}, prop ), optall );
	
					// Empty animations, or finishing resolves immediately
					if ( empty || dataPriv.get( this, "finish" ) ) {
						anim.stop( true );
					}
				};
				doAnimation.finish = doAnimation;
	
			return empty || optall.queue === false ?
				this.each( doAnimation ) :
				this.queue( optall.queue, doAnimation );
		},
		stop: function( type, clearQueue, gotoEnd ) {
			var stopQueue = function( hooks ) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop( gotoEnd );
			};
	
			if ( typeof type !== "string" ) {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if ( clearQueue && type !== false ) {
				this.queue( type || "fx", [] );
			}
	
			return this.each( function() {
				var dequeue = true,
					index = type != null && type + "queueHooks",
					timers = jQuery.timers,
					data = dataPriv.get( this );
	
				if ( index ) {
					if ( data[ index ] && data[ index ].stop ) {
						stopQueue( data[ index ] );
					}
				} else {
					for ( index in data ) {
						if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
							stopQueue( data[ index ] );
						}
					}
				}
	
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this &&
						( type == null || timers[ index ].queue === type ) ) {
	
						timers[ index ].anim.stop( gotoEnd );
						dequeue = false;
						timers.splice( index, 1 );
					}
				}
	
				// Start the next in the queue if the last step wasn't forced.
				// Timers currently will call their complete callbacks, which
				// will dequeue but only if they were gotoEnd.
				if ( dequeue || !gotoEnd ) {
					jQuery.dequeue( this, type );
				}
			} );
		},
		finish: function( type ) {
			if ( type !== false ) {
				type = type || "fx";
			}
			return this.each( function() {
				var index,
					data = dataPriv.get( this ),
					queue = data[ type + "queue" ],
					hooks = data[ type + "queueHooks" ],
					timers = jQuery.timers,
					length = queue ? queue.length : 0;
	
				// Enable finishing flag on private data
				data.finish = true;
	
				// Empty the queue first
				jQuery.queue( this, type, [] );
	
				if ( hooks && hooks.stop ) {
					hooks.stop.call( this, true );
				}
	
				// Look for any active animations, and finish them
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
						timers[ index ].anim.stop( true );
						timers.splice( index, 1 );
					}
				}
	
				// Look for any animations in the old queue and finish them
				for ( index = 0; index < length; index++ ) {
					if ( queue[ index ] && queue[ index ].finish ) {
						queue[ index ].finish.call( this );
					}
				}
	
				// Turn off finishing flag
				delete data.finish;
			} );
		}
	} );
	
	jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
		var cssFn = jQuery.fn[ name ];
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return speed == null || typeof speed === "boolean" ?
				cssFn.apply( this, arguments ) :
				this.animate( genFx( name, true ), speed, easing, callback );
		};
	} );
	
	// Generate shortcuts for custom animations
	jQuery.each( {
		slideDown: genFx( "show" ),
		slideUp: genFx( "hide" ),
		slideToggle: genFx( "toggle" ),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return this.animate( props, speed, easing, callback );
		};
	} );
	
	jQuery.timers = [];
	jQuery.fx.tick = function() {
		var timer,
			i = 0,
			timers = jQuery.timers;
	
		fxNow = jQuery.now();
	
		for ( ; i < timers.length; i++ ) {
			timer = timers[ i ];
	
			// Checks the timer has not already been removed
			if ( !timer() && timers[ i ] === timer ) {
				timers.splice( i--, 1 );
			}
		}
	
		if ( !timers.length ) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};
	
	jQuery.fx.timer = function( timer ) {
		jQuery.timers.push( timer );
		if ( timer() ) {
			jQuery.fx.start();
		} else {
			jQuery.timers.pop();
		}
	};
	
	jQuery.fx.interval = 13;
	jQuery.fx.start = function() {
		if ( !timerId ) {
			timerId = window.requestAnimationFrame ?
				window.requestAnimationFrame( raf ) :
				window.setInterval( jQuery.fx.tick, jQuery.fx.interval );
		}
	};
	
	jQuery.fx.stop = function() {
		if ( window.cancelAnimationFrame ) {
			window.cancelAnimationFrame( timerId );
		} else {
			window.clearInterval( timerId );
		}
	
		timerId = null;
	};
	
	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,
	
		// Default speed
		_default: 400
	};
	
	
	// Based off of the plugin by Clint Helfers, with permission.
	// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
	jQuery.fn.delay = function( time, type ) {
		time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
		type = type || "fx";
	
		return this.queue( type, function( next, hooks ) {
			var timeout = window.setTimeout( next, time );
			hooks.stop = function() {
				window.clearTimeout( timeout );
			};
		} );
	};
	
	
	( function() {
		var input = document.createElement( "input" ),
			select = document.createElement( "select" ),
			opt = select.appendChild( document.createElement( "option" ) );
	
		input.type = "checkbox";
	
		// Support: Android <=4.3 only
		// Default value for a checkbox should be "on"
		support.checkOn = input.value !== "";
	
		// Support: IE <=11 only
		// Must access selectedIndex to make default options select
		support.optSelected = opt.selected;
	
		// Support: IE <=11 only
		// An input loses its value after becoming a radio
		input = document.createElement( "input" );
		input.value = "t";
		input.type = "radio";
		support.radioValue = input.value === "t";
	} )();
	
	
	var boolHook,
		attrHandle = jQuery.expr.attrHandle;
	
	jQuery.fn.extend( {
		attr: function( name, value ) {
			return access( this, jQuery.attr, name, value, arguments.length > 1 );
		},
	
		removeAttr: function( name ) {
			return this.each( function() {
				jQuery.removeAttr( this, name );
			} );
		}
	} );
	
	jQuery.extend( {
		attr: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set attributes on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			// Fallback to prop when attributes are not supported
			if ( typeof elem.getAttribute === "undefined" ) {
				return jQuery.prop( elem, name, value );
			}
	
			// Attribute hooks are determined by the lowercase version
			// Grab necessary hook if one is defined
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
				hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
					( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
			}
	
			if ( value !== undefined ) {
				if ( value === null ) {
					jQuery.removeAttr( elem, name );
					return;
				}
	
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				elem.setAttribute( name, value + "" );
				return value;
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			ret = jQuery.find.attr( elem, name );
	
			// Non-existent attributes return null, we normalize to undefined
			return ret == null ? undefined : ret;
		},
	
		attrHooks: {
			type: {
				set: function( elem, value ) {
					if ( !support.radioValue && value === "radio" &&
						jQuery.nodeName( elem, "input" ) ) {
						var val = elem.value;
						elem.setAttribute( "type", value );
						if ( val ) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		},
	
		removeAttr: function( elem, value ) {
			var name,
				i = 0,
	
				// Attribute names can contain non-HTML whitespace characters
				// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
				attrNames = value && value.match( rnothtmlwhite );
	
			if ( attrNames && elem.nodeType === 1 ) {
				while ( ( name = attrNames[ i++ ] ) ) {
					elem.removeAttribute( name );
				}
			}
		}
	} );
	
	// Hooks for boolean attributes
	boolHook = {
		set: function( elem, value, name ) {
			if ( value === false ) {
	
				// Remove boolean attributes when set to false
				jQuery.removeAttr( elem, name );
			} else {
				elem.setAttribute( name, name );
			}
			return name;
		}
	};
	
	jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
		var getter = attrHandle[ name ] || jQuery.find.attr;
	
		attrHandle[ name ] = function( elem, name, isXML ) {
			var ret, handle,
				lowercaseName = name.toLowerCase();
	
			if ( !isXML ) {
	
				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[ lowercaseName ];
				attrHandle[ lowercaseName ] = ret;
				ret = getter( elem, name, isXML ) != null ?
					lowercaseName :
					null;
				attrHandle[ lowercaseName ] = handle;
			}
			return ret;
		};
	} );
	
	
	
	
	var rfocusable = /^(?:input|select|textarea|button)$/i,
		rclickable = /^(?:a|area)$/i;
	
	jQuery.fn.extend( {
		prop: function( name, value ) {
			return access( this, jQuery.prop, name, value, arguments.length > 1 );
		},
	
		removeProp: function( name ) {
			return this.each( function() {
				delete this[ jQuery.propFix[ name ] || name ];
			} );
		}
	} );
	
	jQuery.extend( {
		prop: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set properties on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
	
				// Fix name and attach hooks
				name = jQuery.propFix[ name ] || name;
				hooks = jQuery.propHooks[ name ];
			}
	
			if ( value !== undefined ) {
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				return ( elem[ name ] = value );
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			return elem[ name ];
		},
	
		propHooks: {
			tabIndex: {
				get: function( elem ) {
	
					// Support: IE <=9 - 11 only
					// elem.tabIndex doesn't always return the
					// correct value when it hasn't been explicitly set
					// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
					// Use proper attribute retrieval(#12072)
					var tabindex = jQuery.find.attr( elem, "tabindex" );
	
					if ( tabindex ) {
						return parseInt( tabindex, 10 );
					}
	
					if (
						rfocusable.test( elem.nodeName ) ||
						rclickable.test( elem.nodeName ) &&
						elem.href
					) {
						return 0;
					}
	
					return -1;
				}
			}
		},
	
		propFix: {
			"for": "htmlFor",
			"class": "className"
		}
	} );
	
	// Support: IE <=11 only
	// Accessing the selectedIndex property
	// forces the browser to respect setting selected
	// on the option
	// The getter ensures a default option is selected
	// when in an optgroup
	// eslint rule "no-unused-expressions" is disabled for this code
	// since it considers such accessions noop
	if ( !support.optSelected ) {
		jQuery.propHooks.selected = {
			get: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent && parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
				return null;
			},
			set: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent ) {
					parent.selectedIndex;
	
					if ( parent.parentNode ) {
						parent.parentNode.selectedIndex;
					}
				}
			}
		};
	}
	
	jQuery.each( [
		"tabIndex",
		"readOnly",
		"maxLength",
		"cellSpacing",
		"cellPadding",
		"rowSpan",
		"colSpan",
		"useMap",
		"frameBorder",
		"contentEditable"
	], function() {
		jQuery.propFix[ this.toLowerCase() ] = this;
	} );
	
	
	
	
		// Strip and collapse whitespace according to HTML spec
		// https://html.spec.whatwg.org/multipage/infrastructure.html#strip-and-collapse-whitespace
		function stripAndCollapse( value ) {
			var tokens = value.match( rnothtmlwhite ) || [];
			return tokens.join( " " );
		}
	
	
	function getClass( elem ) {
		return elem.getAttribute && elem.getAttribute( "class" ) || "";
	}
	
	jQuery.fn.extend( {
		addClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( typeof value === "string" && value ) {
				classes = value.match( rnothtmlwhite ) || [];
	
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
					cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
							if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
								cur += clazz + " ";
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		removeClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( !arguments.length ) {
				return this.attr( "class", "" );
			}
	
			if ( typeof value === "string" && value ) {
				classes = value.match( rnothtmlwhite ) || [];
	
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
	
					// This expression is here for better compressibility (see addClass)
					cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
	
							// Remove *all* instances
							while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
								cur = cur.replace( " " + clazz + " ", " " );
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		toggleClass: function( value, stateVal ) {
			var type = typeof value;
	
			if ( typeof stateVal === "boolean" && type === "string" ) {
				return stateVal ? this.addClass( value ) : this.removeClass( value );
			}
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( i ) {
					jQuery( this ).toggleClass(
						value.call( this, i, getClass( this ), stateVal ),
						stateVal
					);
				} );
			}
	
			return this.each( function() {
				var className, i, self, classNames;
	
				if ( type === "string" ) {
	
					// Toggle individual class names
					i = 0;
					self = jQuery( this );
					classNames = value.match( rnothtmlwhite ) || [];
	
					while ( ( className = classNames[ i++ ] ) ) {
	
						// Check each className given, space separated list
						if ( self.hasClass( className ) ) {
							self.removeClass( className );
						} else {
							self.addClass( className );
						}
					}
	
				// Toggle whole class name
				} else if ( value === undefined || type === "boolean" ) {
					className = getClass( this );
					if ( className ) {
	
						// Store className if set
						dataPriv.set( this, "__className__", className );
					}
	
					// If the element has a class name or if we're passed `false`,
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					if ( this.setAttribute ) {
						this.setAttribute( "class",
							className || value === false ?
							"" :
							dataPriv.get( this, "__className__" ) || ""
						);
					}
				}
			} );
		},
	
		hasClass: function( selector ) {
			var className, elem,
				i = 0;
	
			className = " " + selector + " ";
			while ( ( elem = this[ i++ ] ) ) {
				if ( elem.nodeType === 1 &&
					( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
						return true;
				}
			}
	
			return false;
		}
	} );
	
	
	
	
	var rreturn = /\r/g;
	
	jQuery.fn.extend( {
		val: function( value ) {
			var hooks, ret, isFunction,
				elem = this[ 0 ];
	
			if ( !arguments.length ) {
				if ( elem ) {
					hooks = jQuery.valHooks[ elem.type ] ||
						jQuery.valHooks[ elem.nodeName.toLowerCase() ];
	
					if ( hooks &&
						"get" in hooks &&
						( ret = hooks.get( elem, "value" ) ) !== undefined
					) {
						return ret;
					}
	
					ret = elem.value;
	
					// Handle most common string cases
					if ( typeof ret === "string" ) {
						return ret.replace( rreturn, "" );
					}
	
					// Handle cases where value is null/undef or number
					return ret == null ? "" : ret;
				}
	
				return;
			}
	
			isFunction = jQuery.isFunction( value );
	
			return this.each( function( i ) {
				var val;
	
				if ( this.nodeType !== 1 ) {
					return;
				}
	
				if ( isFunction ) {
					val = value.call( this, i, jQuery( this ).val() );
				} else {
					val = value;
				}
	
				// Treat null/undefined as ""; convert numbers to string
				if ( val == null ) {
					val = "";
	
				} else if ( typeof val === "number" ) {
					val += "";
	
				} else if ( jQuery.isArray( val ) ) {
					val = jQuery.map( val, function( value ) {
						return value == null ? "" : value + "";
					} );
				}
	
				hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];
	
				// If set returns undefined, fall back to normal setting
				if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
					this.value = val;
				}
			} );
		}
	} );
	
	jQuery.extend( {
		valHooks: {
			option: {
				get: function( elem ) {
	
					var val = jQuery.find.attr( elem, "value" );
					return val != null ?
						val :
	
						// Support: IE <=10 - 11 only
						// option.text throws exceptions (#14686, #14858)
						// Strip and collapse whitespace
						// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
						stripAndCollapse( jQuery.text( elem ) );
				}
			},
			select: {
				get: function( elem ) {
					var value, option, i,
						options = elem.options,
						index = elem.selectedIndex,
						one = elem.type === "select-one",
						values = one ? null : [],
						max = one ? index + 1 : options.length;
	
					if ( index < 0 ) {
						i = max;
	
					} else {
						i = one ? index : 0;
					}
	
					// Loop through all the selected options
					for ( ; i < max; i++ ) {
						option = options[ i ];
	
						// Support: IE <=9 only
						// IE8-9 doesn't update selected after form reset (#2551)
						if ( ( option.selected || i === index ) &&
	
								// Don't return options that are disabled or in a disabled optgroup
								!option.disabled &&
								( !option.parentNode.disabled ||
									!jQuery.nodeName( option.parentNode, "optgroup" ) ) ) {
	
							// Get the specific value for the option
							value = jQuery( option ).val();
	
							// We don't need an array for one selects
							if ( one ) {
								return value;
							}
	
							// Multi-Selects return an array
							values.push( value );
						}
					}
	
					return values;
				},
	
				set: function( elem, value ) {
					var optionSet, option,
						options = elem.options,
						values = jQuery.makeArray( value ),
						i = options.length;
	
					while ( i-- ) {
						option = options[ i ];
	
						/* eslint-disable no-cond-assign */
	
						if ( option.selected =
							jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
						) {
							optionSet = true;
						}
	
						/* eslint-enable no-cond-assign */
					}
	
					// Force browsers to behave consistently when non-matching value is set
					if ( !optionSet ) {
						elem.selectedIndex = -1;
					}
					return values;
				}
			}
		}
	} );
	
	// Radios and checkboxes getter/setter
	jQuery.each( [ "radio", "checkbox" ], function() {
		jQuery.valHooks[ this ] = {
			set: function( elem, value ) {
				if ( jQuery.isArray( value ) ) {
					return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
				}
			}
		};
		if ( !support.checkOn ) {
			jQuery.valHooks[ this ].get = function( elem ) {
				return elem.getAttribute( "value" ) === null ? "on" : elem.value;
			};
		}
	} );
	
	
	
	
	// Return jQuery for attributes-only inclusion
	
	
	var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/;
	
	jQuery.extend( jQuery.event, {
	
		trigger: function( event, data, elem, onlyHandlers ) {
	
			var i, cur, tmp, bubbleType, ontype, handle, special,
				eventPath = [ elem || document ],
				type = hasOwn.call( event, "type" ) ? event.type : event,
				namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];
	
			cur = tmp = elem = elem || document;
	
			// Don't do events on text and comment nodes
			if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
				return;
			}
	
			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
				return;
			}
	
			if ( type.indexOf( "." ) > -1 ) {
	
				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split( "." );
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf( ":" ) < 0 && "on" + type;
	
			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[ jQuery.expando ] ?
				event :
				new jQuery.Event( type, typeof event === "object" && event );
	
			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join( "." );
			event.rnamespace = event.namespace ?
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
				null;
	
			// Clean up the event in case it is being reused
			event.result = undefined;
			if ( !event.target ) {
				event.target = elem;
			}
	
			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ?
				[ event ] :
				jQuery.makeArray( data, [ event ] );
	
			// Allow special events to draw outside the lines
			special = jQuery.event.special[ type ] || {};
			if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
				return;
			}
	
			// Determine event propagation path in advance, per W3C events spec (#9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
			if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {
	
				bubbleType = special.delegateType || type;
				if ( !rfocusMorph.test( bubbleType + type ) ) {
					cur = cur.parentNode;
				}
				for ( ; cur; cur = cur.parentNode ) {
					eventPath.push( cur );
					tmp = cur;
				}
	
				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if ( tmp === ( elem.ownerDocument || document ) ) {
					eventPath.push( tmp.defaultView || tmp.parentWindow || window );
				}
			}
	
			// Fire handlers on the event path
			i = 0;
			while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
	
				event.type = i > 1 ?
					bubbleType :
					special.bindType || type;
	
				// jQuery handler
				handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
					dataPriv.get( cur, "handle" );
				if ( handle ) {
					handle.apply( cur, data );
				}
	
				// Native handler
				handle = ontype && cur[ ontype ];
				if ( handle && handle.apply && acceptData( cur ) ) {
					event.result = handle.apply( cur, data );
					if ( event.result === false ) {
						event.preventDefault();
					}
				}
			}
			event.type = type;
	
			// If nobody prevented the default action, do it now
			if ( !onlyHandlers && !event.isDefaultPrevented() ) {
	
				if ( ( !special._default ||
					special._default.apply( eventPath.pop(), data ) === false ) &&
					acceptData( elem ) ) {
	
					// Call a native DOM method on the target with the same name as the event.
					// Don't do default actions on window, that's where global variables be (#6170)
					if ( ontype && jQuery.isFunction( elem[ type ] ) && !jQuery.isWindow( elem ) ) {
	
						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ ontype ];
	
						if ( tmp ) {
							elem[ ontype ] = null;
						}
	
						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;
						elem[ type ]();
						jQuery.event.triggered = undefined;
	
						if ( tmp ) {
							elem[ ontype ] = tmp;
						}
					}
				}
			}
	
			return event.result;
		},
	
		// Piggyback on a donor event to simulate a different one
		// Used only for `focus(in | out)` events
		simulate: function( type, elem, event ) {
			var e = jQuery.extend(
				new jQuery.Event(),
				event,
				{
					type: type,
					isSimulated: true
				}
			);
	
			jQuery.event.trigger( e, null, elem );
		}
	
	} );
	
	jQuery.fn.extend( {
	
		trigger: function( type, data ) {
			return this.each( function() {
				jQuery.event.trigger( type, data, this );
			} );
		},
		triggerHandler: function( type, data ) {
			var elem = this[ 0 ];
			if ( elem ) {
				return jQuery.event.trigger( type, data, elem, true );
			}
		}
	} );
	
	
	jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
		"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
		"change select submit keydown keypress keyup contextmenu" ).split( " " ),
		function( i, name ) {
	
		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	} );
	
	jQuery.fn.extend( {
		hover: function( fnOver, fnOut ) {
			return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
		}
	} );
	
	
	
	
	support.focusin = "onfocusin" in window;
	
	
	// Support: Firefox <=44
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
	if ( !support.focusin ) {
		jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {
	
			// Attach a single capturing handler on the document while someone wants focusin/focusout
			var handler = function( event ) {
				jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
			};
	
			jQuery.event.special[ fix ] = {
				setup: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix );
	
					if ( !attaches ) {
						doc.addEventListener( orig, handler, true );
					}
					dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
				},
				teardown: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix ) - 1;
	
					if ( !attaches ) {
						doc.removeEventListener( orig, handler, true );
						dataPriv.remove( doc, fix );
	
					} else {
						dataPriv.access( doc, fix, attaches );
					}
				}
			};
		} );
	}
	var location = window.location;
	
	var nonce = jQuery.now();
	
	var rquery = ( /\?/ );
	
	
	
	// Cross-browser xml parsing
	jQuery.parseXML = function( data ) {
		var xml;
		if ( !data || typeof data !== "string" ) {
			return null;
		}
	
		// Support: IE 9 - 11 only
		// IE throws on parseFromString with invalid input.
		try {
			xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
		} catch ( e ) {
			xml = undefined;
		}
	
		if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
			jQuery.error( "Invalid XML: " + data );
		}
		return xml;
	};
	
	
	var
		rbracket = /\[\]$/,
		rCRLF = /\r?\n/g,
		rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		rsubmittable = /^(?:input|select|textarea|keygen)/i;
	
	function buildParams( prefix, obj, traditional, add ) {
		var name;
	
		if ( jQuery.isArray( obj ) ) {
	
			// Serialize array item.
			jQuery.each( obj, function( i, v ) {
				if ( traditional || rbracket.test( prefix ) ) {
	
					// Treat each array item as a scalar.
					add( prefix, v );
	
				} else {
	
					// Item is non-scalar (array or object), encode its numeric index.
					buildParams(
						prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
						v,
						traditional,
						add
					);
				}
			} );
	
		} else if ( !traditional && jQuery.type( obj ) === "object" ) {
	
			// Serialize object item.
			for ( name in obj ) {
				buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
			}
	
		} else {
	
			// Serialize scalar item.
			add( prefix, obj );
		}
	}
	
	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function( a, traditional ) {
		var prefix,
			s = [],
			add = function( key, valueOrFunction ) {
	
				// If value is a function, invoke it and use its return value
				var value = jQuery.isFunction( valueOrFunction ) ?
					valueOrFunction() :
					valueOrFunction;
	
				s[ s.length ] = encodeURIComponent( key ) + "=" +
					encodeURIComponent( value == null ? "" : value );
			};
	
		// If an array was passed in, assume that it is an array of form elements.
		if ( jQuery.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
	
			// Serialize the form elements
			jQuery.each( a, function() {
				add( this.name, this.value );
			} );
	
		} else {
	
			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for ( prefix in a ) {
				buildParams( prefix, a[ prefix ], traditional, add );
			}
		}
	
		// Return the resulting serialization
		return s.join( "&" );
	};
	
	jQuery.fn.extend( {
		serialize: function() {
			return jQuery.param( this.serializeArray() );
		},
		serializeArray: function() {
			return this.map( function() {
	
				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop( this, "elements" );
				return elements ? jQuery.makeArray( elements ) : this;
			} )
			.filter( function() {
				var type = this.type;
	
				// Use .is( ":disabled" ) so that fieldset[disabled] works
				return this.name && !jQuery( this ).is( ":disabled" ) &&
					rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
					( this.checked || !rcheckableType.test( type ) );
			} )
			.map( function( i, elem ) {
				var val = jQuery( this ).val();
	
				if ( val == null ) {
					return null;
				}
	
				if ( jQuery.isArray( val ) ) {
					return jQuery.map( val, function( val ) {
						return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
					} );
				}
	
				return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
			} ).get();
		}
	} );
	
	
	var
		r20 = /%20/g,
		rhash = /#.*$/,
		rantiCache = /([?&])_=[^&]*/,
		rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
	
		// #7653, #8125, #8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		rnoContent = /^(?:GET|HEAD)$/,
		rprotocol = /^\/\//,
	
		/* Prefilters
		 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
		 * 2) These are called:
		 *    - BEFORE asking for a transport
		 *    - AFTER param serialization (s.data is a string if s.processData is true)
		 * 3) key is the dataType
		 * 4) the catchall symbol "*" can be used
		 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
		 */
		prefilters = {},
	
		/* Transports bindings
		 * 1) key is the dataType
		 * 2) the catchall symbol "*" can be used
		 * 3) selection will start with transport dataType and THEN go to "*" if needed
		 */
		transports = {},
	
		// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
		allTypes = "*/".concat( "*" ),
	
		// Anchor tag for parsing the document origin
		originAnchor = document.createElement( "a" );
		originAnchor.href = location.href;
	
	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {
	
		// dataTypeExpression is optional and defaults to "*"
		return function( dataTypeExpression, func ) {
	
			if ( typeof dataTypeExpression !== "string" ) {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}
	
			var dataType,
				i = 0,
				dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];
	
			if ( jQuery.isFunction( func ) ) {
	
				// For each dataType in the dataTypeExpression
				while ( ( dataType = dataTypes[ i++ ] ) ) {
	
					// Prepend if requested
					if ( dataType[ 0 ] === "+" ) {
						dataType = dataType.slice( 1 ) || "*";
						( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );
	
					// Otherwise append
					} else {
						( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
					}
				}
			}
		};
	}
	
	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {
	
		var inspected = {},
			seekingTransport = ( structure === transports );
	
		function inspect( dataType ) {
			var selected;
			inspected[ dataType ] = true;
			jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
				var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
				if ( typeof dataTypeOrTransport === "string" &&
					!seekingTransport && !inspected[ dataTypeOrTransport ] ) {
	
					options.dataTypes.unshift( dataTypeOrTransport );
					inspect( dataTypeOrTransport );
					return false;
				} else if ( seekingTransport ) {
					return !( selected = dataTypeOrTransport );
				}
			} );
			return selected;
		}
	
		return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}
	
	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes #9887
	function ajaxExtend( target, src ) {
		var key, deep,
			flatOptions = jQuery.ajaxSettings.flatOptions || {};
	
		for ( key in src ) {
			if ( src[ key ] !== undefined ) {
				( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
			}
		}
		if ( deep ) {
			jQuery.extend( true, target, deep );
		}
	
		return target;
	}
	
	/* Handles responses to an ajax request:
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {
	
		var ct, type, finalDataType, firstDataType,
			contents = s.contents,
			dataTypes = s.dataTypes;
	
		// Remove auto dataType and get content-type in the process
		while ( dataTypes[ 0 ] === "*" ) {
			dataTypes.shift();
			if ( ct === undefined ) {
				ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
			}
		}
	
		// Check if we're dealing with a known content-type
		if ( ct ) {
			for ( type in contents ) {
				if ( contents[ type ] && contents[ type ].test( ct ) ) {
					dataTypes.unshift( type );
					break;
				}
			}
		}
	
		// Check to see if we have a response for the expected dataType
		if ( dataTypes[ 0 ] in responses ) {
			finalDataType = dataTypes[ 0 ];
		} else {
	
			// Try convertible dataTypes
			for ( type in responses ) {
				if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
					finalDataType = type;
					break;
				}
				if ( !firstDataType ) {
					firstDataType = type;
				}
			}
	
			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}
	
		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if ( finalDataType ) {
			if ( finalDataType !== dataTypes[ 0 ] ) {
				dataTypes.unshift( finalDataType );
			}
			return responses[ finalDataType ];
		}
	}
	
	/* Chain conversions given the request and the original response
	 * Also sets the responseXXX fields on the jqXHR instance
	 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
		var conv2, current, conv, tmp, prev,
			converters = {},
	
			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();
	
		// Create converters map with lowercased keys
		if ( dataTypes[ 1 ] ) {
			for ( conv in s.converters ) {
				converters[ conv.toLowerCase() ] = s.converters[ conv ];
			}
		}
	
		current = dataTypes.shift();
	
		// Convert to each sequential dataType
		while ( current ) {
	
			if ( s.responseFields[ current ] ) {
				jqXHR[ s.responseFields[ current ] ] = response;
			}
	
			// Apply the dataFilter if provided
			if ( !prev && isSuccess && s.dataFilter ) {
				response = s.dataFilter( response, s.dataType );
			}
	
			prev = current;
			current = dataTypes.shift();
	
			if ( current ) {
	
				// There's only work to do if current dataType is non-auto
				if ( current === "*" ) {
	
					current = prev;
	
				// Convert response if prev dataType is non-auto and differs from current
				} else if ( prev !== "*" && prev !== current ) {
	
					// Seek a direct converter
					conv = converters[ prev + " " + current ] || converters[ "* " + current ];
	
					// If none found, seek a pair
					if ( !conv ) {
						for ( conv2 in converters ) {
	
							// If conv2 outputs current
							tmp = conv2.split( " " );
							if ( tmp[ 1 ] === current ) {
	
								// If prev can be converted to accepted input
								conv = converters[ prev + " " + tmp[ 0 ] ] ||
									converters[ "* " + tmp[ 0 ] ];
								if ( conv ) {
	
									// Condense equivalence converters
									if ( conv === true ) {
										conv = converters[ conv2 ];
	
									// Otherwise, insert the intermediate dataType
									} else if ( converters[ conv2 ] !== true ) {
										current = tmp[ 0 ];
										dataTypes.unshift( tmp[ 1 ] );
									}
									break;
								}
							}
						}
					}
	
					// Apply converter (if not an equivalence)
					if ( conv !== true ) {
	
						// Unless errors are allowed to bubble, catch and return them
						if ( conv && s.throws ) {
							response = conv( response );
						} else {
							try {
								response = conv( response );
							} catch ( e ) {
								return {
									state: "parsererror",
									error: conv ? e : "No conversion from " + prev + " to " + current
								};
							}
						}
					}
				}
			}
		}
	
		return { state: "success", data: response };
	}
	
	jQuery.extend( {
	
		// Counter for holding the number of active queries
		active: 0,
	
		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},
	
		ajaxSettings: {
			url: location.href,
			type: "GET",
			isLocal: rlocalProtocol.test( location.protocol ),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",
	
			/*
			timeout: 0,
			data: null,
			dataType: null,
			username: null,
			password: null,
			cache: null,
			throws: false,
			traditional: false,
			headers: {},
			*/
	
			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},
	
			contents: {
				xml: /\bxml\b/,
				html: /\bhtml/,
				json: /\bjson\b/
			},
	
			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},
	
			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {
	
				// Convert anything to text
				"* text": String,
	
				// Text to html (true = no transformation)
				"text html": true,
	
				// Evaluate text as a json expression
				"text json": JSON.parse,
	
				// Parse text as xml
				"text xml": jQuery.parseXML
			},
	
			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},
	
		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function( target, settings ) {
			return settings ?
	
				// Building a settings object
				ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :
	
				// Extending ajaxSettings
				ajaxExtend( jQuery.ajaxSettings, target );
		},
	
		ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
		ajaxTransport: addToPrefiltersOrTransports( transports ),
	
		// Main method
		ajax: function( url, options ) {
	
			// If url is an object, simulate pre-1.5 signature
			if ( typeof url === "object" ) {
				options = url;
				url = undefined;
			}
	
			// Force options to be an object
			options = options || {};
	
			var transport,
	
				// URL without anti-cache param
				cacheURL,
	
				// Response headers
				responseHeadersString,
				responseHeaders,
	
				// timeout handle
				timeoutTimer,
	
				// Url cleanup var
				urlAnchor,
	
				// Request state (becomes false upon send and true upon completion)
				completed,
	
				// To know if global events are to be dispatched
				fireGlobals,
	
				// Loop variable
				i,
	
				// uncached part of the url
				uncached,
	
				// Create the final options object
				s = jQuery.ajaxSetup( {}, options ),
	
				// Callbacks context
				callbackContext = s.context || s,
	
				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context &&
					( callbackContext.nodeType || callbackContext.jquery ) ?
						jQuery( callbackContext ) :
						jQuery.event,
	
				// Deferreds
				deferred = jQuery.Deferred(),
				completeDeferred = jQuery.Callbacks( "once memory" ),
	
				// Status-dependent callbacks
				statusCode = s.statusCode || {},
	
				// Headers (they are sent all at once)
				requestHeaders = {},
				requestHeadersNames = {},
	
				// Default abort message
				strAbort = "canceled",
	
				// Fake xhr
				jqXHR = {
					readyState: 0,
	
					// Builds headers hashtable if needed
					getResponseHeader: function( key ) {
						var match;
						if ( completed ) {
							if ( !responseHeaders ) {
								responseHeaders = {};
								while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
									responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
								}
							}
							match = responseHeaders[ key.toLowerCase() ];
						}
						return match == null ? null : match;
					},
	
					// Raw string
					getAllResponseHeaders: function() {
						return completed ? responseHeadersString : null;
					},
	
					// Caches the header
					setRequestHeader: function( name, value ) {
						if ( completed == null ) {
							name = requestHeadersNames[ name.toLowerCase() ] =
								requestHeadersNames[ name.toLowerCase() ] || name;
							requestHeaders[ name ] = value;
						}
						return this;
					},
	
					// Overrides response content-type header
					overrideMimeType: function( type ) {
						if ( completed == null ) {
							s.mimeType = type;
						}
						return this;
					},
	
					// Status-dependent callbacks
					statusCode: function( map ) {
						var code;
						if ( map ) {
							if ( completed ) {
	
								// Execute the appropriate callbacks
								jqXHR.always( map[ jqXHR.status ] );
							} else {
	
								// Lazy-add the new callbacks in a way that preserves old ones
								for ( code in map ) {
									statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
								}
							}
						}
						return this;
					},
	
					// Cancel the request
					abort: function( statusText ) {
						var finalText = statusText || strAbort;
						if ( transport ) {
							transport.abort( finalText );
						}
						done( 0, finalText );
						return this;
					}
				};
	
			// Attach deferreds
			deferred.promise( jqXHR );
	
			// Add protocol if not provided (prefilters might expect it)
			// Handle falsy url in the settings object (#10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ( ( url || s.url || location.href ) + "" )
				.replace( rprotocol, location.protocol + "//" );
	
			// Alias method option to type as per ticket #12004
			s.type = options.method || options.type || s.method || s.type;
	
			// Extract dataTypes list
			s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];
	
			// A cross-domain request is in order when the origin doesn't match the current origin.
			if ( s.crossDomain == null ) {
				urlAnchor = document.createElement( "a" );
	
				// Support: IE <=8 - 11, Edge 12 - 13
				// IE throws exception on accessing the href property if url is malformed,
				// e.g. http://example.com:80x/
				try {
					urlAnchor.href = s.url;
	
					// Support: IE <=8 - 11 only
					// Anchor's host property isn't correctly set when s.url is relative
					urlAnchor.href = urlAnchor.href;
					s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
						urlAnchor.protocol + "//" + urlAnchor.host;
				} catch ( e ) {
	
					// If there is an error parsing the URL, assume it is crossDomain,
					// it can be rejected by the transport if it is invalid
					s.crossDomain = true;
				}
			}
	
			// Convert data if not already a string
			if ( s.data && s.processData && typeof s.data !== "string" ) {
				s.data = jQuery.param( s.data, s.traditional );
			}
	
			// Apply prefilters
			inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );
	
			// If request was aborted inside a prefilter, stop there
			if ( completed ) {
				return jqXHR;
			}
	
			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
			fireGlobals = jQuery.event && s.global;
	
			// Watch for a new set of requests
			if ( fireGlobals && jQuery.active++ === 0 ) {
				jQuery.event.trigger( "ajaxStart" );
			}
	
			// Uppercase the type
			s.type = s.type.toUpperCase();
	
			// Determine if request has content
			s.hasContent = !rnoContent.test( s.type );
	
			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			// Remove hash to simplify url manipulation
			cacheURL = s.url.replace( rhash, "" );
	
			// More options handling for requests with no content
			if ( !s.hasContent ) {
	
				// Remember the hash so we can put it back
				uncached = s.url.slice( cacheURL.length );
	
				// If data is available, append data to url
				if ( s.data ) {
					cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;
	
					// #9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}
	
				// Add or update anti-cache param if needed
				if ( s.cache === false ) {
					cacheURL = cacheURL.replace( rantiCache, "$1" );
					uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
				}
	
				// Put hash and anti-cache on the URL that will be requested (gh-1732)
				s.url = cacheURL + uncached;
	
			// Change '%20' to '+' if this is encoded form body content (gh-2658)
			} else if ( s.data && s.processData &&
				( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
				s.data = s.data.replace( r20, "+" );
			}
	
			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if ( s.ifModified ) {
				if ( jQuery.lastModified[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
				}
				if ( jQuery.etag[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
				}
			}
	
			// Set the correct header, if data is being sent
			if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
				jqXHR.setRequestHeader( "Content-Type", s.contentType );
			}
	
			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader(
				"Accept",
				s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
					s.accepts[ s.dataTypes[ 0 ] ] +
						( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
					s.accepts[ "*" ]
			);
	
			// Check for headers option
			for ( i in s.headers ) {
				jqXHR.setRequestHeader( i, s.headers[ i ] );
			}
	
			// Allow custom headers/mimetypes and early abort
			if ( s.beforeSend &&
				( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {
	
				// Abort if not done already and return
				return jqXHR.abort();
			}
	
			// Aborting is no longer a cancellation
			strAbort = "abort";
	
			// Install callbacks on deferreds
			completeDeferred.add( s.complete );
			jqXHR.done( s.success );
			jqXHR.fail( s.error );
	
			// Get transport
			transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );
	
			// If no transport, we auto-abort
			if ( !transport ) {
				done( -1, "No Transport" );
			} else {
				jqXHR.readyState = 1;
	
				// Send global event
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
				}
	
				// If request was aborted inside ajaxSend, stop there
				if ( completed ) {
					return jqXHR;
				}
	
				// Timeout
				if ( s.async && s.timeout > 0 ) {
					timeoutTimer = window.setTimeout( function() {
						jqXHR.abort( "timeout" );
					}, s.timeout );
				}
	
				try {
					completed = false;
					transport.send( requestHeaders, done );
				} catch ( e ) {
	
					// Rethrow post-completion exceptions
					if ( completed ) {
						throw e;
					}
	
					// Propagate others as results
					done( -1, e );
				}
			}
	
			// Callback for when everything is done
			function done( status, nativeStatusText, responses, headers ) {
				var isSuccess, success, error, response, modified,
					statusText = nativeStatusText;
	
				// Ignore repeat invocations
				if ( completed ) {
					return;
				}
	
				completed = true;
	
				// Clear timeout if it exists
				if ( timeoutTimer ) {
					window.clearTimeout( timeoutTimer );
				}
	
				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;
	
				// Cache response headers
				responseHeadersString = headers || "";
	
				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;
	
				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;
	
				// Get response data
				if ( responses ) {
					response = ajaxHandleResponses( s, jqXHR, responses );
				}
	
				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert( s, response, jqXHR, isSuccess );
	
				// If successful, handle type chaining
				if ( isSuccess ) {
	
					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if ( s.ifModified ) {
						modified = jqXHR.getResponseHeader( "Last-Modified" );
						if ( modified ) {
							jQuery.lastModified[ cacheURL ] = modified;
						}
						modified = jqXHR.getResponseHeader( "etag" );
						if ( modified ) {
							jQuery.etag[ cacheURL ] = modified;
						}
					}
	
					// if no content
					if ( status === 204 || s.type === "HEAD" ) {
						statusText = "nocontent";
	
					// if not modified
					} else if ( status === 304 ) {
						statusText = "notmodified";
	
					// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {
	
					// Extract error from statusText and normalize for non-aborts
					error = statusText;
					if ( status || !statusText ) {
						statusText = "error";
						if ( status < 0 ) {
							status = 0;
						}
					}
				}
	
				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = ( nativeStatusText || statusText ) + "";
	
				// Success/Error
				if ( isSuccess ) {
					deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
				} else {
					deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
				}
	
				// Status-dependent callbacks
				jqXHR.statusCode( statusCode );
				statusCode = undefined;
	
				if ( fireGlobals ) {
					globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
						[ jqXHR, s, isSuccess ? success : error ] );
				}
	
				// Complete
				completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );
	
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
	
					// Handle the global AJAX counter
					if ( !( --jQuery.active ) ) {
						jQuery.event.trigger( "ajaxStop" );
					}
				}
			}
	
			return jqXHR;
		},
	
		getJSON: function( url, data, callback ) {
			return jQuery.get( url, data, callback, "json" );
		},
	
		getScript: function( url, callback ) {
			return jQuery.get( url, undefined, callback, "script" );
		}
	} );
	
	jQuery.each( [ "get", "post" ], function( i, method ) {
		jQuery[ method ] = function( url, data, callback, type ) {
	
			// Shift arguments if data argument was omitted
			if ( jQuery.isFunction( data ) ) {
				type = type || callback;
				callback = data;
				data = undefined;
			}
	
			// The url can be an options object (which then must have .url)
			return jQuery.ajax( jQuery.extend( {
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			}, jQuery.isPlainObject( url ) && url ) );
		};
	} );
	
	
	jQuery._evalUrl = function( url ) {
		return jQuery.ajax( {
			url: url,
	
			// Make this explicit, since user can override this through ajaxSetup (#11264)
			type: "GET",
			dataType: "script",
			cache: true,
			async: false,
			global: false,
			"throws": true
		} );
	};
	
	
	jQuery.fn.extend( {
		wrapAll: function( html ) {
			var wrap;
	
			if ( this[ 0 ] ) {
				if ( jQuery.isFunction( html ) ) {
					html = html.call( this[ 0 ] );
				}
	
				// The elements to wrap the target around
				wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );
	
				if ( this[ 0 ].parentNode ) {
					wrap.insertBefore( this[ 0 ] );
				}
	
				wrap.map( function() {
					var elem = this;
	
					while ( elem.firstElementChild ) {
						elem = elem.firstElementChild;
					}
	
					return elem;
				} ).append( this );
			}
	
			return this;
		},
	
		wrapInner: function( html ) {
			if ( jQuery.isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapInner( html.call( this, i ) );
				} );
			}
	
			return this.each( function() {
				var self = jQuery( this ),
					contents = self.contents();
	
				if ( contents.length ) {
					contents.wrapAll( html );
	
				} else {
					self.append( html );
				}
			} );
		},
	
		wrap: function( html ) {
			var isFunction = jQuery.isFunction( html );
	
			return this.each( function( i ) {
				jQuery( this ).wrapAll( isFunction ? html.call( this, i ) : html );
			} );
		},
	
		unwrap: function( selector ) {
			this.parent( selector ).not( "body" ).each( function() {
				jQuery( this ).replaceWith( this.childNodes );
			} );
			return this;
		}
	} );
	
	
	jQuery.expr.pseudos.hidden = function( elem ) {
		return !jQuery.expr.pseudos.visible( elem );
	};
	jQuery.expr.pseudos.visible = function( elem ) {
		return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
	};
	
	
	
	
	jQuery.ajaxSettings.xhr = function() {
		try {
			return new window.XMLHttpRequest();
		} catch ( e ) {}
	};
	
	var xhrSuccessStatus = {
	
			// File protocol always yields status code 0, assume 200
			0: 200,
	
			// Support: IE <=9 only
			// #1450: sometimes IE returns 1223 when it should be 204
			1223: 204
		},
		xhrSupported = jQuery.ajaxSettings.xhr();
	
	support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	support.ajax = xhrSupported = !!xhrSupported;
	
	jQuery.ajaxTransport( function( options ) {
		var callback, errorCallback;
	
		// Cross domain only allowed if supported through XMLHttpRequest
		if ( support.cors || xhrSupported && !options.crossDomain ) {
			return {
				send: function( headers, complete ) {
					var i,
						xhr = options.xhr();
	
					xhr.open(
						options.type,
						options.url,
						options.async,
						options.username,
						options.password
					);
	
					// Apply custom fields if provided
					if ( options.xhrFields ) {
						for ( i in options.xhrFields ) {
							xhr[ i ] = options.xhrFields[ i ];
						}
					}
	
					// Override mime type if needed
					if ( options.mimeType && xhr.overrideMimeType ) {
						xhr.overrideMimeType( options.mimeType );
					}
	
					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
						headers[ "X-Requested-With" ] = "XMLHttpRequest";
					}
	
					// Set headers
					for ( i in headers ) {
						xhr.setRequestHeader( i, headers[ i ] );
					}
	
					// Callback
					callback = function( type ) {
						return function() {
							if ( callback ) {
								callback = errorCallback = xhr.onload =
									xhr.onerror = xhr.onabort = xhr.onreadystatechange = null;
	
								if ( type === "abort" ) {
									xhr.abort();
								} else if ( type === "error" ) {
	
									// Support: IE <=9 only
									// On a manual native abort, IE9 throws
									// errors on any property access that is not readyState
									if ( typeof xhr.status !== "number" ) {
										complete( 0, "error" );
									} else {
										complete(
	
											// File: protocol always yields status 0; see #8605, #14207
											xhr.status,
											xhr.statusText
										);
									}
								} else {
									complete(
										xhrSuccessStatus[ xhr.status ] || xhr.status,
										xhr.statusText,
	
										// Support: IE <=9 only
										// IE9 has no XHR2 but throws on binary (trac-11426)
										// For XHR2 non-text, let the caller handle it (gh-2498)
										( xhr.responseType || "text" ) !== "text"  ||
										typeof xhr.responseText !== "string" ?
											{ binary: xhr.response } :
											{ text: xhr.responseText },
										xhr.getAllResponseHeaders()
									);
								}
							}
						};
					};
	
					// Listen to events
					xhr.onload = callback();
					errorCallback = xhr.onerror = callback( "error" );
	
					// Support: IE 9 only
					// Use onreadystatechange to replace onabort
					// to handle uncaught aborts
					if ( xhr.onabort !== undefined ) {
						xhr.onabort = errorCallback;
					} else {
						xhr.onreadystatechange = function() {
	
							// Check readyState before timeout as it changes
							if ( xhr.readyState === 4 ) {
	
								// Allow onerror to be called first,
								// but that will not handle a native abort
								// Also, save errorCallback to a variable
								// as xhr.onerror cannot be accessed
								window.setTimeout( function() {
									if ( callback ) {
										errorCallback();
									}
								} );
							}
						};
					}
	
					// Create the abort callback
					callback = callback( "abort" );
	
					try {
	
						// Do send the request (this may raise an exception)
						xhr.send( options.hasContent && options.data || null );
					} catch ( e ) {
	
						// #14683: Only rethrow if this hasn't been notified as an error yet
						if ( callback ) {
							throw e;
						}
					}
				},
	
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
	jQuery.ajaxPrefilter( function( s ) {
		if ( s.crossDomain ) {
			s.contents.script = false;
		}
	} );
	
	// Install script dataType
	jQuery.ajaxSetup( {
		accepts: {
			script: "text/javascript, application/javascript, " +
				"application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /\b(?:java|ecma)script\b/
		},
		converters: {
			"text script": function( text ) {
				jQuery.globalEval( text );
				return text;
			}
		}
	} );
	
	// Handle cache's special case and crossDomain
	jQuery.ajaxPrefilter( "script", function( s ) {
		if ( s.cache === undefined ) {
			s.cache = false;
		}
		if ( s.crossDomain ) {
			s.type = "GET";
		}
	} );
	
	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function( s ) {
	
		// This transport only deals with cross domain requests
		if ( s.crossDomain ) {
			var script, callback;
			return {
				send: function( _, complete ) {
					script = jQuery( "<script>" ).prop( {
						charset: s.scriptCharset,
						src: s.url
					} ).on(
						"load error",
						callback = function( evt ) {
							script.remove();
							callback = null;
							if ( evt ) {
								complete( evt.type === "error" ? 404 : 200, evt.type );
							}
						}
					);
	
					// Use native DOM manipulation to avoid our domManip AJAX trickery
					document.head.appendChild( script[ 0 ] );
				},
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	var oldCallbacks = [],
		rjsonp = /(=)\?(?=&|$)|\?\?/;
	
	// Default jsonp settings
	jQuery.ajaxSetup( {
		jsonp: "callback",
		jsonpCallback: function() {
			var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
			this[ callback ] = true;
			return callback;
		}
	} );
	
	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {
	
		var callbackName, overwritten, responseContainer,
			jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
				"url" :
				typeof s.data === "string" &&
					( s.contentType || "" )
						.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
					rjsonp.test( s.data ) && "data"
			);
	
		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {
	
			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?
				s.jsonpCallback() :
				s.jsonpCallback;
	
			// Insert callback into url or form data
			if ( jsonProp ) {
				s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
			} else if ( s.jsonp !== false ) {
				s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
			}
	
			// Use data converter to retrieve json after script execution
			s.converters[ "script json" ] = function() {
				if ( !responseContainer ) {
					jQuery.error( callbackName + " was not called" );
				}
				return responseContainer[ 0 ];
			};
	
			// Force json dataType
			s.dataTypes[ 0 ] = "json";
	
			// Install callback
			overwritten = window[ callbackName ];
			window[ callbackName ] = function() {
				responseContainer = arguments;
			};
	
			// Clean-up function (fires after converters)
			jqXHR.always( function() {
	
				// If previous value didn't exist - remove it
				if ( overwritten === undefined ) {
					jQuery( window ).removeProp( callbackName );
	
				// Otherwise restore preexisting value
				} else {
					window[ callbackName ] = overwritten;
				}
	
				// Save back as free
				if ( s[ callbackName ] ) {
	
					// Make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;
	
					// Save the callback name for future use
					oldCallbacks.push( callbackName );
				}
	
				// Call if it was a function and we have a response
				if ( responseContainer && jQuery.isFunction( overwritten ) ) {
					overwritten( responseContainer[ 0 ] );
				}
	
				responseContainer = overwritten = undefined;
			} );
	
			// Delegate to script
			return "script";
		}
	} );
	
	
	
	
	// Support: Safari 8 only
	// In Safari 8 documents created via document.implementation.createHTMLDocument
	// collapse sibling forms: the second one becomes a child of the first one.
	// Because of that, this security measure has to be disabled in Safari 8.
	// https://bugs.webkit.org/show_bug.cgi?id=137337
	support.createHTMLDocument = ( function() {
		var body = document.implementation.createHTMLDocument( "" ).body;
		body.innerHTML = "<form></form><form></form>";
		return body.childNodes.length === 2;
	} )();
	
	
	// Argument "data" should be string of html
	// context (optional): If specified, the fragment will be created in this context,
	// defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function( data, context, keepScripts ) {
		if ( typeof data !== "string" ) {
			return [];
		}
		if ( typeof context === "boolean" ) {
			keepScripts = context;
			context = false;
		}
	
		var base, parsed, scripts;
	
		if ( !context ) {
	
			// Stop scripts or inline event handlers from being executed immediately
			// by using document.implementation
			if ( support.createHTMLDocument ) {
				context = document.implementation.createHTMLDocument( "" );
	
				// Set the base href for the created document
				// so any parsed elements with URLs
				// are based on the document's URL (gh-2965)
				base = context.createElement( "base" );
				base.href = document.location.href;
				context.head.appendChild( base );
			} else {
				context = document;
			}
		}
	
		parsed = rsingleTag.exec( data );
		scripts = !keepScripts && [];
	
		// Single tag
		if ( parsed ) {
			return [ context.createElement( parsed[ 1 ] ) ];
		}
	
		parsed = buildFragment( [ data ], context, scripts );
	
		if ( scripts && scripts.length ) {
			jQuery( scripts ).remove();
		}
	
		return jQuery.merge( [], parsed.childNodes );
	};
	
	
	/**
	 * Load a url into a page
	 */
	jQuery.fn.load = function( url, params, callback ) {
		var selector, type, response,
			self = this,
			off = url.indexOf( " " );
	
		if ( off > -1 ) {
			selector = stripAndCollapse( url.slice( off ) );
			url = url.slice( 0, off );
		}
	
		// If it's a function
		if ( jQuery.isFunction( params ) ) {
	
			// We assume that it's the callback
			callback = params;
			params = undefined;
	
		// Otherwise, build a param string
		} else if ( params && typeof params === "object" ) {
			type = "POST";
		}
	
		// If we have elements to modify, make the request
		if ( self.length > 0 ) {
			jQuery.ajax( {
				url: url,
	
				// If "type" variable is undefined, then "GET" method will be used.
				// Make value of this field explicit since
				// user can override it through ajaxSetup method
				type: type || "GET",
				dataType: "html",
				data: params
			} ).done( function( responseText ) {
	
				// Save response for use in complete callback
				response = arguments;
	
				self.html( selector ?
	
					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :
	
					// Otherwise use the full result
					responseText );
	
			// If the request succeeds, this function gets "data", "status", "jqXHR"
			// but they are ignored because response was set above.
			// If it fails, this function gets "jqXHR", "status", "error"
			} ).always( callback && function( jqXHR, status ) {
				self.each( function() {
					callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
				} );
			} );
		}
	
		return this;
	};
	
	
	
	
	// Attach a bunch of functions for handling common AJAX events
	jQuery.each( [
		"ajaxStart",
		"ajaxStop",
		"ajaxComplete",
		"ajaxError",
		"ajaxSuccess",
		"ajaxSend"
	], function( i, type ) {
		jQuery.fn[ type ] = function( fn ) {
			return this.on( type, fn );
		};
	} );
	
	
	
	
	jQuery.expr.pseudos.animated = function( elem ) {
		return jQuery.grep( jQuery.timers, function( fn ) {
			return elem === fn.elem;
		} ).length;
	};
	
	
	
	
	/**
	 * Gets a window from an element
	 */
	function getWindow( elem ) {
		return jQuery.isWindow( elem ) ? elem : elem.nodeType === 9 && elem.defaultView;
	}
	
	jQuery.offset = {
		setOffset: function( elem, options, i ) {
			var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
				position = jQuery.css( elem, "position" ),
				curElem = jQuery( elem ),
				props = {};
	
			// Set position first, in-case top/left are set even on static elem
			if ( position === "static" ) {
				elem.style.position = "relative";
			}
	
			curOffset = curElem.offset();
			curCSSTop = jQuery.css( elem, "top" );
			curCSSLeft = jQuery.css( elem, "left" );
			calculatePosition = ( position === "absolute" || position === "fixed" ) &&
				( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;
	
			// Need to be able to calculate position if either
			// top or left is auto and position is either absolute or fixed
			if ( calculatePosition ) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;
	
			} else {
				curTop = parseFloat( curCSSTop ) || 0;
				curLeft = parseFloat( curCSSLeft ) || 0;
			}
	
			if ( jQuery.isFunction( options ) ) {
	
				// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
				options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
			}
	
			if ( options.top != null ) {
				props.top = ( options.top - curOffset.top ) + curTop;
			}
			if ( options.left != null ) {
				props.left = ( options.left - curOffset.left ) + curLeft;
			}
	
			if ( "using" in options ) {
				options.using.call( elem, props );
	
			} else {
				curElem.css( props );
			}
		}
	};
	
	jQuery.fn.extend( {
		offset: function( options ) {
	
			// Preserve chaining for setter
			if ( arguments.length ) {
				return options === undefined ?
					this :
					this.each( function( i ) {
						jQuery.offset.setOffset( this, options, i );
					} );
			}
	
			var docElem, win, rect, doc,
				elem = this[ 0 ];
	
			if ( !elem ) {
				return;
			}
	
			// Support: IE <=11 only
			// Running getBoundingClientRect on a
			// disconnected node in IE throws an error
			if ( !elem.getClientRects().length ) {
				return { top: 0, left: 0 };
			}
	
			rect = elem.getBoundingClientRect();
	
			// Make sure element is not hidden (display: none)
			if ( rect.width || rect.height ) {
				doc = elem.ownerDocument;
				win = getWindow( doc );
				docElem = doc.documentElement;
	
				return {
					top: rect.top + win.pageYOffset - docElem.clientTop,
					left: rect.left + win.pageXOffset - docElem.clientLeft
				};
			}
	
			// Return zeros for disconnected and hidden elements (gh-2310)
			return rect;
		},
	
		position: function() {
			if ( !this[ 0 ] ) {
				return;
			}
	
			var offsetParent, offset,
				elem = this[ 0 ],
				parentOffset = { top: 0, left: 0 };
	
			// Fixed elements are offset from window (parentOffset = {top:0, left: 0},
			// because it is its only offset parent
			if ( jQuery.css( elem, "position" ) === "fixed" ) {
	
				// Assume getBoundingClientRect is there when computed position is fixed
				offset = elem.getBoundingClientRect();
	
			} else {
	
				// Get *real* offsetParent
				offsetParent = this.offsetParent();
	
				// Get correct offsets
				offset = this.offset();
				if ( !jQuery.nodeName( offsetParent[ 0 ], "html" ) ) {
					parentOffset = offsetParent.offset();
				}
	
				// Add offsetParent borders
				parentOffset = {
					top: parentOffset.top + jQuery.css( offsetParent[ 0 ], "borderTopWidth", true ),
					left: parentOffset.left + jQuery.css( offsetParent[ 0 ], "borderLeftWidth", true )
				};
			}
	
			// Subtract parent offsets and element margins
			return {
				top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
				left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
			};
		},
	
		// This method will return documentElement in the following cases:
		// 1) For the element inside the iframe without offsetParent, this method will return
		//    documentElement of the parent window
		// 2) For the hidden or detached element
		// 3) For body or html element, i.e. in case of the html node - it will return itself
		//
		// but those exceptions were never presented as a real life use-cases
		// and might be considered as more preferable results.
		//
		// This logic, however, is not guaranteed and can change at any point in the future
		offsetParent: function() {
			return this.map( function() {
				var offsetParent = this.offsetParent;
	
				while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
					offsetParent = offsetParent.offsetParent;
				}
	
				return offsetParent || documentElement;
			} );
		}
	} );
	
	// Create scrollLeft and scrollTop methods
	jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
		var top = "pageYOffset" === prop;
	
		jQuery.fn[ method ] = function( val ) {
			return access( this, function( elem, method, val ) {
				var win = getWindow( elem );
	
				if ( val === undefined ) {
					return win ? win[ prop ] : elem[ method ];
				}
	
				if ( win ) {
					win.scrollTo(
						!top ? val : win.pageXOffset,
						top ? val : win.pageYOffset
					);
	
				} else {
					elem[ method ] = val;
				}
			}, method, val, arguments.length );
		};
	} );
	
	// Support: Safari <=7 - 9.1, Chrome <=37 - 49
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
	// getComputedStyle returns percent when specified for top/left/bottom/right;
	// rather than make the css module depend on the offset module, just check for it here
	jQuery.each( [ "top", "left" ], function( i, prop ) {
		jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
			function( elem, computed ) {
				if ( computed ) {
					computed = curCSS( elem, prop );
	
					// If curCSS returns percentage, fallback to offset
					return rnumnonpx.test( computed ) ?
						jQuery( elem ).position()[ prop ] + "px" :
						computed;
				}
			}
		);
	} );
	
	
	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
		jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
			function( defaultExtra, funcName ) {
	
			// Margin is only for outerHeight, outerWidth
			jQuery.fn[ funcName ] = function( margin, value ) {
				var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
					extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );
	
				return access( this, function( elem, type, value ) {
					var doc;
	
					if ( jQuery.isWindow( elem ) ) {
	
						// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
						return funcName.indexOf( "outer" ) === 0 ?
							elem[ "inner" + name ] :
							elem.document.documentElement[ "client" + name ];
					}
	
					// Get document width or height
					if ( elem.nodeType === 9 ) {
						doc = elem.documentElement;
	
						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
						// whichever is greatest
						return Math.max(
							elem.body[ "scroll" + name ], doc[ "scroll" + name ],
							elem.body[ "offset" + name ], doc[ "offset" + name ],
							doc[ "client" + name ]
						);
					}
	
					return value === undefined ?
	
						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css( elem, type, extra ) :
	
						// Set width or height on the element
						jQuery.style( elem, type, value, extra );
				}, type, chainable ? margin : undefined, chainable );
			};
		} );
	} );
	
	
	jQuery.fn.extend( {
	
		bind: function( types, data, fn ) {
			return this.on( types, null, data, fn );
		},
		unbind: function( types, fn ) {
			return this.off( types, null, fn );
		},
	
		delegate: function( selector, types, data, fn ) {
			return this.on( types, selector, data, fn );
		},
		undelegate: function( selector, types, fn ) {
	
			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ?
				this.off( selector, "**" ) :
				this.off( types, selector || "**", fn );
		}
	} );
	
	jQuery.parseJSON = JSON.parse;
	
	
	
	
	// Register as a named AMD module, since jQuery can be concatenated with other
	// files that may use define, but not via a proper concatenation script that
	// understands anonymous AMD modules. A named AMD is safest and most robust
	// way to register. Lowercase jquery is used because AMD module names are
	// derived from file names, and jQuery is normally delivered in a lowercase
	// file name. Do this after creating the global so that if an AMD module wants
	// to call noConflict to hide this version of jQuery, it will work.
	
	// Note that for maximum portability, libraries that are not jQuery should
	// declare themselves as anonymous modules, and avoid setting a global if an
	// AMD loader is present. jQuery is a special case. For more information, see
	// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
	
	if ( true ) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return jQuery;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	
	
	
	var
	
		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,
	
		// Map over the $ in case of overwrite
		_$ = window.$;
	
	jQuery.noConflict = function( deep ) {
		if ( window.$ === jQuery ) {
			window.$ = _$;
		}
	
		if ( deep && window.jQuery === jQuery ) {
			window.jQuery = _jQuery;
		}
	
		return jQuery;
	};
	
	// Expose jQuery and $ identifiers, even in AMD
	// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (#13566)
	if ( !noGlobal ) {
		window.jQuery = window.$ = jQuery;
	}
	
	
	
	
	
	return jQuery;
	} );


/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(55);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(55);
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (
	      promise._81 === 2 && // IS REJECTED
	      rejections[promise._72]
	    ) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) { // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._72),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(127);


/***/ },
/* 114 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = {
	  Properties: {
	    // Global States and Properties
	    'aria-current': 0, // state
	    'aria-details': 0,
	    'aria-disabled': 0, // state
	    'aria-hidden': 0, // state
	    'aria-invalid': 0, // state
	    'aria-keyshortcuts': 0,
	    'aria-label': 0,
	    'aria-roledescription': 0,
	    // Widget Attributes
	    'aria-autocomplete': 0,
	    'aria-checked': 0,
	    'aria-expanded': 0,
	    'aria-haspopup': 0,
	    'aria-level': 0,
	    'aria-modal': 0,
	    'aria-multiline': 0,
	    'aria-multiselectable': 0,
	    'aria-orientation': 0,
	    'aria-placeholder': 0,
	    'aria-pressed': 0,
	    'aria-readonly': 0,
	    'aria-required': 0,
	    'aria-selected': 0,
	    'aria-sort': 0,
	    'aria-valuemax': 0,
	    'aria-valuemin': 0,
	    'aria-valuenow': 0,
	    'aria-valuetext': 0,
	    // Live Region Attributes
	    'aria-atomic': 0,
	    'aria-busy': 0,
	    'aria-live': 0,
	    'aria-relevant': 0,
	    // Drag-and-Drop Attributes
	    'aria-dropeffect': 0,
	    'aria-grabbed': 0,
	    // Relationship Attributes
	    'aria-activedescendant': 0,
	    'aria-colcount': 0,
	    'aria-colindex': 0,
	    'aria-colspan': 0,
	    'aria-controls': 0,
	    'aria-describedby': 0,
	    'aria-errormessage': 0,
	    'aria-flowto': 0,
	    'aria-labelledby': 0,
	    'aria-owns': 0,
	    'aria-posinset': 0,
	    'aria-rowcount': 0,
	    'aria-rowindex': 0,
	    'aria-rowspan': 0,
	    'aria-setsize': 0
	  },
	  DOMAttributeNames: {},
	  DOMPropertyNames: {}
	};
	
	module.exports = ARIADOMPropertyConfig;

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(5);
	
	var focusNode = __webpack_require__(52);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(21);
	var ExecutionEnvironment = __webpack_require__(6);
	var FallbackCompositionState = __webpack_require__(122);
	var SyntheticCompositionEvent = __webpack_require__(159);
	var SyntheticInputEvent = __webpack_require__(162);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: 'onBeforeInput',
	      captured: 'onBeforeInputCapture'
	    },
	    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionEnd',
	      captured: 'onCompositionEndCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionStart',
	      captured: 'onCompositionStartCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionUpdate',
	      captured: 'onCompositionUpdateCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case 'topCompositionStart':
	      return eventTypes.compositionStart;
	    case 'topCompositionEnd':
	      return eventTypes.compositionEnd;
	    case 'topCompositionUpdate':
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topKeyUp':
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case 'topKeyDown':
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case 'topKeyPress':
	    case 'topMouseDown':
	    case 'topBlur':
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topCompositionEnd':
	      return getDataFromCustomEvent(nativeEvent);
	    case 'topKeyPress':
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case 'topTextInput':
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  // If composition event is available, we extract a string only at
	  // compositionevent, otherwise extract it at fallback events.
	  if (currentComposition) {
	    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case 'topPaste':
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case 'topKeyPress':
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case 'topCompositionEnd':
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(56);
	var ExecutionEnvironment = __webpack_require__(6);
	var ReactInstrumentation = __webpack_require__(8);
	
	var camelizeStyleName = __webpack_require__(98);
	var dangerousStyleValue = __webpack_require__(168);
	var hyphenateStyleName = __webpack_require__(105);
	var memoizeStringOnly = __webpack_require__(108);
	var warning = __webpack_require__(2);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Style property values shouldn\'t contain a semicolon.%s ' + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var styleValue = styles[styleName];
	      if (false) {
	        warnValidStyle(styleName, styleValue, component);
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: component._debugID,
	        type: 'update styles',
	        payload: styles
	      });
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      if (false) {
	        warnValidStyle(styleName, styles[styleName], component);
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	
	};
	
	module.exports = CSSPropertyOperations;

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(20);
	var EventPropagators = __webpack_require__(21);
	var ExecutionEnvironment = __webpack_require__(6);
	var ReactDOMComponentTree = __webpack_require__(5);
	var ReactUpdates = __webpack_require__(9);
	var SyntheticEvent = __webpack_require__(10);
	
	var getEventTarget = __webpack_require__(45);
	var isEventSupported = __webpack_require__(46);
	var isTextInputElement = __webpack_require__(73);
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: 'onChange',
	      captured: 'onChangeCapture'
	    },
	    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
	  }
	};
	
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	var activeElementValue = null;
	var activeElementValueProp = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topChange') {
	    return targetInst;
	  }
	}
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	  // IE10+ fire input events to often, such when a placeholder
	  // changes or when an input with a placeholder is focused.
	  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 11);
	}
	
	/**
	 * (For IE <=11) Replacement getter/setter for the `value` property that gets
	 * set on the active element.
	 */
	var newValueProp = {
	  get: function () {
	    return activeElementValueProp.get.call(this);
	  },
	  set: function (val) {
	    // Cast to a string so we can do equality checks.
	    activeElementValue = '' + val;
	    activeElementValueProp.set.call(this, val);
	  }
	};
	
	/**
	 * (For IE <=11) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElementValue = target.value;
	  activeElementValueProp = Object.getOwnPropertyDescriptor(target.constructor.prototype, 'value');
	
	  // Not guarded in a canDefineProperty check: IE8 supports defineProperty only
	  // on DOM elements
	  Object.defineProperty(activeElement, 'value', newValueProp);
	  if (activeElement.attachEvent) {
	    activeElement.attachEvent('onpropertychange', handlePropertyChange);
	  } else {
	    activeElement.addEventListener('propertychange', handlePropertyChange, false);
	  }
	}
	
	/**
	 * (For IE <=11) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	
	  // delete restores the original property definition
	  delete activeElement.value;
	
	  if (activeElement.detachEvent) {
	    activeElement.detachEvent('onpropertychange', handlePropertyChange);
	  } else {
	    activeElement.removeEventListener('propertychange', handlePropertyChange, false);
	  }
	
	  activeElement = null;
	  activeElementInst = null;
	  activeElementValue = null;
	  activeElementValueProp = null;
	}
	
	/**
	 * (For IE <=11) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  var value = nativeEvent.srcElement.value;
	  if (value === activeElementValue) {
	    return;
	  }
	  activeElementValue = value;
	
	  manualDispatchChangeEvent(nativeEvent);
	}
	
	/**
	 * If a `change` event should be fired, returns the target's ID.
	 */
	function getTargetInstForInputEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topInput') {
	    // In modern browsers (i.e., not IE8 or IE9), the input event is exactly
	    // what we want so fall through here and trigger an abstract event
	    return targetInst;
	  }
	}
	
	function handleEventsForInputEventIE(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9-11, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventIE(topLevelType, targetInst) {
	  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    if (activeElement && activeElement.value !== activeElementValue) {
	      activeElementValue = activeElement.value;
	      return activeElementInst;
	    }
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  return elem.nodeName && elem.nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topClick') {
	    return targetInst;
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventIE;
	        handleEventFunc = handleEventsForInputEventIE;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst);
	      if (inst) {
	        var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, nativeEventTarget);
	        event.type = 'change';
	        EventPropagators.accumulateTwoPhaseDispatches(event);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	  }
	
	};
	
	module.exports = ChangeEventPlugin;

/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var DOMLazyTree = __webpack_require__(13);
	var ExecutionEnvironment = __webpack_require__(6);
	
	var createNodesFromMarkup = __webpack_require__(101);
	var emptyFunction = __webpack_require__(7);
	var invariant = __webpack_require__(1);
	
	var Danger = {
	
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	
	};
	
	module.exports = Danger;

/***/ },
/* 120 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	
	var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];
	
	module.exports = DefaultEventPluginOrder;

/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(21);
	var ReactDOMComponentTree = __webpack_require__(5);
	var SyntheticMouseEvent = __webpack_require__(26);
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: 'onMouseEnter',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  },
	  mouseLeave: {
	    registrationName: 'onMouseLeave',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  }
	};
	
	var EnterLeaveEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === 'topMouseOut') {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var PooledClass = __webpack_require__(12);
	
	var getTextContentAccessor = __webpack_require__(71);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(14);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    // specifies target context for links with `preload` type
	    as: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: HAS_BOOLEAN_VALUE,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {}
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(15);
	
	var instantiateReactComponent = __webpack_require__(72);
	var KeyEscapeUtils = __webpack_require__(37);
	var shouldUpdateReactComponent = __webpack_require__(47);
	var traverseAllChildren = __webpack_require__(75);
	var warning = __webpack_require__(2);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_URL":"/frankfurt_districts"}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(76);
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    if (!ReactComponentTreeHook) {
	      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	    }
	    if (!keyUnique) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID // 0 in production and for roots
	  ) {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID // 0 in production and for roots
	  ) {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(54)))

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(33);
	var ReactDOMIDOperations = __webpack_require__(132);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3),
	    _assign = __webpack_require__(4);
	
	var React = __webpack_require__(16);
	var ReactComponentEnvironment = __webpack_require__(39);
	var ReactCurrentOwner = __webpack_require__(11);
	var ReactErrorUtils = __webpack_require__(40);
	var ReactInstanceMap = __webpack_require__(22);
	var ReactInstrumentation = __webpack_require__(8);
	var ReactNodeTypes = __webpack_require__(66);
	var ReactReconciler = __webpack_require__(15);
	
	if (false) {
	  var checkReactTypeSpec = require('./checkReactTypeSpec');
	}
	
	var emptyObject = __webpack_require__(19);
	var invariant = __webpack_require__(1);
	var shallowEqual = __webpack_require__(31);
	var shouldUpdateReactComponent = __webpack_require__(47);
	var warning = __webpack_require__(2);
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	// Separated into a function to contain deoptimizations caused by try/finally.
	function measureLifeCyclePerf(fn, debugID, timerType) {
	  if (debugID === 0) {
	    // Top-level wrappers (see ReactMount) and empty components (see
	    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
	    // Both are implementation details that should go away in the future.
	    return fn();
	  }
	
	  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
	  try {
	    return fn();
	  } finally {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
	  }
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponent = {
	
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = 0;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + 'up the same props that your component\'s constructor was passed.', componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(function () {
	            return inst.componentDidMount();
	          }, _this._debugID, 'componentDidMount');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	
	    if (doConstruct) {
	      if (false) {
	        return measureLifeCyclePerf(function () {
	          return new Component(publicProps, publicContext, updateQueue);
	        }, this._debugID, 'ctor');
	      } else {
	        return new Component(publicProps, publicContext, updateQueue);
	      }
	    }
	
	    // This can still be an instance in case of factory components
	    // but we'll count this as time spent rendering as the more common case.
	    if (false) {
	      return measureLifeCyclePerf(function () {
	        return Component(publicProps, publicContext, updateQueue);
	      }, this._debugID, 'render');
	    } else {
	      return Component(publicProps, publicContext, updateQueue);
	    }
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (inst.componentWillMount) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillMount();
	        }, debugID, 'componentWillMount');
	      } else {
	        inst.componentWillMount();
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
	
	    if (false) {
	      if (debugID !== 0) {
	        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        if (false) {
	          measureLifeCyclePerf(function () {
	            return inst.componentWillUnmount();
	          }, this._debugID, 'componentWillUnmount');
	        } else {
	          inst.componentWillUnmount();
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = 0;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext;
	
	    if (inst.getChildContext) {
	      if (false) {
	        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	        try {
	          childContext = inst.getChildContext();
	        } finally {
	          ReactInstrumentation.debugTool.onEndProcessingChildContext();
	        }
	      } else {
	        childContext = inst.getChildContext();
	      }
	    }
	
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, 'childContext');
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    if (false) {
	      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillReceiveProps(nextProps, nextContext);
	        }, this._debugID, 'componentWillReceiveProps');
	      } else {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (false) {
	          shouldUpdate = measureLifeCyclePerf(function () {
	            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	          }, this._debugID, 'shouldComponentUpdate');
	        } else {
	          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var _this2 = this;
	
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillUpdate(nextProps, nextState, nextContext);
	        }, this._debugID, 'componentWillUpdate');
	      } else {
	        inst.componentWillUpdate(nextProps, nextState, nextContext);
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
	
	      if (false) {
	        if (debugID !== 0) {
	          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedElement;
	
	    if (false) {
	      renderedElement = measureLifeCyclePerf(function () {
	        return inst.render();
	      }, this._debugID, 'render');
	    } else {
	      renderedElement = inst.render();
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedElement === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedElement = null;
	      }
	    }
	
	    return renderedElement;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedElement;
	    if (("production") !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedElement;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	
	};
	
	module.exports = ReactCompositeComponent;

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(5);
	var ReactDefaultInjection = __webpack_require__(140);
	var ReactMount = __webpack_require__(65);
	var ReactReconciler = __webpack_require__(15);
	var ReactUpdates = __webpack_require__(9);
	var ReactVersion = __webpack_require__(153);
	
	var findDOMNode = __webpack_require__(169);
	var getHostComponentFromComposite = __webpack_require__(70);
	var renderSubtreeIntoContainer = __webpack_require__(177);
	var warning = __webpack_require__(2);
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, 'It looks like you\'re using a minified copy of the development build ' + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	if (false) {
	  var ReactInstrumentation = require('./ReactInstrumentation');
	  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
	  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
	  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');
	
	  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
	}
	
	module.exports = ReactDOM;

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3),
	    _assign = __webpack_require__(4);
	
	var AutoFocusUtils = __webpack_require__(115);
	var CSSPropertyOperations = __webpack_require__(117);
	var DOMLazyTree = __webpack_require__(13);
	var DOMNamespaces = __webpack_require__(34);
	var DOMProperty = __webpack_require__(14);
	var DOMPropertyOperations = __webpack_require__(58);
	var EventPluginHub = __webpack_require__(20);
	var EventPluginRegistry = __webpack_require__(35);
	var ReactBrowserEventEmitter = __webpack_require__(25);
	var ReactDOMComponentFlags = __webpack_require__(59);
	var ReactDOMComponentTree = __webpack_require__(5);
	var ReactDOMInput = __webpack_require__(133);
	var ReactDOMOption = __webpack_require__(134);
	var ReactDOMSelect = __webpack_require__(60);
	var ReactDOMTextarea = __webpack_require__(137);
	var ReactInstrumentation = __webpack_require__(8);
	var ReactMultiChild = __webpack_require__(146);
	var ReactServerRenderingTransaction = __webpack_require__(151);
	
	var emptyFunction = __webpack_require__(7);
	var escapeTextContentForBrowser = __webpack_require__(28);
	var invariant = __webpack_require__(1);
	var isEventSupported = __webpack_require__(46);
	var shallowEqual = __webpack_require__(31);
	var validateDOMNesting = __webpack_require__(48);
	var warning = __webpack_require__(2);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { 'string': true, 'number': true };
	
	var STYLE = 'style';
	var HTML = '__html';
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), 'This browser doesn\'t support the `onScroll` event') : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setAndValidateContentChildDev = emptyFunction;
	if (false) {
	  setAndValidateContentChildDev = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    // This ID represents the inlined child that has no backing instance:
	    var contentDebugID = -debugID;
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    validateDOMNesting(null, String(content), this, this._ancestorInfo);
	    this._contentDebugID = contentDebugID;
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  'area': true,
	  'base': true,
	  'br': true,
	  'col': true,
	  'embed': true,
	  'hr': true,
	  'img': true,
	  'input': true,
	  'keygen': true,
	  'link': true,
	  'meta': true,
	  'param': true,
	  'source': true,
	  'track': true,
	  'wbr': true
	};
	
	var newlineEatingTags = {
	  'listing': true,
	  'pre': true,
	  'textarea': true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  'menuitem': true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = 0;
	  this._domID = 0;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setAndValidateContentChildDev.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the parent component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, null, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      // TODO: Validate that text is allowed as a child of this node
	      if (contentToUse != null) {
	        // Avoid setting textContent when the text is empty. In IE11 setting
	        // textContent on a text area will cause the placeholder to not
	        // show within the textarea until it has been focused and blurred again.
	        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
	        if (contentToUse !== '') {
	          if (false) {
	            setAndValidateContentChildDev.call(this, contentToUse);
	          }
	          DOMLazyTree.queueText(lazyTree, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'input':
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    switch (this._tag) {
	      case 'input':
	        // Update the wrapper around inputs *after* updating props. This has to
	        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
	        // raise warnings and prevent the new value from being assigned.
	        ReactDOMInput.updateWrapper(this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        break;
	      case 'select':
	        // <select> value update needs to occur after <option> children
	        // reconciliation
	        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	        break;
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setAndValidateContentChildDev.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setAndValidateContentChildDev.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    this._rootNodeID = 0;
	    this._domID = 0;
	    this._wrapperState = null;
	
	    if (false) {
	      setAndValidateContentChildDev.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(48);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var DOMLazyTree = __webpack_require__(13);
	var ReactDOMComponentTree = __webpack_require__(5);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = 0;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ },
/* 131 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true,
	  useFiber: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(33);
	var ReactDOMComponentTree = __webpack_require__(5);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3),
	    _assign = __webpack_require__(4);
	
	var DOMPropertyOperations = __webpack_require__(58);
	var LinkedValueUtils = __webpack_require__(38);
	var ReactDOMComponentTree = __webpack_require__(5);
	var ReactUpdates = __webpack_require__(9);
	
	var invariant = __webpack_require__(1);
	var warning = __webpack_require__(2);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked != null : props.value != null;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined,
	      // Make sure we set .min & .max before .value (to ensure proper order
	      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
	      min: undefined,
	      max: undefined
	    }, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	
	    if (false) {
	      inst._wrapperState.controlled = isControlled(props);
	    }
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        // In Chrome, assigning defaultValue to certain input types triggers input validation.
	        // For number inputs, the display value loses trailing decimal points. For email inputs,
	        // Chrome raises "The specified value <x> is not a valid email address".
	        //
	        // Here we check to see if the defaultValue has actually changed, avoiding these problems
	        // when the user is inputting text
	        //
	        // https://github.com/facebook/react/issues/7253
	        if (node.defaultValue !== '' + props.defaultValue) {
	          node.defaultValue = '' + props.defaultValue;
	        }
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	
	    switch (props.type) {
	      case 'submit':
	      case 'reset':
	        break;
	      case 'color':
	      case 'date':
	      case 'datetime':
	      case 'datetime-local':
	      case 'month':
	      case 'time':
	      case 'week':
	        // This fixes the no-show issue on iOS Safari and Android Chrome:
	        // https://github.com/facebook/react/issues/7233
	        node.value = '';
	        node.value = node.defaultValue;
	        break;
	      default:
	        node.value = node.value;
	        break;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var React = __webpack_require__(16);
	var ReactDOMComponentTree = __webpack_require__(5);
	var ReactDOMSelect = __webpack_require__(60);
	
	var warning = __webpack_require__(2);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  React.Children.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	
	};
	
	module.exports = ReactDOMOption;

/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(6);
	
	var getNodeForCharacterOffset = __webpack_require__(174);
	var getTextContentAccessor = __webpack_require__(71);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3),
	    _assign = __webpack_require__(4);
	
	var DOMChildrenOperations = __webpack_require__(33);
	var DOMLazyTree = __webpack_require__(13);
	var ReactDOMComponentTree = __webpack_require__(5);
	
	var escapeTextContentForBrowser = __webpack_require__(28);
	var invariant = __webpack_require__(1);
	var validateDOMNesting = __webpack_require__(48);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = 0;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(null, this._stringText, this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	
	});
	
	module.exports = ReactDOMTextComponent;

/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3),
	    _assign = __webpack_require__(4);
	
	var LinkedValueUtils = __webpack_require__(38);
	var ReactDOMComponentTree = __webpack_require__(5);
	var ReactUpdates = __webpack_require__(9);
	
	var invariant = __webpack_require__(1);
	var warning = __webpack_require__(2);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, props, {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var textContent = node.textContent;
	
	    // Only set node.value if textContent is equal to the expected
	    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
	    // will populate textContent as well.
	    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
	    if (textContent === inst._wrapperState.initialValue) {
	      node.value = textContent;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var invariant = __webpack_require__(1);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], 'captured', arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], 'bubbled', arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], 'bubbled', argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], 'captured', argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var ReactUpdates = __webpack_require__(9);
	var Transaction = __webpack_require__(27);
	
	var emptyFunction = __webpack_require__(7);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      return callback(a, b, c, d, e);
	    } else {
	      return transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = __webpack_require__(114);
	var BeforeInputEventPlugin = __webpack_require__(116);
	var ChangeEventPlugin = __webpack_require__(118);
	var DefaultEventPluginOrder = __webpack_require__(120);
	var EnterLeaveEventPlugin = __webpack_require__(121);
	var HTMLDOMPropertyConfig = __webpack_require__(123);
	var ReactComponentBrowserEnvironment = __webpack_require__(125);
	var ReactDOMComponent = __webpack_require__(128);
	var ReactDOMComponentTree = __webpack_require__(5);
	var ReactDOMEmptyComponent = __webpack_require__(130);
	var ReactDOMTreeTraversal = __webpack_require__(138);
	var ReactDOMTextComponent = __webpack_require__(136);
	var ReactDefaultBatchingStrategy = __webpack_require__(139);
	var ReactEventListener = __webpack_require__(143);
	var ReactInjection = __webpack_require__(144);
	var ReactReconcileTransaction = __webpack_require__(149);
	var SVGDOMPropertyConfig = __webpack_require__(154);
	var SelectEventPlugin = __webpack_require__(155);
	var SimpleEventPlugin = __webpack_require__(156);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ },
/* 141 */
77,
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(20);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var EventListener = __webpack_require__(51);
	var ExecutionEnvironment = __webpack_require__(6);
	var PooledClass = __webpack_require__(12);
	var ReactDOMComponentTree = __webpack_require__(5);
	var ReactUpdates = __webpack_require__(9);
	
	var getEventTarget = __webpack_require__(45);
	var getUnboundedScrollPosition = __webpack_require__(103);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(14);
	var EventPluginHub = __webpack_require__(20);
	var EventPluginUtils = __webpack_require__(36);
	var ReactComponentEnvironment = __webpack_require__(39);
	var ReactEmptyComponent = __webpack_require__(61);
	var ReactBrowserEventEmitter = __webpack_require__(25);
	var ReactHostComponent = __webpack_require__(63);
	var ReactUpdates = __webpack_require__(9);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(167);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var ReactComponentEnvironment = __webpack_require__(39);
	var ReactInstanceMap = __webpack_require__(22);
	var ReactInstrumentation = __webpack_require__(8);
	
	var ReactCurrentOwner = __webpack_require__(11);
	var ReactReconciler = __webpack_require__(15);
	var ReactChildReconciler = __webpack_require__(124);
	
	var emptyFunction = __webpack_require__(7);
	var flattenChildren = __webpack_require__(170);
	var invariant = __webpack_require__(1);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'INSERT_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'MOVE_EXISTING',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'REMOVE_NODE',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'SET_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'TEXT_CONTENT',
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        var selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      var selfDebugID = 0;
	      if (false) {
	        selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var selfDebugID = 0;
	          if (false) {
	            selfDebugID = getDebugID(this);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	
	  }
	
	};
	
	module.exports = ReactMultiChild;

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var invariant = __webpack_require__(1);
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid owner.
	 * @final
	 */
	function isValidOwner(object) {
	  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	}
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	
	};
	
	module.exports = ReactOwner;

/***/ },
/* 148 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var CallbackQueue = __webpack_require__(57);
	var PooledClass = __webpack_require__(12);
	var ReactBrowserEventEmitter = __webpack_require__(25);
	var ReactInputSelection = __webpack_require__(64);
	var ReactInstrumentation = __webpack_require__(8);
	var Transaction = __webpack_require__(27);
	var ReactUpdateQueue = __webpack_require__(41);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(147);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevRef = null;
	  var prevOwner = null;
	  if (prevElement !== null && typeof prevElement === 'object') {
	    prevRef = prevElement.ref;
	    prevOwner = prevElement._owner;
	  }
	
	  var nextRef = null;
	  var nextOwner = null;
	  if (nextElement !== null && typeof nextElement === 'object') {
	    nextRef = nextElement.ref;
	    nextOwner = nextElement._owner;
	  }
	
	  return prevRef !== nextRef ||
	  // If owner changes but we have an unchanged function ref, don't update refs
	  typeof nextRef === 'string' && nextOwner !== prevOwner;
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var PooledClass = __webpack_require__(12);
	var Transaction = __webpack_require__(27);
	var ReactInstrumentation = __webpack_require__(8);
	var ReactServerUpdateQueue = __webpack_require__(152);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__(41);
	
	var warning = __webpack_require__(2);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ },
/* 153 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.4.2';

/***/ },
/* 154 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(21);
	var ExecutionEnvironment = __webpack_require__(6);
	var ReactDOMComponentTree = __webpack_require__(5);
	var ReactInputSelection = __webpack_require__(64);
	var SyntheticEvent = __webpack_require__(10);
	
	var getActiveElement = __webpack_require__(53);
	var isTextInputElement = __webpack_require__(73);
	var shallowEqual = __webpack_require__(31);
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: 'onSelect',
	      captured: 'onSelectCapture'
	    },
	    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case 'topFocus':
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case 'topBlur':
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case 'topMouseDown':
	        mouseDown = true;
	        break;
	      case 'topContextMenu':
	      case 'topMouseUp':
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case 'topSelectionChange':
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case 'topKeyDown':
	      case 'topKeyUp':
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === 'onSelect') {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var EventListener = __webpack_require__(51);
	var EventPropagators = __webpack_require__(21);
	var ReactDOMComponentTree = __webpack_require__(5);
	var SyntheticAnimationEvent = __webpack_require__(157);
	var SyntheticClipboardEvent = __webpack_require__(158);
	var SyntheticEvent = __webpack_require__(10);
	var SyntheticFocusEvent = __webpack_require__(161);
	var SyntheticKeyboardEvent = __webpack_require__(163);
	var SyntheticMouseEvent = __webpack_require__(26);
	var SyntheticDragEvent = __webpack_require__(160);
	var SyntheticTouchEvent = __webpack_require__(164);
	var SyntheticTransitionEvent = __webpack_require__(165);
	var SyntheticUIEvent = __webpack_require__(23);
	var SyntheticWheelEvent = __webpack_require__(166);
	
	var emptyFunction = __webpack_require__(7);
	var getEventCharCode = __webpack_require__(43);
	var invariant = __webpack_require__(1);
	
	/**
	 * Turns
	 * ['abort', ...]
	 * into
	 * eventTypes = {
	 *   'abort': {
	 *     phasedRegistrationNames: {
	 *       bubbled: 'onAbort',
	 *       captured: 'onAbortCapture',
	 *     },
	 *     dependencies: ['topAbort'],
	 *   },
	 *   ...
	 * };
	 * topLevelEventsToDispatchConfig = {
	 *   'topAbort': { sameConfig }
	 * };
	 */
	var eventTypes = {};
	var topLevelEventsToDispatchConfig = {};
	['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
	  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
	  var onEvent = 'on' + capitalizedEvent;
	  var topEvent = 'top' + capitalizedEvent;
	
	  var type = {
	    phasedRegistrationNames: {
	      bubbled: onEvent,
	      captured: onEvent + 'Capture'
	    },
	    dependencies: [topEvent]
	  };
	  eventTypes[event] = type;
	  topLevelEventsToDispatchConfig[topEvent] = type;
	});
	
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	}
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	var SimpleEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case 'topAbort':
	      case 'topCanPlay':
	      case 'topCanPlayThrough':
	      case 'topDurationChange':
	      case 'topEmptied':
	      case 'topEncrypted':
	      case 'topEnded':
	      case 'topError':
	      case 'topInput':
	      case 'topInvalid':
	      case 'topLoad':
	      case 'topLoadedData':
	      case 'topLoadedMetadata':
	      case 'topLoadStart':
	      case 'topPause':
	      case 'topPlay':
	      case 'topPlaying':
	      case 'topProgress':
	      case 'topRateChange':
	      case 'topReset':
	      case 'topSeeked':
	      case 'topSeeking':
	      case 'topStalled':
	      case 'topSubmit':
	      case 'topSuspend':
	      case 'topTimeUpdate':
	      case 'topVolumeChange':
	      case 'topWaiting':
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case 'topKeyPress':
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case 'topKeyDown':
	      case 'topKeyUp':
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case 'topBlur':
	      case 'topFocus':
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case 'topClick':
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case 'topDoubleClick':
	      case 'topMouseDown':
	      case 'topMouseMove':
	      case 'topMouseUp':
	      // TODO: Disabled elements should not respond to mouse events
	      /* falls through */
	      case 'topMouseOut':
	      case 'topMouseOver':
	      case 'topContextMenu':
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case 'topDrag':
	      case 'topDragEnd':
	      case 'topDragEnter':
	      case 'topDragExit':
	      case 'topDragLeave':
	      case 'topDragOver':
	      case 'topDragStart':
	      case 'topDrop':
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case 'topTouchCancel':
	      case 'topTouchEnd':
	      case 'topTouchMove':
	      case 'topTouchStart':
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case 'topAnimationEnd':
	      case 'topAnimationIteration':
	      case 'topAnimationStart':
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case 'topTransitionEnd':
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case 'topScroll':
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case 'topWheel':
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case 'topCopy':
	      case 'topCut':
	      case 'topPaste':
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	
	};
	
	module.exports = SimpleEventPlugin;

/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(10);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(10);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(10);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(26);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(23);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(10);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(23);
	
	var getEventCharCode = __webpack_require__(43);
	var getEventKey = __webpack_require__(171);
	var getEventModifierState = __webpack_require__(44);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(23);
	
	var getEventModifierState = __webpack_require__(44);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(10);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(26);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX :
	    // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY :
	    // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY :
	    // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ },
/* 167 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(56);
	var warning = __webpack_require__(2);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var ReactCurrentOwner = __webpack_require__(11);
	var ReactDOMComponentTree = __webpack_require__(5);
	var ReactInstanceMap = __webpack_require__(22);
	
	var getHostComponentFromComposite = __webpack_require__(70);
	var invariant = __webpack_require__(1);
	var warning = __webpack_require__(2);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(37);
	var traverseAllChildren = __webpack_require__(75);
	var warning = __webpack_require__(2);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_URL":"/frankfurt_districts"}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(76);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(54)))

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(43);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  'Esc': 'Escape',
	  'Spacebar': ' ',
	  'Left': 'ArrowLeft',
	  'Up': 'ArrowUp',
	  'Right': 'ArrowRight',
	  'Down': 'ArrowDown',
	  'Del': 'Delete',
	  'Win': 'OS',
	  'Menu': 'ContextMenu',
	  'Apps': 'ContextMenu',
	  'Scroll': 'ScrollLock',
	  'MozPrintableKey': 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1', 113: 'F2', 114: 'F3', 115: 'F4', 116: 'F5', 117: 'F6',
	  118: 'F7', 119: 'F8', 120: 'F9', 121: 'F10', 122: 'F11', 123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ },
/* 172 */
80,
/* 173 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var nextDebugID = 1;
	
	function getNextDebugID() {
	  return nextDebugID++;
	}
	
	module.exports = getNextDebugID;

/***/ },
/* 174 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(6);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(28);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(65);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	// @remove-on-eject-begin
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	// @remove-on-eject-end
	
	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(112).enable();
	  window.Promise = __webpack_require__(111);
	}
	
	// fetch() polyfill for making API calls.
	__webpack_require__(179);
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(4);


/***/ },
/* 179 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = String(input)
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    rawHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = 'status' in options ? options.status : 200
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ },
/* 180 */
37,
/* 181 */
[192, 18],
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(181);
	var ReactElement = __webpack_require__(17);
	
	var emptyFunction = __webpack_require__(7);
	var traverseAllChildren = __webpack_require__(190);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(18),
	    _assign = __webpack_require__(4);
	
	var ReactComponent = __webpack_require__(49);
	var ReactElement = __webpack_require__(17);
	var ReactPropTypeLocationNames = __webpack_require__(78);
	var ReactNoopUpdateQueue = __webpack_require__(50);
	
	var emptyObject = __webpack_require__(19);
	var invariant = __webpack_require__(1);
	var warning = __webpack_require__(2);
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	/**
	 * Policies that describe methods in `ReactClassInterface`.
	 */
	
	
	var injectedMixins = [];
	
	/**
	 * Composite components are higher-level components that compose other composite
	 * or host components.
	 *
	 * To create a new type of `ReactClass`, pass a specification of
	 * your new class to `React.createClass`. The only requirement of your class
	 * specification is that you implement a `render` method.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return <div>Hello World</div>;
	 *     }
	 *   });
	 *
	 * The class specification supports a specific protocol of methods that have
	 * special meaning (e.g. `render`). See `ReactClassInterface` for
	 * more the comprehensive protocol. Any other properties and methods in the
	 * class specification will be available on the prototype.
	 *
	 * @interface ReactClassInterface
	 * @internal
	 */
	var ReactClassInterface = {
	
	  /**
	   * An array of Mixin objects to include when defining your component.
	   *
	   * @type {array}
	   * @optional
	   */
	  mixins: 'DEFINE_MANY',
	
	  /**
	   * An object containing properties and methods that should be defined on
	   * the component's constructor instead of its prototype (static methods).
	   *
	   * @type {object}
	   * @optional
	   */
	  statics: 'DEFINE_MANY',
	
	  /**
	   * Definition of prop types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  propTypes: 'DEFINE_MANY',
	
	  /**
	   * Definition of context types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  contextTypes: 'DEFINE_MANY',
	
	  /**
	   * Definition of context types this component sets for its children.
	   *
	   * @type {object}
	   * @optional
	   */
	  childContextTypes: 'DEFINE_MANY',
	
	  // ==== Definition methods ====
	
	  /**
	   * Invoked when the component is mounted. Values in the mapping will be set on
	   * `this.props` if that prop is not specified (i.e. using an `in` check).
	   *
	   * This method is invoked before `getInitialState` and therefore cannot rely
	   * on `this.state` or use `this.setState`.
	   *
	   * @return {object}
	   * @optional
	   */
	  getDefaultProps: 'DEFINE_MANY_MERGED',
	
	  /**
	   * Invoked once before the component is mounted. The return value will be used
	   * as the initial value of `this.state`.
	   *
	   *   getInitialState: function() {
	   *     return {
	   *       isOn: false,
	   *       fooBaz: new BazFoo()
	   *     }
	   *   }
	   *
	   * @return {object}
	   * @optional
	   */
	  getInitialState: 'DEFINE_MANY_MERGED',
	
	  /**
	   * @return {object}
	   * @optional
	   */
	  getChildContext: 'DEFINE_MANY_MERGED',
	
	  /**
	   * Uses props from `this.props` and state from `this.state` to render the
	   * structure of the component.
	   *
	   * No guarantees are made about when or how often this method is invoked, so
	   * it must not have side effects.
	   *
	   *   render: function() {
	   *     var name = this.props.name;
	   *     return <div>Hello, {name}!</div>;
	   *   }
	   *
	   * @return {ReactComponent}
	   * @nosideeffects
	   * @required
	   */
	  render: 'DEFINE_ONCE',
	
	  // ==== Delegate methods ====
	
	  /**
	   * Invoked when the component is initially created and about to be mounted.
	   * This may have side effects, but any external subscriptions or data created
	   * by this method must be cleaned up in `componentWillUnmount`.
	   *
	   * @optional
	   */
	  componentWillMount: 'DEFINE_MANY',
	
	  /**
	   * Invoked when the component has been mounted and has a DOM representation.
	   * However, there is no guarantee that the DOM node is in the document.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been mounted (initialized and rendered) for the first time.
	   *
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidMount: 'DEFINE_MANY',
	
	  /**
	   * Invoked before the component receives new props.
	   *
	   * Use this as an opportunity to react to a prop transition by updating the
	   * state using `this.setState`. Current props are accessed via `this.props`.
	   *
	   *   componentWillReceiveProps: function(nextProps, nextContext) {
	   *     this.setState({
	   *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	   *     });
	   *   }
	   *
	   * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	   * transition may cause a state change, but the opposite is not true. If you
	   * need it, you are probably looking for `componentWillUpdate`.
	   *
	   * @param {object} nextProps
	   * @optional
	   */
	  componentWillReceiveProps: 'DEFINE_MANY',
	
	  /**
	   * Invoked while deciding if the component should be updated as a result of
	   * receiving new props, state and/or context.
	   *
	   * Use this as an opportunity to `return false` when you're certain that the
	   * transition to the new props/state/context will not require a component
	   * update.
	   *
	   *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	   *     return !equal(nextProps, this.props) ||
	   *       !equal(nextState, this.state) ||
	   *       !equal(nextContext, this.context);
	   *   }
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @return {boolean} True if the component should update.
	   * @optional
	   */
	  shouldComponentUpdate: 'DEFINE_ONCE',
	
	  /**
	   * Invoked when the component is about to update due to a transition from
	   * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	   * and `nextContext`.
	   *
	   * Use this as an opportunity to perform preparation before an update occurs.
	   *
	   * NOTE: You **cannot** use `this.setState()` in this method.
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @param {ReactReconcileTransaction} transaction
	   * @optional
	   */
	  componentWillUpdate: 'DEFINE_MANY',
	
	  /**
	   * Invoked when the component's DOM representation has been updated.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been updated.
	   *
	   * @param {object} prevProps
	   * @param {?object} prevState
	   * @param {?object} prevContext
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidUpdate: 'DEFINE_MANY',
	
	  /**
	   * Invoked when the component is about to be removed from its parent and have
	   * its DOM representation destroyed.
	   *
	   * Use this as an opportunity to deallocate any external resources.
	   *
	   * NOTE: There is no `componentDidUnmount` since your component will have been
	   * destroyed by that point.
	   *
	   * @optional
	   */
	  componentWillUnmount: 'DEFINE_MANY',
	
	  // ==== Advanced methods ====
	
	  /**
	   * Updates the component's currently mounted DOM representation.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   * @overridable
	   */
	  updateComponent: 'OVERRIDE_BASE'
	
	};
	
	/**
	 * Mapping from class specification keys to special processing functions.
	 *
	 * Although these are declared like instance properties in the specification
	 * when defining classes using `React.createClass`, they are actually static
	 * and are accessible on the constructor instead of the prototype. Despite
	 * being static, they must be defined outside of the "statics" key under
	 * which all other static methods are defined.
	 */
	var RESERVED_SPEC_KEYS = {
	  displayName: function (Constructor, displayName) {
	    Constructor.displayName = displayName;
	  },
	  mixins: function (Constructor, mixins) {
	    if (mixins) {
	      for (var i = 0; i < mixins.length; i++) {
	        mixSpecIntoComponent(Constructor, mixins[i]);
	      }
	    }
	  },
	  childContextTypes: function (Constructor, childContextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, childContextTypes, 'childContext');
	    }
	    Constructor.childContextTypes = _assign({}, Constructor.childContextTypes, childContextTypes);
	  },
	  contextTypes: function (Constructor, contextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, contextTypes, 'context');
	    }
	    Constructor.contextTypes = _assign({}, Constructor.contextTypes, contextTypes);
	  },
	  /**
	   * Special case getDefaultProps which should move into statics but requires
	   * automatic merging.
	   */
	  getDefaultProps: function (Constructor, getDefaultProps) {
	    if (Constructor.getDefaultProps) {
	      Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
	    } else {
	      Constructor.getDefaultProps = getDefaultProps;
	    }
	  },
	  propTypes: function (Constructor, propTypes) {
	    if (false) {
	      validateTypeDef(Constructor, propTypes, 'prop');
	    }
	    Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	  },
	  statics: function (Constructor, statics) {
	    mixStaticSpecIntoComponent(Constructor, statics);
	  },
	  autobind: function () {} };
	
	function validateTypeDef(Constructor, typeDef, location) {
	  for (var propName in typeDef) {
	    if (typeDef.hasOwnProperty(propName)) {
	      // use a warning instead of an invariant so components
	      // don't show up in prod but only in __DEV__
	       false ? warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName) : void 0;
	    }
	  }
	}
	
	function validateMethodOverride(isAlreadyDefined, name) {
	  var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;
	
	  // Disallow overriding of base class methods unless explicitly allowed.
	  if (ReactClassMixin.hasOwnProperty(name)) {
	    !(specPolicy === 'OVERRIDE_BASE') ?  false ? invariant(false, 'ReactClassInterface: You are attempting to override `%s` from your class specification. Ensure that your method names do not overlap with React methods.', name) : _prodInvariant('73', name) : void 0;
	  }
	
	  // Disallow defining methods more than once unless explicitly allowed.
	  if (isAlreadyDefined) {
	    !(specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED') ?  false ? invariant(false, 'ReactClassInterface: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('74', name) : void 0;
	  }
	}
	
	/**
	 * Mixin helper which handles policy validation and reserved
	 * specification keys when building React classes.
	 */
	function mixSpecIntoComponent(Constructor, spec) {
	  if (!spec) {
	    if (false) {
	      var typeofSpec = typeof spec;
	      var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	      process.env.NODE_ENV !== 'production' ? warning(isMixinValid, '%s: You\'re attempting to include a mixin that is either null ' + 'or not an object. Check the mixins included by the component, ' + 'as well as any mixins they include themselves. ' + 'Expected object but got %s.', Constructor.displayName || 'ReactClass', spec === null ? null : typeofSpec) : void 0;
	    }
	
	    return;
	  }
	
	  !(typeof spec !== 'function') ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component class or function as a mixin. Instead, just use a regular object.') : _prodInvariant('75') : void 0;
	  !!ReactElement.isValidElement(spec) ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component as a mixin. Instead, just use a regular object.') : _prodInvariant('76') : void 0;
	
	  var proto = Constructor.prototype;
	  var autoBindPairs = proto.__reactAutoBindPairs;
	
	  // By handling mixins before any other properties, we ensure the same
	  // chaining order is applied to methods with DEFINE_MANY policy, whether
	  // mixins are listed before or after these methods in the spec.
	  if (spec.hasOwnProperty(MIXINS_KEY)) {
	    RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	  }
	
	  for (var name in spec) {
	    if (!spec.hasOwnProperty(name)) {
	      continue;
	    }
	
	    if (name === MIXINS_KEY) {
	      // We have already handled mixins in a special case above.
	      continue;
	    }
	
	    var property = spec[name];
	    var isAlreadyDefined = proto.hasOwnProperty(name);
	    validateMethodOverride(isAlreadyDefined, name);
	
	    if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	      RESERVED_SPEC_KEYS[name](Constructor, property);
	    } else {
	      // Setup methods on prototype:
	      // The following member methods should not be automatically bound:
	      // 1. Expected ReactClass methods (in the "interface").
	      // 2. Overridden methods (that were mixed in).
	      var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	      var isFunction = typeof property === 'function';
	      var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;
	
	      if (shouldAutoBind) {
	        autoBindPairs.push(name, property);
	        proto[name] = property;
	      } else {
	        if (isAlreadyDefined) {
	          var specPolicy = ReactClassInterface[name];
	
	          // These cases should already be caught by validateMethodOverride.
	          !(isReactClassMethod && (specPolicy === 'DEFINE_MANY_MERGED' || specPolicy === 'DEFINE_MANY')) ?  false ? invariant(false, 'ReactClass: Unexpected spec policy %s for key %s when mixing in component specs.', specPolicy, name) : _prodInvariant('77', specPolicy, name) : void 0;
	
	          // For methods which are defined more than once, call the existing
	          // methods before calling the new property, merging if appropriate.
	          if (specPolicy === 'DEFINE_MANY_MERGED') {
	            proto[name] = createMergedResultFunction(proto[name], property);
	          } else if (specPolicy === 'DEFINE_MANY') {
	            proto[name] = createChainedFunction(proto[name], property);
	          }
	        } else {
	          proto[name] = property;
	          if (false) {
	            // Add verbose displayName to the function, which helps when looking
	            // at profiling tools.
	            if (typeof property === 'function' && spec.displayName) {
	              proto[name].displayName = spec.displayName + '_' + name;
	            }
	          }
	        }
	      }
	    }
	  }
	}
	
	function mixStaticSpecIntoComponent(Constructor, statics) {
	  if (!statics) {
	    return;
	  }
	  for (var name in statics) {
	    var property = statics[name];
	    if (!statics.hasOwnProperty(name)) {
	      continue;
	    }
	
	    var isReserved = name in RESERVED_SPEC_KEYS;
	    !!isReserved ?  false ? invariant(false, 'ReactClass: You are attempting to define a reserved property, `%s`, that shouldn\'t be on the "statics" key. Define it as an instance property instead; it will still be accessible on the constructor.', name) : _prodInvariant('78', name) : void 0;
	
	    var isInherited = name in Constructor;
	    !!isInherited ?  false ? invariant(false, 'ReactClass: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('79', name) : void 0;
	    Constructor[name] = property;
	  }
	}
	
	/**
	 * Merge two objects, but throw if both contain the same key.
	 *
	 * @param {object} one The first object, which is mutated.
	 * @param {object} two The second object
	 * @return {object} one after it has been mutated to contain everything in two.
	 */
	function mergeIntoWithNoDuplicateKeys(one, two) {
	  !(one && two && typeof one === 'object' && typeof two === 'object') ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.') : _prodInvariant('80') : void 0;
	
	  for (var key in two) {
	    if (two.hasOwnProperty(key)) {
	      !(one[key] === undefined) ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Tried to merge two objects with the same key: `%s`. This conflict may be due to a mixin; in particular, this may be caused by two getInitialState() or getDefaultProps() methods returning objects with clashing keys.', key) : _prodInvariant('81', key) : void 0;
	      one[key] = two[key];
	    }
	  }
	  return one;
	}
	
	/**
	 * Creates a function that invokes two functions and merges their return values.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createMergedResultFunction(one, two) {
	  return function mergedResult() {
	    var a = one.apply(this, arguments);
	    var b = two.apply(this, arguments);
	    if (a == null) {
	      return b;
	    } else if (b == null) {
	      return a;
	    }
	    var c = {};
	    mergeIntoWithNoDuplicateKeys(c, a);
	    mergeIntoWithNoDuplicateKeys(c, b);
	    return c;
	  };
	}
	
	/**
	 * Creates a function that invokes two functions and ignores their return vales.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createChainedFunction(one, two) {
	  return function chainedFunction() {
	    one.apply(this, arguments);
	    two.apply(this, arguments);
	  };
	}
	
	/**
	 * Binds a method to the component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 * @param {function} method Method to be bound.
	 * @return {function} The bound method.
	 */
	function bindAutoBindMethod(component, method) {
	  var boundMethod = method.bind(component);
	  if (false) {
	    boundMethod.__reactBoundContext = component;
	    boundMethod.__reactBoundMethod = method;
	    boundMethod.__reactBoundArguments = null;
	    var componentName = component.constructor.displayName;
	    var _bind = boundMethod.bind;
	    boundMethod.bind = function (newThis) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      // User is trying to bind() an autobound method; we effectively will
	      // ignore the value of "this" that the user is trying to use, so
	      // let's warn.
	      if (newThis !== component && newThis !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName) : void 0;
	      } else if (!args.length) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName) : void 0;
	        return boundMethod;
	      }
	      var reboundMethod = _bind.apply(boundMethod, arguments);
	      reboundMethod.__reactBoundContext = component;
	      reboundMethod.__reactBoundMethod = method;
	      reboundMethod.__reactBoundArguments = args;
	      return reboundMethod;
	    };
	  }
	  return boundMethod;
	}
	
	/**
	 * Binds all auto-bound methods in a component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 */
	function bindAutoBindMethods(component) {
	  var pairs = component.__reactAutoBindPairs;
	  for (var i = 0; i < pairs.length; i += 2) {
	    var autoBindKey = pairs[i];
	    var method = pairs[i + 1];
	    component[autoBindKey] = bindAutoBindMethod(component, method);
	  }
	}
	
	/**
	 * Add more to the ReactClass base class. These are all legacy features and
	 * therefore not already part of the modern ReactComponent.
	 */
	var ReactClassMixin = {
	
	  /**
	   * TODO: This will be deprecated because state should always keep a consistent
	   * type signature and the only use case for this, is to avoid that.
	   */
	  replaceState: function (newState, callback) {
	    this.updater.enqueueReplaceState(this, newState);
	    if (callback) {
	      this.updater.enqueueCallback(this, callback, 'replaceState');
	    }
	  },
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function () {
	    return this.updater.isMounted(this);
	  }
	};
	
	var ReactClassComponent = function () {};
	_assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);
	
	/**
	 * Module for creating composite components.
	 *
	 * @class ReactClass
	 */
	var ReactClass = {
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  createClass: function (spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function (props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory') : void 0;
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (initialState === undefined && this.getInitialState._isMockFunction) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent') : _prodInvariant('82', Constructor.displayName || 'ReactCompositeComponent') : void 0;
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, spec);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    !Constructor.prototype.render ?  false ? invariant(false, 'createClass(...): Class specification must implement a `render` method.') : _prodInvariant('83') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component') : void 0;
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  },
	
	  injection: {
	    injectMixin: function (mixin) {
	      injectedMixins.push(mixin);
	    }
	  }
	
	};
	
	module.exports = ReactClass;

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(17);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 * This is also accessible via `React.DOM`.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(17);
	var ReactPropTypeLocationNames = __webpack_require__(78);
	var ReactPropTypesSecret = __webpack_require__(186);
	
	var emptyFunction = __webpack_require__(7);
	var getIteratorFn = __webpack_require__(80);
	var warning = __webpack_require__(2);
	
	/**
	 * Collection of methods that allow declaration and validation of props that are
	 * supplied to React components. Example usage:
	 *
	 *   var Props = require('ReactPropTypes');
	 *   var MyArticle = React.createClass({
	 *     propTypes: {
	 *       // An optional string prop named "description".
	 *       description: Props.string,
	 *
	 *       // A required enum prop named "category".
	 *       category: Props.oneOf(['News','Photos']).isRequired,
	 *
	 *       // A prop named "dialog" that requires an instance of Dialog.
	 *       dialog: Props.instanceOf(Dialog).isRequired
	 *     },
	 *     render: function() { ... }
	 *   });
	 *
	 * A more formal specification of how these methods are used:
	 *
	 *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	 *   decl := ReactPropTypes.{type}(.isRequired)?
	 *
	 * Each and every declaration produces a function with the same signature. This
	 * allows the creation of custom validation functions. For example:
	 *
	 *  var MyLink = React.createClass({
	 *    propTypes: {
	 *      // An optional string or URI prop named "href".
	 *      href: function(props, propName, componentName) {
	 *        var propValue = props[propName];
	 *        if (propValue != null && typeof propValue !== 'string' &&
	 *            !(propValue instanceof URI)) {
	 *          return new Error(
	 *            'Expected a string or an URI for ' + propName + ' in ' +
	 *            componentName
	 *          );
	 *        }
	 *      }
	 *    },
	 *    render: function() {...}
	 *  });
	 *
	 * @internal
	 */
	
	var ANONYMOUS = '<<anonymous>>';
	
	var ReactPropTypes = {
	  array: createPrimitiveTypeChecker('array'),
	  bool: createPrimitiveTypeChecker('boolean'),
	  func: createPrimitiveTypeChecker('function'),
	  number: createPrimitiveTypeChecker('number'),
	  object: createPrimitiveTypeChecker('object'),
	  string: createPrimitiveTypeChecker('string'),
	  symbol: createPrimitiveTypeChecker('symbol'),
	
	  any: createAnyTypeChecker(),
	  arrayOf: createArrayOfTypeChecker,
	  element: createElementTypeChecker(),
	  instanceOf: createInstanceTypeChecker,
	  node: createNodeChecker(),
	  objectOf: createObjectOfTypeChecker,
	  oneOf: createEnumTypeChecker,
	  oneOfType: createUnionTypeChecker,
	  shape: createShapeTypeChecker
	};
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	/*eslint-disable no-self-compare*/
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    return x !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	/*eslint-enable no-self-compare*/
	
	/**
	 * We use an Error-like object for backward compatibility as people may call
	 * PropTypes directly and inspect their output. However we don't use real
	 * Errors anymore. We don't inspect their stack anyway, and creating them
	 * is prohibitively expensive if they are created too often, such as what
	 * happens in oneOfType() for any type before the one that matched.
	 */
	function PropTypeError(message) {
	  this.message = message;
	  this.stack = '';
	}
	// Make `instanceof Error` still work for returned errors.
	PropTypeError.prototype = Error.prototype;
	
	function createChainableTypeChecker(validate) {
	  if (false) {
	    var manualPropTypeCallCache = {};
	  }
	  function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	    componentName = componentName || ANONYMOUS;
	    propFullName = propFullName || propName;
	    if (false) {
	      if (secret !== ReactPropTypesSecret && typeof console !== 'undefined') {
	        var cacheKey = componentName + ':' + propName;
	        if (!manualPropTypeCallCache[cacheKey]) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'You are manually calling a React.PropTypes validation ' + 'function for the `%s` prop on `%s`. This is deprecated ' + 'and will not work in production with the next major version. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.', propFullName, componentName) : void 0;
	          manualPropTypeCallCache[cacheKey] = true;
	        }
	      }
	    }
	    if (props[propName] == null) {
	      var locationName = ReactPropTypeLocationNames[location];
	      if (isRequired) {
	        if (props[propName] === null) {
	          return new PropTypeError('The ' + locationName + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	        }
	        return new PropTypeError('The ' + locationName + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	      }
	      return null;
	    } else {
	      return validate(props, propName, componentName, location, propFullName);
	    }
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}
	
	function createPrimitiveTypeChecker(expectedType) {
	  function validate(props, propName, componentName, location, propFullName, secret) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== expectedType) {
	      var locationName = ReactPropTypeLocationNames[location];
	      // `propValue` being instance of, say, date/regexp, pass the 'object'
	      // check, but we can offer a more precise error message here rather than
	      // 'of type `object`'.
	      var preciseType = getPreciseType(propValue);
	
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createAnyTypeChecker() {
	  return createChainableTypeChecker(emptyFunction.thatReturns(null));
	}
	
	function createArrayOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (typeof typeChecker !== 'function') {
	      return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	    }
	    var propValue = props[propName];
	    if (!Array.isArray(propValue)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var propType = getPropType(propValue);
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	    }
	    for (var i = 0; i < propValue.length; i++) {
	      var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	      if (error instanceof Error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createElementTypeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    if (!ReactElement.isValidElement(propValue)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var propType = getPropType(propValue);
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createInstanceTypeChecker(expectedClass) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!(props[propName] instanceof expectedClass)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var expectedClassName = expectedClass.name || ANONYMOUS;
	      var actualClassName = getClassName(props[propName]);
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createEnumTypeChecker(expectedValues) {
	  if (!Array.isArray(expectedValues)) {
	     false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	    return emptyFunction.thatReturnsNull;
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    for (var i = 0; i < expectedValues.length; i++) {
	      if (is(propValue, expectedValues[i])) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    var valuesString = JSON.stringify(expectedValues);
	    return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createObjectOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (typeof typeChecker !== 'function') {
	      return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	    }
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	    }
	    for (var key in propValue) {
	      if (propValue.hasOwnProperty(key)) {
	        var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createUnionTypeChecker(arrayOfTypeCheckers) {
	  if (!Array.isArray(arrayOfTypeCheckers)) {
	     false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	    return emptyFunction.thatReturnsNull;
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createNodeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!isNode(props[propName])) {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createShapeTypeChecker(shapeTypes) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	    }
	    for (var key in shapeTypes) {
	      var checker = shapeTypes[key];
	      if (!checker) {
	        continue;
	      }
	      var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	      if (error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function isNode(propValue) {
	  switch (typeof propValue) {
	    case 'number':
	    case 'string':
	    case 'undefined':
	      return true;
	    case 'boolean':
	      return !propValue;
	    case 'object':
	      if (Array.isArray(propValue)) {
	        return propValue.every(isNode);
	      }
	      if (propValue === null || ReactElement.isValidElement(propValue)) {
	        return true;
	      }
	
	      var iteratorFn = getIteratorFn(propValue);
	      if (iteratorFn) {
	        var iterator = iteratorFn.call(propValue);
	        var step;
	        if (iteratorFn !== propValue.entries) {
	          while (!(step = iterator.next()).done) {
	            if (!isNode(step.value)) {
	              return false;
	            }
	          }
	        } else {
	          // Iterator will provide entry [k,v] tuples rather than values.
	          while (!(step = iterator.next()).done) {
	            var entry = step.value;
	            if (entry) {
	              if (!isNode(entry[1])) {
	                return false;
	              }
	            }
	          }
	        }
	      } else {
	        return false;
	      }
	
	      return true;
	    default:
	      return false;
	  }
	}
	
	function isSymbol(propType, propValue) {
	  // Native Symbol.
	  if (propType === 'symbol') {
	    return true;
	  }
	
	  // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	  if (propValue['@@toStringTag'] === 'Symbol') {
	    return true;
	  }
	
	  // Fallback for non-spec compliant Symbols which are polyfilled.
	  if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	    return true;
	  }
	
	  return false;
	}
	
	// Equivalent of `typeof` but with special handling for array and regexp.
	function getPropType(propValue) {
	  var propType = typeof propValue;
	  if (Array.isArray(propValue)) {
	    return 'array';
	  }
	  if (propValue instanceof RegExp) {
	    // Old webkits (at least until Android 4.0) return 'function' rather than
	    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	    // passes PropTypes.object.
	    return 'object';
	  }
	  if (isSymbol(propType, propValue)) {
	    return 'symbol';
	  }
	  return propType;
	}
	
	// This handles more types than `getPropType`. Only used for error messages.
	// See `createPrimitiveTypeChecker`.
	function getPreciseType(propValue) {
	  var propType = getPropType(propValue);
	  if (propType === 'object') {
	    if (propValue instanceof Date) {
	      return 'date';
	    } else if (propValue instanceof RegExp) {
	      return 'regexp';
	    }
	  }
	  return propType;
	}
	
	// Returns class name of the object, if any.
	function getClassName(propValue) {
	  if (!propValue.constructor || !propValue.constructor.name) {
	    return ANONYMOUS;
	  }
	  return propValue.constructor.name;
	}
	
	module.exports = ReactPropTypes;

/***/ },
/* 186 */
148,
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var ReactComponent = __webpack_require__(49);
	var ReactNoopUpdateQueue = __webpack_require__(50);
	
	var emptyObject = __webpack_require__(19);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = ReactPureComponent;

/***/ },
/* 188 */
153,
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(18);
	
	var ReactElement = __webpack_require__(17);
	
	var invariant = __webpack_require__(1);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(18);
	
	var ReactCurrentOwner = __webpack_require__(11);
	var REACT_ELEMENT_TYPE = __webpack_require__(77);
	
	var getIteratorFn = __webpack_require__(80);
	var invariant = __webpack_require__(1);
	var KeyEscapeUtils = __webpack_require__(180);
	var warning = __webpack_require__(2);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 191 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(__webpack_module_template_argument_0__);
	
	var invariant = __webpack_require__(1);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ }
/******/ ])));


// WEBPACK FOOTER //
// static/js/main.9875bdcd.js